/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,z=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});

/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e(require("@popperjs/core")):"function"==typeof define&&define.amd?define(["@popperjs/core"],e):(t="undefined"!=typeof globalThis?globalThis:t||self).bootstrap=e(t.Popper)}(this,(function(t){"use strict";function e(t){const e=Object.create(null,{[Symbol.toStringTag]:{value:"Module"}});if(t)for(const i in t)if("default"!==i){const s=Object.getOwnPropertyDescriptor(t,i);Object.defineProperty(e,i,s.get?s:{enumerable:!0,get:()=>t[i]})}return e.default=t,Object.freeze(e)}const i=e(t),s=new Map,n={set(t,e,i){s.has(t)||s.set(t,new Map);const n=s.get(t);n.has(e)||0===n.size?n.set(e,i):console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`)},get:(t,e)=>s.has(t)&&s.get(t).get(e)||null,remove(t,e){if(!s.has(t))return;const i=s.get(t);i.delete(e),0===i.size&&s.delete(t)}},o="transitionend",r=t=>(t&&window.CSS&&window.CSS.escape&&(t=t.replace(/#([^\s"#']+)/g,((t,e)=>`#${CSS.escape(e)}`))),t),a=t=>{t.dispatchEvent(new Event(o))},l=t=>!(!t||"object"!=typeof t)&&(void 0!==t.jquery&&(t=t[0]),void 0!==t.nodeType),c=t=>l(t)?t.jquery?t[0]:t:"string"==typeof t&&t.length>0?document.querySelector(r(t)):null,h=t=>{if(!l(t)||0===t.getClientRects().length)return!1;const e="visible"===getComputedStyle(t).getPropertyValue("visibility"),i=t.closest("details:not([open])");if(!i)return e;if(i!==t){const e=t.closest("summary");if(e&&e.parentNode!==i)return!1;if(null===e)return!1}return e},d=t=>!t||t.nodeType!==Node.ELEMENT_NODE||!!t.classList.contains("disabled")||(void 0!==t.disabled?t.disabled:t.hasAttribute("disabled")&&"false"!==t.getAttribute("disabled")),u=t=>{if(!document.documentElement.attachShadow)return null;if("function"==typeof t.getRootNode){const e=t.getRootNode();return e instanceof ShadowRoot?e:null}return t instanceof ShadowRoot?t:t.parentNode?u(t.parentNode):null},_=()=>{},g=t=>{t.offsetHeight},f=()=>window.jQuery&&!document.body.hasAttribute("data-bs-no-jquery")?window.jQuery:null,m=[],p=()=>"rtl"===document.documentElement.dir,b=t=>{var e;e=()=>{const e=f();if(e){const i=t.NAME,s=e.fn[i];e.fn[i]=t.jQueryInterface,e.fn[i].Constructor=t,e.fn[i].noConflict=()=>(e.fn[i]=s,t.jQueryInterface)}},"loading"===document.readyState?(m.length||document.addEventListener("DOMContentLoaded",(()=>{for(const t of m)t()})),m.push(e)):e()},v=(t,e=[],i=t)=>"function"==typeof t?t(...e):i,y=(t,e,i=!0)=>{if(!i)return void v(t);const s=(t=>{if(!t)return 0;let{transitionDuration:e,transitionDelay:i}=window.getComputedStyle(t);const s=Number.parseFloat(e),n=Number.parseFloat(i);return s||n?(e=e.split(",")[0],i=i.split(",")[0],1e3*(Number.parseFloat(e)+Number.parseFloat(i))):0})(e)+5;let n=!1;const r=({target:i})=>{i===e&&(n=!0,e.removeEventListener(o,r),v(t))};e.addEventListener(o,r),setTimeout((()=>{n||a(e)}),s)},w=(t,e,i,s)=>{const n=t.length;let o=t.indexOf(e);return-1===o?!i&&s?t[n-1]:t[0]:(o+=i?1:-1,s&&(o=(o+n)%n),t[Math.max(0,Math.min(o,n-1))])},A=/[^.]*(?=\..*)\.|.*/,E=/\..*/,C=/::\d+$/,T={};let k=1;const $={mouseenter:"mouseover",mouseleave:"mouseout"},S=new Set(["click","dblclick","mouseup","mousedown","contextmenu","mousewheel","DOMMouseScroll","mouseover","mouseout","mousemove","selectstart","selectend","keydown","keypress","keyup","orientationchange","touchstart","touchmove","touchend","touchcancel","pointerdown","pointermove","pointerup","pointerleave","pointercancel","gesturestart","gesturechange","gestureend","focus","blur","change","reset","select","submit","focusin","focusout","load","unload","beforeunload","resize","move","DOMContentLoaded","readystatechange","error","abort","scroll"]);function L(t,e){return e&&`${e}::${k++}`||t.uidEvent||k++}function O(t){const e=L(t);return t.uidEvent=e,T[e]=T[e]||{},T[e]}function I(t,e,i=null){return Object.values(t).find((t=>t.callable===e&&t.delegationSelector===i))}function D(t,e,i){const s="string"==typeof e,n=s?i:e||i;let o=M(t);return S.has(o)||(o=t),[s,n,o]}function N(t,e,i,s,n){if("string"!=typeof e||!t)return;let[o,r,a]=D(e,i,s);if(e in $){const t=t=>function(e){if(!e.relatedTarget||e.relatedTarget!==e.delegateTarget&&!e.delegateTarget.contains(e.relatedTarget))return t.call(this,e)};r=t(r)}const l=O(t),c=l[a]||(l[a]={}),h=I(c,r,o?i:null);if(h)return void(h.oneOff=h.oneOff&&n);const d=L(r,e.replace(A,"")),u=o?function(t,e,i){return function s(n){const o=t.querySelectorAll(e);for(let{target:r}=n;r&&r!==this;r=r.parentNode)for(const a of o)if(a===r)return F(n,{delegateTarget:r}),s.oneOff&&j.off(t,n.type,e,i),i.apply(r,[n])}}(t,i,r):function(t,e){return function i(s){return F(s,{delegateTarget:t}),i.oneOff&&j.off(t,s.type,e),e.apply(t,[s])}}(t,r);u.delegationSelector=o?i:null,u.callable=r,u.oneOff=n,u.uidEvent=d,c[d]=u,t.addEventListener(a,u,o)}function P(t,e,i,s,n){const o=I(e[i],s,n);o&&(t.removeEventListener(i,o,Boolean(n)),delete e[i][o.uidEvent])}function x(t,e,i,s){const n=e[i]||{};for(const[o,r]of Object.entries(n))o.includes(s)&&P(t,e,i,r.callable,r.delegationSelector)}function M(t){return t=t.replace(E,""),$[t]||t}const j={on(t,e,i,s){N(t,e,i,s,!1)},one(t,e,i,s){N(t,e,i,s,!0)},off(t,e,i,s){if("string"!=typeof e||!t)return;const[n,o,r]=D(e,i,s),a=r!==e,l=O(t),c=l[r]||{},h=e.startsWith(".");if(void 0===o){if(h)for(const i of Object.keys(l))x(t,l,i,e.slice(1));for(const[i,s]of Object.entries(c)){const n=i.replace(C,"");a&&!e.includes(n)||P(t,l,r,s.callable,s.delegationSelector)}}else{if(!Object.keys(c).length)return;P(t,l,r,o,n?i:null)}},trigger(t,e,i){if("string"!=typeof e||!t)return null;const s=f();let n=null,o=!0,r=!0,a=!1;e!==M(e)&&s&&(n=s.Event(e,i),s(t).trigger(n),o=!n.isPropagationStopped(),r=!n.isImmediatePropagationStopped(),a=n.isDefaultPrevented());const l=F(new Event(e,{bubbles:o,cancelable:!0}),i);return a&&l.preventDefault(),r&&t.dispatchEvent(l),l.defaultPrevented&&n&&n.preventDefault(),l}};function F(t,e={}){for(const[i,s]of Object.entries(e))try{t[i]=s}catch(e){Object.defineProperty(t,i,{configurable:!0,get:()=>s})}return t}function z(t){if("true"===t)return!0;if("false"===t)return!1;if(t===Number(t).toString())return Number(t);if(""===t||"null"===t)return null;if("string"!=typeof t)return t;try{return JSON.parse(decodeURIComponent(t))}catch(e){return t}}function H(t){return t.replace(/[A-Z]/g,(t=>`-${t.toLowerCase()}`))}const B={setDataAttribute(t,e,i){t.setAttribute(`data-bs-${H(e)}`,i)},removeDataAttribute(t,e){t.removeAttribute(`data-bs-${H(e)}`)},getDataAttributes(t){if(!t)return{};const e={},i=Object.keys(t.dataset).filter((t=>t.startsWith("bs")&&!t.startsWith("bsConfig")));for(const s of i){let i=s.replace(/^bs/,"");i=i.charAt(0).toLowerCase()+i.slice(1,i.length),e[i]=z(t.dataset[s])}return e},getDataAttribute:(t,e)=>z(t.getAttribute(`data-bs-${H(e)}`))};class q{static get Default(){return{}}static get DefaultType(){return{}}static get NAME(){throw new Error('You have to implement the static method "NAME", for each component!')}_getConfig(t){return t=this._mergeConfigObj(t),t=this._configAfterMerge(t),this._typeCheckConfig(t),t}_configAfterMerge(t){return t}_mergeConfigObj(t,e){const i=l(e)?B.getDataAttribute(e,"config"):{};return{...this.constructor.Default,..."object"==typeof i?i:{},...l(e)?B.getDataAttributes(e):{},..."object"==typeof t?t:{}}}_typeCheckConfig(t,e=this.constructor.DefaultType){for(const[s,n]of Object.entries(e)){const e=t[s],o=l(e)?"element":null==(i=e)?`${i}`:Object.prototype.toString.call(i).match(/\s([a-z]+)/i)[1].toLowerCase();if(!new RegExp(n).test(o))throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${s}" provided type "${o}" but expected type "${n}".`)}var i}}class W extends q{constructor(t,e){super(),(t=c(t))&&(this._element=t,this._config=this._getConfig(e),n.set(this._element,this.constructor.DATA_KEY,this))}dispose(){n.remove(this._element,this.constructor.DATA_KEY),j.off(this._element,this.constructor.EVENT_KEY);for(const t of Object.getOwnPropertyNames(this))this[t]=null}_queueCallback(t,e,i=!0){y(t,e,i)}_getConfig(t){return t=this._mergeConfigObj(t,this._element),t=this._configAfterMerge(t),this._typeCheckConfig(t),t}static getInstance(t){return n.get(c(t),this.DATA_KEY)}static getOrCreateInstance(t,e={}){return this.getInstance(t)||new this(t,"object"==typeof e?e:null)}static get VERSION(){return"5.3.3"}static get DATA_KEY(){return`bs.${this.NAME}`}static get EVENT_KEY(){return`.${this.DATA_KEY}`}static eventName(t){return`${t}${this.EVENT_KEY}`}}const R=t=>{let e=t.getAttribute("data-bs-target");if(!e||"#"===e){let i=t.getAttribute("href");if(!i||!i.includes("#")&&!i.startsWith("."))return null;i.includes("#")&&!i.startsWith("#")&&(i=`#${i.split("#")[1]}`),e=i&&"#"!==i?i.trim():null}return e?e.split(",").map((t=>r(t))).join(","):null},K={find:(t,e=document.documentElement)=>[].concat(...Element.prototype.querySelectorAll.call(e,t)),findOne:(t,e=document.documentElement)=>Element.prototype.querySelector.call(e,t),children:(t,e)=>[].concat(...t.children).filter((t=>t.matches(e))),parents(t,e){const i=[];let s=t.parentNode.closest(e);for(;s;)i.push(s),s=s.parentNode.closest(e);return i},prev(t,e){let i=t.previousElementSibling;for(;i;){if(i.matches(e))return[i];i=i.previousElementSibling}return[]},next(t,e){let i=t.nextElementSibling;for(;i;){if(i.matches(e))return[i];i=i.nextElementSibling}return[]},focusableChildren(t){const e=["a","button","input","textarea","select","details","[tabindex]",'[contenteditable="true"]'].map((t=>`${t}:not([tabindex^="-"])`)).join(",");return this.find(e,t).filter((t=>!d(t)&&h(t)))},getSelectorFromElement(t){const e=R(t);return e&&K.findOne(e)?e:null},getElementFromSelector(t){const e=R(t);return e?K.findOne(e):null},getMultipleElementsFromSelector(t){const e=R(t);return e?K.find(e):[]}},V=(t,e="hide")=>{const i=`click.dismiss${t.EVENT_KEY}`,s=t.NAME;j.on(document,i,`[data-bs-dismiss="${s}"]`,(function(i){if(["A","AREA"].includes(this.tagName)&&i.preventDefault(),d(this))return;const n=K.getElementFromSelector(this)||this.closest(`.${s}`);t.getOrCreateInstance(n)[e]()}))},Q=".bs.alert",X=`close${Q}`,Y=`closed${Q}`;class U extends W{static get NAME(){return"alert"}close(){if(j.trigger(this._element,X).defaultPrevented)return;this._element.classList.remove("show");const t=this._element.classList.contains("fade");this._queueCallback((()=>this._destroyElement()),this._element,t)}_destroyElement(){this._element.remove(),j.trigger(this._element,Y),this.dispose()}static jQueryInterface(t){return this.each((function(){const e=U.getOrCreateInstance(this);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}V(U,"close"),b(U);const G='[data-bs-toggle="button"]';class J extends W{static get NAME(){return"button"}toggle(){this._element.setAttribute("aria-pressed",this._element.classList.toggle("active"))}static jQueryInterface(t){return this.each((function(){const e=J.getOrCreateInstance(this);"toggle"===t&&e[t]()}))}}j.on(document,"click.bs.button.data-api",G,(t=>{t.preventDefault();const e=t.target.closest(G);J.getOrCreateInstance(e).toggle()})),b(J);const Z=".bs.swipe",tt=`touchstart${Z}`,et=`touchmove${Z}`,it=`touchend${Z}`,st=`pointerdown${Z}`,nt=`pointerup${Z}`,ot={endCallback:null,leftCallback:null,rightCallback:null},rt={endCallback:"(function|null)",leftCallback:"(function|null)",rightCallback:"(function|null)"};class at extends q{constructor(t,e){super(),this._element=t,t&&at.isSupported()&&(this._config=this._getConfig(e),this._deltaX=0,this._supportPointerEvents=Boolean(window.PointerEvent),this._initEvents())}static get Default(){return ot}static get DefaultType(){return rt}static get NAME(){return"swipe"}dispose(){j.off(this._element,Z)}_start(t){this._supportPointerEvents?this._eventIsPointerPenTouch(t)&&(this._deltaX=t.clientX):this._deltaX=t.touches[0].clientX}_end(t){this._eventIsPointerPenTouch(t)&&(this._deltaX=t.clientX-this._deltaX),this._handleSwipe(),v(this._config.endCallback)}_move(t){this._deltaX=t.touches&&t.touches.length>1?0:t.touches[0].clientX-this._deltaX}_handleSwipe(){const t=Math.abs(this._deltaX);if(t<=40)return;const e=t/this._deltaX;this._deltaX=0,e&&v(e>0?this._config.rightCallback:this._config.leftCallback)}_initEvents(){this._supportPointerEvents?(j.on(this._element,st,(t=>this._start(t))),j.on(this._element,nt,(t=>this._end(t))),this._element.classList.add("pointer-event")):(j.on(this._element,tt,(t=>this._start(t))),j.on(this._element,et,(t=>this._move(t))),j.on(this._element,it,(t=>this._end(t))))}_eventIsPointerPenTouch(t){return this._supportPointerEvents&&("pen"===t.pointerType||"touch"===t.pointerType)}static isSupported(){return"ontouchstart"in document.documentElement||navigator.maxTouchPoints>0}}const lt=".bs.carousel",ct=".data-api",ht="next",dt="prev",ut="left",_t="right",gt=`slide${lt}`,ft=`slid${lt}`,mt=`keydown${lt}`,pt=`mouseenter${lt}`,bt=`mouseleave${lt}`,vt=`dragstart${lt}`,yt=`load${lt}${ct}`,wt=`click${lt}${ct}`,At="carousel",Et="active",Ct=".active",Tt=".carousel-item",kt=Ct+Tt,$t={ArrowLeft:_t,ArrowRight:ut},St={interval:5e3,keyboard:!0,pause:"hover",ride:!1,touch:!0,wrap:!0},Lt={interval:"(number|boolean)",keyboard:"boolean",pause:"(string|boolean)",ride:"(boolean|string)",touch:"boolean",wrap:"boolean"};class Ot extends W{constructor(t,e){super(t,e),this._interval=null,this._activeElement=null,this._isSliding=!1,this.touchTimeout=null,this._swipeHelper=null,this._indicatorsElement=K.findOne(".carousel-indicators",this._element),this._addEventListeners(),this._config.ride===At&&this.cycle()}static get Default(){return St}static get DefaultType(){return Lt}static get NAME(){return"carousel"}next(){this._slide(ht)}nextWhenVisible(){!document.hidden&&h(this._element)&&this.next()}prev(){this._slide(dt)}pause(){this._isSliding&&a(this._element),this._clearInterval()}cycle(){this._clearInterval(),this._updateInterval(),this._interval=setInterval((()=>this.nextWhenVisible()),this._config.interval)}_maybeEnableCycle(){this._config.ride&&(this._isSliding?j.one(this._element,ft,(()=>this.cycle())):this.cycle())}to(t){const e=this._getItems();if(t>e.length-1||t<0)return;if(this._isSliding)return void j.one(this._element,ft,(()=>this.to(t)));const i=this._getItemIndex(this._getActive());if(i===t)return;const s=t>i?ht:dt;this._slide(s,e[t])}dispose(){this._swipeHelper&&this._swipeHelper.dispose(),super.dispose()}_configAfterMerge(t){return t.defaultInterval=t.interval,t}_addEventListeners(){this._config.keyboard&&j.on(this._element,mt,(t=>this._keydown(t))),"hover"===this._config.pause&&(j.on(this._element,pt,(()=>this.pause())),j.on(this._element,bt,(()=>this._maybeEnableCycle()))),this._config.touch&&at.isSupported()&&this._addTouchEventListeners()}_addTouchEventListeners(){for(const t of K.find(".carousel-item img",this._element))j.on(t,vt,(t=>t.preventDefault()));const t={leftCallback:()=>this._slide(this._directionToOrder(ut)),rightCallback:()=>this._slide(this._directionToOrder(_t)),endCallback:()=>{"hover"===this._config.pause&&(this.pause(),this.touchTimeout&&clearTimeout(this.touchTimeout),this.touchTimeout=setTimeout((()=>this._maybeEnableCycle()),500+this._config.interval))}};this._swipeHelper=new at(this._element,t)}_keydown(t){if(/input|textarea/i.test(t.target.tagName))return;const e=$t[t.key];e&&(t.preventDefault(),this._slide(this._directionToOrder(e)))}_getItemIndex(t){return this._getItems().indexOf(t)}_setActiveIndicatorElement(t){if(!this._indicatorsElement)return;const e=K.findOne(Ct,this._indicatorsElement);e.classList.remove(Et),e.removeAttribute("aria-current");const i=K.findOne(`[data-bs-slide-to="${t}"]`,this._indicatorsElement);i&&(i.classList.add(Et),i.setAttribute("aria-current","true"))}_updateInterval(){const t=this._activeElement||this._getActive();if(!t)return;const e=Number.parseInt(t.getAttribute("data-bs-interval"),10);this._config.interval=e||this._config.defaultInterval}_slide(t,e=null){if(this._isSliding)return;const i=this._getActive(),s=t===ht,n=e||w(this._getItems(),i,s,this._config.wrap);if(n===i)return;const o=this._getItemIndex(n),r=e=>j.trigger(this._element,e,{relatedTarget:n,direction:this._orderToDirection(t),from:this._getItemIndex(i),to:o});if(r(gt).defaultPrevented)return;if(!i||!n)return;const a=Boolean(this._interval);this.pause(),this._isSliding=!0,this._setActiveIndicatorElement(o),this._activeElement=n;const l=s?"carousel-item-start":"carousel-item-end",c=s?"carousel-item-next":"carousel-item-prev";n.classList.add(c),g(n),i.classList.add(l),n.classList.add(l),this._queueCallback((()=>{n.classList.remove(l,c),n.classList.add(Et),i.classList.remove(Et,c,l),this._isSliding=!1,r(ft)}),i,this._isAnimated()),a&&this.cycle()}_isAnimated(){return this._element.classList.contains("slide")}_getActive(){return K.findOne(kt,this._element)}_getItems(){return K.find(Tt,this._element)}_clearInterval(){this._interval&&(clearInterval(this._interval),this._interval=null)}_directionToOrder(t){return p()?t===ut?dt:ht:t===ut?ht:dt}_orderToDirection(t){return p()?t===dt?ut:_t:t===dt?_t:ut}static jQueryInterface(t){return this.each((function(){const e=Ot.getOrCreateInstance(this,t);if("number"!=typeof t){if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t]()}}else e.to(t)}))}}j.on(document,wt,"[data-bs-slide], [data-bs-slide-to]",(function(t){const e=K.getElementFromSelector(this);if(!e||!e.classList.contains(At))return;t.preventDefault();const i=Ot.getOrCreateInstance(e),s=this.getAttribute("data-bs-slide-to");return s?(i.to(s),void i._maybeEnableCycle()):"next"===B.getDataAttribute(this,"slide")?(i.next(),void i._maybeEnableCycle()):(i.prev(),void i._maybeEnableCycle())})),j.on(window,yt,(()=>{const t=K.find('[data-bs-ride="carousel"]');for(const e of t)Ot.getOrCreateInstance(e)})),b(Ot);const It=".bs.collapse",Dt=`show${It}`,Nt=`shown${It}`,Pt=`hide${It}`,xt=`hidden${It}`,Mt=`click${It}.data-api`,jt="show",Ft="collapse",zt="collapsing",Ht=`:scope .${Ft} .${Ft}`,Bt='[data-bs-toggle="collapse"]',qt={parent:null,toggle:!0},Wt={parent:"(null|element)",toggle:"boolean"};class Rt extends W{constructor(t,e){super(t,e),this._isTransitioning=!1,this._triggerArray=[];const i=K.find(Bt);for(const t of i){const e=K.getSelectorFromElement(t),i=K.find(e).filter((t=>t===this._element));null!==e&&i.length&&this._triggerArray.push(t)}this._initializeChildren(),this._config.parent||this._addAriaAndCollapsedClass(this._triggerArray,this._isShown()),this._config.toggle&&this.toggle()}static get Default(){return qt}static get DefaultType(){return Wt}static get NAME(){return"collapse"}toggle(){this._isShown()?this.hide():this.show()}show(){if(this._isTransitioning||this._isShown())return;let t=[];if(this._config.parent&&(t=this._getFirstLevelChildren(".collapse.show, .collapse.collapsing").filter((t=>t!==this._element)).map((t=>Rt.getOrCreateInstance(t,{toggle:!1})))),t.length&&t[0]._isTransitioning)return;if(j.trigger(this._element,Dt).defaultPrevented)return;for(const e of t)e.hide();const e=this._getDimension();this._element.classList.remove(Ft),this._element.classList.add(zt),this._element.style[e]=0,this._addAriaAndCollapsedClass(this._triggerArray,!0),this._isTransitioning=!0;const i=`scroll${e[0].toUpperCase()+e.slice(1)}`;this._queueCallback((()=>{this._isTransitioning=!1,this._element.classList.remove(zt),this._element.classList.add(Ft,jt),this._element.style[e]="",j.trigger(this._element,Nt)}),this._element,!0),this._element.style[e]=`${this._element[i]}px`}hide(){if(this._isTransitioning||!this._isShown())return;if(j.trigger(this._element,Pt).defaultPrevented)return;const t=this._getDimension();this._element.style[t]=`${this._element.getBoundingClientRect()[t]}px`,g(this._element),this._element.classList.add(zt),this._element.classList.remove(Ft,jt);for(const t of this._triggerArray){const e=K.getElementFromSelector(t);e&&!this._isShown(e)&&this._addAriaAndCollapsedClass([t],!1)}this._isTransitioning=!0,this._element.style[t]="",this._queueCallback((()=>{this._isTransitioning=!1,this._element.classList.remove(zt),this._element.classList.add(Ft),j.trigger(this._element,xt)}),this._element,!0)}_isShown(t=this._element){return t.classList.contains(jt)}_configAfterMerge(t){return t.toggle=Boolean(t.toggle),t.parent=c(t.parent),t}_getDimension(){return this._element.classList.contains("collapse-horizontal")?"width":"height"}_initializeChildren(){if(!this._config.parent)return;const t=this._getFirstLevelChildren(Bt);for(const e of t){const t=K.getElementFromSelector(e);t&&this._addAriaAndCollapsedClass([e],this._isShown(t))}}_getFirstLevelChildren(t){const e=K.find(Ht,this._config.parent);return K.find(t,this._config.parent).filter((t=>!e.includes(t)))}_addAriaAndCollapsedClass(t,e){if(t.length)for(const i of t)i.classList.toggle("collapsed",!e),i.setAttribute("aria-expanded",e)}static jQueryInterface(t){const e={};return"string"==typeof t&&/show|hide/.test(t)&&(e.toggle=!1),this.each((function(){const i=Rt.getOrCreateInstance(this,e);if("string"==typeof t){if(void 0===i[t])throw new TypeError(`No method named "${t}"`);i[t]()}}))}}j.on(document,Mt,Bt,(function(t){("A"===t.target.tagName||t.delegateTarget&&"A"===t.delegateTarget.tagName)&&t.preventDefault();for(const t of K.getMultipleElementsFromSelector(this))Rt.getOrCreateInstance(t,{toggle:!1}).toggle()})),b(Rt);const Kt="dropdown",Vt=".bs.dropdown",Qt=".data-api",Xt="ArrowUp",Yt="ArrowDown",Ut=`hide${Vt}`,Gt=`hidden${Vt}`,Jt=`show${Vt}`,Zt=`shown${Vt}`,te=`click${Vt}${Qt}`,ee=`keydown${Vt}${Qt}`,ie=`keyup${Vt}${Qt}`,se="show",ne='[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)',oe=`${ne}.${se}`,re=".dropdown-menu",ae=p()?"top-end":"top-start",le=p()?"top-start":"top-end",ce=p()?"bottom-end":"bottom-start",he=p()?"bottom-start":"bottom-end",de=p()?"left-start":"right-start",ue=p()?"right-start":"left-start",_e={autoClose:!0,boundary:"clippingParents",display:"dynamic",offset:[0,2],popperConfig:null,reference:"toggle"},ge={autoClose:"(boolean|string)",boundary:"(string|element)",display:"string",offset:"(array|string|function)",popperConfig:"(null|object|function)",reference:"(string|element|object)"};class fe extends W{constructor(t,e){super(t,e),this._popper=null,this._parent=this._element.parentNode,this._menu=K.next(this._element,re)[0]||K.prev(this._element,re)[0]||K.findOne(re,this._parent),this._inNavbar=this._detectNavbar()}static get Default(){return _e}static get DefaultType(){return ge}static get NAME(){return Kt}toggle(){return this._isShown()?this.hide():this.show()}show(){if(d(this._element)||this._isShown())return;const t={relatedTarget:this._element};if(!j.trigger(this._element,Jt,t).defaultPrevented){if(this._createPopper(),"ontouchstart"in document.documentElement&&!this._parent.closest(".navbar-nav"))for(const t of[].concat(...document.body.children))j.on(t,"mouseover",_);this._element.focus(),this._element.setAttribute("aria-expanded",!0),this._menu.classList.add(se),this._element.classList.add(se),j.trigger(this._element,Zt,t)}}hide(){if(d(this._element)||!this._isShown())return;const t={relatedTarget:this._element};this._completeHide(t)}dispose(){this._popper&&this._popper.destroy(),super.dispose()}update(){this._inNavbar=this._detectNavbar(),this._popper&&this._popper.update()}_completeHide(t){if(!j.trigger(this._element,Ut,t).defaultPrevented){if("ontouchstart"in document.documentElement)for(const t of[].concat(...document.body.children))j.off(t,"mouseover",_);this._popper&&this._popper.destroy(),this._menu.classList.remove(se),this._element.classList.remove(se),this._element.setAttribute("aria-expanded","false"),B.removeDataAttribute(this._menu,"popper"),j.trigger(this._element,Gt,t)}}_getConfig(t){if("object"==typeof(t=super._getConfig(t)).reference&&!l(t.reference)&&"function"!=typeof t.reference.getBoundingClientRect)throw new TypeError(`${Kt.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);return t}_createPopper(){if(void 0===i)throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");let t=this._element;"parent"===this._config.reference?t=this._parent:l(this._config.reference)?t=c(this._config.reference):"object"==typeof this._config.reference&&(t=this._config.reference);const e=this._getPopperConfig();this._popper=i.createPopper(t,this._menu,e)}_isShown(){return this._menu.classList.contains(se)}_getPlacement(){const t=this._parent;if(t.classList.contains("dropend"))return de;if(t.classList.contains("dropstart"))return ue;if(t.classList.contains("dropup-center"))return"top";if(t.classList.contains("dropdown-center"))return"bottom";const e="end"===getComputedStyle(this._menu).getPropertyValue("--bs-position").trim();return t.classList.contains("dropup")?e?le:ae:e?he:ce}_detectNavbar(){return null!==this._element.closest(".navbar")}_getOffset(){const{offset:t}=this._config;return"string"==typeof t?t.split(",").map((t=>Number.parseInt(t,10))):"function"==typeof t?e=>t(e,this._element):t}_getPopperConfig(){const t={placement:this._getPlacement(),modifiers:[{name:"preventOverflow",options:{boundary:this._config.boundary}},{name:"offset",options:{offset:this._getOffset()}}]};return(this._inNavbar||"static"===this._config.display)&&(B.setDataAttribute(this._menu,"popper","static"),t.modifiers=[{name:"applyStyles",enabled:!1}]),{...t,...v(this._config.popperConfig,[t])}}_selectMenuItem({key:t,target:e}){const i=K.find(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",this._menu).filter((t=>h(t)));i.length&&w(i,e,t===Yt,!i.includes(e)).focus()}static jQueryInterface(t){return this.each((function(){const e=fe.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}static clearMenus(t){if(2===t.button||"keyup"===t.type&&"Tab"!==t.key)return;const e=K.find(oe);for(const i of e){const e=fe.getInstance(i);if(!e||!1===e._config.autoClose)continue;const s=t.composedPath(),n=s.includes(e._menu);if(s.includes(e._element)||"inside"===e._config.autoClose&&!n||"outside"===e._config.autoClose&&n)continue;if(e._menu.contains(t.target)&&("keyup"===t.type&&"Tab"===t.key||/input|select|option|textarea|form/i.test(t.target.tagName)))continue;const o={relatedTarget:e._element};"click"===t.type&&(o.clickEvent=t),e._completeHide(o)}}static dataApiKeydownHandler(t){const e=/input|textarea/i.test(t.target.tagName),i="Escape"===t.key,s=[Xt,Yt].includes(t.key);if(!s&&!i)return;if(e&&!i)return;t.preventDefault();const n=this.matches(ne)?this:K.prev(this,ne)[0]||K.next(this,ne)[0]||K.findOne(ne,t.delegateTarget.parentNode),o=fe.getOrCreateInstance(n);if(s)return t.stopPropagation(),o.show(),void o._selectMenuItem(t);o._isShown()&&(t.stopPropagation(),o.hide(),n.focus())}}j.on(document,ee,ne,fe.dataApiKeydownHandler),j.on(document,ee,re,fe.dataApiKeydownHandler),j.on(document,te,fe.clearMenus),j.on(document,ie,fe.clearMenus),j.on(document,te,ne,(function(t){t.preventDefault(),fe.getOrCreateInstance(this).toggle()})),b(fe);const me="backdrop",pe="show",be=`mousedown.bs.${me}`,ve={className:"modal-backdrop",clickCallback:null,isAnimated:!1,isVisible:!0,rootElement:"body"},ye={className:"string",clickCallback:"(function|null)",isAnimated:"boolean",isVisible:"boolean",rootElement:"(element|string)"};class we extends q{constructor(t){super(),this._config=this._getConfig(t),this._isAppended=!1,this._element=null}static get Default(){return ve}static get DefaultType(){return ye}static get NAME(){return me}show(t){if(!this._config.isVisible)return void v(t);this._append();const e=this._getElement();this._config.isAnimated&&g(e),e.classList.add(pe),this._emulateAnimation((()=>{v(t)}))}hide(t){this._config.isVisible?(this._getElement().classList.remove(pe),this._emulateAnimation((()=>{this.dispose(),v(t)}))):v(t)}dispose(){this._isAppended&&(j.off(this._element,be),this._element.remove(),this._isAppended=!1)}_getElement(){if(!this._element){const t=document.createElement("div");t.className=this._config.className,this._config.isAnimated&&t.classList.add("fade"),this._element=t}return this._element}_configAfterMerge(t){return t.rootElement=c(t.rootElement),t}_append(){if(this._isAppended)return;const t=this._getElement();this._config.rootElement.append(t),j.on(t,be,(()=>{v(this._config.clickCallback)})),this._isAppended=!0}_emulateAnimation(t){y(t,this._getElement(),this._config.isAnimated)}}const Ae=".bs.focustrap",Ee=`focusin${Ae}`,Ce=`keydown.tab${Ae}`,Te="backward",ke={autofocus:!0,trapElement:null},$e={autofocus:"boolean",trapElement:"element"};class Se extends q{constructor(t){super(),this._config=this._getConfig(t),this._isActive=!1,this._lastTabNavDirection=null}static get Default(){return ke}static get DefaultType(){return $e}static get NAME(){return"focustrap"}activate(){this._isActive||(this._config.autofocus&&this._config.trapElement.focus(),j.off(document,Ae),j.on(document,Ee,(t=>this._handleFocusin(t))),j.on(document,Ce,(t=>this._handleKeydown(t))),this._isActive=!0)}deactivate(){this._isActive&&(this._isActive=!1,j.off(document,Ae))}_handleFocusin(t){const{trapElement:e}=this._config;if(t.target===document||t.target===e||e.contains(t.target))return;const i=K.focusableChildren(e);0===i.length?e.focus():this._lastTabNavDirection===Te?i[i.length-1].focus():i[0].focus()}_handleKeydown(t){"Tab"===t.key&&(this._lastTabNavDirection=t.shiftKey?Te:"forward")}}const Le=".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",Oe=".sticky-top",Ie="padding-right",De="margin-right";class Ne{constructor(){this._element=document.body}getWidth(){const t=document.documentElement.clientWidth;return Math.abs(window.innerWidth-t)}hide(){const t=this.getWidth();this._disableOverFlow(),this._setElementAttributes(this._element,Ie,(e=>e+t)),this._setElementAttributes(Le,Ie,(e=>e+t)),this._setElementAttributes(Oe,De,(e=>e-t))}reset(){this._resetElementAttributes(this._element,"overflow"),this._resetElementAttributes(this._element,Ie),this._resetElementAttributes(Le,Ie),this._resetElementAttributes(Oe,De)}isOverflowing(){return this.getWidth()>0}_disableOverFlow(){this._saveInitialAttribute(this._element,"overflow"),this._element.style.overflow="hidden"}_setElementAttributes(t,e,i){const s=this.getWidth();this._applyManipulationCallback(t,(t=>{if(t!==this._element&&window.innerWidth>t.clientWidth+s)return;this._saveInitialAttribute(t,e);const n=window.getComputedStyle(t).getPropertyValue(e);t.style.setProperty(e,`${i(Number.parseFloat(n))}px`)}))}_saveInitialAttribute(t,e){const i=t.style.getPropertyValue(e);i&&B.setDataAttribute(t,e,i)}_resetElementAttributes(t,e){this._applyManipulationCallback(t,(t=>{const i=B.getDataAttribute(t,e);null!==i?(B.removeDataAttribute(t,e),t.style.setProperty(e,i)):t.style.removeProperty(e)}))}_applyManipulationCallback(t,e){if(l(t))e(t);else for(const i of K.find(t,this._element))e(i)}}const Pe=".bs.modal",xe=`hide${Pe}`,Me=`hidePrevented${Pe}`,je=`hidden${Pe}`,Fe=`show${Pe}`,ze=`shown${Pe}`,He=`resize${Pe}`,Be=`click.dismiss${Pe}`,qe=`mousedown.dismiss${Pe}`,We=`keydown.dismiss${Pe}`,Re=`click${Pe}.data-api`,Ke="modal-open",Ve="show",Qe="modal-static",Xe={backdrop:!0,focus:!0,keyboard:!0},Ye={backdrop:"(boolean|string)",focus:"boolean",keyboard:"boolean"};class Ue extends W{constructor(t,e){super(t,e),this._dialog=K.findOne(".modal-dialog",this._element),this._backdrop=this._initializeBackDrop(),this._focustrap=this._initializeFocusTrap(),this._isShown=!1,this._isTransitioning=!1,this._scrollBar=new Ne,this._addEventListeners()}static get Default(){return Xe}static get DefaultType(){return Ye}static get NAME(){return"modal"}toggle(t){return this._isShown?this.hide():this.show(t)}show(t){this._isShown||this._isTransitioning||j.trigger(this._element,Fe,{relatedTarget:t}).defaultPrevented||(this._isShown=!0,this._isTransitioning=!0,this._scrollBar.hide(),document.body.classList.add(Ke),this._adjustDialog(),this._backdrop.show((()=>this._showElement(t))))}hide(){this._isShown&&!this._isTransitioning&&(j.trigger(this._element,xe).defaultPrevented||(this._isShown=!1,this._isTransitioning=!0,this._focustrap.deactivate(),this._element.classList.remove(Ve),this._queueCallback((()=>this._hideModal()),this._element,this._isAnimated())))}dispose(){j.off(window,Pe),j.off(this._dialog,Pe),this._backdrop.dispose(),this._focustrap.deactivate(),super.dispose()}handleUpdate(){this._adjustDialog()}_initializeBackDrop(){return new we({isVisible:Boolean(this._config.backdrop),isAnimated:this._isAnimated()})}_initializeFocusTrap(){return new Se({trapElement:this._element})}_showElement(t){document.body.contains(this._element)||document.body.append(this._element),this._element.style.display="block",this._element.removeAttribute("aria-hidden"),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),this._element.scrollTop=0;const e=K.findOne(".modal-body",this._dialog);e&&(e.scrollTop=0),g(this._element),this._element.classList.add(Ve),this._queueCallback((()=>{this._config.focus&&this._focustrap.activate(),this._isTransitioning=!1,j.trigger(this._element,ze,{relatedTarget:t})}),this._dialog,this._isAnimated())}_addEventListeners(){j.on(this._element,We,(t=>{"Escape"===t.key&&(this._config.keyboard?this.hide():this._triggerBackdropTransition())})),j.on(window,He,(()=>{this._isShown&&!this._isTransitioning&&this._adjustDialog()})),j.on(this._element,qe,(t=>{j.one(this._element,Be,(e=>{this._element===t.target&&this._element===e.target&&("static"!==this._config.backdrop?this._config.backdrop&&this.hide():this._triggerBackdropTransition())}))}))}_hideModal(){this._element.style.display="none",this._element.setAttribute("aria-hidden",!0),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._isTransitioning=!1,this._backdrop.hide((()=>{document.body.classList.remove(Ke),this._resetAdjustments(),this._scrollBar.reset(),j.trigger(this._element,je)}))}_isAnimated(){return this._element.classList.contains("fade")}_triggerBackdropTransition(){if(j.trigger(this._element,Me).defaultPrevented)return;const t=this._element.scrollHeight>document.documentElement.clientHeight,e=this._element.style.overflowY;"hidden"===e||this._element.classList.contains(Qe)||(t||(this._element.style.overflowY="hidden"),this._element.classList.add(Qe),this._queueCallback((()=>{this._element.classList.remove(Qe),this._queueCallback((()=>{this._element.style.overflowY=e}),this._dialog)}),this._dialog),this._element.focus())}_adjustDialog(){const t=this._element.scrollHeight>document.documentElement.clientHeight,e=this._scrollBar.getWidth(),i=e>0;if(i&&!t){const t=p()?"paddingLeft":"paddingRight";this._element.style[t]=`${e}px`}if(!i&&t){const t=p()?"paddingRight":"paddingLeft";this._element.style[t]=`${e}px`}}_resetAdjustments(){this._element.style.paddingLeft="",this._element.style.paddingRight=""}static jQueryInterface(t,e){return this.each((function(){const i=Ue.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===i[t])throw new TypeError(`No method named "${t}"`);i[t](e)}}))}}j.on(document,Re,'[data-bs-toggle="modal"]',(function(t){const e=K.getElementFromSelector(this);["A","AREA"].includes(this.tagName)&&t.preventDefault(),j.one(e,Fe,(t=>{t.defaultPrevented||j.one(e,je,(()=>{h(this)&&this.focus()}))}));const i=K.findOne(".modal.show");i&&Ue.getInstance(i).hide(),Ue.getOrCreateInstance(e).toggle(this)})),V(Ue),b(Ue);const Ge=".bs.offcanvas",Je=".data-api",Ze=`load${Ge}${Je}`,ti="show",ei="showing",ii="hiding",si=".offcanvas.show",ni=`show${Ge}`,oi=`shown${Ge}`,ri=`hide${Ge}`,ai=`hidePrevented${Ge}`,li=`hidden${Ge}`,ci=`resize${Ge}`,hi=`click${Ge}${Je}`,di=`keydown.dismiss${Ge}`,ui={backdrop:!0,keyboard:!0,scroll:!1},_i={backdrop:"(boolean|string)",keyboard:"boolean",scroll:"boolean"};class gi extends W{constructor(t,e){super(t,e),this._isShown=!1,this._backdrop=this._initializeBackDrop(),this._focustrap=this._initializeFocusTrap(),this._addEventListeners()}static get Default(){return ui}static get DefaultType(){return _i}static get NAME(){return"offcanvas"}toggle(t){return this._isShown?this.hide():this.show(t)}show(t){this._isShown||j.trigger(this._element,ni,{relatedTarget:t}).defaultPrevented||(this._isShown=!0,this._backdrop.show(),this._config.scroll||(new Ne).hide(),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),this._element.classList.add(ei),this._queueCallback((()=>{this._config.scroll&&!this._config.backdrop||this._focustrap.activate(),this._element.classList.add(ti),this._element.classList.remove(ei),j.trigger(this._element,oi,{relatedTarget:t})}),this._element,!0))}hide(){this._isShown&&(j.trigger(this._element,ri).defaultPrevented||(this._focustrap.deactivate(),this._element.blur(),this._isShown=!1,this._element.classList.add(ii),this._backdrop.hide(),this._queueCallback((()=>{this._element.classList.remove(ti,ii),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._config.scroll||(new Ne).reset(),j.trigger(this._element,li)}),this._element,!0)))}dispose(){this._backdrop.dispose(),this._focustrap.deactivate(),super.dispose()}_initializeBackDrop(){const t=Boolean(this._config.backdrop);return new we({className:"offcanvas-backdrop",isVisible:t,isAnimated:!0,rootElement:this._element.parentNode,clickCallback:t?()=>{"static"!==this._config.backdrop?this.hide():j.trigger(this._element,ai)}:null})}_initializeFocusTrap(){return new Se({trapElement:this._element})}_addEventListeners(){j.on(this._element,di,(t=>{"Escape"===t.key&&(this._config.keyboard?this.hide():j.trigger(this._element,ai))}))}static jQueryInterface(t){return this.each((function(){const e=gi.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}j.on(document,hi,'[data-bs-toggle="offcanvas"]',(function(t){const e=K.getElementFromSelector(this);if(["A","AREA"].includes(this.tagName)&&t.preventDefault(),d(this))return;j.one(e,li,(()=>{h(this)&&this.focus()}));const i=K.findOne(si);i&&i!==e&&gi.getInstance(i).hide(),gi.getOrCreateInstance(e).toggle(this)})),j.on(window,Ze,(()=>{for(const t of K.find(si))gi.getOrCreateInstance(t).show()})),j.on(window,ci,(()=>{for(const t of K.find("[aria-modal][class*=show][class*=offcanvas-]"))"fixed"!==getComputedStyle(t).position&&gi.getOrCreateInstance(t).hide()})),V(gi),b(gi);const fi={"*":["class","dir","id","lang","role",/^aria-[\w-]*$/i],a:["target","href","title","rel"],area:[],b:[],br:[],col:[],code:[],dd:[],div:[],dl:[],dt:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:["src","srcset","alt","title","width","height"],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]},mi=new Set(["background","cite","href","itemtype","longdesc","poster","src","xlink:href"]),pi=/^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i,bi=(t,e)=>{const i=t.nodeName.toLowerCase();return e.includes(i)?!mi.has(i)||Boolean(pi.test(t.nodeValue)):e.filter((t=>t instanceof RegExp)).some((t=>t.test(i)))},vi={allowList:fi,content:{},extraClass:"",html:!1,sanitize:!0,sanitizeFn:null,template:"<div></div>"},yi={allowList:"object",content:"object",extraClass:"(string|function)",html:"boolean",sanitize:"boolean",sanitizeFn:"(null|function)",template:"string"},wi={entry:"(string|element|function|null)",selector:"(string|element)"};class Ai extends q{constructor(t){super(),this._config=this._getConfig(t)}static get Default(){return vi}static get DefaultType(){return yi}static get NAME(){return"TemplateFactory"}getContent(){return Object.values(this._config.content).map((t=>this._resolvePossibleFunction(t))).filter(Boolean)}hasContent(){return this.getContent().length>0}changeContent(t){return this._checkContent(t),this._config.content={...this._config.content,...t},this}toHtml(){const t=document.createElement("div");t.innerHTML=this._maybeSanitize(this._config.template);for(const[e,i]of Object.entries(this._config.content))this._setContent(t,i,e);const e=t.children[0],i=this._resolvePossibleFunction(this._config.extraClass);return i&&e.classList.add(...i.split(" ")),e}_typeCheckConfig(t){super._typeCheckConfig(t),this._checkContent(t.content)}_checkContent(t){for(const[e,i]of Object.entries(t))super._typeCheckConfig({selector:e,entry:i},wi)}_setContent(t,e,i){const s=K.findOne(i,t);s&&((e=this._resolvePossibleFunction(e))?l(e)?this._putElementInTemplate(c(e),s):this._config.html?s.innerHTML=this._maybeSanitize(e):s.textContent=e:s.remove())}_maybeSanitize(t){return this._config.sanitize?function(t,e,i){if(!t.length)return t;if(i&&"function"==typeof i)return i(t);const s=(new window.DOMParser).parseFromString(t,"text/html"),n=[].concat(...s.body.querySelectorAll("*"));for(const t of n){const i=t.nodeName.toLowerCase();if(!Object.keys(e).includes(i)){t.remove();continue}const s=[].concat(...t.attributes),n=[].concat(e["*"]||[],e[i]||[]);for(const e of s)bi(e,n)||t.removeAttribute(e.nodeName)}return s.body.innerHTML}(t,this._config.allowList,this._config.sanitizeFn):t}_resolvePossibleFunction(t){return v(t,[this])}_putElementInTemplate(t,e){if(this._config.html)return e.innerHTML="",void e.append(t);e.textContent=t.textContent}}const Ei=new Set(["sanitize","allowList","sanitizeFn"]),Ci="fade",Ti="show",ki=".modal",$i="hide.bs.modal",Si="hover",Li="focus",Oi={AUTO:"auto",TOP:"top",RIGHT:p()?"left":"right",BOTTOM:"bottom",LEFT:p()?"right":"left"},Ii={allowList:fi,animation:!0,boundary:"clippingParents",container:!1,customClass:"",delay:0,fallbackPlacements:["top","right","bottom","left"],html:!1,offset:[0,6],placement:"top",popperConfig:null,sanitize:!0,sanitizeFn:null,selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',title:"",trigger:"hover focus"},Di={allowList:"object",animation:"boolean",boundary:"(string|element)",container:"(string|element|boolean)",customClass:"(string|function)",delay:"(number|object)",fallbackPlacements:"array",html:"boolean",offset:"(array|string|function)",placement:"(string|function)",popperConfig:"(null|object|function)",sanitize:"boolean",sanitizeFn:"(null|function)",selector:"(string|boolean)",template:"string",title:"(string|element|function)",trigger:"string"};class Ni extends W{constructor(t,e){if(void 0===i)throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");super(t,e),this._isEnabled=!0,this._timeout=0,this._isHovered=null,this._activeTrigger={},this._popper=null,this._templateFactory=null,this._newContent=null,this.tip=null,this._setListeners(),this._config.selector||this._fixTitle()}static get Default(){return Ii}static get DefaultType(){return Di}static get NAME(){return"tooltip"}enable(){this._isEnabled=!0}disable(){this._isEnabled=!1}toggleEnabled(){this._isEnabled=!this._isEnabled}toggle(){this._isEnabled&&(this._activeTrigger.click=!this._activeTrigger.click,this._isShown()?this._leave():this._enter())}dispose(){clearTimeout(this._timeout),j.off(this._element.closest(ki),$i,this._hideModalHandler),this._element.getAttribute("data-bs-original-title")&&this._element.setAttribute("title",this._element.getAttribute("data-bs-original-title")),this._disposePopper(),super.dispose()}show(){if("none"===this._element.style.display)throw new Error("Please use show on visible elements");if(!this._isWithContent()||!this._isEnabled)return;const t=j.trigger(this._element,this.constructor.eventName("show")),e=(u(this._element)||this._element.ownerDocument.documentElement).contains(this._element);if(t.defaultPrevented||!e)return;this._disposePopper();const i=this._getTipElement();this._element.setAttribute("aria-describedby",i.getAttribute("id"));const{container:s}=this._config;if(this._element.ownerDocument.documentElement.contains(this.tip)||(s.append(i),j.trigger(this._element,this.constructor.eventName("inserted"))),this._popper=this._createPopper(i),i.classList.add(Ti),"ontouchstart"in document.documentElement)for(const t of[].concat(...document.body.children))j.on(t,"mouseover",_);this._queueCallback((()=>{j.trigger(this._element,this.constructor.eventName("shown")),!1===this._isHovered&&this._leave(),this._isHovered=!1}),this.tip,this._isAnimated())}hide(){if(this._isShown()&&!j.trigger(this._element,this.constructor.eventName("hide")).defaultPrevented){if(this._getTipElement().classList.remove(Ti),"ontouchstart"in document.documentElement)for(const t of[].concat(...document.body.children))j.off(t,"mouseover",_);this._activeTrigger.click=!1,this._activeTrigger[Li]=!1,this._activeTrigger[Si]=!1,this._isHovered=null,this._queueCallback((()=>{this._isWithActiveTrigger()||(this._isHovered||this._disposePopper(),this._element.removeAttribute("aria-describedby"),j.trigger(this._element,this.constructor.eventName("hidden")))}),this.tip,this._isAnimated())}}update(){this._popper&&this._popper.update()}_isWithContent(){return Boolean(this._getTitle())}_getTipElement(){return this.tip||(this.tip=this._createTipElement(this._newContent||this._getContentForTemplate())),this.tip}_createTipElement(t){const e=this._getTemplateFactory(t).toHtml();if(!e)return null;e.classList.remove(Ci,Ti),e.classList.add(`bs-${this.constructor.NAME}-auto`);const i=(t=>{do{t+=Math.floor(1e6*Math.random())}while(document.getElementById(t));return t})(this.constructor.NAME).toString();return e.setAttribute("id",i),this._isAnimated()&&e.classList.add(Ci),e}setContent(t){this._newContent=t,this._isShown()&&(this._disposePopper(),this.show())}_getTemplateFactory(t){return this._templateFactory?this._templateFactory.changeContent(t):this._templateFactory=new Ai({...this._config,content:t,extraClass:this._resolvePossibleFunction(this._config.customClass)}),this._templateFactory}_getContentForTemplate(){return{".tooltip-inner":this._getTitle()}}_getTitle(){return this._resolvePossibleFunction(this._config.title)||this._element.getAttribute("data-bs-original-title")}_initializeOnDelegatedTarget(t){return this.constructor.getOrCreateInstance(t.delegateTarget,this._getDelegateConfig())}_isAnimated(){return this._config.animation||this.tip&&this.tip.classList.contains(Ci)}_isShown(){return this.tip&&this.tip.classList.contains(Ti)}_createPopper(t){const e=v(this._config.placement,[this,t,this._element]),s=Oi[e.toUpperCase()];return i.createPopper(this._element,t,this._getPopperConfig(s))}_getOffset(){const{offset:t}=this._config;return"string"==typeof t?t.split(",").map((t=>Number.parseInt(t,10))):"function"==typeof t?e=>t(e,this._element):t}_resolvePossibleFunction(t){return v(t,[this._element])}_getPopperConfig(t){const e={placement:t,modifiers:[{name:"flip",options:{fallbackPlacements:this._config.fallbackPlacements}},{name:"offset",options:{offset:this._getOffset()}},{name:"preventOverflow",options:{boundary:this._config.boundary}},{name:"arrow",options:{element:`.${this.constructor.NAME}-arrow`}},{name:"preSetPlacement",enabled:!0,phase:"beforeMain",fn:t=>{this._getTipElement().setAttribute("data-popper-placement",t.state.placement)}}]};return{...e,...v(this._config.popperConfig,[e])}}_setListeners(){const t=this._config.trigger.split(" ");for(const e of t)if("click"===e)j.on(this._element,this.constructor.eventName("click"),this._config.selector,(t=>{this._initializeOnDelegatedTarget(t).toggle()}));else if("manual"!==e){const t=e===Si?this.constructor.eventName("mouseenter"):this.constructor.eventName("focusin"),i=e===Si?this.constructor.eventName("mouseleave"):this.constructor.eventName("focusout");j.on(this._element,t,this._config.selector,(t=>{const e=this._initializeOnDelegatedTarget(t);e._activeTrigger["focusin"===t.type?Li:Si]=!0,e._enter()})),j.on(this._element,i,this._config.selector,(t=>{const e=this._initializeOnDelegatedTarget(t);e._activeTrigger["focusout"===t.type?Li:Si]=e._element.contains(t.relatedTarget),e._leave()}))}this._hideModalHandler=()=>{this._element&&this.hide()},j.on(this._element.closest(ki),$i,this._hideModalHandler)}_fixTitle(){const t=this._element.getAttribute("title");t&&(this._element.getAttribute("aria-label")||this._element.textContent.trim()||this._element.setAttribute("aria-label",t),this._element.setAttribute("data-bs-original-title",t),this._element.removeAttribute("title"))}_enter(){this._isShown()||this._isHovered?this._isHovered=!0:(this._isHovered=!0,this._setTimeout((()=>{this._isHovered&&this.show()}),this._config.delay.show))}_leave(){this._isWithActiveTrigger()||(this._isHovered=!1,this._setTimeout((()=>{this._isHovered||this.hide()}),this._config.delay.hide))}_setTimeout(t,e){clearTimeout(this._timeout),this._timeout=setTimeout(t,e)}_isWithActiveTrigger(){return Object.values(this._activeTrigger).includes(!0)}_getConfig(t){const e=B.getDataAttributes(this._element);for(const t of Object.keys(e))Ei.has(t)&&delete e[t];return t={...e,..."object"==typeof t&&t?t:{}},t=this._mergeConfigObj(t),t=this._configAfterMerge(t),this._typeCheckConfig(t),t}_configAfterMerge(t){return t.container=!1===t.container?document.body:c(t.container),"number"==typeof t.delay&&(t.delay={show:t.delay,hide:t.delay}),"number"==typeof t.title&&(t.title=t.title.toString()),"number"==typeof t.content&&(t.content=t.content.toString()),t}_getDelegateConfig(){const t={};for(const[e,i]of Object.entries(this._config))this.constructor.Default[e]!==i&&(t[e]=i);return t.selector=!1,t.trigger="manual",t}_disposePopper(){this._popper&&(this._popper.destroy(),this._popper=null),this.tip&&(this.tip.remove(),this.tip=null)}static jQueryInterface(t){return this.each((function(){const e=Ni.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}b(Ni);const Pi={...Ni.Default,content:"",offset:[0,8],placement:"right",template:'<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',trigger:"click"},xi={...Ni.DefaultType,content:"(null|string|element|function)"};class Mi extends Ni{static get Default(){return Pi}static get DefaultType(){return xi}static get NAME(){return"popover"}_isWithContent(){return this._getTitle()||this._getContent()}_getContentForTemplate(){return{".popover-header":this._getTitle(),".popover-body":this._getContent()}}_getContent(){return this._resolvePossibleFunction(this._config.content)}static jQueryInterface(t){return this.each((function(){const e=Mi.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}b(Mi);const ji=".bs.scrollspy",Fi=`activate${ji}`,zi=`click${ji}`,Hi=`load${ji}.data-api`,Bi="active",qi="[href]",Wi=".nav-link",Ri=`${Wi}, .nav-item > ${Wi}, .list-group-item`,Ki={offset:null,rootMargin:"0px 0px -25%",smoothScroll:!1,target:null,threshold:[.1,.5,1]},Vi={offset:"(number|null)",rootMargin:"string",smoothScroll:"boolean",target:"element",threshold:"array"};class Qi extends W{constructor(t,e){super(t,e),this._targetLinks=new Map,this._observableSections=new Map,this._rootElement="visible"===getComputedStyle(this._element).overflowY?null:this._element,this._activeTarget=null,this._observer=null,this._previousScrollData={visibleEntryTop:0,parentScrollTop:0},this.refresh()}static get Default(){return Ki}static get DefaultType(){return Vi}static get NAME(){return"scrollspy"}refresh(){this._initializeTargetsAndObservables(),this._maybeEnableSmoothScroll(),this._observer?this._observer.disconnect():this._observer=this._getNewObserver();for(const t of this._observableSections.values())this._observer.observe(t)}dispose(){this._observer.disconnect(),super.dispose()}_configAfterMerge(t){return t.target=c(t.target)||document.body,t.rootMargin=t.offset?`${t.offset}px 0px -30%`:t.rootMargin,"string"==typeof t.threshold&&(t.threshold=t.threshold.split(",").map((t=>Number.parseFloat(t)))),t}_maybeEnableSmoothScroll(){this._config.smoothScroll&&(j.off(this._config.target,zi),j.on(this._config.target,zi,qi,(t=>{const e=this._observableSections.get(t.target.hash);if(e){t.preventDefault();const i=this._rootElement||window,s=e.offsetTop-this._element.offsetTop;if(i.scrollTo)return void i.scrollTo({top:s,behavior:"smooth"});i.scrollTop=s}})))}_getNewObserver(){const t={root:this._rootElement,threshold:this._config.threshold,rootMargin:this._config.rootMargin};return new IntersectionObserver((t=>this._observerCallback(t)),t)}_observerCallback(t){const e=t=>this._targetLinks.get(`#${t.target.id}`),i=t=>{this._previousScrollData.visibleEntryTop=t.target.offsetTop,this._process(e(t))},s=(this._rootElement||document.documentElement).scrollTop,n=s>=this._previousScrollData.parentScrollTop;this._previousScrollData.parentScrollTop=s;for(const o of t){if(!o.isIntersecting){this._activeTarget=null,this._clearActiveClass(e(o));continue}const t=o.target.offsetTop>=this._previousScrollData.visibleEntryTop;if(n&&t){if(i(o),!s)return}else n||t||i(o)}}_initializeTargetsAndObservables(){this._targetLinks=new Map,this._observableSections=new Map;const t=K.find(qi,this._config.target);for(const e of t){if(!e.hash||d(e))continue;const t=K.findOne(decodeURI(e.hash),this._element);h(t)&&(this._targetLinks.set(decodeURI(e.hash),e),this._observableSections.set(e.hash,t))}}_process(t){this._activeTarget!==t&&(this._clearActiveClass(this._config.target),this._activeTarget=t,t.classList.add(Bi),this._activateParents(t),j.trigger(this._element,Fi,{relatedTarget:t}))}_activateParents(t){if(t.classList.contains("dropdown-item"))K.findOne(".dropdown-toggle",t.closest(".dropdown")).classList.add(Bi);else for(const e of K.parents(t,".nav, .list-group"))for(const t of K.prev(e,Ri))t.classList.add(Bi)}_clearActiveClass(t){t.classList.remove(Bi);const e=K.find(`${qi}.${Bi}`,t);for(const t of e)t.classList.remove(Bi)}static jQueryInterface(t){return this.each((function(){const e=Qi.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t]()}}))}}j.on(window,Hi,(()=>{for(const t of K.find('[data-bs-spy="scroll"]'))Qi.getOrCreateInstance(t)})),b(Qi);const Xi=".bs.tab",Yi=`hide${Xi}`,Ui=`hidden${Xi}`,Gi=`show${Xi}`,Ji=`shown${Xi}`,Zi=`click${Xi}`,ts=`keydown${Xi}`,es=`load${Xi}`,is="ArrowLeft",ss="ArrowRight",ns="ArrowUp",os="ArrowDown",rs="Home",as="End",ls="active",cs="fade",hs="show",ds=".dropdown-toggle",us=`:not(${ds})`,_s='[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]',gs=`.nav-link${us}, .list-group-item${us}, [role="tab"]${us}, ${_s}`,fs=`.${ls}[data-bs-toggle="tab"], .${ls}[data-bs-toggle="pill"], .${ls}[data-bs-toggle="list"]`;class ms extends W{constructor(t){super(t),this._parent=this._element.closest('.list-group, .nav, [role="tablist"]'),this._parent&&(this._setInitialAttributes(this._parent,this._getChildren()),j.on(this._element,ts,(t=>this._keydown(t))))}static get NAME(){return"tab"}show(){const t=this._element;if(this._elemIsActive(t))return;const e=this._getActiveElem(),i=e?j.trigger(e,Yi,{relatedTarget:t}):null;j.trigger(t,Gi,{relatedTarget:e}).defaultPrevented||i&&i.defaultPrevented||(this._deactivate(e,t),this._activate(t,e))}_activate(t,e){t&&(t.classList.add(ls),this._activate(K.getElementFromSelector(t)),this._queueCallback((()=>{"tab"===t.getAttribute("role")?(t.removeAttribute("tabindex"),t.setAttribute("aria-selected",!0),this._toggleDropDown(t,!0),j.trigger(t,Ji,{relatedTarget:e})):t.classList.add(hs)}),t,t.classList.contains(cs)))}_deactivate(t,e){t&&(t.classList.remove(ls),t.blur(),this._deactivate(K.getElementFromSelector(t)),this._queueCallback((()=>{"tab"===t.getAttribute("role")?(t.setAttribute("aria-selected",!1),t.setAttribute("tabindex","-1"),this._toggleDropDown(t,!1),j.trigger(t,Ui,{relatedTarget:e})):t.classList.remove(hs)}),t,t.classList.contains(cs)))}_keydown(t){if(![is,ss,ns,os,rs,as].includes(t.key))return;t.stopPropagation(),t.preventDefault();const e=this._getChildren().filter((t=>!d(t)));let i;if([rs,as].includes(t.key))i=e[t.key===rs?0:e.length-1];else{const s=[ss,os].includes(t.key);i=w(e,t.target,s,!0)}i&&(i.focus({preventScroll:!0}),ms.getOrCreateInstance(i).show())}_getChildren(){return K.find(gs,this._parent)}_getActiveElem(){return this._getChildren().find((t=>this._elemIsActive(t)))||null}_setInitialAttributes(t,e){this._setAttributeIfNotExists(t,"role","tablist");for(const t of e)this._setInitialAttributesOnChild(t)}_setInitialAttributesOnChild(t){t=this._getInnerElement(t);const e=this._elemIsActive(t),i=this._getOuterElement(t);t.setAttribute("aria-selected",e),i!==t&&this._setAttributeIfNotExists(i,"role","presentation"),e||t.setAttribute("tabindex","-1"),this._setAttributeIfNotExists(t,"role","tab"),this._setInitialAttributesOnTargetPanel(t)}_setInitialAttributesOnTargetPanel(t){const e=K.getElementFromSelector(t);e&&(this._setAttributeIfNotExists(e,"role","tabpanel"),t.id&&this._setAttributeIfNotExists(e,"aria-labelledby",`${t.id}`))}_toggleDropDown(t,e){const i=this._getOuterElement(t);if(!i.classList.contains("dropdown"))return;const s=(t,s)=>{const n=K.findOne(t,i);n&&n.classList.toggle(s,e)};s(ds,ls),s(".dropdown-menu",hs),i.setAttribute("aria-expanded",e)}_setAttributeIfNotExists(t,e,i){t.hasAttribute(e)||t.setAttribute(e,i)}_elemIsActive(t){return t.classList.contains(ls)}_getInnerElement(t){return t.matches(gs)?t:K.findOne(gs,t)}_getOuterElement(t){return t.closest(".nav-item, .list-group-item")||t}static jQueryInterface(t){return this.each((function(){const e=ms.getOrCreateInstance(this);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t]()}}))}}j.on(document,Zi,_s,(function(t){["A","AREA"].includes(this.tagName)&&t.preventDefault(),d(this)||ms.getOrCreateInstance(this).show()})),j.on(window,es,(()=>{for(const t of K.find(fs))ms.getOrCreateInstance(t)})),b(ms);const ps=".bs.toast",bs=`mouseover${ps}`,vs=`mouseout${ps}`,ys=`focusin${ps}`,ws=`focusout${ps}`,As=`hide${ps}`,Es=`hidden${ps}`,Cs=`show${ps}`,Ts=`shown${ps}`,ks="hide",$s="show",Ss="showing",Ls={animation:"boolean",autohide:"boolean",delay:"number"},Os={animation:!0,autohide:!0,delay:5e3};class Is extends W{constructor(t,e){super(t,e),this._timeout=null,this._hasMouseInteraction=!1,this._hasKeyboardInteraction=!1,this._setListeners()}static get Default(){return Os}static get DefaultType(){return Ls}static get NAME(){return"toast"}show(){j.trigger(this._element,Cs).defaultPrevented||(this._clearTimeout(),this._config.animation&&this._element.classList.add("fade"),this._element.classList.remove(ks),g(this._element),this._element.classList.add($s,Ss),this._queueCallback((()=>{this._element.classList.remove(Ss),j.trigger(this._element,Ts),this._maybeScheduleHide()}),this._element,this._config.animation))}hide(){this.isShown()&&(j.trigger(this._element,As).defaultPrevented||(this._element.classList.add(Ss),this._queueCallback((()=>{this._element.classList.add(ks),this._element.classList.remove(Ss,$s),j.trigger(this._element,Es)}),this._element,this._config.animation)))}dispose(){this._clearTimeout(),this.isShown()&&this._element.classList.remove($s),super.dispose()}isShown(){return this._element.classList.contains($s)}_maybeScheduleHide(){this._config.autohide&&(this._hasMouseInteraction||this._hasKeyboardInteraction||(this._timeout=setTimeout((()=>{this.hide()}),this._config.delay)))}_onInteraction(t,e){switch(t.type){case"mouseover":case"mouseout":this._hasMouseInteraction=e;break;case"focusin":case"focusout":this._hasKeyboardInteraction=e}if(e)return void this._clearTimeout();const i=t.relatedTarget;this._element===i||this._element.contains(i)||this._maybeScheduleHide()}_setListeners(){j.on(this._element,bs,(t=>this._onInteraction(t,!0))),j.on(this._element,vs,(t=>this._onInteraction(t,!1))),j.on(this._element,ys,(t=>this._onInteraction(t,!0))),j.on(this._element,ws,(t=>this._onInteraction(t,!1)))}_clearTimeout(){clearTimeout(this._timeout),this._timeout=null}static jQueryInterface(t){return this.each((function(){const e=Is.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}return V(Is),b(Is),{Alert:U,Button:J,Carousel:Ot,Collapse:Rt,Dropdown:fe,Modal:Ue,Offcanvas:gi,Popover:Mi,ScrollSpy:Qi,Tab:ms,Toast:Is,Tooltip:Ni}}));
//# sourceMappingURL=bootstrap.min.js.map
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

!(function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
        ? e(exports, require("jquery"))
        : "function" == typeof define && define.amd
          ? define(["exports", "jquery"], e)
          : e(((t = t || self).bootstrap = {}), t.jQuery);
})(this, function (t, f) {
    "use strict";
    function n(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            (n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                "value" in n && (n.writable = !0),
                Object.defineProperty(t, n.key, n);
        }
    }
    function r(t, e, i) {
        return e && n(t.prototype, e), i && n(t, i), t;
    }
    function l(o) {
        for (var t = 1; t < arguments.length; t++) {
            var s = null != arguments[t] ? arguments[t] : {},
                e = Object.keys(s);
            "function" == typeof Object.getOwnPropertySymbols &&
                (e = e.concat(
                    Object.getOwnPropertySymbols(s).filter(function (t) {
                        return Object.getOwnPropertyDescriptor(s, t).enumerable;
                    }),
                )),
                e.forEach(function (t) {
                    var e, i, n;
                    (e = o),
                        (n = s[(i = t)]),
                        i in e
                            ? Object.defineProperty(e, i, {
                                  value: n,
                                  enumerable: !0,
                                  configurable: !0,
                                  writable: !0,
                              })
                            : (e[i] = n);
                });
        }
        return o;
    }
    f = f && f.hasOwnProperty("default") ? f.default : f;
    var e = "transitionend";
    function i(t) {
        var e = this,
            i = !1;
        return (
            f(this).one(g.TRANSITION_END, function () {
                i = !0;
            }),
            setTimeout(function () {
                i || g.triggerTransitionEnd(e);
            }, t),
            this
        );
    }
    var g = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function (t) {
            for (
                ;
                (t += ~~(1e6 * Math.random())), document.getElementById(t);

            );
            return t;
        },
        getSelectorFromElement: function (t) {
            var e = t.getAttribute("data-target");
            if (!e || "#" === e) {
                var i = t.getAttribute("href");
                e = i && "#" !== i ? i.trim() : "";
            }
            try {
                return document.querySelector(e) ? e : null;
            } catch (t) {
                return null;
            }
        },
        getTransitionDurationFromElement: function (t) {
            if (!t) return 0;
            var e = f(t).css("transition-duration"),
                i = f(t).css("transition-delay"),
                n = parseFloat(e),
                o = parseFloat(i);
            return n || o
                ? ((e = e.split(",")[0]),
                  (i = i.split(",")[0]),
                  1e3 * (parseFloat(e) + parseFloat(i)))
                : 0;
        },
        reflow: function (t) {
            return t.offsetHeight;
        },
        triggerTransitionEnd: function (t) {
            f(t).trigger(e);
        },
        supportsTransitionEnd: function () {
            return Boolean(e);
        },
        isElement: function (t) {
            return (t[0] || t).nodeType;
        },
        typeCheckConfig: function (t, e, i) {
            for (var n in i)
                if (Object.prototype.hasOwnProperty.call(i, n)) {
                    var o = i[n],
                        s = e[n],
                        r =
                            s && g.isElement(s)
                                ? "element"
                                : ((a = s),
                                  {}.toString
                                      .call(a)
                                      .match(/\s([a-z]+)/i)[1]
                                      .toLowerCase());
                    if (!new RegExp(o).test(r))
                        throw new Error(
                            t.toUpperCase() +
                                ': Option "' +
                                n +
                                '" provided type "' +
                                r +
                                '" but expected type "' +
                                o +
                                '".',
                        );
                }
            var a;
        },
        findShadowRoot: function (t) {
            if (!document.documentElement.attachShadow) return null;
            if ("function" != typeof t.getRootNode)
                return t instanceof ShadowRoot
                    ? t
                    : t.parentNode
                      ? g.findShadowRoot(t.parentNode)
                      : null;
            var e = t.getRootNode();
            return e instanceof ShadowRoot ? e : null;
        },
    };
    (f.fn.emulateTransitionEnd = i),
        (f.event.special[g.TRANSITION_END] = {
            bindType: e,
            delegateType: e,
            handle: function (t) {
                if (f(t.target).is(this))
                    return t.handleObj.handler.apply(this, arguments);
            },
        });
    var o = "alert",
        s = "bs.alert",
        a = "." + s,
        c = f.fn[o],
        h = {
            CLOSE: "close" + a,
            CLOSED: "closed" + a,
            CLICK_DATA_API: "click" + a + ".data-api",
        },
        d = "alert",
        u = "fade",
        p = "show",
        m = (function () {
            function n(t) {
                this._element = t;
            }
            var t = n.prototype;
            return (
                (t.close = function (t) {
                    var e = this._element;
                    t && (e = this._getRootElement(t)),
                        this._triggerCloseEvent(e).isDefaultPrevented() ||
                            this._removeElement(e);
                }),
                (t.dispose = function () {
                    f.removeData(this._element, s), (this._element = null);
                }),
                (t._getRootElement = function (t) {
                    var e = g.getSelectorFromElement(t),
                        i = !1;
                    return (
                        e && (i = document.querySelector(e)),
                        (i = i || f(t).closest("." + d)[0])
                    );
                }),
                (t._triggerCloseEvent = function (t) {
                    var e = f.Event(h.CLOSE);
                    return f(t).trigger(e), e;
                }),
                (t._removeElement = function (e) {
                    var i = this;
                    if ((f(e).removeClass(p), f(e).hasClass(u))) {
                        var t = g.getTransitionDurationFromElement(e);
                        f(e)
                            .one(g.TRANSITION_END, function (t) {
                                return i._destroyElement(e, t);
                            })
                            .emulateTransitionEnd(t);
                    } else this._destroyElement(e);
                }),
                (t._destroyElement = function (t) {
                    f(t).detach().trigger(h.CLOSED).remove();
                }),
                (n._jQueryInterface = function (i) {
                    return this.each(function () {
                        var t = f(this),
                            e = t.data(s);
                        e || ((e = new n(this)), t.data(s, e)),
                            "close" === i && e[i](this);
                    });
                }),
                (n._handleDismiss = function (e) {
                    return function (t) {
                        t && t.preventDefault(), e.close(this);
                    };
                }),
                r(n, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                ]),
                n
            );
        })();
    f(document).on(
        h.CLICK_DATA_API,
        '[data-dismiss="alert"]',
        m._handleDismiss(new m()),
    ),
        (f.fn[o] = m._jQueryInterface),
        (f.fn[o].Constructor = m),
        (f.fn[o].noConflict = function () {
            return (f.fn[o] = c), m._jQueryInterface;
        });
    var v = "button",
        y = "bs.button",
        _ = "." + y,
        b = ".data-api",
        w = f.fn[v],
        x = "active",
        S = "btn",
        T = "focus",
        C = '[data-toggle^="button"]',
        k = '[data-toggle="buttons"]',
        E = 'input:not([type="hidden"])',
        $ = ".active",
        I = ".btn",
        A = {
            CLICK_DATA_API: "click" + _ + b,
            FOCUS_BLUR_DATA_API: "focus" + _ + b + " blur" + _ + b,
        },
        O = (function () {
            function i(t) {
                this._element = t;
            }
            var t = i.prototype;
            return (
                (t.toggle = function () {
                    var t = !0,
                        e = !0,
                        i = f(this._element).closest(k)[0];
                    if (i) {
                        var n = this._element.querySelector(E);
                        if (n) {
                            if ("radio" === n.type)
                                if (
                                    n.checked &&
                                    this._element.classList.contains(x)
                                )
                                    t = !1;
                                else {
                                    var o = i.querySelector($);
                                    o && f(o).removeClass(x);
                                }
                            if (t) {
                                if (
                                    n.hasAttribute("disabled") ||
                                    i.hasAttribute("disabled") ||
                                    n.classList.contains("disabled") ||
                                    i.classList.contains("disabled")
                                )
                                    return;
                                (n.checked =
                                    !this._element.classList.contains(x)),
                                    f(n).trigger("change");
                            }
                            n.focus(), (e = !1);
                        }
                    }
                    e &&
                        this._element.setAttribute(
                            "aria-pressed",
                            !this._element.classList.contains(x),
                        ),
                        t && f(this._element).toggleClass(x);
                }),
                (t.dispose = function () {
                    f.removeData(this._element, y), (this._element = null);
                }),
                (i._jQueryInterface = function (e) {
                    return this.each(function () {
                        var t = f(this).data(y);
                        t || ((t = new i(this)), f(this).data(y, t)),
                            "toggle" === e && t[e]();
                    });
                }),
                r(i, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                ]),
                i
            );
        })();
    f(document)
        .on(A.CLICK_DATA_API, C, function (t) {
            t.preventDefault();
            var e = t.target;
            f(e).hasClass(S) || (e = f(e).closest(I)),
                O._jQueryInterface.call(f(e), "toggle");
        })
        .on(A.FOCUS_BLUR_DATA_API, C, function (t) {
            var e = f(t.target).closest(I)[0];
            f(e).toggleClass(T, /^focus(in)?$/.test(t.type));
        }),
        (f.fn[v] = O._jQueryInterface),
        (f.fn[v].Constructor = O),
        (f.fn[v].noConflict = function () {
            return (f.fn[v] = w), O._jQueryInterface;
        });
    var P = "carousel",
        D = "bs.carousel",
        M = "." + D,
        L = ".data-api",
        j = f.fn[P],
        z = {
            interval: 5e3,
            keyboard: !0,
            slide: !1,
            pause: "hover",
            wrap: !0,
            touch: !0,
        },
        F = {
            interval: "(number|boolean)",
            keyboard: "boolean",
            slide: "(boolean|string)",
            pause: "(string|boolean)",
            wrap: "boolean",
            touch: "boolean",
        },
        H = "next",
        N = "prev",
        R = "left",
        W = "right",
        q = {
            SLIDE: "slide" + M,
            SLID: "slid" + M,
            KEYDOWN: "keydown" + M,
            MOUSEENTER: "mouseenter" + M,
            MOUSELEAVE: "mouseleave" + M,
            TOUCHSTART: "touchstart" + M,
            TOUCHMOVE: "touchmove" + M,
            TOUCHEND: "touchend" + M,
            POINTERDOWN: "pointerdown" + M,
            POINTERUP: "pointerup" + M,
            DRAG_START: "dragstart" + M,
            LOAD_DATA_API: "load" + M + L,
            CLICK_DATA_API: "click" + M + L,
        },
        B = "carousel",
        U = "active",
        Q = "slide",
        Y = "carousel-item-right",
        X = "carousel-item-left",
        V = "carousel-item-next",
        K = "carousel-item-prev",
        G = "pointer-event",
        Z = ".active",
        J = ".active.carousel-item",
        tt = ".carousel-item",
        et = ".carousel-item img",
        it = ".carousel-item-next, .carousel-item-prev",
        nt = ".carousel-indicators",
        ot = "[data-slide], [data-slide-to]",
        st = '[data-ride="carousel"]',
        rt = { TOUCH: "touch", PEN: "pen" },
        at = (function () {
            function s(t, e) {
                (this._items = null),
                    (this._interval = null),
                    (this._activeElement = null),
                    (this._isPaused = !1),
                    (this._isSliding = !1),
                    (this.touchTimeout = null),
                    (this.touchStartX = 0),
                    (this.touchDeltaX = 0),
                    (this._config = this._getConfig(e)),
                    (this._element = t),
                    (this._indicatorsElement = this._element.querySelector(nt)),
                    (this._touchSupported =
                        "ontouchstart" in document.documentElement ||
                        0 < navigator.maxTouchPoints),
                    (this._pointerEvent = Boolean(
                        window.PointerEvent || window.MSPointerEvent,
                    )),
                    this._addEventListeners();
            }
            var t = s.prototype;
            return (
                (t.next = function () {
                    this._isSliding || this._slide(H);
                }),
                (t.nextWhenVisible = function () {
                    !document.hidden &&
                        f(this._element).is(":visible") &&
                        "hidden" !== f(this._element).css("visibility") &&
                        this.next();
                }),
                (t.prev = function () {
                    this._isSliding || this._slide(N);
                }),
                (t.pause = function (t) {
                    t || (this._isPaused = !0),
                        this._element.querySelector(it) &&
                            (g.triggerTransitionEnd(this._element),
                            this.cycle(!0)),
                        clearInterval(this._interval),
                        (this._interval = null);
                }),
                (t.cycle = function (t) {
                    t || (this._isPaused = !1),
                        this._interval &&
                            (clearInterval(this._interval),
                            (this._interval = null)),
                        this._config.interval &&
                            !this._isPaused &&
                            (this._interval = setInterval(
                                (document.visibilityState
                                    ? this.nextWhenVisible
                                    : this.next
                                ).bind(this),
                                this._config.interval,
                            ));
                }),
                (t.to = function (t) {
                    var e = this;
                    this._activeElement = this._element.querySelector(J);
                    var i = this._getItemIndex(this._activeElement);
                    if (!(t > this._items.length - 1 || t < 0))
                        if (this._isSliding)
                            f(this._element).one(q.SLID, function () {
                                return e.to(t);
                            });
                        else {
                            if (i === t) return this.pause(), void this.cycle();
                            var n = i < t ? H : N;
                            this._slide(n, this._items[t]);
                        }
                }),
                (t.dispose = function () {
                    f(this._element).off(M),
                        f.removeData(this._element, D),
                        (this._items = null),
                        (this._config = null),
                        (this._element = null),
                        (this._interval = null),
                        (this._isPaused = null),
                        (this._isSliding = null),
                        (this._activeElement = null),
                        (this._indicatorsElement = null);
                }),
                (t._getConfig = function (t) {
                    return (t = l({}, z, t)), g.typeCheckConfig(P, t, F), t;
                }),
                (t._handleSwipe = function () {
                    var t = Math.abs(this.touchDeltaX);
                    if (!(t <= 40)) {
                        var e = t / this.touchDeltaX;
                        0 < e && this.prev(), e < 0 && this.next();
                    }
                }),
                (t._addEventListeners = function () {
                    var e = this;
                    this._config.keyboard &&
                        f(this._element).on(q.KEYDOWN, function (t) {
                            return e._keydown(t);
                        }),
                        "hover" === this._config.pause &&
                            f(this._element)
                                .on(q.MOUSEENTER, function (t) {
                                    return e.pause(t);
                                })
                                .on(q.MOUSELEAVE, function (t) {
                                    return e.cycle(t);
                                }),
                        this._config.touch && this._addTouchEventListeners();
                }),
                (t._addTouchEventListeners = function () {
                    var i = this;
                    if (this._touchSupported) {
                        var e = function (t) {
                                i._pointerEvent &&
                                rt[t.originalEvent.pointerType.toUpperCase()]
                                    ? (i.touchStartX = t.originalEvent.clientX)
                                    : i._pointerEvent ||
                                      (i.touchStartX =
                                          t.originalEvent.touches[0].clientX);
                            },
                            n = function (t) {
                                i._pointerEvent &&
                                    rt[
                                        t.originalEvent.pointerType.toUpperCase()
                                    ] &&
                                    (i.touchDeltaX =
                                        t.originalEvent.clientX -
                                        i.touchStartX),
                                    i._handleSwipe(),
                                    "hover" === i._config.pause &&
                                        (i.pause(),
                                        i.touchTimeout &&
                                            clearTimeout(i.touchTimeout),
                                        (i.touchTimeout = setTimeout(function (
                                            t,
                                        ) {
                                            return i.cycle(t);
                                        }, 500 + i._config.interval)));
                            };
                        f(this._element.querySelectorAll(et)).on(
                            q.DRAG_START,
                            function (t) {
                                return t.preventDefault();
                            },
                        ),
                            this._pointerEvent
                                ? (f(this._element).on(
                                      q.POINTERDOWN,
                                      function (t) {
                                          return e(t);
                                      },
                                  ),
                                  f(this._element).on(
                                      q.POINTERUP,
                                      function (t) {
                                          return n(t);
                                      },
                                  ),
                                  this._element.classList.add(G))
                                : (f(this._element).on(
                                      q.TOUCHSTART,
                                      function (t) {
                                          return e(t);
                                      },
                                  ),
                                  f(this._element).on(
                                      q.TOUCHMOVE,
                                      function (t) {
                                          var e;
                                          (e = t).originalEvent.touches &&
                                          1 < e.originalEvent.touches.length
                                              ? (i.touchDeltaX = 0)
                                              : (i.touchDeltaX =
                                                    e.originalEvent.touches[0]
                                                        .clientX -
                                                    i.touchStartX);
                                      },
                                  ),
                                  f(this._element).on(q.TOUCHEND, function (t) {
                                      return n(t);
                                  }));
                    }
                }),
                (t._keydown = function (t) {
                    if (!/input|textarea/i.test(t.target.tagName))
                        switch (t.which) {
                            case 37:
                                t.preventDefault(), this.prev();
                                break;
                            case 39:
                                t.preventDefault(), this.next();
                        }
                }),
                (t._getItemIndex = function (t) {
                    return (
                        (this._items =
                            t && t.parentNode
                                ? [].slice.call(
                                      t.parentNode.querySelectorAll(tt),
                                  )
                                : []),
                        this._items.indexOf(t)
                    );
                }),
                (t._getItemByDirection = function (t, e) {
                    var i = t === H,
                        n = t === N,
                        o = this._getItemIndex(e),
                        s = this._items.length - 1;
                    if (
                        ((n && 0 === o) || (i && o === s)) &&
                        !this._config.wrap
                    )
                        return e;
                    var r = (o + (t === N ? -1 : 1)) % this._items.length;
                    return -1 == r
                        ? this._items[this._items.length - 1]
                        : this._items[r];
                }),
                (t._triggerSlideEvent = function (t, e) {
                    var i = this._getItemIndex(t),
                        n = this._getItemIndex(this._element.querySelector(J)),
                        o = f.Event(q.SLIDE, {
                            relatedTarget: t,
                            direction: e,
                            from: n,
                            to: i,
                        });
                    return f(this._element).trigger(o), o;
                }),
                (t._setActiveIndicatorElement = function (t) {
                    if (this._indicatorsElement) {
                        var e = [].slice.call(
                            this._indicatorsElement.querySelectorAll(Z),
                        );
                        f(e).removeClass(U);
                        var i =
                            this._indicatorsElement.children[
                                this._getItemIndex(t)
                            ];
                        i && f(i).addClass(U);
                    }
                }),
                (t._slide = function (t, e) {
                    var i,
                        n,
                        o,
                        s = this,
                        r = this._element.querySelector(J),
                        a = this._getItemIndex(r),
                        l = e || (r && this._getItemByDirection(t, r)),
                        c = this._getItemIndex(l),
                        h = Boolean(this._interval);
                    if (
                        ((o =
                            t === H
                                ? ((i = X), (n = V), R)
                                : ((i = Y), (n = K), W)),
                        l && f(l).hasClass(U))
                    )
                        this._isSliding = !1;
                    else if (
                        !this._triggerSlideEvent(l, o).isDefaultPrevented() &&
                        r &&
                        l
                    ) {
                        (this._isSliding = !0),
                            h && this.pause(),
                            this._setActiveIndicatorElement(l);
                        var d = f.Event(q.SLID, {
                            relatedTarget: l,
                            direction: o,
                            from: a,
                            to: c,
                        });
                        if (f(this._element).hasClass(Q)) {
                            f(l).addClass(n),
                                g.reflow(l),
                                f(r).addClass(i),
                                f(l).addClass(i);
                            var u = parseInt(
                                l.getAttribute("data-interval"),
                                10,
                            );
                            u
                                ? ((this._config.defaultInterval =
                                      this._config.defaultInterval ||
                                      this._config.interval),
                                  (this._config.interval = u))
                                : (this._config.interval =
                                      this._config.defaultInterval ||
                                      this._config.interval);
                            var p = g.getTransitionDurationFromElement(r);
                            f(r)
                                .one(g.TRANSITION_END, function () {
                                    f(l)
                                        .removeClass(i + " " + n)
                                        .addClass(U),
                                        f(r).removeClass(U + " " + n + " " + i),
                                        (s._isSliding = !1),
                                        setTimeout(function () {
                                            return f(s._element).trigger(d);
                                        }, 0);
                                })
                                .emulateTransitionEnd(p);
                        } else
                            f(r).removeClass(U),
                                f(l).addClass(U),
                                (this._isSliding = !1),
                                f(this._element).trigger(d);
                        h && this.cycle();
                    }
                }),
                (s._jQueryInterface = function (n) {
                    return this.each(function () {
                        var t = f(this).data(D),
                            e = l({}, z, f(this).data());
                        "object" == typeof n && (e = l({}, e, n));
                        var i = "string" == typeof n ? n : e.slide;
                        if (
                            (t || ((t = new s(this, e)), f(this).data(D, t)),
                            "number" == typeof n)
                        )
                            t.to(n);
                        else if ("string" == typeof i) {
                            if (void 0 === t[i])
                                throw new TypeError(
                                    'No method named "' + i + '"',
                                );
                            t[i]();
                        } else e.interval && e.ride && (t.pause(), t.cycle());
                    });
                }),
                (s._dataApiClickHandler = function (t) {
                    var e = g.getSelectorFromElement(this);
                    if (e) {
                        var i = f(e)[0];
                        if (i && f(i).hasClass(B)) {
                            var n = l({}, f(i).data(), f(this).data()),
                                o = this.getAttribute("data-slide-to");
                            o && (n.interval = !1),
                                s._jQueryInterface.call(f(i), n),
                                o && f(i).data(D).to(o),
                                t.preventDefault();
                        }
                    }
                }),
                r(s, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                    {
                        key: "Default",
                        get: function () {
                            return z;
                        },
                    },
                ]),
                s
            );
        })();
    f(document).on(q.CLICK_DATA_API, ot, at._dataApiClickHandler),
        f(window).on(q.LOAD_DATA_API, function () {
            for (
                var t = [].slice.call(document.querySelectorAll(st)),
                    e = 0,
                    i = t.length;
                e < i;
                e++
            ) {
                var n = f(t[e]);
                at._jQueryInterface.call(n, n.data());
            }
        }),
        (f.fn[P] = at._jQueryInterface),
        (f.fn[P].Constructor = at),
        (f.fn[P].noConflict = function () {
            return (f.fn[P] = j), at._jQueryInterface;
        });
    var lt = "collapse",
        ct = "bs.collapse",
        ht = "." + ct,
        dt = f.fn[lt],
        ut = { toggle: !0, parent: "" },
        pt = { toggle: "boolean", parent: "(string|element)" },
        ft = {
            SHOW: "show" + ht,
            SHOWN: "shown" + ht,
            HIDE: "hide" + ht,
            HIDDEN: "hidden" + ht,
            CLICK_DATA_API: "click" + ht + ".data-api",
        },
        gt = "show",
        mt = "collapse",
        vt = "collapsing",
        yt = "collapsed",
        _t = "width",
        bt = "height",
        wt = ".show, .collapsing",
        xt = '[data-toggle="collapse"]',
        St = (function () {
            function a(e, t) {
                (this._isTransitioning = !1),
                    (this._element = e),
                    (this._config = this._getConfig(t)),
                    (this._triggerArray = [].slice.call(
                        document.querySelectorAll(
                            '[data-toggle="collapse"][href="#' +
                                e.id +
                                '"],[data-toggle="collapse"][data-target="#' +
                                e.id +
                                '"]',
                        ),
                    ));
                for (
                    var i = [].slice.call(document.querySelectorAll(xt)),
                        n = 0,
                        o = i.length;
                    n < o;
                    n++
                ) {
                    var s = i[n],
                        r = g.getSelectorFromElement(s),
                        a = [].slice
                            .call(document.querySelectorAll(r))
                            .filter(function (t) {
                                return t === e;
                            });
                    null !== r &&
                        0 < a.length &&
                        ((this._selector = r), this._triggerArray.push(s));
                }
                (this._parent = this._config.parent ? this._getParent() : null),
                    this._config.parent ||
                        this._addAriaAndCollapsedClass(
                            this._element,
                            this._triggerArray,
                        ),
                    this._config.toggle && this.toggle();
            }
            var t = a.prototype;
            return (
                (t.toggle = function () {
                    f(this._element).hasClass(gt) ? this.hide() : this.show();
                }),
                (t.show = function () {
                    var t,
                        e,
                        i = this;
                    if (
                        !this._isTransitioning &&
                        !f(this._element).hasClass(gt) &&
                        (this._parent &&
                            0 ===
                                (t = [].slice
                                    .call(this._parent.querySelectorAll(wt))
                                    .filter(function (t) {
                                        return "string" ==
                                            typeof i._config.parent
                                            ? t.getAttribute("data-parent") ===
                                                  i._config.parent
                                            : t.classList.contains(mt);
                                    })).length &&
                            (t = null),
                        !(
                            t &&
                            (e = f(t).not(this._selector).data(ct)) &&
                            e._isTransitioning
                        ))
                    ) {
                        var n = f.Event(ft.SHOW);
                        if (
                            (f(this._element).trigger(n),
                            !n.isDefaultPrevented())
                        ) {
                            t &&
                                (a._jQueryInterface.call(
                                    f(t).not(this._selector),
                                    "hide",
                                ),
                                e || f(t).data(ct, null));
                            var o = this._getDimension();
                            f(this._element).removeClass(mt).addClass(vt),
                                (this._element.style[o] = 0),
                                this._triggerArray.length &&
                                    f(this._triggerArray)
                                        .removeClass(yt)
                                        .attr("aria-expanded", !0),
                                this.setTransitioning(!0);
                            var s =
                                    "scroll" +
                                    (o[0].toUpperCase() + o.slice(1)),
                                r = g.getTransitionDurationFromElement(
                                    this._element,
                                );
                            f(this._element)
                                .one(g.TRANSITION_END, function () {
                                    f(i._element)
                                        .removeClass(vt)
                                        .addClass(mt)
                                        .addClass(gt),
                                        (i._element.style[o] = ""),
                                        i.setTransitioning(!1),
                                        f(i._element).trigger(ft.SHOWN);
                                })
                                .emulateTransitionEnd(r),
                                (this._element.style[o] =
                                    this._element[s] + "px");
                        }
                    }
                }),
                (t.hide = function () {
                    var t = this;
                    if (
                        !this._isTransitioning &&
                        f(this._element).hasClass(gt)
                    ) {
                        var e = f.Event(ft.HIDE);
                        if (
                            (f(this._element).trigger(e),
                            !e.isDefaultPrevented())
                        ) {
                            var i = this._getDimension();
                            (this._element.style[i] =
                                this._element.getBoundingClientRect()[i] +
                                "px"),
                                g.reflow(this._element),
                                f(this._element)
                                    .addClass(vt)
                                    .removeClass(mt)
                                    .removeClass(gt);
                            var n = this._triggerArray.length;
                            if (0 < n)
                                for (var o = 0; o < n; o++) {
                                    var s = this._triggerArray[o],
                                        r = g.getSelectorFromElement(s);
                                    if (null !== r)
                                        f(
                                            [].slice.call(
                                                document.querySelectorAll(r),
                                            ),
                                        ).hasClass(gt) ||
                                            f(s)
                                                .addClass(yt)
                                                .attr("aria-expanded", !1);
                                }
                            this.setTransitioning(!0);
                            this._element.style[i] = "";
                            var a = g.getTransitionDurationFromElement(
                                this._element,
                            );
                            f(this._element)
                                .one(g.TRANSITION_END, function () {
                                    t.setTransitioning(!1),
                                        f(t._element)
                                            .removeClass(vt)
                                            .addClass(mt)
                                            .trigger(ft.HIDDEN);
                                })
                                .emulateTransitionEnd(a);
                        }
                    }
                }),
                (t.setTransitioning = function (t) {
                    this._isTransitioning = t;
                }),
                (t.dispose = function () {
                    f.removeData(this._element, ct),
                        (this._config = null),
                        (this._parent = null),
                        (this._element = null),
                        (this._triggerArray = null),
                        (this._isTransitioning = null);
                }),
                (t._getConfig = function (t) {
                    return (
                        ((t = l({}, ut, t)).toggle = Boolean(t.toggle)),
                        g.typeCheckConfig(lt, t, pt),
                        t
                    );
                }),
                (t._getDimension = function () {
                    return f(this._element).hasClass(_t) ? _t : bt;
                }),
                (t._getParent = function () {
                    var t,
                        i = this;
                    g.isElement(this._config.parent)
                        ? ((t = this._config.parent),
                          void 0 !== this._config.parent.jquery &&
                              (t = this._config.parent[0]))
                        : (t = document.querySelector(this._config.parent));
                    var e =
                            '[data-toggle="collapse"][data-parent="' +
                            this._config.parent +
                            '"]',
                        n = [].slice.call(t.querySelectorAll(e));
                    return (
                        f(n).each(function (t, e) {
                            i._addAriaAndCollapsedClass(
                                a._getTargetFromElement(e),
                                [e],
                            );
                        }),
                        t
                    );
                }),
                (t._addAriaAndCollapsedClass = function (t, e) {
                    var i = f(t).hasClass(gt);
                    e.length &&
                        f(e).toggleClass(yt, !i).attr("aria-expanded", i);
                }),
                (a._getTargetFromElement = function (t) {
                    var e = g.getSelectorFromElement(t);
                    return e ? document.querySelector(e) : null;
                }),
                (a._jQueryInterface = function (n) {
                    return this.each(function () {
                        var t = f(this),
                            e = t.data(ct),
                            i = l(
                                {},
                                ut,
                                t.data(),
                                "object" == typeof n && n ? n : {},
                            );
                        if (
                            (!e &&
                                i.toggle &&
                                /show|hide/.test(n) &&
                                (i.toggle = !1),
                            e || ((e = new a(this, i)), t.data(ct, e)),
                            "string" == typeof n)
                        ) {
                            if (void 0 === e[n])
                                throw new TypeError(
                                    'No method named "' + n + '"',
                                );
                            e[n]();
                        }
                    });
                }),
                r(a, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                    {
                        key: "Default",
                        get: function () {
                            return ut;
                        },
                    },
                ]),
                a
            );
        })();
    f(document).on(ft.CLICK_DATA_API, xt, function (t) {
        "A" === t.currentTarget.tagName && t.preventDefault();
        var i = f(this),
            e = g.getSelectorFromElement(this),
            n = [].slice.call(document.querySelectorAll(e));
        f(n).each(function () {
            var t = f(this),
                e = t.data(ct) ? "toggle" : i.data();
            St._jQueryInterface.call(t, e);
        });
    }),
        (f.fn[lt] = St._jQueryInterface),
        (f.fn[lt].Constructor = St),
        (f.fn[lt].noConflict = function () {
            return (f.fn[lt] = dt), St._jQueryInterface;
        });
    for (
        var Tt = "undefined" != typeof window && "undefined" != typeof document,
            Ct = ["Edge", "Trident", "Firefox"],
            kt = 0,
            Et = 0;
        Et < Ct.length;
        Et += 1
    )
        if (Tt && 0 <= navigator.userAgent.indexOf(Ct[Et])) {
            kt = 1;
            break;
        }
    var $t =
        Tt && window.Promise
            ? function (t) {
                  var e = !1;
                  return function () {
                      e ||
                          ((e = !0),
                          window.Promise.resolve().then(function () {
                              (e = !1), t();
                          }));
                  };
              }
            : function (t) {
                  var e = !1;
                  return function () {
                      e ||
                          ((e = !0),
                          setTimeout(function () {
                              (e = !1), t();
                          }, kt));
                  };
              };
    function It(t) {
        return t && "[object Function]" === {}.toString.call(t);
    }
    function At(t, e) {
        if (1 !== t.nodeType) return [];
        var i = t.ownerDocument.defaultView.getComputedStyle(t, null);
        return e ? i[e] : i;
    }
    function Ot(t) {
        return "HTML" === t.nodeName ? t : t.parentNode || t.host;
    }
    function Pt(t) {
        if (!t) return document.body;
        switch (t.nodeName) {
            case "HTML":
            case "BODY":
                return t.ownerDocument.body;
            case "#document":
                return t.body;
        }
        var e = At(t),
            i = e.overflow,
            n = e.overflowX,
            o = e.overflowY;
        return /(auto|scroll|overlay)/.test(i + o + n) ? t : Pt(Ot(t));
    }
    var Dt = Tt && !(!window.MSInputMethodContext || !document.documentMode),
        Mt = Tt && /MSIE 10/.test(navigator.userAgent);
    function Lt(t) {
        return 11 === t ? Dt : (10 !== t && Dt) || Mt;
    }
    function jt(t) {
        if (!t) return document.documentElement;
        for (
            var e = Lt(10) ? document.body : null, i = t.offsetParent || null;
            i === e && t.nextElementSibling;

        )
            i = (t = t.nextElementSibling).offsetParent;
        var n = i && i.nodeName;
        return n && "BODY" !== n && "HTML" !== n
            ? -1 !== ["TH", "TD", "TABLE"].indexOf(i.nodeName) &&
              "static" === At(i, "position")
                ? jt(i)
                : i
            : t
              ? t.ownerDocument.documentElement
              : document.documentElement;
    }
    function zt(t) {
        return null !== t.parentNode ? zt(t.parentNode) : t;
    }
    function Ft(t, e) {
        if (!(t && t.nodeType && e && e.nodeType))
            return document.documentElement;
        var i = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING,
            n = i ? t : e,
            o = i ? e : t,
            s = document.createRange();
        s.setStart(n, 0), s.setEnd(o, 0);
        var r,
            a,
            l = s.commonAncestorContainer;
        if ((t !== l && e !== l) || n.contains(o))
            return "BODY" === (a = (r = l).nodeName) ||
                ("HTML" !== a && jt(r.firstElementChild) !== r)
                ? jt(l)
                : l;
        var c = zt(t);
        return c.host ? Ft(c.host, e) : Ft(t, zt(e).host);
    }
    function Ht(t, e) {
        var i =
                "top" === (1 < arguments.length && void 0 !== e ? e : "top")
                    ? "scrollTop"
                    : "scrollLeft",
            n = t.nodeName;
        if ("BODY" !== n && "HTML" !== n) return t[i];
        var o = t.ownerDocument.documentElement;
        return (t.ownerDocument.scrollingElement || o)[i];
    }
    function Nt(t, e) {
        var i = "x" === e ? "Left" : "Top",
            n = "Left" == i ? "Right" : "Bottom";
        return (
            parseFloat(t["border" + i + "Width"], 10) +
            parseFloat(t["border" + n + "Width"], 10)
        );
    }
    function Rt(t, e, i, n) {
        return Math.max(
            e["offset" + t],
            e["scroll" + t],
            i["client" + t],
            i["offset" + t],
            i["scroll" + t],
            Lt(10)
                ? parseInt(i["offset" + t]) +
                      parseInt(
                          n["margin" + ("Height" === t ? "Top" : "Left")],
                      ) +
                      parseInt(
                          n["margin" + ("Height" === t ? "Bottom" : "Right")],
                      )
                : 0,
        );
    }
    function Wt(t) {
        var e = t.body,
            i = t.documentElement,
            n = Lt(10) && getComputedStyle(i);
        return { height: Rt("Height", e, i, n), width: Rt("Width", e, i, n) };
    }
    var qt = function (t, e, i) {
        return e && Bt(t.prototype, e), i && Bt(t, i), t;
    };
    function Bt(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            (n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                "value" in n && (n.writable = !0),
                Object.defineProperty(t, n.key, n);
        }
    }
    function Ut(t, e, i) {
        return (
            e in t
                ? Object.defineProperty(t, e, {
                      value: i,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                  })
                : (t[e] = i),
            t
        );
    }
    var Qt =
        Object.assign ||
        function (t) {
            for (var e = 1; e < arguments.length; e++) {
                var i = arguments[e];
                for (var n in i)
                    Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
            }
            return t;
        };
    function Yt(t) {
        return Qt({}, t, { right: t.left + t.width, bottom: t.top + t.height });
    }
    function Xt(t) {
        var e = {};
        try {
            if (Lt(10)) {
                e = t.getBoundingClientRect();
                var i = Ht(t, "top"),
                    n = Ht(t, "left");
                (e.top += i), (e.left += n), (e.bottom += i), (e.right += n);
            } else e = t.getBoundingClientRect();
        } catch (t) {}
        var o = {
                left: e.left,
                top: e.top,
                width: e.right - e.left,
                height: e.bottom - e.top,
            },
            s = "HTML" === t.nodeName ? Wt(t.ownerDocument) : {},
            r = s.width || t.clientWidth || o.right - o.left,
            a = s.height || t.clientHeight || o.bottom - o.top,
            l = t.offsetWidth - r,
            c = t.offsetHeight - a;
        if (l || c) {
            var h = At(t);
            (l -= Nt(h, "x")),
                (c -= Nt(h, "y")),
                (o.width -= l),
                (o.height -= c);
        }
        return Yt(o);
    }
    function Vt(t, e, i) {
        var n = 2 < arguments.length && void 0 !== i && i,
            o = Lt(10),
            s = "HTML" === e.nodeName,
            r = Xt(t),
            a = Xt(e),
            l = Pt(t),
            c = At(e),
            h = parseFloat(c.borderTopWidth, 10),
            d = parseFloat(c.borderLeftWidth, 10);
        n &&
            s &&
            ((a.top = Math.max(a.top, 0)), (a.left = Math.max(a.left, 0)));
        var u = Yt({
            top: r.top - a.top - h,
            left: r.left - a.left - d,
            width: r.width,
            height: r.height,
        });
        if (((u.marginTop = 0), (u.marginLeft = 0), !o && s)) {
            var p = parseFloat(c.marginTop, 10),
                f = parseFloat(c.marginLeft, 10);
            (u.top -= h - p),
                (u.bottom -= h - p),
                (u.left -= d - f),
                (u.right -= d - f),
                (u.marginTop = p),
                (u.marginLeft = f);
        }
        return (
            (o && !n ? e.contains(l) : e === l && "BODY" !== l.nodeName) &&
                (u = (function (t, e, i) {
                    var n = 2 < arguments.length && void 0 !== i && i,
                        o = Ht(e, "top"),
                        s = Ht(e, "left"),
                        r = n ? -1 : 1;
                    return (
                        (t.top += o * r),
                        (t.bottom += o * r),
                        (t.left += s * r),
                        (t.right += s * r),
                        t
                    );
                })(u, e)),
            u
        );
    }
    function Kt(t) {
        if (!t || !t.parentElement || Lt()) return document.documentElement;
        for (var e = t.parentElement; e && "none" === At(e, "transform"); )
            e = e.parentElement;
        return e || document.documentElement;
    }
    function Gt(t, e, i, n, o) {
        var s = 4 < arguments.length && void 0 !== o && o,
            r = { top: 0, left: 0 },
            a = s ? Kt(t) : Ft(t, e);
        if ("viewport" === n)
            r = (function (t, e) {
                var i = 1 < arguments.length && void 0 !== e && e,
                    n = t.ownerDocument.documentElement,
                    o = Vt(t, n),
                    s = Math.max(n.clientWidth, window.innerWidth || 0),
                    r = Math.max(n.clientHeight, window.innerHeight || 0),
                    a = i ? 0 : Ht(n),
                    l = i ? 0 : Ht(n, "left");
                return Yt({
                    top: a - o.top + o.marginTop,
                    left: l - o.left + o.marginLeft,
                    width: s,
                    height: r,
                });
            })(a, s);
        else {
            var l = void 0;
            "scrollParent" === n
                ? "BODY" === (l = Pt(Ot(e))).nodeName &&
                  (l = t.ownerDocument.documentElement)
                : (l = "window" === n ? t.ownerDocument.documentElement : n);
            var c = Vt(l, a, s);
            if (
                "HTML" !== l.nodeName ||
                (function t(e) {
                    var i = e.nodeName;
                    if ("BODY" === i || "HTML" === i) return !1;
                    if ("fixed" === At(e, "position")) return !0;
                    var n = Ot(e);
                    return !!n && t(n);
                })(a)
            )
                r = c;
            else {
                var h = Wt(t.ownerDocument),
                    d = h.height,
                    u = h.width;
                (r.top += c.top - c.marginTop),
                    (r.bottom = d + c.top),
                    (r.left += c.left - c.marginLeft),
                    (r.right = u + c.left);
            }
        }
        var p = "number" == typeof (i = i || 0);
        return (
            (r.left += p ? i : i.left || 0),
            (r.top += p ? i : i.top || 0),
            (r.right -= p ? i : i.right || 0),
            (r.bottom -= p ? i : i.bottom || 0),
            r
        );
    }
    function Zt(t, e, n, i, o, s) {
        var r = 5 < arguments.length && void 0 !== s ? s : 0;
        if (-1 === t.indexOf("auto")) return t;
        var a = Gt(n, i, r, o),
            l = {
                top: { width: a.width, height: e.top - a.top },
                right: { width: a.right - e.right, height: a.height },
                bottom: { width: a.width, height: a.bottom - e.bottom },
                left: { width: e.left - a.left, height: a.height },
            },
            c = Object.keys(l)
                .map(function (t) {
                    return Qt({ key: t }, l[t], {
                        area: (e = l[t]).width * e.height,
                    });
                    var e;
                })
                .sort(function (t, e) {
                    return e.area - t.area;
                }),
            h = c.filter(function (t) {
                var e = t.width,
                    i = t.height;
                return e >= n.clientWidth && i >= n.clientHeight;
            }),
            d = 0 < h.length ? h[0].key : c[0].key,
            u = t.split("-")[1];
        return d + (u ? "-" + u : "");
    }
    function Jt(t, e, i, n) {
        var o = 3 < arguments.length && void 0 !== n ? n : null;
        return Vt(i, o ? Kt(e) : Ft(e, i), o);
    }
    function te(t) {
        var e = t.ownerDocument.defaultView.getComputedStyle(t),
            i = parseFloat(e.marginTop || 0) + parseFloat(e.marginBottom || 0),
            n = parseFloat(e.marginLeft || 0) + parseFloat(e.marginRight || 0);
        return { width: t.offsetWidth + n, height: t.offsetHeight + i };
    }
    function ee(t) {
        var e = { left: "right", right: "left", bottom: "top", top: "bottom" };
        return t.replace(/left|right|bottom|top/g, function (t) {
            return e[t];
        });
    }
    function ie(t, e, i) {
        i = i.split("-")[0];
        var n = te(t),
            o = { width: n.width, height: n.height },
            s = -1 !== ["right", "left"].indexOf(i),
            r = s ? "top" : "left",
            a = s ? "left" : "top",
            l = s ? "height" : "width",
            c = s ? "width" : "height";
        return (
            (o[r] = e[r] + e[l] / 2 - n[l] / 2),
            (o[a] = i === a ? e[a] - n[c] : e[ee(a)]),
            o
        );
    }
    function ne(t, e) {
        return Array.prototype.find ? t.find(e) : t.filter(e)[0];
    }
    function oe(t, i, e) {
        return (
            (void 0 === e
                ? t
                : t.slice(
                      0,
                      (function (t, e, i) {
                          if (Array.prototype.findIndex)
                              return t.findIndex(function (t) {
                                  return t[e] === i;
                              });
                          var n = ne(t, function (t) {
                              return t[e] === i;
                          });
                          return t.indexOf(n);
                      })(t, "name", e),
                  )
            ).forEach(function (t) {
                t.function &&
                    console.warn(
                        "`modifier.function` is deprecated, use `modifier.fn`!",
                    );
                var e = t.function || t.fn;
                t.enabled &&
                    It(e) &&
                    ((i.offsets.popper = Yt(i.offsets.popper)),
                    (i.offsets.reference = Yt(i.offsets.reference)),
                    (i = e(i, t)));
            }),
            i
        );
    }
    function se(t, i) {
        return t.some(function (t) {
            var e = t.name;
            return t.enabled && e === i;
        });
    }
    function re(t) {
        for (
            var e = [!1, "ms", "Webkit", "Moz", "O"],
                i = t.charAt(0).toUpperCase() + t.slice(1),
                n = 0;
            n < e.length;
            n++
        ) {
            var o = e[n],
                s = o ? "" + o + i : t;
            if (void 0 !== document.body.style[s]) return s;
        }
        return null;
    }
    function ae(t) {
        var e = t.ownerDocument;
        return e ? e.defaultView : window;
    }
    function le(t, e, i, n) {
        (i.updateBound = n),
            ae(t).addEventListener("resize", i.updateBound, { passive: !0 });
        var o = Pt(t);
        return (
            (function t(e, i, n, o) {
                var s = "BODY" === e.nodeName,
                    r = s ? e.ownerDocument.defaultView : e;
                r.addEventListener(i, n, { passive: !0 }),
                    s || t(Pt(r.parentNode), i, n, o),
                    o.push(r);
            })(o, "scroll", i.updateBound, i.scrollParents),
            (i.scrollElement = o),
            (i.eventsEnabled = !0),
            i
        );
    }
    function ce() {
        var t, e;
        this.state.eventsEnabled &&
            (cancelAnimationFrame(this.scheduleUpdate),
            (this.state =
                ((t = this.reference),
                (e = this.state),
                ae(t).removeEventListener("resize", e.updateBound),
                e.scrollParents.forEach(function (t) {
                    t.removeEventListener("scroll", e.updateBound);
                }),
                (e.updateBound = null),
                (e.scrollParents = []),
                (e.scrollElement = null),
                (e.eventsEnabled = !1),
                e)));
    }
    function he(t) {
        return "" !== t && !isNaN(parseFloat(t)) && isFinite(t);
    }
    function de(i, n) {
        Object.keys(n).forEach(function (t) {
            var e = "";
            -1 !==
                ["width", "height", "top", "right", "bottom", "left"].indexOf(
                    t,
                ) &&
                he(n[t]) &&
                (e = "px"),
                (i.style[t] = n[t] + e);
        });
    }
    function ue(t, e) {
        function i(t) {
            return t;
        }
        var n = t.offsets,
            o = n.popper,
            s = n.reference,
            r = Math.round,
            a = Math.floor,
            l = r(s.width),
            c = r(o.width),
            h = -1 !== ["left", "right"].indexOf(t.placement),
            d = -1 !== t.placement.indexOf("-"),
            u = e ? (h || d || l % 2 == c % 2 ? r : a) : i,
            p = e ? r : i;
        return {
            left: u(l % 2 == 1 && c % 2 == 1 && !d && e ? o.left - 1 : o.left),
            top: p(o.top),
            bottom: p(o.bottom),
            right: u(o.right),
        };
    }
    var pe = Tt && /Firefox/i.test(navigator.userAgent);
    function fe(t, e, i) {
        var n = ne(t, function (t) {
                return t.name === e;
            }),
            o =
                !!n &&
                t.some(function (t) {
                    return t.name === i && t.enabled && t.order < n.order;
                });
        if (!o) {
            var s = "`" + e + "`",
                r = "`" + i + "`";
            console.warn(
                r +
                    " modifier is required by " +
                    s +
                    " modifier in order to work, be sure to include it before " +
                    s +
                    "!",
            );
        }
        return o;
    }
    var ge = [
            "auto-start",
            "auto",
            "auto-end",
            "top-start",
            "top",
            "top-end",
            "right-start",
            "right",
            "right-end",
            "bottom-end",
            "bottom",
            "bottom-start",
            "left-end",
            "left",
            "left-start",
        ],
        me = ge.slice(3);
    function ve(t, e) {
        var i = 1 < arguments.length && void 0 !== e && e,
            n = me.indexOf(t),
            o = me.slice(n + 1).concat(me.slice(0, n));
        return i ? o.reverse() : o;
    }
    var ye = "flip",
        _e = "clockwise",
        be = "counterclockwise";
    function we(t, o, s, e) {
        var r = [0, 0],
            a = -1 !== ["right", "left"].indexOf(e),
            i = t.split(/(\+|\-)/).map(function (t) {
                return t.trim();
            }),
            n = i.indexOf(
                ne(i, function (t) {
                    return -1 !== t.search(/,|\s/);
                }),
            );
        i[n] &&
            -1 === i[n].indexOf(",") &&
            console.warn(
                "Offsets separated by white space(s) are deprecated, use a comma (,) instead.",
            );
        var l = /\s*,\s*|\s+/,
            c =
                -1 !== n
                    ? [
                          i.slice(0, n).concat([i[n].split(l)[0]]),
                          [i[n].split(l)[1]].concat(i.slice(n + 1)),
                      ]
                    : [i];
        return (
            (c = c.map(function (t, e) {
                var i = (1 === e ? !a : a) ? "height" : "width",
                    n = !1;
                return t
                    .reduce(function (t, e) {
                        return "" === t[t.length - 1] &&
                            -1 !== ["+", "-"].indexOf(e)
                            ? ((t[t.length - 1] = e), (n = !0), t)
                            : n
                              ? ((t[t.length - 1] += e), (n = !1), t)
                              : t.concat(e);
                    }, [])
                    .map(function (t) {
                        return (function (t, e, i, n) {
                            var o = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                                s = +o[1],
                                r = o[2];
                            if (!s) return t;
                            if (0 !== r.indexOf("%"))
                                return "vh" !== r && "vw" !== r
                                    ? s
                                    : (("vh" === r
                                          ? Math.max(
                                                document.documentElement
                                                    .clientHeight,
                                                window.innerHeight || 0,
                                            )
                                          : Math.max(
                                                document.documentElement
                                                    .clientWidth,
                                                window.innerWidth || 0,
                                            )) /
                                          100) *
                                          s;
                            var a = void 0;
                            switch (r) {
                                case "%p":
                                    a = i;
                                    break;
                                case "%":
                                case "%r":
                                default:
                                    a = n;
                            }
                            return (Yt(a)[e] / 100) * s;
                        })(t, i, o, s);
                    });
            })).forEach(function (i, n) {
                i.forEach(function (t, e) {
                    he(t) && (r[n] += t * ("-" === i[e - 1] ? -1 : 1));
                });
            }),
            r
        );
    }
    var xe = {
            placement: "bottom",
            positionFixed: !1,
            eventsEnabled: !0,
            removeOnDestroy: !1,
            onCreate: function () {},
            onUpdate: function () {},
            modifiers: {
                shift: {
                    order: 100,
                    enabled: !0,
                    fn: function (t) {
                        var e = t.placement,
                            i = e.split("-")[0],
                            n = e.split("-")[1];
                        if (n) {
                            var o = t.offsets,
                                s = o.reference,
                                r = o.popper,
                                a = -1 !== ["bottom", "top"].indexOf(i),
                                l = a ? "left" : "top",
                                c = a ? "width" : "height",
                                h = {
                                    start: Ut({}, l, s[l]),
                                    end: Ut({}, l, s[l] + s[c] - r[c]),
                                };
                            t.offsets.popper = Qt({}, r, h[n]);
                        }
                        return t;
                    },
                },
                offset: {
                    order: 200,
                    enabled: !0,
                    fn: function (t, e) {
                        var i = e.offset,
                            n = t.placement,
                            o = t.offsets,
                            s = o.popper,
                            r = o.reference,
                            a = n.split("-")[0],
                            l = void 0;
                        return (
                            (l = he(+i) ? [+i, 0] : we(i, s, r, a)),
                            "left" === a
                                ? ((s.top += l[0]), (s.left -= l[1]))
                                : "right" === a
                                  ? ((s.top += l[0]), (s.left += l[1]))
                                  : "top" === a
                                    ? ((s.left += l[0]), (s.top -= l[1]))
                                    : "bottom" === a &&
                                      ((s.left += l[0]), (s.top += l[1])),
                            (t.popper = s),
                            t
                        );
                    },
                    offset: 0,
                },
                preventOverflow: {
                    order: 300,
                    enabled: !0,
                    fn: function (t, n) {
                        var e = n.boundariesElement || jt(t.instance.popper);
                        t.instance.reference === e && (e = jt(e));
                        var i = re("transform"),
                            o = t.instance.popper.style,
                            s = o.top,
                            r = o.left,
                            a = o[i];
                        (o.top = ""), (o.left = ""), (o[i] = "");
                        var l = Gt(
                            t.instance.popper,
                            t.instance.reference,
                            n.padding,
                            e,
                            t.positionFixed,
                        );
                        (o.top = s),
                            (o.left = r),
                            (o[i] = a),
                            (n.boundaries = l);
                        var c = n.priority,
                            h = t.offsets.popper,
                            d = {
                                primary: function (t) {
                                    var e = h[t];
                                    return (
                                        h[t] < l[t] &&
                                            !n.escapeWithReference &&
                                            (e = Math.max(h[t], l[t])),
                                        Ut({}, t, e)
                                    );
                                },
                                secondary: function (t) {
                                    var e = "right" === t ? "left" : "top",
                                        i = h[e];
                                    return (
                                        h[t] > l[t] &&
                                            !n.escapeWithReference &&
                                            (i = Math.min(
                                                h[e],
                                                l[t] -
                                                    ("right" === t
                                                        ? h.width
                                                        : h.height),
                                            )),
                                        Ut({}, e, i)
                                    );
                                },
                            };
                        return (
                            c.forEach(function (t) {
                                var e =
                                    -1 !== ["left", "top"].indexOf(t)
                                        ? "primary"
                                        : "secondary";
                                h = Qt({}, h, d[e](t));
                            }),
                            (t.offsets.popper = h),
                            t
                        );
                    },
                    priority: ["left", "right", "top", "bottom"],
                    padding: 5,
                    boundariesElement: "scrollParent",
                },
                keepTogether: {
                    order: 400,
                    enabled: !0,
                    fn: function (t) {
                        var e = t.offsets,
                            i = e.popper,
                            n = e.reference,
                            o = t.placement.split("-")[0],
                            s = Math.floor,
                            r = -1 !== ["top", "bottom"].indexOf(o),
                            a = r ? "right" : "bottom",
                            l = r ? "left" : "top",
                            c = r ? "width" : "height";
                        return (
                            i[a] < s(n[l]) &&
                                (t.offsets.popper[l] = s(n[l]) - i[c]),
                            i[l] > s(n[a]) && (t.offsets.popper[l] = s(n[a])),
                            t
                        );
                    },
                },
                arrow: {
                    order: 500,
                    enabled: !0,
                    fn: function (t, e) {
                        var i;
                        if (!fe(t.instance.modifiers, "arrow", "keepTogether"))
                            return t;
                        var n = e.element;
                        if ("string" == typeof n) {
                            if (!(n = t.instance.popper.querySelector(n)))
                                return t;
                        } else if (!t.instance.popper.contains(n))
                            return (
                                console.warn(
                                    "WARNING: `arrow.element` must be child of its popper element!",
                                ),
                                t
                            );
                        var o = t.placement.split("-")[0],
                            s = t.offsets,
                            r = s.popper,
                            a = s.reference,
                            l = -1 !== ["left", "right"].indexOf(o),
                            c = l ? "height" : "width",
                            h = l ? "Top" : "Left",
                            d = h.toLowerCase(),
                            u = l ? "left" : "top",
                            p = l ? "bottom" : "right",
                            f = te(n)[c];
                        a[p] - f < r[d] &&
                            (t.offsets.popper[d] -= r[d] - (a[p] - f)),
                            a[d] + f > r[p] &&
                                (t.offsets.popper[d] += a[d] + f - r[p]),
                            (t.offsets.popper = Yt(t.offsets.popper));
                        var g = a[d] + a[c] / 2 - f / 2,
                            m = At(t.instance.popper),
                            v = parseFloat(m["margin" + h], 10),
                            y = parseFloat(m["border" + h + "Width"], 10),
                            _ = g - t.offsets.popper[d] - v - y;
                        return (
                            (_ = Math.max(Math.min(r[c] - f, _), 0)),
                            (t.arrowElement = n),
                            (t.offsets.arrow =
                                (Ut((i = {}), d, Math.round(_)),
                                Ut(i, u, ""),
                                i)),
                            t
                        );
                    },
                    element: "[x-arrow]",
                },
                flip: {
                    order: 600,
                    enabled: !0,
                    fn: function (f, g) {
                        if (se(f.instance.modifiers, "inner")) return f;
                        if (f.flipped && f.placement === f.originalPlacement)
                            return f;
                        var m = Gt(
                                f.instance.popper,
                                f.instance.reference,
                                g.padding,
                                g.boundariesElement,
                                f.positionFixed,
                            ),
                            v = f.placement.split("-")[0],
                            y = ee(v),
                            _ = f.placement.split("-")[1] || "",
                            b = [];
                        switch (g.behavior) {
                            case ye:
                                b = [v, y];
                                break;
                            case _e:
                                b = ve(v);
                                break;
                            case be:
                                b = ve(v, !0);
                                break;
                            default:
                                b = g.behavior;
                        }
                        return (
                            b.forEach(function (t, e) {
                                if (v !== t || b.length === e + 1) return f;
                                (v = f.placement.split("-")[0]), (y = ee(v));
                                var i,
                                    n = f.offsets.popper,
                                    o = f.offsets.reference,
                                    s = Math.floor,
                                    r =
                                        ("left" === v &&
                                            s(n.right) > s(o.left)) ||
                                        ("right" === v &&
                                            s(n.left) < s(o.right)) ||
                                        ("top" === v &&
                                            s(n.bottom) > s(o.top)) ||
                                        ("bottom" === v &&
                                            s(n.top) < s(o.bottom)),
                                    a = s(n.left) < s(m.left),
                                    l = s(n.right) > s(m.right),
                                    c = s(n.top) < s(m.top),
                                    h = s(n.bottom) > s(m.bottom),
                                    d =
                                        ("left" === v && a) ||
                                        ("right" === v && l) ||
                                        ("top" === v && c) ||
                                        ("bottom" === v && h),
                                    u = -1 !== ["top", "bottom"].indexOf(v),
                                    p =
                                        !!g.flipVariations &&
                                        ((u && "start" === _ && a) ||
                                            (u && "end" === _ && l) ||
                                            (!u && "start" === _ && c) ||
                                            (!u && "end" === _ && h));
                                (r || d || p) &&
                                    ((f.flipped = !0),
                                    (r || d) && (v = b[e + 1]),
                                    p &&
                                        (_ =
                                            "end" === (i = _)
                                                ? "start"
                                                : "start" === i
                                                  ? "end"
                                                  : i),
                                    (f.placement = v + (_ ? "-" + _ : "")),
                                    (f.offsets.popper = Qt(
                                        {},
                                        f.offsets.popper,
                                        ie(
                                            f.instance.popper,
                                            f.offsets.reference,
                                            f.placement,
                                        ),
                                    )),
                                    (f = oe(f.instance.modifiers, f, "flip")));
                            }),
                            f
                        );
                    },
                    behavior: "flip",
                    padding: 5,
                    boundariesElement: "viewport",
                },
                inner: {
                    order: 700,
                    enabled: !1,
                    fn: function (t) {
                        var e = t.placement,
                            i = e.split("-")[0],
                            n = t.offsets,
                            o = n.popper,
                            s = n.reference,
                            r = -1 !== ["left", "right"].indexOf(i),
                            a = -1 === ["top", "left"].indexOf(i);
                        return (
                            (o[r ? "left" : "top"] =
                                s[i] - (a ? o[r ? "width" : "height"] : 0)),
                            (t.placement = ee(e)),
                            (t.offsets.popper = Yt(o)),
                            t
                        );
                    },
                },
                hide: {
                    order: 800,
                    enabled: !0,
                    fn: function (t) {
                        if (
                            !fe(t.instance.modifiers, "hide", "preventOverflow")
                        )
                            return t;
                        var e = t.offsets.reference,
                            i = ne(t.instance.modifiers, function (t) {
                                return "preventOverflow" === t.name;
                            }).boundaries;
                        if (
                            e.bottom < i.top ||
                            e.left > i.right ||
                            e.top > i.bottom ||
                            e.right < i.left
                        ) {
                            if (!0 === t.hide) return t;
                            (t.hide = !0),
                                (t.attributes["x-out-of-boundaries"] = "");
                        } else {
                            if (!1 === t.hide) return t;
                            (t.hide = !1),
                                (t.attributes["x-out-of-boundaries"] = !1);
                        }
                        return t;
                    },
                },
                computeStyle: {
                    order: 850,
                    enabled: !0,
                    fn: function (t, e) {
                        var i = e.x,
                            n = e.y,
                            o = t.offsets.popper,
                            s = ne(t.instance.modifiers, function (t) {
                                return "applyStyle" === t.name;
                            }).gpuAcceleration;
                        void 0 !== s &&
                            console.warn(
                                "WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!",
                            );
                        var r = void 0 !== s ? s : e.gpuAcceleration,
                            a = jt(t.instance.popper),
                            l = Xt(a),
                            c = { position: o.position },
                            h = ue(t, window.devicePixelRatio < 2 || !pe),
                            d = "bottom" === i ? "top" : "bottom",
                            u = "right" === n ? "left" : "right",
                            p = re("transform"),
                            f = void 0,
                            g = void 0;
                        if (
                            ((g =
                                "bottom" == d
                                    ? "HTML" === a.nodeName
                                        ? -a.clientHeight + h.bottom
                                        : -l.height + h.bottom
                                    : h.top),
                            (f =
                                "right" == u
                                    ? "HTML" === a.nodeName
                                        ? -a.clientWidth + h.right
                                        : -l.width + h.right
                                    : h.left),
                            r && p)
                        )
                            (c[p] = "translate3d(" + f + "px, " + g + "px, 0)"),
                                (c[d] = 0),
                                (c[u] = 0),
                                (c.willChange = "transform");
                        else {
                            var m = "bottom" == d ? -1 : 1,
                                v = "right" == u ? -1 : 1;
                            (c[d] = g * m),
                                (c[u] = f * v),
                                (c.willChange = d + ", " + u);
                        }
                        var y = { "x-placement": t.placement };
                        return (
                            (t.attributes = Qt({}, y, t.attributes)),
                            (t.styles = Qt({}, c, t.styles)),
                            (t.arrowStyles = Qt(
                                {},
                                t.offsets.arrow,
                                t.arrowStyles,
                            )),
                            t
                        );
                    },
                    gpuAcceleration: !0,
                    x: "bottom",
                    y: "right",
                },
                applyStyle: {
                    order: 900,
                    enabled: !0,
                    fn: function (t) {
                        var e, i;
                        return (
                            de(t.instance.popper, t.styles),
                            (e = t.instance.popper),
                            (i = t.attributes),
                            Object.keys(i).forEach(function (t) {
                                !1 !== i[t]
                                    ? e.setAttribute(t, i[t])
                                    : e.removeAttribute(t);
                            }),
                            t.arrowElement &&
                                Object.keys(t.arrowStyles).length &&
                                de(t.arrowElement, t.arrowStyles),
                            t
                        );
                    },
                    onLoad: function (t, e, i, n, o) {
                        var s = Jt(o, e, t, i.positionFixed),
                            r = Zt(
                                i.placement,
                                s,
                                e,
                                t,
                                i.modifiers.flip.boundariesElement,
                                i.modifiers.flip.padding,
                            );
                        return (
                            e.setAttribute("x-placement", r),
                            de(e, {
                                position: i.positionFixed
                                    ? "fixed"
                                    : "absolute",
                            }),
                            i
                        );
                    },
                    gpuAcceleration: void 0,
                },
            },
        },
        Se =
            (qt(Te, [
                {
                    key: "update",
                    value: function () {
                        return function () {
                            if (!this.state.isDestroyed) {
                                var t = {
                                    instance: this,
                                    styles: {},
                                    arrowStyles: {},
                                    attributes: {},
                                    flipped: !1,
                                    offsets: {},
                                };
                                (t.offsets.reference = Jt(
                                    this.state,
                                    this.popper,
                                    this.reference,
                                    this.options.positionFixed,
                                )),
                                    (t.placement = Zt(
                                        this.options.placement,
                                        t.offsets.reference,
                                        this.popper,
                                        this.reference,
                                        this.options.modifiers.flip
                                            .boundariesElement,
                                        this.options.modifiers.flip.padding,
                                    )),
                                    (t.originalPlacement = t.placement),
                                    (t.positionFixed =
                                        this.options.positionFixed),
                                    (t.offsets.popper = ie(
                                        this.popper,
                                        t.offsets.reference,
                                        t.placement,
                                    )),
                                    (t.offsets.popper.position = this.options
                                        .positionFixed
                                        ? "fixed"
                                        : "absolute"),
                                    (t = oe(this.modifiers, t)),
                                    this.state.isCreated
                                        ? this.options.onUpdate(t)
                                        : ((this.state.isCreated = !0),
                                          this.options.onCreate(t));
                            }
                        }.call(this);
                    },
                },
                {
                    key: "destroy",
                    value: function () {
                        return function () {
                            return (
                                (this.state.isDestroyed = !0),
                                se(this.modifiers, "applyStyle") &&
                                    (this.popper.removeAttribute("x-placement"),
                                    (this.popper.style.position = ""),
                                    (this.popper.style.top = ""),
                                    (this.popper.style.left = ""),
                                    (this.popper.style.right = ""),
                                    (this.popper.style.bottom = ""),
                                    (this.popper.style.willChange = ""),
                                    (this.popper.style[re("transform")] = "")),
                                this.disableEventListeners(),
                                this.options.removeOnDestroy &&
                                    this.popper.parentNode.removeChild(
                                        this.popper,
                                    ),
                                this
                            );
                        }.call(this);
                    },
                },
                {
                    key: "enableEventListeners",
                    value: function () {
                        return function () {
                            this.state.eventsEnabled ||
                                (this.state = le(
                                    this.reference,
                                    this.options,
                                    this.state,
                                    this.scheduleUpdate,
                                ));
                        }.call(this);
                    },
                },
                {
                    key: "disableEventListeners",
                    value: function () {
                        return ce.call(this);
                    },
                },
            ]),
            Te);
    function Te(t, e) {
        var i = this,
            n =
                2 < arguments.length && void 0 !== arguments[2]
                    ? arguments[2]
                    : {};
        !(function (t, e) {
            if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
        })(this, Te),
            (this.scheduleUpdate = function () {
                return requestAnimationFrame(i.update);
            }),
            (this.update = $t(this.update.bind(this))),
            (this.options = Qt({}, Te.Defaults, n)),
            (this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: [],
            }),
            (this.reference = t && t.jquery ? t[0] : t),
            (this.popper = e && e.jquery ? e[0] : e),
            (this.options.modifiers = {}),
            Object.keys(Qt({}, Te.Defaults.modifiers, n.modifiers)).forEach(
                function (t) {
                    i.options.modifiers[t] = Qt(
                        {},
                        Te.Defaults.modifiers[t] || {},
                        n.modifiers ? n.modifiers[t] : {},
                    );
                },
            ),
            (this.modifiers = Object.keys(this.options.modifiers)
                .map(function (t) {
                    return Qt({ name: t }, i.options.modifiers[t]);
                })
                .sort(function (t, e) {
                    return t.order - e.order;
                })),
            this.modifiers.forEach(function (t) {
                t.enabled &&
                    It(t.onLoad) &&
                    t.onLoad(i.reference, i.popper, i.options, t, i.state);
            }),
            this.update();
        var o = this.options.eventsEnabled;
        o && this.enableEventListeners(), (this.state.eventsEnabled = o);
    }
    (Se.Utils = ("undefined" != typeof window ? window : global).PopperUtils),
        (Se.placements = ge),
        (Se.Defaults = xe);
    var Ce = "dropdown",
        ke = "bs.dropdown",
        Ee = "." + ke,
        $e = ".data-api",
        Ie = f.fn[Ce],
        Ae = new RegExp("38|40|27"),
        Oe = {
            HIDE: "hide" + Ee,
            HIDDEN: "hidden" + Ee,
            SHOW: "show" + Ee,
            SHOWN: "shown" + Ee,
            CLICK: "click" + Ee,
            CLICK_DATA_API: "click" + Ee + $e,
            KEYDOWN_DATA_API: "keydown" + Ee + $e,
            KEYUP_DATA_API: "keyup" + Ee + $e,
        },
        Pe = "disabled",
        De = "show",
        Me = "dropup",
        Le = "dropright",
        je = "dropleft",
        ze = "dropdown-menu-right",
        Fe = "position-static",
        He = '[data-toggle="dropdown"]',
        Ne = ".dropdown form",
        Re = ".dropdown-menu",
        We = ".navbar-nav",
        qe = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",
        Be = "top-start",
        Ue = "top-end",
        Qe = "bottom-start",
        Ye = "bottom-end",
        Xe = "right-start",
        Ve = "left-start",
        Ke = {
            offset: 0,
            flip: !0,
            boundary: "scrollParent",
            reference: "toggle",
            display: "dynamic",
        },
        Ge = {
            offset: "(number|string|function)",
            flip: "boolean",
            boundary: "(string|element)",
            reference: "(string|element)",
            display: "string",
        },
        Ze = (function () {
            function c(t, e) {
                (this._element = t),
                    (this._popper = null),
                    (this._config = this._getConfig(e)),
                    (this._menu = this._getMenuElement()),
                    (this._inNavbar = this._detectNavbar()),
                    this._addEventListeners();
            }
            var t = c.prototype;
            return (
                (t.toggle = function () {
                    if (
                        !this._element.disabled &&
                        !f(this._element).hasClass(Pe)
                    ) {
                        var t = c._getParentFromElement(this._element),
                            e = f(this._menu).hasClass(De);
                        if ((c._clearMenus(), !e)) {
                            var i = { relatedTarget: this._element },
                                n = f.Event(Oe.SHOW, i);
                            if ((f(t).trigger(n), !n.isDefaultPrevented())) {
                                if (!this._inNavbar) {
                                    if (void 0 === Se)
                                        throw new TypeError(
                                            "Bootstrap's dropdowns require Popper.js (https://popper.js.org/)",
                                        );
                                    var o = this._element;
                                    "parent" === this._config.reference
                                        ? (o = t)
                                        : g.isElement(this._config.reference) &&
                                          ((o = this._config.reference),
                                          void 0 !==
                                              this._config.reference.jquery &&
                                              (o = this._config.reference[0])),
                                        "scrollParent" !==
                                            this._config.boundary &&
                                            f(t).addClass(Fe),
                                        (this._popper = new Se(
                                            o,
                                            this._menu,
                                            this._getPopperConfig(),
                                        ));
                                }
                                "ontouchstart" in document.documentElement &&
                                    0 === f(t).closest(We).length &&
                                    f(document.body)
                                        .children()
                                        .on("mouseover", null, f.noop),
                                    this._element.focus(),
                                    this._element.setAttribute(
                                        "aria-expanded",
                                        !0,
                                    ),
                                    f(this._menu).toggleClass(De),
                                    f(t)
                                        .toggleClass(De)
                                        .trigger(f.Event(Oe.SHOWN, i));
                            }
                        }
                    }
                }),
                (t.show = function () {
                    if (
                        !(
                            this._element.disabled ||
                            f(this._element).hasClass(Pe) ||
                            f(this._menu).hasClass(De)
                        )
                    ) {
                        var t = { relatedTarget: this._element },
                            e = f.Event(Oe.SHOW, t),
                            i = c._getParentFromElement(this._element);
                        f(i).trigger(e),
                            e.isDefaultPrevented() ||
                                (f(this._menu).toggleClass(De),
                                f(i)
                                    .toggleClass(De)
                                    .trigger(f.Event(Oe.SHOWN, t)));
                    }
                }),
                (t.hide = function () {
                    if (
                        !this._element.disabled &&
                        !f(this._element).hasClass(Pe) &&
                        f(this._menu).hasClass(De)
                    ) {
                        var t = { relatedTarget: this._element },
                            e = f.Event(Oe.HIDE, t),
                            i = c._getParentFromElement(this._element);
                        f(i).trigger(e),
                            e.isDefaultPrevented() ||
                                (f(this._menu).toggleClass(De),
                                f(i)
                                    .toggleClass(De)
                                    .trigger(f.Event(Oe.HIDDEN, t)));
                    }
                }),
                (t.dispose = function () {
                    f.removeData(this._element, ke),
                        f(this._element).off(Ee),
                        (this._element = null),
                        (this._menu = null) !== this._popper &&
                            (this._popper.destroy(), (this._popper = null));
                }),
                (t.update = function () {
                    (this._inNavbar = this._detectNavbar()),
                        null !== this._popper && this._popper.scheduleUpdate();
                }),
                (t._addEventListeners = function () {
                    var e = this;
                    f(this._element).on(Oe.CLICK, function (t) {
                        t.preventDefault(), t.stopPropagation(), e.toggle();
                    });
                }),
                (t._getConfig = function (t) {
                    return (
                        (t = l(
                            {},
                            this.constructor.Default,
                            f(this._element).data(),
                            t,
                        )),
                        g.typeCheckConfig(Ce, t, this.constructor.DefaultType),
                        t
                    );
                }),
                (t._getMenuElement = function () {
                    if (!this._menu) {
                        var t = c._getParentFromElement(this._element);
                        t && (this._menu = t.querySelector(Re));
                    }
                    return this._menu;
                }),
                (t._getPlacement = function () {
                    var t = f(this._element.parentNode),
                        e = Qe;
                    return (
                        t.hasClass(Me)
                            ? ((e = Be), f(this._menu).hasClass(ze) && (e = Ue))
                            : t.hasClass(Le)
                              ? (e = Xe)
                              : t.hasClass(je)
                                ? (e = Ve)
                                : f(this._menu).hasClass(ze) && (e = Ye),
                        e
                    );
                }),
                (t._detectNavbar = function () {
                    return 0 < f(this._element).closest(".navbar").length;
                }),
                (t._getOffset = function () {
                    var e = this,
                        t = {};
                    return (
                        "function" == typeof this._config.offset
                            ? (t.fn = function (t) {
                                  return (
                                      (t.offsets = l(
                                          {},
                                          t.offsets,
                                          e._config.offset(
                                              t.offsets,
                                              e._element,
                                          ) || {},
                                      )),
                                      t
                                  );
                              })
                            : (t.offset = this._config.offset),
                        t
                    );
                }),
                (t._getPopperConfig = function () {
                    var t = {
                        placement: this._getPlacement(),
                        modifiers: {
                            offset: this._getOffset(),
                            flip: { enabled: this._config.flip },
                            preventOverflow: {
                                boundariesElement: this._config.boundary,
                            },
                        },
                    };
                    return (
                        "static" === this._config.display &&
                            (t.modifiers.applyStyle = { enabled: !1 }),
                        t
                    );
                }),
                (c._jQueryInterface = function (e) {
                    return this.each(function () {
                        var t = f(this).data(ke);
                        if (
                            (t ||
                                ((t = new c(
                                    this,
                                    "object" == typeof e ? e : null,
                                )),
                                f(this).data(ke, t)),
                            "string" == typeof e)
                        ) {
                            if (void 0 === t[e])
                                throw new TypeError(
                                    'No method named "' + e + '"',
                                );
                            t[e]();
                        }
                    });
                }),
                (c._clearMenus = function (t) {
                    if (
                        !t ||
                        (3 !== t.which && ("keyup" !== t.type || 9 === t.which))
                    )
                        for (
                            var e = [].slice.call(
                                    document.querySelectorAll(He),
                                ),
                                i = 0,
                                n = e.length;
                            i < n;
                            i++
                        ) {
                            var o = c._getParentFromElement(e[i]),
                                s = f(e[i]).data(ke),
                                r = { relatedTarget: e[i] };
                            if (
                                (t && "click" === t.type && (r.clickEvent = t),
                                s)
                            ) {
                                var a = s._menu;
                                if (
                                    f(o).hasClass(De) &&
                                    !(
                                        t &&
                                        (("click" === t.type &&
                                            /input|textarea/i.test(
                                                t.target.tagName,
                                            )) ||
                                            ("keyup" === t.type &&
                                                9 === t.which)) &&
                                        f.contains(o, t.target)
                                    )
                                ) {
                                    var l = f.Event(Oe.HIDE, r);
                                    f(o).trigger(l),
                                        l.isDefaultPrevented() ||
                                            ("ontouchstart" in
                                                document.documentElement &&
                                                f(document.body)
                                                    .children()
                                                    .off(
                                                        "mouseover",
                                                        null,
                                                        f.noop,
                                                    ),
                                            e[i].setAttribute(
                                                "aria-expanded",
                                                "false",
                                            ),
                                            f(a).removeClass(De),
                                            f(o)
                                                .removeClass(De)
                                                .trigger(
                                                    f.Event(Oe.HIDDEN, r),
                                                ));
                                }
                            }
                        }
                }),
                (c._getParentFromElement = function (t) {
                    var e,
                        i = g.getSelectorFromElement(t);
                    return (
                        i && (e = document.querySelector(i)), e || t.parentNode
                    );
                }),
                (c._dataApiKeydownHandler = function (t) {
                    if (
                        (/input|textarea/i.test(t.target.tagName)
                            ? !(
                                  32 === t.which ||
                                  (27 !== t.which &&
                                      ((40 !== t.which && 38 !== t.which) ||
                                          f(t.target).closest(Re).length))
                              )
                            : Ae.test(t.which)) &&
                        (t.preventDefault(),
                        t.stopPropagation(),
                        !this.disabled && !f(this).hasClass(Pe))
                    ) {
                        var e = c._getParentFromElement(this),
                            i = f(e).hasClass(De);
                        if (i && (!i || (27 !== t.which && 32 !== t.which))) {
                            var n = [].slice.call(e.querySelectorAll(qe));
                            if (0 !== n.length) {
                                var o = n.indexOf(t.target);
                                38 === t.which && 0 < o && o--,
                                    40 === t.which && o < n.length - 1 && o++,
                                    o < 0 && (o = 0),
                                    n[o].focus();
                            }
                        } else {
                            if (27 === t.which) {
                                var s = e.querySelector(He);
                                f(s).trigger("focus");
                            }
                            f(this).trigger("click");
                        }
                    }
                }),
                r(c, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                    {
                        key: "Default",
                        get: function () {
                            return Ke;
                        },
                    },
                    {
                        key: "DefaultType",
                        get: function () {
                            return Ge;
                        },
                    },
                ]),
                c
            );
        })();
    f(document)
        .on(Oe.KEYDOWN_DATA_API, He, Ze._dataApiKeydownHandler)
        .on(Oe.KEYDOWN_DATA_API, Re, Ze._dataApiKeydownHandler)
        .on(Oe.CLICK_DATA_API + " " + Oe.KEYUP_DATA_API, Ze._clearMenus)
        .on(Oe.CLICK_DATA_API, He, function (t) {
            t.preventDefault(),
                t.stopPropagation(),
                Ze._jQueryInterface.call(f(this), "toggle");
        })
        .on(Oe.CLICK_DATA_API, Ne, function (t) {
            t.stopPropagation();
        }),
        (f.fn[Ce] = Ze._jQueryInterface),
        (f.fn[Ce].Constructor = Ze),
        (f.fn[Ce].noConflict = function () {
            return (f.fn[Ce] = Ie), Ze._jQueryInterface;
        });
    var Je = "modal",
        ti = "bs.modal",
        ei = "." + ti,
        ii = f.fn[Je],
        ni = { backdrop: !0, keyboard: !0, focus: !0, show: !0 },
        oi = {
            backdrop: "(boolean|string)",
            keyboard: "boolean",
            focus: "boolean",
            show: "boolean",
        },
        si = {
            HIDE: "hide" + ei,
            HIDDEN: "hidden" + ei,
            SHOW: "show" + ei,
            SHOWN: "shown" + ei,
            FOCUSIN: "focusin" + ei,
            RESIZE: "resize" + ei,
            CLICK_DISMISS: "click.dismiss" + ei,
            KEYDOWN_DISMISS: "keydown.dismiss" + ei,
            MOUSEUP_DISMISS: "mouseup.dismiss" + ei,
            MOUSEDOWN_DISMISS: "mousedown.dismiss" + ei,
            CLICK_DATA_API: "click" + ei + ".data-api",
        },
        ri = "modal-dialog-scrollable",
        ai = "modal-scrollbar-measure",
        li = "modal-backdrop",
        ci = "modal-open",
        hi = "fade",
        di = "show",
        ui = ".modal-dialog",
        pi = ".modal-body",
        fi = '[data-toggle="modal"]',
        gi = '[data-dismiss="modal"]',
        mi = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
        vi = ".sticky-top",
        yi = (function () {
            function o(t, e) {
                (this._config = this._getConfig(e)),
                    (this._element = t),
                    (this._dialog = t.querySelector(ui)),
                    (this._backdrop = null),
                    (this._isShown = !1),
                    (this._isBodyOverflowing = !1),
                    (this._ignoreBackdropClick = !1),
                    (this._isTransitioning = !1),
                    (this._scrollbarWidth = 0);
            }
            var t = o.prototype;
            return (
                (t.toggle = function (t) {
                    return this._isShown ? this.hide() : this.show(t);
                }),
                (t.show = function (t) {
                    var e = this;
                    if (!this._isShown && !this._isTransitioning) {
                        f(this._element).hasClass(hi) &&
                            (this._isTransitioning = !0);
                        var i = f.Event(si.SHOW, { relatedTarget: t });
                        f(this._element).trigger(i),
                            this._isShown ||
                                i.isDefaultPrevented() ||
                                ((this._isShown = !0),
                                this._checkScrollbar(),
                                this._setScrollbar(),
                                this._adjustDialog(),
                                this._setEscapeEvent(),
                                this._setResizeEvent(),
                                f(this._element).on(
                                    si.CLICK_DISMISS,
                                    gi,
                                    function (t) {
                                        return e.hide(t);
                                    },
                                ),
                                f(this._dialog).on(
                                    si.MOUSEDOWN_DISMISS,
                                    function () {
                                        f(e._element).one(
                                            si.MOUSEUP_DISMISS,
                                            function (t) {
                                                f(t.target).is(e._element) &&
                                                    (e._ignoreBackdropClick =
                                                        !0);
                                            },
                                        );
                                    },
                                ),
                                this._showBackdrop(function () {
                                    return e._showElement(t);
                                }));
                    }
                }),
                (t.hide = function (t) {
                    var e = this;
                    if (
                        (t && t.preventDefault(),
                        this._isShown && !this._isTransitioning)
                    ) {
                        var i = f.Event(si.HIDE);
                        if (
                            (f(this._element).trigger(i),
                            this._isShown && !i.isDefaultPrevented())
                        ) {
                            this._isShown = !1;
                            var n = f(this._element).hasClass(hi);
                            if (
                                (n && (this._isTransitioning = !0),
                                this._setEscapeEvent(),
                                this._setResizeEvent(),
                                f(document).off(si.FOCUSIN),
                                f(this._element).removeClass(di),
                                f(this._element).off(si.CLICK_DISMISS),
                                f(this._dialog).off(si.MOUSEDOWN_DISMISS),
                                n)
                            ) {
                                var o = g.getTransitionDurationFromElement(
                                    this._element,
                                );
                                f(this._element)
                                    .one(g.TRANSITION_END, function (t) {
                                        return e._hideModal(t);
                                    })
                                    .emulateTransitionEnd(o);
                            } else this._hideModal();
                        }
                    }
                }),
                (t.dispose = function () {
                    [window, this._element, this._dialog].forEach(function (t) {
                        return f(t).off(ei);
                    }),
                        f(document).off(si.FOCUSIN),
                        f.removeData(this._element, ti),
                        (this._config = null),
                        (this._element = null),
                        (this._dialog = null),
                        (this._backdrop = null),
                        (this._isShown = null),
                        (this._isBodyOverflowing = null),
                        (this._ignoreBackdropClick = null),
                        (this._isTransitioning = null),
                        (this._scrollbarWidth = null);
                }),
                (t.handleUpdate = function () {
                    this._adjustDialog();
                }),
                (t._getConfig = function (t) {
                    return (t = l({}, ni, t)), g.typeCheckConfig(Je, t, oi), t;
                }),
                (t._showElement = function (t) {
                    var e = this,
                        i = f(this._element).hasClass(hi);
                    (this._element.parentNode &&
                        this._element.parentNode.nodeType ===
                            Node.ELEMENT_NODE) ||
                        document.body.appendChild(this._element),
                        (this._element.style.display = "block"),
                        this._element.removeAttribute("aria-hidden"),
                        this._element.setAttribute("aria-modal", !0),
                        f(this._dialog).hasClass(ri)
                            ? (this._dialog.querySelector(pi).scrollTop = 0)
                            : (this._element.scrollTop = 0),
                        i && g.reflow(this._element),
                        f(this._element).addClass(di),
                        this._config.focus && this._enforceFocus();
                    function n() {
                        e._config.focus && e._element.focus(),
                            (e._isTransitioning = !1),
                            f(e._element).trigger(o);
                    }
                    var o = f.Event(si.SHOWN, { relatedTarget: t });
                    if (i) {
                        var s = g.getTransitionDurationFromElement(
                            this._dialog,
                        );
                        f(this._dialog)
                            .one(g.TRANSITION_END, n)
                            .emulateTransitionEnd(s);
                    } else n();
                }),
                (t._enforceFocus = function () {
                    var e = this;
                    f(document)
                        .off(si.FOCUSIN)
                        .on(si.FOCUSIN, function (t) {
                            document !== t.target &&
                                e._element !== t.target &&
                                0 === f(e._element).has(t.target).length &&
                                e._element.focus();
                        });
                }),
                (t._setEscapeEvent = function () {
                    var e = this;
                    this._isShown && this._config.keyboard
                        ? f(this._element).on(si.KEYDOWN_DISMISS, function (t) {
                              27 === t.which && (t.preventDefault(), e.hide());
                          })
                        : this._isShown ||
                          f(this._element).off(si.KEYDOWN_DISMISS);
                }),
                (t._setResizeEvent = function () {
                    var e = this;
                    this._isShown
                        ? f(window).on(si.RESIZE, function (t) {
                              return e.handleUpdate(t);
                          })
                        : f(window).off(si.RESIZE);
                }),
                (t._hideModal = function () {
                    var t = this;
                    (this._element.style.display = "none"),
                        this._element.setAttribute("aria-hidden", !0),
                        this._element.removeAttribute("aria-modal"),
                        (this._isTransitioning = !1),
                        this._showBackdrop(function () {
                            f(document.body).removeClass(ci),
                                t._resetAdjustments(),
                                t._resetScrollbar(),
                                f(t._element).trigger(si.HIDDEN);
                        });
                }),
                (t._removeBackdrop = function () {
                    this._backdrop &&
                        (f(this._backdrop).remove(), (this._backdrop = null));
                }),
                (t._showBackdrop = function (t) {
                    var e = this,
                        i = f(this._element).hasClass(hi) ? hi : "";
                    if (this._isShown && this._config.backdrop) {
                        if (
                            ((this._backdrop = document.createElement("div")),
                            (this._backdrop.className = li),
                            i && this._backdrop.classList.add(i),
                            f(this._backdrop).appendTo(document.body),
                            f(this._element).on(si.CLICK_DISMISS, function (t) {
                                e._ignoreBackdropClick
                                    ? (e._ignoreBackdropClick = !1)
                                    : t.target === t.currentTarget &&
                                      ("static" === e._config.backdrop
                                          ? e._element.focus()
                                          : e.hide());
                            }),
                            i && g.reflow(this._backdrop),
                            f(this._backdrop).addClass(di),
                            !t)
                        )
                            return;
                        if (!i) return void t();
                        var n = g.getTransitionDurationFromElement(
                            this._backdrop,
                        );
                        f(this._backdrop)
                            .one(g.TRANSITION_END, t)
                            .emulateTransitionEnd(n);
                    } else if (!this._isShown && this._backdrop) {
                        f(this._backdrop).removeClass(di);
                        var o = function () {
                            e._removeBackdrop(), t && t();
                        };
                        if (f(this._element).hasClass(hi)) {
                            var s = g.getTransitionDurationFromElement(
                                this._backdrop,
                            );
                            f(this._backdrop)
                                .one(g.TRANSITION_END, o)
                                .emulateTransitionEnd(s);
                        } else o();
                    } else t && t();
                }),
                (t._adjustDialog = function () {
                    var t =
                        this._element.scrollHeight >
                        document.documentElement.clientHeight;
                    !this._isBodyOverflowing &&
                        t &&
                        (this._element.style.paddingLeft =
                            this._scrollbarWidth + "px"),
                        this._isBodyOverflowing &&
                            !t &&
                            (this._element.style.paddingRight =
                                this._scrollbarWidth + "px");
                }),
                (t._resetAdjustments = function () {
                    (this._element.style.paddingLeft = ""),
                        (this._element.style.paddingRight = "");
                }),
                (t._checkScrollbar = function () {
                    var t = document.body.getBoundingClientRect();
                    (this._isBodyOverflowing =
                        t.left + t.right < window.innerWidth),
                        (this._scrollbarWidth = this._getScrollbarWidth());
                }),
                (t._setScrollbar = function () {
                    var o = this;
                    if (this._isBodyOverflowing) {
                        var t = [].slice.call(document.querySelectorAll(mi)),
                            e = [].slice.call(document.querySelectorAll(vi));
                        f(t).each(function (t, e) {
                            var i = e.style.paddingRight,
                                n = f(e).css("padding-right");
                            f(e)
                                .data("padding-right", i)
                                .css(
                                    "padding-right",
                                    parseFloat(n) + o._scrollbarWidth + "px",
                                );
                        }),
                            f(e).each(function (t, e) {
                                var i = e.style.marginRight,
                                    n = f(e).css("margin-right");
                                f(e)
                                    .data("margin-right", i)
                                    .css(
                                        "margin-right",
                                        parseFloat(n) -
                                            o._scrollbarWidth +
                                            "px",
                                    );
                            });
                        var i = document.body.style.paddingRight,
                            n = f(document.body).css("padding-right");
                        f(document.body)
                            .data("padding-right", i)
                            .css(
                                "padding-right",
                                parseFloat(n) + this._scrollbarWidth + "px",
                            );
                    }
                    f(document.body).addClass(ci);
                }),
                (t._resetScrollbar = function () {
                    var t = [].slice.call(document.querySelectorAll(mi));
                    f(t).each(function (t, e) {
                        var i = f(e).data("padding-right");
                        f(e).removeData("padding-right"),
                            (e.style.paddingRight = i || "");
                    });
                    var e = [].slice.call(document.querySelectorAll("" + vi));
                    f(e).each(function (t, e) {
                        var i = f(e).data("margin-right");
                        void 0 !== i &&
                            f(e)
                                .css("margin-right", i)
                                .removeData("margin-right");
                    });
                    var i = f(document.body).data("padding-right");
                    f(document.body).removeData("padding-right"),
                        (document.body.style.paddingRight = i || "");
                }),
                (t._getScrollbarWidth = function () {
                    var t = document.createElement("div");
                    (t.className = ai), document.body.appendChild(t);
                    var e = t.getBoundingClientRect().width - t.clientWidth;
                    return document.body.removeChild(t), e;
                }),
                (o._jQueryInterface = function (i, n) {
                    return this.each(function () {
                        var t = f(this).data(ti),
                            e = l(
                                {},
                                ni,
                                f(this).data(),
                                "object" == typeof i && i ? i : {},
                            );
                        if (
                            (t || ((t = new o(this, e)), f(this).data(ti, t)),
                            "string" == typeof i)
                        ) {
                            if (void 0 === t[i])
                                throw new TypeError(
                                    'No method named "' + i + '"',
                                );
                            t[i](n);
                        } else e.show && t.show(n);
                    });
                }),
                r(o, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                    {
                        key: "Default",
                        get: function () {
                            return ni;
                        },
                    },
                ]),
                o
            );
        })();
    f(document).on(si.CLICK_DATA_API, fi, function (t) {
        var e,
            i = this,
            n = g.getSelectorFromElement(this);
        n && (e = document.querySelector(n));
        var o = f(e).data(ti) ? "toggle" : l({}, f(e).data(), f(this).data());
        ("A" !== this.tagName && "AREA" !== this.tagName) || t.preventDefault();
        var s = f(e).one(si.SHOW, function (t) {
            t.isDefaultPrevented() ||
                s.one(si.HIDDEN, function () {
                    f(i).is(":visible") && i.focus();
                });
        });
        yi._jQueryInterface.call(f(e), o, this);
    }),
        (f.fn[Je] = yi._jQueryInterface),
        (f.fn[Je].Constructor = yi),
        (f.fn[Je].noConflict = function () {
            return (f.fn[Je] = ii), yi._jQueryInterface;
        });
    var _i = [
            "background",
            "cite",
            "href",
            "itemtype",
            "longdesc",
            "poster",
            "src",
            "xlink:href",
        ],
        bi = {
            "*": ["class", "dir", "id", "lang", "role", /^aria-[\w-]*$/i],
            a: ["target", "href", "title", "rel"],
            area: [],
            b: [],
            br: [],
            col: [],
            code: [],
            div: [],
            em: [],
            hr: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            i: [],
            img: ["src", "alt", "title", "width", "height"],
            li: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            small: [],
            span: [],
            sub: [],
            sup: [],
            strong: [],
            u: [],
            ul: [],
        },
        wi = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi,
        xi =
            /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
    function Si(t, s, e) {
        if (0 === t.length) return t;
        if (e && "function" == typeof e) return e(t);
        for (
            var i = new window.DOMParser().parseFromString(t, "text/html"),
                r = Object.keys(s),
                a = [].slice.call(i.body.querySelectorAll("*")),
                n = function (t) {
                    var e = a[t],
                        i = e.nodeName.toLowerCase();
                    if (-1 === r.indexOf(e.nodeName.toLowerCase()))
                        return e.parentNode.removeChild(e), "continue";
                    var n = [].slice.call(e.attributes),
                        o = [].concat(s["*"] || [], s[i] || []);
                    n.forEach(function (t) {
                        !(function (t, e) {
                            var i = t.nodeName.toLowerCase();
                            if (-1 !== e.indexOf(i))
                                return (
                                    -1 === _i.indexOf(i) ||
                                    Boolean(
                                        t.nodeValue.match(wi) ||
                                            t.nodeValue.match(xi),
                                    )
                                );
                            for (
                                var n = e.filter(function (t) {
                                        return t instanceof RegExp;
                                    }),
                                    o = 0,
                                    s = n.length;
                                o < s;
                                o++
                            )
                                if (i.match(n[o])) return 1;
                        })(t, o) && e.removeAttribute(t.nodeName);
                    });
                },
                o = 0,
                l = a.length;
            o < l;
            o++
        )
            n(o);
        return i.body.innerHTML;
    }
    var Ti = "tooltip",
        Ci = "bs.tooltip",
        ki = "." + Ci,
        Ei = f.fn[Ti],
        $i = "bs-tooltip",
        Ii = new RegExp("(^|\\s)" + $i + "\\S+", "g"),
        Ai = ["sanitize", "whiteList", "sanitizeFn"],
        Oi = {
            animation: "boolean",
            template: "string",
            title: "(string|element|function)",
            trigger: "string",
            delay: "(number|object)",
            html: "boolean",
            selector: "(string|boolean)",
            placement: "(string|function)",
            offset: "(number|string|function)",
            container: "(string|element|boolean)",
            fallbackPlacement: "(string|array)",
            boundary: "(string|element)",
            sanitize: "boolean",
            sanitizeFn: "(null|function)",
            whiteList: "object",
        },
        Pi = {
            AUTO: "auto",
            TOP: "top",
            RIGHT: "right",
            BOTTOM: "bottom",
            LEFT: "left",
        },
        Di = {
            animation: !0,
            template:
                '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
            trigger: "hover focus",
            title: "",
            delay: 0,
            html: !1,
            selector: !1,
            placement: "top",
            offset: 0,
            container: !1,
            fallbackPlacement: "flip",
            boundary: "scrollParent",
            sanitize: !0,
            sanitizeFn: null,
            whiteList: bi,
        },
        Mi = "show",
        Li = "out",
        ji = {
            HIDE: "hide" + ki,
            HIDDEN: "hidden" + ki,
            SHOW: "show" + ki,
            SHOWN: "shown" + ki,
            INSERTED: "inserted" + ki,
            CLICK: "click" + ki,
            FOCUSIN: "focusin" + ki,
            FOCUSOUT: "focusout" + ki,
            MOUSEENTER: "mouseenter" + ki,
            MOUSELEAVE: "mouseleave" + ki,
        },
        zi = "fade",
        Fi = "show",
        Hi = ".tooltip-inner",
        Ni = ".arrow",
        Ri = "hover",
        Wi = "focus",
        qi = "click",
        Bi = "manual",
        Ui = (function () {
            function n(t, e) {
                if (void 0 === Se)
                    throw new TypeError(
                        "Bootstrap's tooltips require Popper.js (https://popper.js.org/)",
                    );
                (this._isEnabled = !0),
                    (this._timeout = 0),
                    (this._hoverState = ""),
                    (this._activeTrigger = {}),
                    (this._popper = null),
                    (this.element = t),
                    (this.config = this._getConfig(e)),
                    (this.tip = null),
                    this._setListeners();
            }
            var t = n.prototype;
            return (
                (t.enable = function () {
                    this._isEnabled = !0;
                }),
                (t.disable = function () {
                    this._isEnabled = !1;
                }),
                (t.toggleEnabled = function () {
                    this._isEnabled = !this._isEnabled;
                }),
                (t.toggle = function (t) {
                    if (this._isEnabled)
                        if (t) {
                            var e = this.constructor.DATA_KEY,
                                i = f(t.currentTarget).data(e);
                            i ||
                                ((i = new this.constructor(
                                    t.currentTarget,
                                    this._getDelegateConfig(),
                                )),
                                f(t.currentTarget).data(e, i)),
                                (i._activeTrigger.click =
                                    !i._activeTrigger.click),
                                i._isWithActiveTrigger()
                                    ? i._enter(null, i)
                                    : i._leave(null, i);
                        } else {
                            if (f(this.getTipElement()).hasClass(Fi))
                                return void this._leave(null, this);
                            this._enter(null, this);
                        }
                }),
                (t.dispose = function () {
                    clearTimeout(this._timeout),
                        f.removeData(this.element, this.constructor.DATA_KEY),
                        f(this.element).off(this.constructor.EVENT_KEY),
                        f(this.element).closest(".modal").off("hide.bs.modal"),
                        this.tip && f(this.tip).remove(),
                        (this._isEnabled = null),
                        (this._timeout = null),
                        (this._hoverState = null),
                        (this._activeTrigger = null) !== this._popper &&
                            this._popper.destroy(),
                        (this._popper = null),
                        (this.element = null),
                        (this.config = null),
                        (this.tip = null);
                }),
                (t.show = function () {
                    var e = this;
                    if ("none" === f(this.element).css("display"))
                        throw new Error("Please use show on visible elements");
                    var t = f.Event(this.constructor.Event.SHOW);
                    if (this.isWithContent() && this._isEnabled) {
                        f(this.element).trigger(t);
                        var i = g.findShadowRoot(this.element),
                            n = f.contains(
                                null !== i
                                    ? i
                                    : this.element.ownerDocument
                                          .documentElement,
                                this.element,
                            );
                        if (t.isDefaultPrevented() || !n) return;
                        var o = this.getTipElement(),
                            s = g.getUID(this.constructor.NAME);
                        o.setAttribute("id", s),
                            this.element.setAttribute("aria-describedby", s),
                            this.setContent(),
                            this.config.animation && f(o).addClass(zi);
                        var r =
                                "function" == typeof this.config.placement
                                    ? this.config.placement.call(
                                          this,
                                          o,
                                          this.element,
                                      )
                                    : this.config.placement,
                            a = this._getAttachment(r);
                        this.addAttachmentClass(a);
                        var l = this._getContainer();
                        f(o).data(this.constructor.DATA_KEY, this),
                            f.contains(
                                this.element.ownerDocument.documentElement,
                                this.tip,
                            ) || f(o).appendTo(l),
                            f(this.element).trigger(
                                this.constructor.Event.INSERTED,
                            ),
                            (this._popper = new Se(this.element, o, {
                                placement: a,
                                modifiers: {
                                    offset: this._getOffset(),
                                    flip: {
                                        behavior: this.config.fallbackPlacement,
                                    },
                                    arrow: { element: Ni },
                                    preventOverflow: {
                                        boundariesElement: this.config.boundary,
                                    },
                                },
                                onCreate: function (t) {
                                    t.originalPlacement !== t.placement &&
                                        e._handlePopperPlacementChange(t);
                                },
                                onUpdate: function (t) {
                                    return e._handlePopperPlacementChange(t);
                                },
                            })),
                            f(o).addClass(Fi),
                            "ontouchstart" in document.documentElement &&
                                f(document.body)
                                    .children()
                                    .on("mouseover", null, f.noop);
                        var c = function () {
                            e.config.animation && e._fixTransition();
                            var t = e._hoverState;
                            (e._hoverState = null),
                                f(e.element).trigger(e.constructor.Event.SHOWN),
                                t === Li && e._leave(null, e);
                        };
                        if (f(this.tip).hasClass(zi)) {
                            var h = g.getTransitionDurationFromElement(
                                this.tip,
                            );
                            f(this.tip)
                                .one(g.TRANSITION_END, c)
                                .emulateTransitionEnd(h);
                        } else c();
                    }
                }),
                (t.hide = function (t) {
                    function e() {
                        i._hoverState !== Mi &&
                            n.parentNode &&
                            n.parentNode.removeChild(n),
                            i._cleanTipClass(),
                            i.element.removeAttribute("aria-describedby"),
                            f(i.element).trigger(i.constructor.Event.HIDDEN),
                            null !== i._popper && i._popper.destroy(),
                            t && t();
                    }
                    var i = this,
                        n = this.getTipElement(),
                        o = f.Event(this.constructor.Event.HIDE);
                    if ((f(this.element).trigger(o), !o.isDefaultPrevented())) {
                        if (
                            (f(n).removeClass(Fi),
                            "ontouchstart" in document.documentElement &&
                                f(document.body)
                                    .children()
                                    .off("mouseover", null, f.noop),
                            (this._activeTrigger[qi] = !1),
                            (this._activeTrigger[Wi] = !1),
                            (this._activeTrigger[Ri] = !1),
                            f(this.tip).hasClass(zi))
                        ) {
                            var s = g.getTransitionDurationFromElement(n);
                            f(n)
                                .one(g.TRANSITION_END, e)
                                .emulateTransitionEnd(s);
                        } else e();
                        this._hoverState = "";
                    }
                }),
                (t.update = function () {
                    null !== this._popper && this._popper.scheduleUpdate();
                }),
                (t.isWithContent = function () {
                    return Boolean(this.getTitle());
                }),
                (t.addAttachmentClass = function (t) {
                    f(this.getTipElement()).addClass($i + "-" + t);
                }),
                (t.getTipElement = function () {
                    return (
                        (this.tip = this.tip || f(this.config.template)[0]),
                        this.tip
                    );
                }),
                (t.setContent = function () {
                    var t = this.getTipElement();
                    this.setElementContent(
                        f(t.querySelectorAll(Hi)),
                        this.getTitle(),
                    ),
                        f(t).removeClass(zi + " " + Fi);
                }),
                (t.setElementContent = function (t, e) {
                    "object" != typeof e || (!e.nodeType && !e.jquery)
                        ? this.config.html
                            ? (this.config.sanitize &&
                                  (e = Si(
                                      e,
                                      this.config.whiteList,
                                      this.config.sanitizeFn,
                                  )),
                              t.html(e))
                            : t.text(e)
                        : this.config.html
                          ? f(e).parent().is(t) || t.empty().append(e)
                          : t.text(f(e).text());
                }),
                (t.getTitle = function () {
                    var t = this.element.getAttribute("data-original-title");
                    return (t =
                        t ||
                        ("function" == typeof this.config.title
                            ? this.config.title.call(this.element)
                            : this.config.title));
                }),
                (t._getOffset = function () {
                    var e = this,
                        t = {};
                    return (
                        "function" == typeof this.config.offset
                            ? (t.fn = function (t) {
                                  return (
                                      (t.offsets = l(
                                          {},
                                          t.offsets,
                                          e.config.offset(
                                              t.offsets,
                                              e.element,
                                          ) || {},
                                      )),
                                      t
                                  );
                              })
                            : (t.offset = this.config.offset),
                        t
                    );
                }),
                (t._getContainer = function () {
                    return !1 === this.config.container
                        ? document.body
                        : g.isElement(this.config.container)
                          ? f(this.config.container)
                          : f(document).find(this.config.container);
                }),
                (t._getAttachment = function (t) {
                    return Pi[t.toUpperCase()];
                }),
                (t._setListeners = function () {
                    var n = this;
                    this.config.trigger.split(" ").forEach(function (t) {
                        if ("click" === t)
                            f(n.element).on(
                                n.constructor.Event.CLICK,
                                n.config.selector,
                                function (t) {
                                    return n.toggle(t);
                                },
                            );
                        else if (t !== Bi) {
                            var e =
                                    t === Ri
                                        ? n.constructor.Event.MOUSEENTER
                                        : n.constructor.Event.FOCUSIN,
                                i =
                                    t === Ri
                                        ? n.constructor.Event.MOUSELEAVE
                                        : n.constructor.Event.FOCUSOUT;
                            f(n.element)
                                .on(e, n.config.selector, function (t) {
                                    return n._enter(t);
                                })
                                .on(i, n.config.selector, function (t) {
                                    return n._leave(t);
                                });
                        }
                    }),
                        f(this.element)
                            .closest(".modal")
                            .on("hide.bs.modal", function () {
                                n.element && n.hide();
                            }),
                        this.config.selector
                            ? (this.config = l({}, this.config, {
                                  trigger: "manual",
                                  selector: "",
                              }))
                            : this._fixTitle();
                }),
                (t._fixTitle = function () {
                    var t = typeof this.element.getAttribute(
                        "data-original-title",
                    );
                    (!this.element.getAttribute("title") && "string" == t) ||
                        (this.element.setAttribute(
                            "data-original-title",
                            this.element.getAttribute("title") || "",
                        ),
                        this.element.setAttribute("title", ""));
                }),
                (t._enter = function (t, e) {
                    var i = this.constructor.DATA_KEY;
                    (e = e || f(t.currentTarget).data(i)) ||
                        ((e = new this.constructor(
                            t.currentTarget,
                            this._getDelegateConfig(),
                        )),
                        f(t.currentTarget).data(i, e)),
                        t &&
                            (e._activeTrigger["focusin" === t.type ? Wi : Ri] =
                                !0),
                        f(e.getTipElement()).hasClass(Fi) ||
                        e._hoverState === Mi
                            ? (e._hoverState = Mi)
                            : (clearTimeout(e._timeout),
                              (e._hoverState = Mi),
                              e.config.delay && e.config.delay.show
                                  ? (e._timeout = setTimeout(function () {
                                        e._hoverState === Mi && e.show();
                                    }, e.config.delay.show))
                                  : e.show());
                }),
                (t._leave = function (t, e) {
                    var i = this.constructor.DATA_KEY;
                    (e = e || f(t.currentTarget).data(i)) ||
                        ((e = new this.constructor(
                            t.currentTarget,
                            this._getDelegateConfig(),
                        )),
                        f(t.currentTarget).data(i, e)),
                        t &&
                            (e._activeTrigger["focusout" === t.type ? Wi : Ri] =
                                !1),
                        e._isWithActiveTrigger() ||
                            (clearTimeout(e._timeout),
                            (e._hoverState = Li),
                            e.config.delay && e.config.delay.hide
                                ? (e._timeout = setTimeout(function () {
                                      e._hoverState === Li && e.hide();
                                  }, e.config.delay.hide))
                                : e.hide());
                }),
                (t._isWithActiveTrigger = function () {
                    for (var t in this._activeTrigger)
                        if (this._activeTrigger[t]) return !0;
                    return !1;
                }),
                (t._getConfig = function (t) {
                    var e = f(this.element).data();
                    return (
                        Object.keys(e).forEach(function (t) {
                            -1 !== Ai.indexOf(t) && delete e[t];
                        }),
                        "number" ==
                            typeof (t = l(
                                {},
                                this.constructor.Default,
                                e,
                                "object" == typeof t && t ? t : {},
                            )).delay &&
                            (t.delay = { show: t.delay, hide: t.delay }),
                        "number" == typeof t.title &&
                            (t.title = t.title.toString()),
                        "number" == typeof t.content &&
                            (t.content = t.content.toString()),
                        g.typeCheckConfig(Ti, t, this.constructor.DefaultType),
                        t.sanitize &&
                            (t.template = Si(
                                t.template,
                                t.whiteList,
                                t.sanitizeFn,
                            )),
                        t
                    );
                }),
                (t._getDelegateConfig = function () {
                    var t = {};
                    if (this.config)
                        for (var e in this.config)
                            this.constructor.Default[e] !== this.config[e] &&
                                (t[e] = this.config[e]);
                    return t;
                }),
                (t._cleanTipClass = function () {
                    var t = f(this.getTipElement()),
                        e = t.attr("class").match(Ii);
                    null !== e && e.length && t.removeClass(e.join(""));
                }),
                (t._handlePopperPlacementChange = function (t) {
                    var e = t.instance;
                    (this.tip = e.popper),
                        this._cleanTipClass(),
                        this.addAttachmentClass(
                            this._getAttachment(t.placement),
                        );
                }),
                (t._fixTransition = function () {
                    var t = this.getTipElement(),
                        e = this.config.animation;
                    null === t.getAttribute("x-placement") &&
                        (f(t).removeClass(zi),
                        (this.config.animation = !1),
                        this.hide(),
                        this.show(),
                        (this.config.animation = e));
                }),
                (n._jQueryInterface = function (i) {
                    return this.each(function () {
                        var t = f(this).data(Ci),
                            e = "object" == typeof i && i;
                        if (
                            (t || !/dispose|hide/.test(i)) &&
                            (t || ((t = new n(this, e)), f(this).data(Ci, t)),
                            "string" == typeof i)
                        ) {
                            if (void 0 === t[i])
                                throw new TypeError(
                                    'No method named "' + i + '"',
                                );
                            t[i]();
                        }
                    });
                }),
                r(n, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                    {
                        key: "Default",
                        get: function () {
                            return Di;
                        },
                    },
                    {
                        key: "NAME",
                        get: function () {
                            return Ti;
                        },
                    },
                    {
                        key: "DATA_KEY",
                        get: function () {
                            return Ci;
                        },
                    },
                    {
                        key: "Event",
                        get: function () {
                            return ji;
                        },
                    },
                    {
                        key: "EVENT_KEY",
                        get: function () {
                            return ki;
                        },
                    },
                    {
                        key: "DefaultType",
                        get: function () {
                            return Oi;
                        },
                    },
                ]),
                n
            );
        })();
    (f.fn[Ti] = Ui._jQueryInterface),
        (f.fn[Ti].Constructor = Ui),
        (f.fn[Ti].noConflict = function () {
            return (f.fn[Ti] = Ei), Ui._jQueryInterface;
        });
    var Qi = "popover",
        Yi = "bs.popover",
        Xi = "." + Yi,
        Vi = f.fn[Qi],
        Ki = "bs-popover",
        Gi = new RegExp("(^|\\s)" + Ki + "\\S+", "g"),
        Zi = l({}, Ui.Default, {
            placement: "right",
            trigger: "click",
            content: "",
            template:
                '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        }),
        Ji = l({}, Ui.DefaultType, { content: "(string|element|function)" }),
        tn = "fade",
        en = "show",
        nn = ".popover-header",
        on = ".popover-body",
        sn = {
            HIDE: "hide" + Xi,
            HIDDEN: "hidden" + Xi,
            SHOW: "show" + Xi,
            SHOWN: "shown" + Xi,
            INSERTED: "inserted" + Xi,
            CLICK: "click" + Xi,
            FOCUSIN: "focusin" + Xi,
            FOCUSOUT: "focusout" + Xi,
            MOUSEENTER: "mouseenter" + Xi,
            MOUSELEAVE: "mouseleave" + Xi,
        },
        rn = (function (t) {
            var e, i;
            function n() {
                return t.apply(this, arguments) || this;
            }
            (i = t),
                ((e = n).prototype = Object.create(i.prototype)),
                ((e.prototype.constructor = e).__proto__ = i);
            var o = n.prototype;
            return (
                (o.isWithContent = function () {
                    return this.getTitle() || this._getContent();
                }),
                (o.addAttachmentClass = function (t) {
                    f(this.getTipElement()).addClass(Ki + "-" + t);
                }),
                (o.getTipElement = function () {
                    return (
                        (this.tip = this.tip || f(this.config.template)[0]),
                        this.tip
                    );
                }),
                (o.setContent = function () {
                    var t = f(this.getTipElement());
                    this.setElementContent(t.find(nn), this.getTitle());
                    var e = this._getContent();
                    "function" == typeof e && (e = e.call(this.element)),
                        this.setElementContent(t.find(on), e),
                        t.removeClass(tn + " " + en);
                }),
                (o._getContent = function () {
                    return (
                        this.element.getAttribute("data-content") ||
                        this.config.content
                    );
                }),
                (o._cleanTipClass = function () {
                    var t = f(this.getTipElement()),
                        e = t.attr("class").match(Gi);
                    null !== e && 0 < e.length && t.removeClass(e.join(""));
                }),
                (n._jQueryInterface = function (i) {
                    return this.each(function () {
                        var t = f(this).data(Yi),
                            e = "object" == typeof i ? i : null;
                        if (
                            (t || !/dispose|hide/.test(i)) &&
                            (t || ((t = new n(this, e)), f(this).data(Yi, t)),
                            "string" == typeof i)
                        ) {
                            if (void 0 === t[i])
                                throw new TypeError(
                                    'No method named "' + i + '"',
                                );
                            t[i]();
                        }
                    });
                }),
                r(n, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                    {
                        key: "Default",
                        get: function () {
                            return Zi;
                        },
                    },
                    {
                        key: "NAME",
                        get: function () {
                            return Qi;
                        },
                    },
                    {
                        key: "DATA_KEY",
                        get: function () {
                            return Yi;
                        },
                    },
                    {
                        key: "Event",
                        get: function () {
                            return sn;
                        },
                    },
                    {
                        key: "EVENT_KEY",
                        get: function () {
                            return Xi;
                        },
                    },
                    {
                        key: "DefaultType",
                        get: function () {
                            return Ji;
                        },
                    },
                ]),
                n
            );
        })(Ui);
    (f.fn[Qi] = rn._jQueryInterface),
        (f.fn[Qi].Constructor = rn),
        (f.fn[Qi].noConflict = function () {
            return (f.fn[Qi] = Vi), rn._jQueryInterface;
        });
    var an = "scrollspy",
        ln = "bs.scrollspy",
        cn = "." + ln,
        hn = f.fn[an],
        dn = { offset: 10, method: "auto", target: "" },
        un = { offset: "number", method: "string", target: "(string|element)" },
        pn = {
            ACTIVATE: "activate" + cn,
            SCROLL: "scroll" + cn,
            LOAD_DATA_API: "load" + cn + ".data-api",
        },
        fn = "dropdown-item",
        gn = "active",
        mn = '[data-spy="scroll"]',
        vn = ".nav, .list-group",
        yn = ".nav-link",
        _n = ".nav-item",
        bn = ".list-group-item",
        wn = ".dropdown",
        xn = ".dropdown-item",
        Sn = ".dropdown-toggle",
        Tn = "offset",
        Cn = "position",
        kn = (function () {
            function i(t, e) {
                var i = this;
                (this._element = t),
                    (this._scrollElement = "BODY" === t.tagName ? window : t),
                    (this._config = this._getConfig(e)),
                    (this._selector =
                        this._config.target +
                        " " +
                        yn +
                        "," +
                        this._config.target +
                        " " +
                        bn +
                        "," +
                        this._config.target +
                        " " +
                        xn),
                    (this._offsets = []),
                    (this._targets = []),
                    (this._activeTarget = null),
                    (this._scrollHeight = 0),
                    f(this._scrollElement).on(pn.SCROLL, function (t) {
                        return i._process(t);
                    }),
                    this.refresh(),
                    this._process();
            }
            var t = i.prototype;
            return (
                (t.refresh = function () {
                    var e = this,
                        t =
                            this._scrollElement === this._scrollElement.window
                                ? Tn
                                : Cn,
                        o =
                            "auto" === this._config.method
                                ? t
                                : this._config.method,
                        s = o === Cn ? this._getScrollTop() : 0;
                    (this._offsets = []),
                        (this._targets = []),
                        (this._scrollHeight = this._getScrollHeight()),
                        [].slice
                            .call(document.querySelectorAll(this._selector))
                            .map(function (t) {
                                var e,
                                    i = g.getSelectorFromElement(t);
                                if ((i && (e = document.querySelector(i)), e)) {
                                    var n = e.getBoundingClientRect();
                                    if (n.width || n.height)
                                        return [f(e)[o]().top + s, i];
                                }
                                return null;
                            })
                            .filter(function (t) {
                                return t;
                            })
                            .sort(function (t, e) {
                                return t[0] - e[0];
                            })
                            .forEach(function (t) {
                                e._offsets.push(t[0]), e._targets.push(t[1]);
                            });
                }),
                (t.dispose = function () {
                    f.removeData(this._element, ln),
                        f(this._scrollElement).off(cn),
                        (this._element = null),
                        (this._scrollElement = null),
                        (this._config = null),
                        (this._selector = null),
                        (this._offsets = null),
                        (this._targets = null),
                        (this._activeTarget = null),
                        (this._scrollHeight = null);
                }),
                (t._getConfig = function (t) {
                    if (
                        "string" !=
                        typeof (t = l(
                            {},
                            dn,
                            "object" == typeof t && t ? t : {},
                        )).target
                    ) {
                        var e = f(t.target).attr("id");
                        e || ((e = g.getUID(an)), f(t.target).attr("id", e)),
                            (t.target = "#" + e);
                    }
                    return g.typeCheckConfig(an, t, un), t;
                }),
                (t._getScrollTop = function () {
                    return this._scrollElement === window
                        ? this._scrollElement.pageYOffset
                        : this._scrollElement.scrollTop;
                }),
                (t._getScrollHeight = function () {
                    return (
                        this._scrollElement.scrollHeight ||
                        Math.max(
                            document.body.scrollHeight,
                            document.documentElement.scrollHeight,
                        )
                    );
                }),
                (t._getOffsetHeight = function () {
                    return this._scrollElement === window
                        ? window.innerHeight
                        : this._scrollElement.getBoundingClientRect().height;
                }),
                (t._process = function () {
                    var t = this._getScrollTop() + this._config.offset,
                        e = this._getScrollHeight(),
                        i = this._config.offset + e - this._getOffsetHeight();
                    if ((this._scrollHeight !== e && this.refresh(), i <= t)) {
                        var n = this._targets[this._targets.length - 1];
                        this._activeTarget !== n && this._activate(n);
                    } else {
                        if (
                            this._activeTarget &&
                            t < this._offsets[0] &&
                            0 < this._offsets[0]
                        )
                            return (
                                (this._activeTarget = null), void this._clear()
                            );
                        for (var o = this._offsets.length; o--; ) {
                            this._activeTarget !== this._targets[o] &&
                                t >= this._offsets[o] &&
                                (void 0 === this._offsets[o + 1] ||
                                    t < this._offsets[o + 1]) &&
                                this._activate(this._targets[o]);
                        }
                    }
                }),
                (t._activate = function (e) {
                    (this._activeTarget = e), this._clear();
                    var t = this._selector.split(",").map(function (t) {
                            return (
                                t +
                                '[data-target="' +
                                e +
                                '"],' +
                                t +
                                '[href="' +
                                e +
                                '"]'
                            );
                        }),
                        i = f(
                            [].slice.call(
                                document.querySelectorAll(t.join(",")),
                            ),
                        );
                    i.hasClass(fn)
                        ? (i.closest(wn).find(Sn).addClass(gn), i.addClass(gn))
                        : (i.addClass(gn),
                          i
                              .parents(vn)
                              .prev(yn + ", " + bn)
                              .addClass(gn),
                          i.parents(vn).prev(_n).children(yn).addClass(gn)),
                        f(this._scrollElement).trigger(pn.ACTIVATE, {
                            relatedTarget: e,
                        });
                }),
                (t._clear = function () {
                    [].slice
                        .call(document.querySelectorAll(this._selector))
                        .filter(function (t) {
                            return t.classList.contains(gn);
                        })
                        .forEach(function (t) {
                            return t.classList.remove(gn);
                        });
                }),
                (i._jQueryInterface = function (e) {
                    return this.each(function () {
                        var t = f(this).data(ln);
                        if (
                            (t ||
                                ((t = new i(this, "object" == typeof e && e)),
                                f(this).data(ln, t)),
                            "string" == typeof e)
                        ) {
                            if (void 0 === t[e])
                                throw new TypeError(
                                    'No method named "' + e + '"',
                                );
                            t[e]();
                        }
                    });
                }),
                r(i, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                    {
                        key: "Default",
                        get: function () {
                            return dn;
                        },
                    },
                ]),
                i
            );
        })();
    f(window).on(pn.LOAD_DATA_API, function () {
        for (
            var t = [].slice.call(document.querySelectorAll(mn)), e = t.length;
            e--;

        ) {
            var i = f(t[e]);
            kn._jQueryInterface.call(i, i.data());
        }
    }),
        (f.fn[an] = kn._jQueryInterface),
        (f.fn[an].Constructor = kn),
        (f.fn[an].noConflict = function () {
            return (f.fn[an] = hn), kn._jQueryInterface;
        });
    var En = "bs.tab",
        $n = "." + En,
        In = f.fn.tab,
        An = {
            HIDE: "hide" + $n,
            HIDDEN: "hidden" + $n,
            SHOW: "show" + $n,
            SHOWN: "shown" + $n,
            CLICK_DATA_API: "click" + $n + ".data-api",
        },
        On = "dropdown-menu",
        Pn = "active",
        Dn = "disabled",
        Mn = "fade",
        Ln = "show",
        jn = ".dropdown",
        zn = ".nav, .list-group",
        Fn = ".active",
        Hn = "> li > .active",
        Nn = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
        Rn = ".dropdown-toggle",
        Wn = "> .dropdown-menu .active",
        qn = (function () {
            function n(t) {
                this._element = t;
            }
            var t = n.prototype;
            return (
                (t.show = function () {
                    var i = this;
                    if (
                        !(
                            (this._element.parentNode &&
                                this._element.parentNode.nodeType ===
                                    Node.ELEMENT_NODE &&
                                f(this._element).hasClass(Pn)) ||
                            f(this._element).hasClass(Dn)
                        )
                    ) {
                        var t,
                            n,
                            e = f(this._element).closest(zn)[0],
                            o = g.getSelectorFromElement(this._element);
                        if (e) {
                            var s =
                                "UL" === e.nodeName || "OL" === e.nodeName
                                    ? Hn
                                    : Fn;
                            n = (n = f.makeArray(f(e).find(s)))[n.length - 1];
                        }
                        var r = f.Event(An.HIDE, {
                                relatedTarget: this._element,
                            }),
                            a = f.Event(An.SHOW, { relatedTarget: n });
                        if (
                            (n && f(n).trigger(r),
                            f(this._element).trigger(a),
                            !a.isDefaultPrevented() && !r.isDefaultPrevented())
                        ) {
                            o && (t = document.querySelector(o)),
                                this._activate(this._element, e);
                            var l = function () {
                                var t = f.Event(An.HIDDEN, {
                                        relatedTarget: i._element,
                                    }),
                                    e = f.Event(An.SHOWN, { relatedTarget: n });
                                f(n).trigger(t), f(i._element).trigger(e);
                            };
                            t ? this._activate(t, t.parentNode, l) : l();
                        }
                    }
                }),
                (t.dispose = function () {
                    f.removeData(this._element, En), (this._element = null);
                }),
                (t._activate = function (t, e, i) {
                    function n() {
                        return o._transitionComplete(t, s, i);
                    }
                    var o = this,
                        s = (
                            !e || ("UL" !== e.nodeName && "OL" !== e.nodeName)
                                ? f(e).children(Fn)
                                : f(e).find(Hn)
                        )[0],
                        r = i && s && f(s).hasClass(Mn);
                    if (s && r) {
                        var a = g.getTransitionDurationFromElement(s);
                        f(s)
                            .removeClass(Ln)
                            .one(g.TRANSITION_END, n)
                            .emulateTransitionEnd(a);
                    } else n();
                }),
                (t._transitionComplete = function (t, e, i) {
                    if (e) {
                        f(e).removeClass(Pn);
                        var n = f(e.parentNode).find(Wn)[0];
                        n && f(n).removeClass(Pn),
                            "tab" === e.getAttribute("role") &&
                                e.setAttribute("aria-selected", !1);
                    }
                    if (
                        (f(t).addClass(Pn),
                        "tab" === t.getAttribute("role") &&
                            t.setAttribute("aria-selected", !0),
                        g.reflow(t),
                        t.classList.contains(Mn) && t.classList.add(Ln),
                        t.parentNode && f(t.parentNode).hasClass(On))
                    ) {
                        var o = f(t).closest(jn)[0];
                        if (o) {
                            var s = [].slice.call(o.querySelectorAll(Rn));
                            f(s).addClass(Pn);
                        }
                        t.setAttribute("aria-expanded", !0);
                    }
                    i && i();
                }),
                (n._jQueryInterface = function (i) {
                    return this.each(function () {
                        var t = f(this),
                            e = t.data(En);
                        if (
                            (e || ((e = new n(this)), t.data(En, e)),
                            "string" == typeof i)
                        ) {
                            if (void 0 === e[i])
                                throw new TypeError(
                                    'No method named "' + i + '"',
                                );
                            e[i]();
                        }
                    });
                }),
                r(n, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                ]),
                n
            );
        })();
    f(document).on(An.CLICK_DATA_API, Nn, function (t) {
        t.preventDefault(), qn._jQueryInterface.call(f(this), "show");
    }),
        (f.fn.tab = qn._jQueryInterface),
        (f.fn.tab.Constructor = qn),
        (f.fn.tab.noConflict = function () {
            return (f.fn.tab = In), qn._jQueryInterface;
        });
    var Bn = "toast",
        Un = "bs.toast",
        Qn = "." + Un,
        Yn = f.fn[Bn],
        Xn = {
            CLICK_DISMISS: "click.dismiss" + Qn,
            HIDE: "hide" + Qn,
            HIDDEN: "hidden" + Qn,
            SHOW: "show" + Qn,
            SHOWN: "shown" + Qn,
        },
        Vn = "fade",
        Kn = "hide",
        Gn = "show",
        Zn = "showing",
        Jn = { animation: "boolean", autohide: "boolean", delay: "number" },
        to = { animation: !0, autohide: !0, delay: 500 },
        eo = '[data-dismiss="toast"]',
        io = (function () {
            function n(t, e) {
                (this._element = t),
                    (this._config = this._getConfig(e)),
                    (this._timeout = null),
                    this._setListeners();
            }
            var t = n.prototype;
            return (
                (t.show = function () {
                    var t = this;
                    f(this._element).trigger(Xn.SHOW),
                        this._config.animation &&
                            this._element.classList.add(Vn);
                    function e() {
                        t._element.classList.remove(Zn),
                            t._element.classList.add(Gn),
                            f(t._element).trigger(Xn.SHOWN),
                            t._config.autohide && t.hide();
                    }
                    if (
                        (this._element.classList.remove(Kn),
                        this._element.classList.add(Zn),
                        this._config.animation)
                    ) {
                        var i = g.getTransitionDurationFromElement(
                            this._element,
                        );
                        f(this._element)
                            .one(g.TRANSITION_END, e)
                            .emulateTransitionEnd(i);
                    } else e();
                }),
                (t.hide = function (t) {
                    var e = this;
                    this._element.classList.contains(Gn) &&
                        (f(this._element).trigger(Xn.HIDE),
                        t
                            ? this._close()
                            : (this._timeout = setTimeout(function () {
                                  e._close();
                              }, this._config.delay)));
                }),
                (t.dispose = function () {
                    clearTimeout(this._timeout),
                        (this._timeout = null),
                        this._element.classList.contains(Gn) &&
                            this._element.classList.remove(Gn),
                        f(this._element).off(Xn.CLICK_DISMISS),
                        f.removeData(this._element, Un),
                        (this._element = null),
                        (this._config = null);
                }),
                (t._getConfig = function (t) {
                    return (
                        (t = l(
                            {},
                            to,
                            f(this._element).data(),
                            "object" == typeof t && t ? t : {},
                        )),
                        g.typeCheckConfig(Bn, t, this.constructor.DefaultType),
                        t
                    );
                }),
                (t._setListeners = function () {
                    var t = this;
                    f(this._element).on(Xn.CLICK_DISMISS, eo, function () {
                        return t.hide(!0);
                    });
                }),
                (t._close = function () {
                    function t() {
                        e._element.classList.add(Kn),
                            f(e._element).trigger(Xn.HIDDEN);
                    }
                    var e = this;
                    if (
                        (this._element.classList.remove(Gn),
                        this._config.animation)
                    ) {
                        var i = g.getTransitionDurationFromElement(
                            this._element,
                        );
                        f(this._element)
                            .one(g.TRANSITION_END, t)
                            .emulateTransitionEnd(i);
                    } else t();
                }),
                (n._jQueryInterface = function (i) {
                    return this.each(function () {
                        var t = f(this),
                            e = t.data(Un);
                        if (
                            (e ||
                                ((e = new n(this, "object" == typeof i && i)),
                                t.data(Un, e)),
                            "string" == typeof i)
                        ) {
                            if (void 0 === e[i])
                                throw new TypeError(
                                    'No method named "' + i + '"',
                                );
                            e[i](this);
                        }
                    });
                }),
                r(n, null, [
                    {
                        key: "VERSION",
                        get: function () {
                            return "4.3.1";
                        },
                    },
                    {
                        key: "DefaultType",
                        get: function () {
                            return Jn;
                        },
                    },
                    {
                        key: "Default",
                        get: function () {
                            return to;
                        },
                    },
                ]),
                n
            );
        })();
    (f.fn[Bn] = io._jQueryInterface),
        (f.fn[Bn].Constructor = io),
        (f.fn[Bn].noConflict = function () {
            return (f.fn[Bn] = Yn), io._jQueryInterface;
        }),
        (function () {
            if (void 0 === f)
                throw new TypeError(
                    "Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.",
                );
            var t = f.fn.jquery.split(" ")[0].split(".");
            if (
                (t[0] < 2 && t[1] < 9) ||
                (1 === t[0] && 9 === t[1] && t[2] < 1) ||
                4 <= t[0]
            )
                throw new Error(
                    "Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0",
                );
        })(),
        (t.Util = g),
        (t.Alert = m),
        (t.Button = O),
        (t.Carousel = at),
        (t.Collapse = St),
        (t.Dropdown = Ze),
        (t.Modal = yi),
        (t.Popover = rn),
        (t.Scrollspy = kn),
        (t.Tab = qn),
        (t.Toast = io),
        (t.Tooltip = Ui),
        Object.defineProperty(t, "__esModule", { value: !0 });
}),
    (function (i) {
        "use strict";
        i.fn.counterUp = function (t) {
            var e = i.extend({ time: 400, delay: 10 }, t);
            return this.each(function () {
                var l = i(this),
                    c = e;
                l.waypoint(
                    function () {
                        var t = [],
                            e = c.time / c.delay,
                            i = l.text(),
                            n = /[0-9]+,[0-9]+/.test(i);
                        i = i.replace(/,/g, "");
                        /^[0-9]+$/.test(i);
                        for (
                            var o = /^[0-9]+\.[0-9]+$/.test(i),
                                s = o ? (i.split(".")[1] || []).length : 0,
                                r = e;
                            1 <= r;
                            r--
                        ) {
                            var a = parseInt((i / e) * r);
                            if (
                                (o && (a = parseFloat((i / e) * r).toFixed(s)),
                                n)
                            )
                                for (; /(\d+)(\d{3})/.test(a.toString()); )
                                    a = a
                                        .toString()
                                        .replace(/(\d+)(\d{3})/, "$1,$2");
                            t.unshift(a);
                        }
                        l.data("counterup-nums", t), l.text("0");
                        l.data("counterup-func", function () {
                            l.text(l.data("counterup-nums").shift()),
                                l.data("counterup-nums").length
                                    ? setTimeout(
                                          l.data("counterup-func"),
                                          c.delay,
                                      )
                                    : (l.data("counterup-nums"),
                                      l.data("counterup-nums", null),
                                      l.data("counterup-func", null));
                        }),
                            setTimeout(l.data("counterup-func"), c.delay);
                    },
                    { offset: "100%", triggerOnce: !0 },
                );
            });
        };
    })(jQuery),
    (function (h, r, g, m) {
        "use strict";
        function i(t, e) {
            var i,
                n,
                o = [],
                s = 0;
            (t && t.isDefaultPrevented()) ||
                (t.preventDefault(),
                (n =
                    (i =
                        (e = t && t.data ? t.data.options : e || {}).$target ||
                        g(t.currentTarget)).attr("data-fancybox") || "")
                    ? (s = (o = (o = e.selector
                          ? g(e.selector)
                          : t.data
                            ? t.data.items
                            : []).length
                          ? o.filter('[data-fancybox="' + n + '"]')
                          : g('[data-fancybox="' + n + '"]')).index(i)) < 0 &&
                      (s = 0)
                    : (o = [i]),
                g.fancybox.open(o, e, s));
        }
        if (((h.console = h.console || { info: function (t) {} }), g)) {
            if (g.fn.fancybox)
                return console.info("fancyBox already initialized");
            var t = {
                    loop: !1,
                    gutter: 50,
                    keyboard: !0,
                    arrows: !0,
                    infobar: !0,
                    smallBtn: "auto",
                    toolbar: "auto",
                    buttons: ["zoom", "thumbs", "close"],
                    idleTime: 3,
                    protect: !1,
                    modal: !1,
                    image: { preload: !1 },
                    ajax: { settings: { data: { fancybox: !0 } } },
                    iframe: {
                        tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen allowtransparency="true" src=""></iframe>',
                        preload: !0,
                        css: {},
                        attr: { scrolling: "auto" },
                    },
                    defaultType: "image",
                    animationEffect: "zoom",
                    animationDuration: 366,
                    zoomOpacity: "auto",
                    transitionEffect: "fade",
                    transitionDuration: 366,
                    slideClass: "",
                    baseClass: "",
                    baseTpl:
                        '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"></div></div></div>',
                    spinnerTpl: '<div class="fancybox-loading"></div>',
                    errorTpl:
                        '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
                    btnTpl: {
                        download:
                            '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg viewBox="0 0 40 40"><path d="M13,16 L20,23 L27,16 M20,7 L20,23 M10,24 L10,28 L30,28 L30,24" /></svg></a>',
                        zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg viewBox="0 0 40 40"><path d="M18,17 m-8,0 a8,8 0 1,0 16,0 a8,8 0 1,0 -16,0 M24,22 L31,29" /></svg></button>',
                        close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg viewBox="0 0 40 40"><path d="M10,10 L30,30 M30,10 L10,30" /></svg></button>',
                        smallBtn:
                            '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"><svg viewBox="0 0 32 32"><path d="M10,10 L22,22 M22,10 L10,22"></path></svg></button>',
                        arrowLeft:
                            '<a data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" href="javascript:;"><svg viewBox="0 0 40 40"><path d="M18,12 L10,20 L18,28 M10,20 L30,20"></path></svg></a>',
                        arrowRight:
                            '<a data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" href="javascript:;"><svg viewBox="0 0 40 40"><path d="M10,20 L30,20 M22,12 L30,20 L22,28"></path></svg></a>',
                    },
                    parentEl: "body",
                    autoFocus: !1,
                    backFocus: !0,
                    trapFocus: !0,
                    fullScreen: { autoStart: !1 },
                    touch: { vertical: !0, momentum: !0 },
                    hash: null,
                    media: {},
                    slideShow: { autoStart: !1, speed: 4e3 },
                    thumbs: {
                        autoStart: !1,
                        hideOnClose: !0,
                        parentEl: ".fancybox-container",
                        axis: "y",
                    },
                    wheel: "auto",
                    onInit: g.noop,
                    beforeLoad: g.noop,
                    afterLoad: g.noop,
                    beforeShow: g.noop,
                    afterShow: g.noop,
                    beforeClose: g.noop,
                    afterClose: g.noop,
                    onActivate: g.noop,
                    onDeactivate: g.noop,
                    clickContent: function (t, e) {
                        return "image" === t.type && "zoom";
                    },
                    clickSlide: "close",
                    clickOutside: "close",
                    dblclickContent: !1,
                    dblclickSlide: !1,
                    dblclickOutside: !1,
                    mobile: {
                        idleTime: !1,
                        clickContent: function (t, e) {
                            return "image" === t.type && "toggleControls";
                        },
                        clickSlide: function (t, e) {
                            return "image" === t.type
                                ? "toggleControls"
                                : "close";
                        },
                        dblclickContent: function (t, e) {
                            return "image" === t.type && "zoom";
                        },
                        dblclickSlide: function (t, e) {
                            return "image" === t.type && "zoom";
                        },
                    },
                    lang: "en",
                    i18n: {
                        en: {
                            CLOSE: "Close",
                            NEXT: "Next",
                            PREV: "Previous",
                            ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                            PLAY_START: "Start slideshow",
                            PLAY_STOP: "Pause slideshow",
                            FULL_SCREEN: "Full screen",
                            THUMBS: "Thumbnails",
                            DOWNLOAD: "Download",
                            SHARE: "Share",
                            ZOOM: "Zoom",
                        },
                        de: {
                            CLOSE: "Schliessen",
                            NEXT: "Weiter",
                            PREV: "Zurück",
                            ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.",
                            PLAY_START: "Diaschau starten",
                            PLAY_STOP: "Diaschau beenden",
                            FULL_SCREEN: "Vollbild",
                            THUMBS: "Vorschaubilder",
                            DOWNLOAD: "Herunterladen",
                            SHARE: "Teilen",
                            ZOOM: "Maßstab",
                        },
                    },
                },
                o = g(h),
                a = g(r),
                s = 0,
                u =
                    h.requestAnimationFrame ||
                    h.webkitRequestAnimationFrame ||
                    h.mozRequestAnimationFrame ||
                    h.oRequestAnimationFrame ||
                    function (t) {
                        return h.setTimeout(t, 1e3 / 60);
                    },
                p = (function () {
                    var t,
                        e = r.createElement("fakeelement"),
                        i = {
                            transition: "transitionend",
                            OTransition: "oTransitionEnd",
                            MozTransition: "transitionend",
                            WebkitTransition: "webkitTransitionEnd",
                        };
                    for (t in i) if (e.style[t] !== m) return i[t];
                    return "transitionend";
                })(),
                f = function (t) {
                    return t && t.length && t[0].offsetHeight;
                },
                l = function (t, e) {
                    var i = g.extend(!0, {}, t, e);
                    return (
                        g.each(e, function (t, e) {
                            g.isArray(e) && (i[t] = e);
                        }),
                        i
                    );
                },
                n = function (t, e, i) {
                    var n = this;
                    (n.opts = l({ index: i }, g.fancybox.defaults)),
                        g.isPlainObject(e) && (n.opts = l(n.opts, e)),
                        g.fancybox.isMobile &&
                            (n.opts = l(n.opts, n.opts.mobile)),
                        (n.id = n.opts.id || ++s),
                        (n.currIndex = parseInt(n.opts.index, 10) || 0),
                        (n.prevIndex = null),
                        (n.prevPos = null),
                        (n.currPos = 0),
                        (n.firstRun = !0),
                        (n.group = []),
                        (n.slides = {}),
                        n.addContent(t),
                        n.group.length &&
                            ((n.$lastFocus = g(r.activeElement).trigger(
                                "blur",
                            )),
                            n.init());
                };
            g.extend(n.prototype, {
                init: function () {
                    var t,
                        e,
                        i,
                        n = this,
                        o = n.group[n.currIndex].opts,
                        s = g.fancybox.scrollbarWidth;
                    g.fancybox.getInstance() ||
                        !1 === o.hideScrollbar ||
                        (g("body").addClass("fancybox-active"),
                        !g.fancybox.isMobile &&
                            r.body.scrollHeight > h.innerHeight &&
                            (s === m &&
                                ((t = g(
                                    '<div style="width:100px;height:100px;overflow:scroll;" />',
                                ).appendTo("body")),
                                (s = g.fancybox.scrollbarWidth =
                                    t[0].offsetWidth - t[0].clientWidth),
                                t.remove()),
                            g("head").append(
                                '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar { margin-right: ' +
                                    s +
                                    "px; }</style>",
                            ),
                            g("body").addClass("compensate-for-scrollbar"))),
                        (i = ""),
                        g.each(o.buttons, function (t, e) {
                            i += o.btnTpl[e] || "";
                        }),
                        (e = g(
                            n.translate(
                                n,
                                o.baseTpl
                                    .replace("{{buttons}}", i)
                                    .replace(
                                        "{{arrows}}",
                                        o.btnTpl.arrowLeft +
                                            o.btnTpl.arrowRight,
                                    ),
                            ),
                        )
                            .attr("id", "fancybox-container-" + n.id)
                            .addClass("fancybox-is-hidden")
                            .addClass(o.baseClass)
                            .data("FancyBox", n)
                            .appendTo(o.parentEl)),
                        (n.$refs = { container: e }),
                        [
                            "bg",
                            "inner",
                            "infobar",
                            "toolbar",
                            "stage",
                            "caption",
                            "navigation",
                        ].forEach(function (t) {
                            n.$refs[t] = e.find(".fancybox-" + t);
                        }),
                        n.trigger("onInit"),
                        n.activate(),
                        n.jumpTo(n.currIndex);
                },
                translate: function (t, e) {
                    var n = t.opts.i18n[t.opts.lang];
                    return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
                        var i = n[e];
                        return i === m ? t : i;
                    });
                },
                addContent: function (t) {
                    var e,
                        c = this,
                        i = g.makeArray(t);
                    g.each(i, function (t, e) {
                        var i,
                            n,
                            o,
                            s,
                            r,
                            a = {},
                            l = {};
                        g.isPlainObject(e)
                            ? (l = (a = e).opts || e)
                            : "object" === g.type(e) && g(e).length
                              ? ((l = (i = g(e)).data() || {}),
                                ((l = g.extend(!0, {}, l, l.options)).$orig =
                                    i),
                                (a.src = c.opts.src || l.src || i.attr("href")),
                                a.type ||
                                    a.src ||
                                    ((a.type = "inline"), (a.src = e)))
                              : (a = { type: "html", src: e + "" }),
                            (a.opts = g.extend(!0, {}, c.opts, l)),
                            g.isArray(l.buttons) &&
                                (a.opts.buttons = l.buttons),
                            (n = a.type || a.opts.type),
                            (s = a.src || ""),
                            !n &&
                                s &&
                                ((o = s.match(/\.(mp4|mov|ogv)((\?|#).*)?$/i))
                                    ? ((n = "video"),
                                      a.opts.videoFormat ||
                                          (a.opts.videoFormat =
                                              "video/" +
                                              ("ogv" === o[1] ? "ogg" : o[1])))
                                    : s.match(
                                            /(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i,
                                        )
                                      ? (n = "image")
                                      : s.match(/\.(pdf)((\?|#).*)?$/i)
                                        ? (n = "iframe")
                                        : "#" === s.charAt(0) &&
                                          (n = "inline")),
                            n ? (a.type = n) : c.trigger("objectNeedsType", a),
                            a.contentType ||
                                (a.contentType =
                                    -1 <
                                    g.inArray(a.type, [
                                        "html",
                                        "inline",
                                        "ajax",
                                    ])
                                        ? "html"
                                        : a.type),
                            (a.index = c.group.length),
                            "auto" == a.opts.smallBtn &&
                                (a.opts.smallBtn =
                                    -1 <
                                    g.inArray(a.type, [
                                        "html",
                                        "inline",
                                        "ajax",
                                    ])),
                            "auto" === a.opts.toolbar &&
                                (a.opts.toolbar = !a.opts.smallBtn),
                            a.opts.$trigger &&
                                a.index === c.opts.index &&
                                (a.opts.$thumb =
                                    a.opts.$trigger.find("img:first")),
                            (a.opts.$thumb && a.opts.$thumb.length) ||
                                !a.opts.$orig ||
                                (a.opts.$thumb =
                                    a.opts.$orig.find("img:first")),
                            "function" === g.type(a.opts.caption) &&
                                (a.opts.caption = a.opts.caption.apply(e, [
                                    c,
                                    a,
                                ])),
                            "function" === g.type(c.opts.caption) &&
                                (a.opts.caption = c.opts.caption.apply(e, [
                                    c,
                                    a,
                                ])),
                            a.opts.caption instanceof g ||
                                (a.opts.caption =
                                    a.opts.caption === m
                                        ? ""
                                        : a.opts.caption + ""),
                            "ajax" !== a.type ||
                                (1 < (r = s.split(/\s+/, 2)).length &&
                                    ((a.src = r.shift()),
                                    (a.opts.filter = r.shift()))),
                            a.opts.modal &&
                                (a.opts = g.extend(!0, a.opts, {
                                    infobar: 0,
                                    toolbar: 0,
                                    smallBtn: 0,
                                    keyboard: 0,
                                    slideShow: 0,
                                    fullScreen: 0,
                                    thumbs: 0,
                                    touch: 0,
                                    clickContent: !1,
                                    clickSlide: !1,
                                    clickOutside: !1,
                                    dblclickContent: !1,
                                    dblclickSlide: !1,
                                    dblclickOutside: !1,
                                })),
                            c.group.push(a);
                    }),
                        Object.keys(c.slides).length &&
                            (c.updateControls(),
                            (e = c.Thumbs) &&
                                e.isActive &&
                                (e.create(), e.focus()));
                },
                addEvents: function () {
                    var n = this;
                    n.removeEvents(),
                        n.$refs.container
                            .on(
                                "click.fb-close",
                                "[data-fancybox-close]",
                                function (t) {
                                    t.stopPropagation(),
                                        t.preventDefault(),
                                        n.close(t);
                                },
                            )
                            .on(
                                "touchstart.fb-prev click.fb-prev",
                                "[data-fancybox-prev]",
                                function (t) {
                                    t.stopPropagation(),
                                        t.preventDefault(),
                                        n.previous();
                                },
                            )
                            .on(
                                "touchstart.fb-next click.fb-next",
                                "[data-fancybox-next]",
                                function (t) {
                                    t.stopPropagation(),
                                        t.preventDefault(),
                                        n.next();
                                },
                            )
                            .on(
                                "click.fb",
                                "[data-fancybox-zoom]",
                                function (t) {
                                    n[
                                        n.isScaledDown()
                                            ? "scaleToActual"
                                            : "scaleToFit"
                                    ]();
                                },
                            ),
                        o.on("orientationchange.fb resize.fb", function (t) {
                            t &&
                            t.originalEvent &&
                            "resize" === t.originalEvent.type
                                ? u(function () {
                                      n.update();
                                  })
                                : (n.$refs.stage.hide(),
                                  setTimeout(
                                      function () {
                                          n.$refs.stage.show(), n.update();
                                      },
                                      g.fancybox.isMobile ? 600 : 250,
                                  ));
                        }),
                        a.on("focusin.fb", function (t) {
                            var e = g.fancybox
                                ? g.fancybox.getInstance()
                                : null;
                            e.isClosing ||
                                !e.current ||
                                !e.current.opts.trapFocus ||
                                g(t.target).hasClass("fancybox-container") ||
                                g(t.target).is(r) ||
                                (e &&
                                    "fixed" !== g(t.target).css("position") &&
                                    !e.$refs.container.has(t.target).length &&
                                    (t.stopPropagation(), e.focus()));
                        }),
                        a.on("keydown.fb", function (t) {
                            var e = n.current,
                                i = t.keyCode || t.which;
                            if (
                                e &&
                                e.opts.keyboard &&
                                !(
                                    t.ctrlKey ||
                                    t.altKey ||
                                    t.shiftKey ||
                                    g(t.target).is("input") ||
                                    g(t.target).is("textarea")
                                )
                            )
                                return 8 === i || 27 === i
                                    ? (t.preventDefault(), void n.close(t))
                                    : 37 === i || 38 === i
                                      ? (t.preventDefault(), void n.previous())
                                      : 39 === i || 40 === i
                                        ? (t.preventDefault(), void n.next())
                                        : void n.trigger("afterKeydown", t, i);
                        }),
                        n.group[n.currIndex].opts.idleTime &&
                            ((n.idleSecondsCounter = 0),
                            a.on(
                                "mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",
                                function (t) {
                                    (n.idleSecondsCounter = 0),
                                        n.isIdle && n.showControls(),
                                        (n.isIdle = !1);
                                },
                            ),
                            (n.idleInterval = h.setInterval(function () {
                                n.idleSecondsCounter++,
                                    n.idleSecondsCounter >=
                                        n.group[n.currIndex].opts.idleTime &&
                                        !n.isDragging &&
                                        ((n.isIdle = !0),
                                        (n.idleSecondsCounter = 0),
                                        n.hideControls());
                            }, 1e3)));
                },
                removeEvents: function () {
                    o.off("orientationchange.fb resize.fb"),
                        a.off("focusin.fb keydown.fb .fb-idle"),
                        this.$refs.container.off(".fb-close .fb-prev .fb-next"),
                        this.idleInterval &&
                            (h.clearInterval(this.idleInterval),
                            (this.idleInterval = null));
                },
                previous: function (t) {
                    return this.jumpTo(this.currPos - 1, t);
                },
                next: function (t) {
                    return this.jumpTo(this.currPos + 1, t);
                },
                jumpTo: function (t, n) {
                    var e,
                        i,
                        o,
                        s,
                        r,
                        a,
                        l,
                        c = this,
                        h = c.group.length;
                    if (
                        !(
                            c.isDragging ||
                            c.isClosing ||
                            (c.isAnimating && c.firstRun)
                        )
                    ) {
                        if (
                            ((t = parseInt(t, 10)),
                            !(i = c.current
                                ? c.current.opts.loop
                                : c.opts.loop) &&
                                (t < 0 || h <= t))
                        )
                            return !1;
                        if (
                            ((e = c.firstRun = !Object.keys(c.slides).length),
                            !(h < 2 && !e && c.isDragging))
                        ) {
                            if (
                                ((s = c.current),
                                (c.prevIndex = c.currIndex),
                                (c.prevPos = c.currPos),
                                (o = c.createSlide(t)),
                                1 < h &&
                                    ((i || 0 < o.index) && c.createSlide(t - 1),
                                    (i || o.index < h - 1) &&
                                        c.createSlide(t + 1)),
                                (c.current = o),
                                (c.currIndex = o.index),
                                (c.currPos = o.pos),
                                c.trigger("beforeShow", e),
                                c.updateControls(),
                                (a = g.fancybox.getTranslate(o.$slide)),
                                (o.isMoved =
                                    (0 !== a.left || 0 !== a.top) &&
                                    !o.$slide.hasClass("fancybox-animated")),
                                (o.forcedDuration = m),
                                g.isNumeric(n)
                                    ? (o.forcedDuration = n)
                                    : (n =
                                          o.opts[
                                              e
                                                  ? "animationDuration"
                                                  : "transitionDuration"
                                          ]),
                                (n = parseInt(n, 10)),
                                e)
                            )
                                return (
                                    o.opts.animationEffect &&
                                        n &&
                                        c.$refs.container.css(
                                            "transition-duration",
                                            n + "ms",
                                        ),
                                    c.$refs.container.removeClass(
                                        "fancybox-is-hidden",
                                    ),
                                    f(c.$refs.container),
                                    c.$refs.container.addClass(
                                        "fancybox-is-open",
                                    ),
                                    f(c.$refs.container),
                                    o.$slide.addClass(
                                        "fancybox-slide--previous",
                                    ),
                                    c.loadSlide(o),
                                    o.$slide
                                        .removeClass("fancybox-slide--previous")
                                        .addClass("fancybox-slide--current"),
                                    void c.preload("image")
                                );
                            g.each(c.slides, function (t, e) {
                                g.fancybox.stop(e.$slide);
                            }),
                                o.$slide
                                    .removeClass(
                                        "fancybox-slide--next fancybox-slide--previous",
                                    )
                                    .addClass("fancybox-slide--current"),
                                o.isMoved
                                    ? ((r = Math.round(o.$slide.width())),
                                      g.each(c.slides, function (t, e) {
                                          var i = e.pos - o.pos;
                                          g.fancybox.animate(
                                              e.$slide,
                                              {
                                                  top: 0,
                                                  left:
                                                      i * r + i * e.opts.gutter,
                                              },
                                              n,
                                              function () {
                                                  e.$slide
                                                      .removeAttr("style")
                                                      .removeClass(
                                                          "fancybox-slide--next fancybox-slide--previous",
                                                      ),
                                                      e.pos === c.currPos &&
                                                          ((o.isMoved = !1),
                                                          c.complete());
                                              },
                                          );
                                      }))
                                    : c.$refs.stage
                                          .children()
                                          .removeAttr("style"),
                                o.isLoaded
                                    ? c.revealContent(o)
                                    : c.loadSlide(o),
                                c.preload("image"),
                                s.pos !== o.pos &&
                                    ((l =
                                        "fancybox-slide--" +
                                        (s.pos > o.pos ? "next" : "previous")),
                                    s.$slide.removeClass(
                                        "fancybox-slide--complete fancybox-slide--current fancybox-slide--next fancybox-slide--previous",
                                    ),
                                    (s.isComplete = !1),
                                    n &&
                                        (o.isMoved ||
                                            o.opts.transitionEffect) &&
                                        (o.isMoved
                                            ? s.$slide.addClass(l)
                                            : ((l =
                                                  "fancybox-animated " +
                                                  l +
                                                  " fancybox-fx-" +
                                                  o.opts.transitionEffect),
                                              g.fancybox.animate(
                                                  s.$slide,
                                                  l,
                                                  n,
                                                  function () {
                                                      s.$slide
                                                          .removeClass(l)
                                                          .removeAttr("style");
                                                  },
                                              ))));
                        }
                    }
                },
                createSlide: function (t) {
                    var e,
                        i,
                        n = this;
                    return (
                        (i =
                            (i = t % n.group.length) < 0
                                ? n.group.length + i
                                : i),
                        !n.slides[t] &&
                            n.group[i] &&
                            ((e = g(
                                '<div class="fancybox-slide"></div>',
                            ).appendTo(n.$refs.stage)),
                            (n.slides[t] = g.extend(!0, {}, n.group[i], {
                                pos: t,
                                $slide: e,
                                isLoaded: !1,
                            })),
                            n.updateSlide(n.slides[t])),
                        n.slides[t]
                    );
                },
                scaleToActual: function (t, e, i) {
                    var n,
                        o,
                        s,
                        r,
                        a,
                        l = this,
                        c = l.current,
                        h = c.$content,
                        d = g.fancybox.getTranslate(c.$slide).width,
                        u = g.fancybox.getTranslate(c.$slide).height,
                        p = c.width,
                        f = c.height;
                    !l.isAnimating &&
                        h &&
                        "image" == c.type &&
                        c.isLoaded &&
                        !c.hasError &&
                        (g.fancybox.stop(h),
                        (l.isAnimating = !0),
                        (t = t === m ? 0.5 * d : t),
                        (e = e === m ? 0.5 * u : e),
                        ((n = g.fancybox.getTranslate(h)).top -=
                            g.fancybox.getTranslate(c.$slide).top),
                        (n.left -= g.fancybox.getTranslate(c.$slide).left),
                        (r = p / n.width),
                        (a = f / n.height),
                        (o = 0.5 * d - 0.5 * p),
                        (s = 0.5 * u - 0.5 * f),
                        d < p &&
                            (0 < (o = n.left * r - (t * r - t)) && (o = 0),
                            o < d - p && (o = d - p)),
                        u < f &&
                            (0 < (s = n.top * a - (e * a - e)) && (s = 0),
                            s < u - f && (s = u - f)),
                        l.updateCursor(p, f),
                        g.fancybox.animate(
                            h,
                            { top: s, left: o, scaleX: r, scaleY: a },
                            i || 330,
                            function () {
                                l.isAnimating = !1;
                            },
                        ),
                        l.SlideShow &&
                            l.SlideShow.isActive &&
                            l.SlideShow.stop());
                },
                scaleToFit: function (t) {
                    var e,
                        i = this,
                        n = i.current,
                        o = n.$content;
                    !i.isAnimating &&
                        o &&
                        "image" == n.type &&
                        n.isLoaded &&
                        !n.hasError &&
                        (g.fancybox.stop(o),
                        (i.isAnimating = !0),
                        (e = i.getFitPos(n)),
                        i.updateCursor(e.width, e.height),
                        g.fancybox.animate(
                            o,
                            {
                                top: e.top,
                                left: e.left,
                                scaleX: e.width / o.width(),
                                scaleY: e.height / o.height(),
                            },
                            t || 330,
                            function () {
                                i.isAnimating = !1;
                            },
                        ));
                },
                getFitPos: function (t) {
                    var e,
                        i,
                        n,
                        o,
                        s,
                        r = t.$content,
                        a = t.width || t.opts.width,
                        l = t.height || t.opts.height,
                        c = {};
                    return (
                        !!(t.isLoaded && r && r.length) &&
                        ((o = {
                            top: parseInt(t.$slide.css("paddingTop"), 10),
                            right: parseInt(t.$slide.css("paddingRight"), 10),
                            bottom: parseInt(t.$slide.css("paddingBottom"), 10),
                            left: parseInt(t.$slide.css("paddingLeft"), 10),
                        }),
                        (e =
                            parseInt(this.$refs.stage.width(), 10) -
                            (o.left + o.right)),
                        (i =
                            parseInt(this.$refs.stage.height(), 10) -
                            (o.top + o.bottom)),
                        (a && l) || ((a = e), (l = i)),
                        (n = Math.min(1, e / a, i / l)),
                        (a = Math.floor(n * a)),
                        (l = Math.floor(n * l)),
                        "image" === t.type
                            ? ((c.top = Math.floor(0.5 * (i - l)) + o.top),
                              (c.left = Math.floor(0.5 * (e - a)) + o.left))
                            : "video" === t.contentType &&
                              (a /
                                  (s =
                                      t.opts.width && t.opts.height
                                          ? a / l
                                          : t.opts.ratio || 16 / 9) <
                              l
                                  ? (l = a / s)
                                  : l * s < a && (a = l * s)),
                        (c.width = a),
                        (c.height = l),
                        c)
                    );
                },
                update: function () {
                    var i = this;
                    g.each(i.slides, function (t, e) {
                        i.updateSlide(e);
                    });
                },
                updateSlide: function (t, e) {
                    var i = this,
                        n = t && t.$content,
                        o = t.width || t.opts.width,
                        s = t.height || t.opts.height;
                    n &&
                        (o || s || "video" === t.contentType) &&
                        !t.hasError &&
                        (g.fancybox.stop(n),
                        g.fancybox.setTranslate(n, i.getFitPos(t)),
                        t.pos === i.currPos &&
                            ((i.isAnimating = !1), i.updateCursor())),
                        t.$slide.trigger("refresh"),
                        i.$refs.toolbar.toggleClass(
                            "compensate-for-scrollbar",
                            t.$slide.get(0).scrollHeight >
                                t.$slide.get(0).clientHeight,
                        ),
                        i.trigger("onUpdate", t);
                },
                centerSlide: function (t, e) {
                    var i, n;
                    this.current &&
                        ((i = Math.round(t.$slide.width())),
                        (n = t.pos - this.current.pos),
                        g.fancybox.animate(
                            t.$slide,
                            {
                                top: 0,
                                left: n * i + n * t.opts.gutter,
                                opacity: 1,
                            },
                            e === m ? 0 : e,
                            null,
                            !1,
                        ));
                },
                updateCursor: function (t, e) {
                    var i,
                        n = this,
                        o = n.current,
                        s = n.$refs.container.removeClass(
                            "fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-drag fancybox-can-zoomOut",
                        );
                    o &&
                        !n.isClosing &&
                        ((i = n.isZoomable()),
                        s.toggleClass("fancybox-is-zoomable", i),
                        g("[data-fancybox-zoom]").prop("disabled", !i),
                        i &&
                        ("zoom" === o.opts.clickContent ||
                            (g.isFunction(o.opts.clickContent) &&
                                "zoom" === o.opts.clickContent(o)))
                            ? n.isScaledDown(t, e)
                                ? s.addClass("fancybox-can-zoomIn")
                                : o.opts.touch
                                  ? s.addClass("fancybox-can-drag")
                                  : s.addClass("fancybox-can-zoomOut")
                            : o.opts.touch &&
                              "video" !== o.contentType &&
                              s.addClass("fancybox-can-drag"));
                },
                isZoomable: function () {
                    var t,
                        e = this.current;
                    if (
                        e &&
                        !this.isClosing &&
                        "image" === e.type &&
                        !e.hasError
                    ) {
                        if (!e.isLoaded) return !0;
                        if (
                            ((t = this.getFitPos(e)),
                            e.width > t.width || e.height > t.height)
                        )
                            return !0;
                    }
                    return !1;
                },
                isScaledDown: function (t, e) {
                    var i = !1,
                        n = this.current,
                        o = n.$content;
                    return (
                        t !== m && e !== m
                            ? (i = t < n.width && e < n.height)
                            : o &&
                              (i =
                                  (i = g.fancybox.getTranslate(o)).width <
                                      n.width && i.height < n.height),
                        i
                    );
                },
                canPan: function () {
                    var t,
                        e = !1,
                        i = this.current;
                    return (
                        "image" === i.type &&
                            (t = i.$content) &&
                            !i.hasError &&
                            ((e = this.getFitPos(i)),
                            (e =
                                1 < Math.abs(t.width() - e.width) ||
                                1 < Math.abs(t.height() - e.height))),
                        e
                    );
                },
                loadSlide: function (i) {
                    var t,
                        e,
                        n,
                        o = this;
                    if (!i.isLoading && !i.isLoaded) {
                        switch (
                            ((i.isLoading = !0),
                            o.trigger("beforeLoad", i),
                            (t = i.type),
                            (e = i.$slide)
                                .off("refresh")
                                .trigger("onReset")
                                .addClass(i.opts.slideClass),
                            t)
                        ) {
                            case "image":
                                o.setImage(i);
                                break;
                            case "iframe":
                                o.setIframe(i);
                                break;
                            case "html":
                                o.setContent(i, i.src || i.content);
                                break;
                            case "video":
                                o.setContent(
                                    i,
                                    '<video class="fancybox-video" controls controlsList="nodownload"><source src="' +
                                        i.src +
                                        '" type="' +
                                        i.opts.videoFormat +
                                        "\">Your browser doesn't support HTML5 video</video",
                                );
                                break;
                            case "inline":
                                g(i.src).length
                                    ? o.setContent(i, g(i.src))
                                    : o.setError(i);
                                break;
                            case "ajax":
                                o.showLoading(i),
                                    (n = g.ajax(
                                        g.extend({}, i.opts.ajax.settings, {
                                            url: i.src,
                                            success: function (t, e) {
                                                "success" === e &&
                                                    o.setContent(i, t);
                                            },
                                            error: function (t, e) {
                                                t &&
                                                    "abort" !== e &&
                                                    o.setError(i);
                                            },
                                        }),
                                    )),
                                    e.one("onReset", function () {
                                        n.abort();
                                    });
                                break;
                            default:
                                o.setError(i);
                        }
                        return !0;
                    }
                },
                setImage: function (e) {
                    var t,
                        i,
                        n,
                        o,
                        s,
                        r = this,
                        a = e.opts.srcset || e.opts.image.srcset;
                    if (
                        ((e.timouts = setTimeout(function () {
                            var t = e.$image;
                            !e.isLoading ||
                                (t && t[0].complete) ||
                                e.hasError ||
                                r.showLoading(e);
                        }, 350)),
                        a)
                    ) {
                        (o = h.devicePixelRatio || 1),
                            (s = h.innerWidth * o),
                            (n = a.split(",").map(function (t) {
                                var n = {};
                                return (
                                    t
                                        .trim()
                                        .split(/\s+/)
                                        .forEach(function (t, e) {
                                            var i = parseInt(
                                                t.substring(0, t.length - 1),
                                                10,
                                            );
                                            return 0 === e
                                                ? (n.url = t)
                                                : void (
                                                      i &&
                                                      ((n.value = i),
                                                      (n.postfix =
                                                          t[t.length - 1]))
                                                  );
                                        }),
                                    n
                                );
                            })).sort(function (t, e) {
                                return t.value - e.value;
                            });
                        for (var l = 0; l < n.length; l++) {
                            var c = n[l];
                            if (
                                ("w" === c.postfix && c.value >= s) ||
                                ("x" === c.postfix && c.value >= o)
                            ) {
                                i = c;
                                break;
                            }
                        }
                        !i && n.length && (i = n[n.length - 1]),
                            i &&
                                ((e.src = i.url),
                                e.width &&
                                    e.height &&
                                    "w" == i.postfix &&
                                    ((e.height =
                                        (e.width / e.height) * i.value),
                                    (e.width = i.value)),
                                (e.opts.srcset = a));
                    }
                    (e.$content = g('<div class="fancybox-content"></div>')
                        .addClass("fancybox-is-hidden")
                        .appendTo(e.$slide.addClass("fancybox-slide--image"))),
                        (t =
                            e.opts.thumb ||
                            (!(!e.opts.$thumb || !e.opts.$thumb.length) &&
                                e.opts.$thumb.attr("src"))),
                        !1 !== e.opts.preload &&
                            e.opts.width &&
                            e.opts.height &&
                            t &&
                            ((e.width = e.opts.width),
                            (e.height = e.opts.height),
                            (e.$ghost = g("<img />")
                                .one("error", function () {
                                    g(this).remove(), (e.$ghost = null);
                                })
                                .one("load", function () {
                                    r.afterLoad(e);
                                })
                                .addClass("fancybox-image")
                                .appendTo(e.$content)
                                .attr("src", t))),
                        r.setBigImage(e);
                },
                setBigImage: function (e) {
                    var i = this,
                        n = g("<img />");
                    (e.$image = n
                        .one("error", function () {
                            i.setError(e);
                        })
                        .one("load", function () {
                            var t;
                            e.$ghost ||
                                (i.resolveImageSlideSize(
                                    e,
                                    this.naturalWidth,
                                    this.naturalHeight,
                                ),
                                i.afterLoad(e)),
                                e.timouts &&
                                    (clearTimeout(e.timouts),
                                    (e.timouts = null)),
                                i.isClosing ||
                                    (e.opts.srcset &&
                                        (((t = e.opts.sizes) && "auto" !== t) ||
                                            (t =
                                                (1 < e.width / e.height &&
                                                1 < o.width() / o.height()
                                                    ? "100"
                                                    : Math.round(
                                                          (e.width / e.height) *
                                                              100,
                                                      )) + "vw"),
                                        n
                                            .attr("sizes", t)
                                            .attr("srcset", e.opts.srcset)),
                                    e.$ghost &&
                                        setTimeout(
                                            function () {
                                                e.$ghost &&
                                                    !i.isClosing &&
                                                    e.$ghost.hide();
                                            },
                                            Math.min(
                                                300,
                                                Math.max(1e3, e.height / 1600),
                                            ),
                                        ),
                                    i.hideLoading(e));
                        })
                        .addClass("fancybox-image")
                        .attr("src", e.src)
                        .appendTo(e.$content)),
                        (n[0].complete || "complete" == n[0].readyState) &&
                        n[0].naturalWidth &&
                        n[0].naturalHeight
                            ? n.trigger("load")
                            : n[0].error && n.trigger("error");
                },
                resolveImageSlideSize: function (t, e, i) {
                    var n = parseInt(t.opts.width, 10),
                        o = parseInt(t.opts.height, 10);
                    (t.width = e),
                        (t.height = i),
                        0 < n &&
                            ((t.width = n),
                            (t.height = Math.floor((n * i) / e))),
                        0 < o &&
                            ((t.width = Math.floor((o * e) / i)),
                            (t.height = o));
                },
                setIframe: function (o) {
                    var s,
                        e = this,
                        r = o.opts.iframe,
                        t = o.$slide;
                    (o.$content = g(
                        '<div class="fancybox-content' +
                            (r.preload ? " fancybox-is-hidden" : "") +
                            '"></div>',
                    )
                        .css(r.css)
                        .appendTo(t)),
                        t.addClass("fancybox-slide--" + o.contentType),
                        (o.$iframe = s =
                            g(r.tpl.replace(/\{rnd\}/g, new Date().getTime()))
                                .attr(r.attr)
                                .appendTo(o.$content)),
                        r.preload
                            ? (e.showLoading(o),
                              s.on("load.fb error.fb", function (t) {
                                  (this.isReady = 1),
                                      o.$slide.trigger("refresh"),
                                      e.afterLoad(o);
                              }),
                              t.on("refresh.fb", function () {
                                  var t,
                                      e = o.$content,
                                      i = r.css.width,
                                      n = r.css.height;
                                  if (1 === s[0].isReady) {
                                      try {
                                          t = s.contents().find("body");
                                      } catch (t) {}
                                      t &&
                                          t.length &&
                                          t.children().length &&
                                          (e.css({ width: "", height: "" }),
                                          i === m &&
                                              (i = Math.ceil(
                                                  Math.max(
                                                      t[0].clientWidth,
                                                      t.outerWidth(!0),
                                                  ),
                                              )),
                                          i && e.width(i),
                                          n === m &&
                                              (n = Math.ceil(
                                                  Math.max(
                                                      t[0].clientHeight,
                                                      t.outerHeight(!0),
                                                  ),
                                              )),
                                          n && e.height(n)),
                                          e.removeClass("fancybox-is-hidden");
                                  }
                              }))
                            : this.afterLoad(o),
                        s.attr("src", o.src),
                        t.one("onReset", function () {
                            try {
                                g(this)
                                    .find("iframe")
                                    .hide()
                                    .unbind()
                                    .attr("src", "//about:blank");
                            } catch (t) {}
                            g(this).off("refresh.fb").empty(),
                                (o.isLoaded = !1);
                        });
                },
                setContent: function (t, e) {
                    var i;
                    this.isClosing ||
                        (this.hideLoading(t),
                        t.$content && g.fancybox.stop(t.$content),
                        t.$slide.empty(),
                        (i = e) &&
                        i.hasOwnProperty &&
                        i instanceof g &&
                        e.parent().length
                            ? (e
                                  .parent()
                                  .parent(".fancybox-slide--inline")
                                  .trigger("onReset"),
                              (t.$placeholder = g("<div>")
                                  .hide()
                                  .insertAfter(e)),
                              e.css("display", "inline-block"))
                            : t.hasError ||
                              ("string" !== g.type(e) ||
                                  (3 ===
                                      (e = g("<div>")
                                          .append(g.trim(e))
                                          .contents())[0].nodeType &&
                                      (e = g("<div>").html(e))),
                              t.opts.filter &&
                                  (e = g("<div>").html(e).find(t.opts.filter))),
                        t.$slide.one("onReset", function () {
                            g(this).find("video,audio").trigger("pause"),
                                t.$placeholder &&
                                    (t.$placeholder.after(e.hide()).remove(),
                                    (t.$placeholder = null)),
                                t.$smallBtn &&
                                    (t.$smallBtn.remove(),
                                    (t.$smallBtn = null)),
                                t.hasError ||
                                    (g(this).empty(), (t.isLoaded = !1));
                        }),
                        g(e).appendTo(t.$slide),
                        g(e).is("video,audio") &&
                            (g(e).addClass("fancybox-video"),
                            g(e).wrap("<div></div>"),
                            (t.contentType = "video"),
                            (t.opts.width = t.opts.width || g(e).attr("width")),
                            (t.opts.height =
                                t.opts.height || g(e).attr("height"))),
                        (t.$content = t.$slide
                            .children()
                            .filter("div,form,main,video,audio")
                            .first()
                            .addClass("fancybox-content")),
                        t.$slide.addClass("fancybox-slide--" + t.contentType),
                        this.afterLoad(t));
                },
                setError: function (t) {
                    (t.hasError = !0),
                        t.$slide
                            .trigger("onReset")
                            .removeClass("fancybox-slide--" + t.contentType)
                            .addClass("fancybox-slide--error"),
                        (t.contentType = "html"),
                        this.setContent(t, this.translate(t, t.opts.errorTpl)),
                        t.pos === this.currPos && (this.isAnimating = !1);
                },
                showLoading: function (t) {
                    (t = t || this.current) &&
                        !t.$spinner &&
                        (t.$spinner = g(
                            this.translate(this, this.opts.spinnerTpl),
                        ).appendTo(t.$slide));
                },
                hideLoading: function (t) {
                    (t = t || this.current) &&
                        t.$spinner &&
                        (t.$spinner.remove(), delete t.$spinner);
                },
                afterLoad: function (t) {
                    var e = this;
                    e.isClosing ||
                        ((t.isLoading = !1),
                        (t.isLoaded = !0),
                        e.trigger("afterLoad", t),
                        e.hideLoading(t),
                        t.pos === e.currPos && e.updateCursor(),
                        !t.opts.smallBtn ||
                            (t.$smallBtn && t.$smallBtn.length) ||
                            (t.$smallBtn = g(
                                e.translate(t, t.opts.btnTpl.smallBtn),
                            ).prependTo(t.$content)),
                        t.opts.protect &&
                            t.$content &&
                            !t.hasError &&
                            (t.$content.on("contextmenu.fb", function (t) {
                                return 2 == t.button && t.preventDefault(), !0;
                            }),
                            "image" === t.type &&
                                g(
                                    '<div class="fancybox-spaceball"></div>',
                                ).appendTo(t.$content)),
                        e.revealContent(t));
                },
                revealContent: function (e) {
                    var t,
                        i,
                        n,
                        o,
                        s = this,
                        r = e.$slide,
                        a = !1,
                        l = !1;
                    return (
                        (t =
                            e.opts[
                                s.firstRun
                                    ? "animationEffect"
                                    : "transitionEffect"
                            ]),
                        (n =
                            e.opts[
                                s.firstRun
                                    ? "animationDuration"
                                    : "transitionDuration"
                            ]),
                        (n = parseInt(
                            e.forcedDuration === m ? n : e.forcedDuration,
                            10,
                        )),
                        e.pos === s.currPos &&
                            (e.isComplete ? (t = !1) : (s.isAnimating = !0)),
                        (!e.isMoved && e.pos === s.currPos && n) || (t = !1),
                        "zoom" === t &&
                            (e.pos === s.currPos &&
                            n &&
                            "image" === e.type &&
                            !e.hasError &&
                            (l = s.getThumbPos(e))
                                ? (a = s.getFitPos(e))
                                : (t = "fade")),
                        "zoom" === t
                            ? ((a.scaleX = a.width / l.width),
                              (a.scaleY = a.height / l.height),
                              "auto" == (o = e.opts.zoomOpacity) &&
                                  (o =
                                      0.1 <
                                      Math.abs(
                                          e.width / e.height -
                                              l.width / l.height,
                                      )),
                              o && ((l.opacity = 0.1), (a.opacity = 1)),
                              g.fancybox.setTranslate(
                                  e.$content.removeClass("fancybox-is-hidden"),
                                  l,
                              ),
                              f(e.$content),
                              void g.fancybox.animate(
                                  e.$content,
                                  a,
                                  n,
                                  function () {
                                      (s.isAnimating = !1), s.complete();
                                  },
                              ))
                            : (s.updateSlide(e),
                              t
                                  ? (g.fancybox.stop(r),
                                    (i =
                                        "fancybox-animated fancybox-slide--" +
                                        (e.pos >= s.prevPos
                                            ? "next"
                                            : "previous") +
                                        " fancybox-fx-" +
                                        t),
                                    r
                                        .removeAttr("style")
                                        .removeClass(
                                            "fancybox-slide--current fancybox-slide--next fancybox-slide--previous",
                                        )
                                        .addClass(i),
                                    e.$content.removeClass(
                                        "fancybox-is-hidden",
                                    ),
                                    f(r),
                                    void g.fancybox.animate(
                                        r,
                                        "fancybox-slide--current",
                                        n,
                                        function (t) {
                                            r
                                                .removeClass(i)
                                                .removeAttr("style"),
                                                e.pos === s.currPos &&
                                                    s.complete();
                                        },
                                        !0,
                                    ))
                                  : (f(r),
                                    e.$content.removeClass(
                                        "fancybox-is-hidden",
                                    ),
                                    void (e.pos === s.currPos && s.complete())))
                    );
                },
                getThumbPos: function (t) {
                    var e,
                        i = !1,
                        n = t.opts.$thumb,
                        o =
                            n && n.length && n[0].ownerDocument === r
                                ? n.offset()
                                : 0;
                    return (
                        o &&
                            (function (t) {
                                for (
                                    var e = t[0],
                                        n = e.getBoundingClientRect(),
                                        i = [];
                                    null !== e.parentElement;

                                )
                                    ("hidden" !==
                                        g(e.parentElement).css("overflow") &&
                                        "auto" !==
                                            g(e.parentElement).css(
                                                "overflow",
                                            )) ||
                                        i.push(
                                            e.parentElement.getBoundingClientRect(),
                                        ),
                                        (e = e.parentElement);
                                return (
                                    i.every(function (t) {
                                        var e =
                                                Math.min(n.right, t.right) -
                                                Math.max(n.left, t.left),
                                            i =
                                                Math.min(n.bottom, t.bottom) -
                                                Math.max(n.top, t.top);
                                        return 0 < e && 0 < i;
                                    }) &&
                                    0 < n.bottom &&
                                    0 < n.right &&
                                    n.left < g(h).width() &&
                                    n.top < g(h).height()
                                );
                            })(n) &&
                            ((e = this.$refs.stage.offset()),
                            (i = {
                                top:
                                    o.top -
                                    e.top +
                                    parseFloat(n.css("border-top-width") || 0),
                                left:
                                    o.left -
                                    e.left +
                                    parseFloat(n.css("border-left-width") || 0),
                                width: n.width(),
                                height: n.height(),
                                scaleX: 1,
                                scaleY: 1,
                            })),
                        i
                    );
                },
                complete: function () {
                    var i = this,
                        t = i.current,
                        n = {};
                    !t.isMoved &&
                        t.isLoaded &&
                        (t.isComplete ||
                            ((t.isComplete = !0),
                            t.$slide.siblings().trigger("onReset"),
                            i.preload("inline"),
                            f(t.$slide),
                            t.$slide.addClass("fancybox-slide--complete"),
                            g.each(i.slides, function (t, e) {
                                e.pos >= i.currPos - 1 && e.pos <= i.currPos + 1
                                    ? (n[e.pos] = e)
                                    : e &&
                                      (g.fancybox.stop(e.$slide),
                                      e.$slide.off().remove());
                            }),
                            (i.slides = n)),
                        (i.isAnimating = !1),
                        i.updateCursor(),
                        i.trigger("afterShow"),
                        t.$slide
                            .find("video,audio")
                            .filter(":visible:first")
                            .trigger("play"),
                        (g(r.activeElement).is("[disabled]") ||
                            (t.opts.autoFocus &&
                                "image" != t.type &&
                                "iframe" !== t.type)) &&
                            i.focus());
                },
                preload: function (t) {
                    var e = this,
                        i = e.slides[e.currPos + 1],
                        n = e.slides[e.currPos - 1];
                    i && i.type === t && e.loadSlide(i),
                        n && n.type === t && e.loadSlide(n);
                },
                focus: function () {
                    var t,
                        e = this.current;
                    this.isClosing ||
                        (e &&
                            e.isComplete &&
                            e.$content &&
                            ((t = e.$content.find(
                                "input[autofocus]:enabled:visible:first",
                            )).length ||
                                (t = e.$content
                                    .find("button,:input,[tabindex],a")
                                    .filter(":enabled:visible:first")),
                            (t = t && t.length ? t : e.$content).trigger(
                                "focus",
                            )));
                },
                activate: function () {
                    var e = this;
                    g(".fancybox-container").each(function () {
                        var t = g(this).data("FancyBox");
                        t &&
                            t.id !== e.id &&
                            !t.isClosing &&
                            (t.trigger("onDeactivate"),
                            t.removeEvents(),
                            (t.isVisible = !1));
                    }),
                        (e.isVisible = !0),
                        (e.current || e.isIdle) &&
                            (e.update(), e.updateControls()),
                        e.trigger("onActivate"),
                        e.addEvents();
                },
                close: function (t, e) {
                    function i() {
                        h.cleanUp(t);
                    }
                    var n,
                        o,
                        s,
                        r,
                        a,
                        l,
                        c,
                        h = this,
                        d = h.current;
                    return (
                        !h.isClosing &&
                        (!(h.isClosing = !0) === h.trigger("beforeClose", t)
                            ? ((h.isClosing = !1),
                              u(function () {
                                  h.update();
                              }),
                              !1)
                            : (h.removeEvents(),
                              d.timouts && clearTimeout(d.timouts),
                              (s = d.$content),
                              (n = d.opts.animationEffect),
                              (o = g.isNumeric(e)
                                  ? e
                                  : n
                                    ? d.opts.animationDuration
                                    : 0),
                              d.$slide
                                  .off(p)
                                  .removeClass(
                                      "fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated",
                                  ),
                              d.$slide.siblings().trigger("onReset").remove(),
                              o &&
                                  h.$refs.container
                                      .removeClass("fancybox-is-open")
                                      .addClass("fancybox-is-closing"),
                              h.hideLoading(d),
                              h.hideControls(),
                              h.updateCursor(),
                              "zoom" !== n ||
                                  (!0 !== t &&
                                      s &&
                                      o &&
                                      "image" === d.type &&
                                      !d.hasError &&
                                      (c = h.getThumbPos(d))) ||
                                  (n = "fade"),
                              "zoom" === n
                                  ? (g.fancybox.stop(s),
                                    (l = {
                                        top: (r = g.fancybox.getTranslate(s))
                                            .top,
                                        left: r.left,
                                        scaleX: r.width / c.width,
                                        scaleY: r.height / c.height,
                                        width: c.width,
                                        height: c.height,
                                    }),
                                    "auto" == (a = d.opts.zoomOpacity) &&
                                        (a =
                                            0.1 <
                                            Math.abs(
                                                d.width / d.height -
                                                    c.width / c.height,
                                            )),
                                    a && (c.opacity = 0),
                                    g.fancybox.setTranslate(s, l),
                                    f(s),
                                    g.fancybox.animate(s, c, o, i))
                                  : n && o
                                    ? !0 === t
                                        ? setTimeout(i, o)
                                        : g.fancybox.animate(
                                              d.$slide.removeClass(
                                                  "fancybox-slide--current",
                                              ),
                                              "fancybox-animated fancybox-slide--previous fancybox-fx-" +
                                                  n,
                                              o,
                                              i,
                                          )
                                    : i(),
                              !0))
                    );
                },
                cleanUp: function (t) {
                    var e,
                        i = this,
                        n = g("body");
                    i.current.$slide.trigger("onReset"),
                        i.$refs.container.empty().remove(),
                        i.trigger("afterClose", t),
                        i.$lastFocus &&
                            i.current.opts.backFocus &&
                            i.$lastFocus.trigger("focus"),
                        (i.current = null),
                        (e = g.fancybox.getInstance())
                            ? e.activate()
                            : (n.removeClass(
                                  "fancybox-active compensate-for-scrollbar",
                              ),
                              g("#fancybox-style-noscroll").remove());
                },
                trigger: function (t, e) {
                    var i,
                        n = Array.prototype.slice.call(arguments, 1),
                        o = this,
                        s = e && e.opts ? e : o.current;
                    return (
                        s ? n.unshift(s) : (s = o),
                        n.unshift(o),
                        g.isFunction(s.opts[t]) && (i = s.opts[t].apply(s, n)),
                        !1 === i
                            ? i
                            : void ("afterClose" !== t && o.$refs
                                  ? o.$refs.container.trigger(t + ".fb", n)
                                  : a.trigger(t + ".fb", n))
                    );
                },
                updateControls: function (t) {
                    var e = this,
                        i = e.current,
                        n = i.index,
                        o = i.opts.caption,
                        s = e.$refs.container,
                        r = e.$refs.caption;
                    i.$slide.trigger("refresh"),
                        (e.$caption = o && o.length ? r.html(o) : null),
                        e.isHiddenControls || e.isIdle || e.showControls(),
                        s.find("[data-fancybox-count]").html(e.group.length),
                        s.find("[data-fancybox-index]").html(n + 1),
                        s
                            .find("[data-fancybox-prev]")
                            .toggleClass("disabled", !i.opts.loop && n <= 0),
                        s
                            .find("[data-fancybox-next]")
                            .toggleClass(
                                "disabled",
                                !i.opts.loop && n >= e.group.length - 1,
                            ),
                        "image" === i.type
                            ? s
                                  .find("[data-fancybox-zoom]")
                                  .show()
                                  .end()
                                  .find("[data-fancybox-download]")
                                  .attr("href", i.opts.image.src || i.src)
                                  .show()
                            : i.opts.toolbar &&
                              s
                                  .find(
                                      "[data-fancybox-download],[data-fancybox-zoom]",
                                  )
                                  .hide();
                },
                hideControls: function () {
                    (this.isHiddenControls = !0),
                        this.$refs.container.removeClass(
                            "fancybox-show-infobar fancybox-show-toolbar fancybox-show-caption fancybox-show-nav",
                        );
                },
                showControls: function () {
                    var t = this,
                        e = t.current ? t.current.opts : t.opts,
                        i = t.$refs.container;
                    (t.isHiddenControls = !1),
                        (t.idleSecondsCounter = 0),
                        i
                            .toggleClass(
                                "fancybox-show-toolbar",
                                !(!e.toolbar || !e.buttons),
                            )
                            .toggleClass(
                                "fancybox-show-infobar",
                                !!(e.infobar && 1 < t.group.length),
                            )
                            .toggleClass(
                                "fancybox-show-nav",
                                !!(e.arrows && 1 < t.group.length),
                            )
                            .toggleClass("fancybox-is-modal", !!e.modal),
                        t.$caption
                            ? i.addClass("fancybox-show-caption ")
                            : i.removeClass("fancybox-show-caption");
                },
                toggleControls: function () {
                    this.isHiddenControls
                        ? this.showControls()
                        : this.hideControls();
                },
            }),
                (g.fancybox = {
                    version: "3.3.5",
                    defaults: t,
                    getInstance: function (t) {
                        var e = g(
                                '.fancybox-container:not(".fancybox-is-closing"):last',
                            ).data("FancyBox"),
                            i = Array.prototype.slice.call(arguments, 1);
                        return (
                            e instanceof n &&
                            ("string" === g.type(t)
                                ? e[t].apply(e, i)
                                : "function" === g.type(t) && t.apply(e, i),
                            e)
                        );
                    },
                    open: function (t, e, i) {
                        return new n(t, e, i);
                    },
                    close: function (t) {
                        var e = this.getInstance();
                        e && (e.close(), !0 === t && this.close());
                    },
                    destroy: function () {
                        this.close(!0),
                            a.add("body").off("click.fb-start", "**");
                    },
                    isMobile:
                        r.createTouch !== m &&
                        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                            navigator.userAgent,
                        ),
                    use3d:
                        ((e = r.createElement("div")),
                        h.getComputedStyle &&
                            h.getComputedStyle(e) &&
                            h
                                .getComputedStyle(e)
                                .getPropertyValue("transform") &&
                            !(r.documentMode && r.documentMode < 11)),
                    getTranslate: function (t) {
                        var e;
                        return (
                            !(!t || !t.length) && {
                                top:
                                    (e = t[0].getBoundingClientRect()).top || 0,
                                left: e.left || 0,
                                width: e.width,
                                height: e.height,
                                opacity: parseFloat(t.css("opacity")),
                            }
                        );
                    },
                    setTranslate: function (t, e) {
                        var i = "",
                            n = {};
                        if (t && e)
                            return (
                                (e.left === m && e.top === m) ||
                                    ((i =
                                        (e.left === m
                                            ? t.position().left
                                            : e.left) +
                                        "px, " +
                                        (e.top === m
                                            ? t.position().top
                                            : e.top) +
                                        "px"),
                                    (i = this.use3d
                                        ? "translate3d(" + i + ", 0px)"
                                        : "translate(" + i + ")")),
                                e.scaleX !== m &&
                                    e.scaleY !== m &&
                                    (i =
                                        (i.length ? i + " " : "") +
                                        "scale(" +
                                        e.scaleX +
                                        ", " +
                                        e.scaleY +
                                        ")"),
                                i.length && (n.transform = i),
                                e.opacity !== m && (n.opacity = e.opacity),
                                e.width !== m && (n.width = e.width),
                                e.height !== m && (n.height = e.height),
                                t.css(n)
                            );
                    },
                    animate: function (e, i, t, n, o) {
                        var s = !1;
                        g.isFunction(t) && ((n = t), (t = null)),
                            g.isPlainObject(i) || e.removeAttr("style"),
                            g.fancybox.stop(e),
                            e.on(p, function (t) {
                                (t &&
                                    t.originalEvent &&
                                    (!e.is(t.originalEvent.target) ||
                                        "z-index" ==
                                            t.originalEvent.propertyName)) ||
                                    (g.fancybox.stop(e),
                                    s && g.fancybox.setTranslate(e, s),
                                    g.isPlainObject(i)
                                        ? !1 === o && e.removeAttr("style")
                                        : !0 !== o && e.removeClass(i),
                                    g.isFunction(n) && n(t));
                            }),
                            g.isNumeric(t) &&
                                e.css("transition-duration", t + "ms"),
                            g.isPlainObject(i)
                                ? (i.scaleX !== m &&
                                      i.scaleY !== m &&
                                      ((s = g.extend({}, i, {
                                          width: e.width() * i.scaleX,
                                          height: e.height() * i.scaleY,
                                          scaleX: 1,
                                          scaleY: 1,
                                      })),
                                      delete i.width,
                                      delete i.height,
                                      e
                                          .parent()
                                          .hasClass("fancybox-slide--image") &&
                                          e
                                              .parent()
                                              .addClass("fancybox-is-scaling")),
                                  g.fancybox.setTranslate(e, i))
                                : e.addClass(i),
                            e.data(
                                "timer",
                                setTimeout(function () {
                                    e.trigger("transitionend");
                                }, t + 16),
                            );
                    },
                    stop: function (t) {
                        t &&
                            t.length &&
                            (clearTimeout(t.data("timer")),
                            t
                                .off("transitionend")
                                .css("transition-duration", ""),
                            t.parent().removeClass("fancybox-is-scaling"));
                    },
                }),
                (g.fn.fancybox = function (t) {
                    var e;
                    return (
                        (e = (t = t || {}).selector || !1)
                            ? g("body")
                                  .off("click.fb-start", e)
                                  .on("click.fb-start", e, { options: t }, i)
                            : this.off("click.fb-start").on(
                                  "click.fb-start",
                                  { items: this, options: t },
                                  i,
                              ),
                        this
                    );
                }),
                a.on("click.fb-start", "[data-fancybox]", i),
                a.on("click.fb-start", "[data-trigger]", function (t) {
                    i(t, {
                        $target: g(
                            '[data-fancybox="' +
                                g(t.currentTarget).attr("data-trigger") +
                                '"]',
                        ).eq(g(t.currentTarget).attr("data-index") || 0),
                        $trigger: g(this),
                    });
                });
        }
        var e;
    })(window, document, window.jQuery || jQuery),
    (function (p) {
        "use strict";
        function f(i, t, e) {
            if (i)
                return (
                    (e = e || ""),
                    "object" === p.type(e) && (e = p.param(e, !0)),
                    p.each(t, function (t, e) {
                        i = i.replace("$" + t, e || "");
                    }),
                    e.length && (i += (0 < i.indexOf("?") ? "&" : "?") + e),
                    i
                );
        }
        var n = {
            youtube: {
                matcher:
                    /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
                params: {
                    autoplay: 1,
                    autohide: 1,
                    fs: 1,
                    rel: 0,
                    hd: 1,
                    wmode: "transparent",
                    enablejsapi: 1,
                    html5: 1,
                },
                paramPlace: 8,
                type: "iframe",
                url: "//www.youtube.com/embed/$4",
                thumb: "//img.youtube.com/vi/$4/hqdefault.jpg",
            },
            vimeo: {
                matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
                params: {
                    autoplay: 1,
                    hd: 1,
                    show_title: 1,
                    show_byline: 1,
                    show_portrait: 0,
                    fullscreen: 1,
                    api: 1,
                },
                paramPlace: 3,
                type: "iframe",
                url: "//player.vimeo.com/video/$2",
            },
            instagram: {
                matcher:
                    /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
                type: "image",
                url: "//$1/p/$2/media/?size=l",
            },
            gmap_place: {
                matcher:
                    /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
                type: "iframe",
                url: function (t) {
                    return (
                        "//maps.google." +
                        t[2] +
                        "/?ll=" +
                        (t[9]
                            ? t[9] +
                              "&z=" +
                              Math.floor(t[10]) +
                              (t[12] ? t[12].replace(/^\//, "&") : "")
                            : t[12] + ""
                        ).replace(/\?/, "&") +
                        "&output=" +
                        (t[12] && 0 < t[12].indexOf("layer=c")
                            ? "svembed"
                            : "embed")
                    );
                },
            },
            gmap_search: {
                matcher:
                    /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
                type: "iframe",
                url: function (t) {
                    return (
                        "//maps.google." +
                        t[2] +
                        "/maps?q=" +
                        t[5].replace("query=", "q=").replace("api=1", "") +
                        "&output=embed"
                    );
                },
            },
        };
        p(document).on("objectNeedsType.fb", function (t, e, o) {
            var i,
                s,
                r,
                a,
                l,
                c,
                h,
                d = o.src || "",
                u = !1;
            (i = p.extend(!0, {}, n, o.opts.media)),
                p.each(i, function (t, e) {
                    if ((r = d.match(e.matcher))) {
                        if (
                            ((u = e.type),
                            (h = t),
                            (c = {}),
                            e.paramPlace && r[e.paramPlace])
                        ) {
                            "?" == (l = r[e.paramPlace])[0] &&
                                (l = l.substring(1)),
                                (l = l.split("&"));
                            for (var i = 0; i < l.length; ++i) {
                                var n = l[i].split("=", 2);
                                2 == n.length &&
                                    (c[n[0]] = decodeURIComponent(
                                        n[1].replace(/\+/g, " "),
                                    ));
                            }
                        }
                        return (
                            (a = p.extend(!0, {}, e.params, o.opts[t], c)),
                            (d =
                                "function" === p.type(e.url)
                                    ? e.url.call(this, r, a, o)
                                    : f(e.url, r, a)),
                            (s =
                                "function" === p.type(e.thumb)
                                    ? e.thumb.call(this, r, a, o)
                                    : f(e.thumb, r)),
                            "youtube" === t
                                ? (d = d.replace(
                                      /&t=((\d+)m)?(\d+)s/,
                                      function (t, e, i, n) {
                                          return (
                                              "&start=" +
                                              ((i ? 60 * parseInt(i, 10) : 0) +
                                                  parseInt(n, 10))
                                          );
                                      },
                                  ))
                                : "vimeo" === t && (d = d.replace("&%23", "#")),
                            !1
                        );
                    }
                }),
                u
                    ? (o.opts.thumb ||
                          (o.opts.$thumb && o.opts.$thumb.length) ||
                          (o.opts.thumb = s),
                      "iframe" === u &&
                          (o.opts = p.extend(!0, o.opts, {
                              iframe: {
                                  preload: !1,
                                  attr: { scrolling: "no" },
                              },
                          })),
                      p.extend(o, {
                          type: u,
                          src: d,
                          origSrc: o.src,
                          contentSource: h,
                          contentType:
                              "image" === u
                                  ? "image"
                                  : "gmap_place" == h || "gmap_search" == h
                                    ? "map"
                                    : "video",
                      }))
                    : d && (o.type = o.opts.defaultType);
        });
    })(window.jQuery || jQuery),
    (function (g, a, m) {
        "use strict";
        function h(t) {
            var e = [];
            for (var i in (t =
                (t = t.originalEvent || t || g.e).touches && t.touches.length
                    ? t.touches
                    : t.changedTouches && t.changedTouches.length
                      ? t.changedTouches
                      : [t]))
                t[i].pageX
                    ? e.push({ x: t[i].pageX, y: t[i].pageY })
                    : t[i].clientX &&
                      e.push({ x: t[i].clientX, y: t[i].clientY });
            return e;
        }
        function v(t, e, i) {
            return e && t
                ? "x" === i
                    ? t.x - e.x
                    : "y" === i
                      ? t.y - e.y
                      : Math.sqrt(
                            Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2),
                        )
                : 0;
        }
        function l(t) {
            if (
                t.is(
                    'a,area,button,[role="button"],input,label,select,summary,textarea,video,audio',
                ) ||
                m.isFunction(t.get(0).onclick) ||
                t.data("selectable")
            )
                return 1;
            for (var e = 0, i = t[0].attributes, n = i.length; e < n; e++)
                if ("data-fancybox-" === i[e].nodeName.substr(0, 14)) return 1;
        }
        function c(t) {
            for (
                var e = !1;
                ((i = t.get(0)),
                0,
                (n = g.getComputedStyle(i)["overflow-y"]),
                (o = g.getComputedStyle(i)["overflow-x"]),
                (s =
                    ("scroll" === n || "auto" === n) &&
                    i.scrollHeight > i.clientHeight),
                (r =
                    ("scroll" === o || "auto" === o) &&
                    i.scrollWidth > i.clientWidth),
                !(e = s || r)) &&
                (t = t.parent()).length &&
                !t.hasClass("fancybox-stage") &&
                !t.is("body");

            );
            var i, n, o, s, r;
            return e;
        }
        function i(t) {
            var e = this;
            (e.instance = t),
                (e.$bg = t.$refs.bg),
                (e.$stage = t.$refs.stage),
                (e.$container = t.$refs.container),
                e.destroy(),
                e.$container.on(
                    "touchstart.fb.touch mousedown.fb.touch",
                    m.proxy(e, "ontouchstart"),
                );
        }
        var y =
                g.requestAnimationFrame ||
                g.webkitRequestAnimationFrame ||
                g.mozRequestAnimationFrame ||
                g.oRequestAnimationFrame ||
                function (t) {
                    return g.setTimeout(t, 1e3 / 60);
                },
            _ =
                g.cancelAnimationFrame ||
                g.webkitCancelAnimationFrame ||
                g.mozCancelAnimationFrame ||
                g.oCancelAnimationFrame ||
                function (t) {
                    g.clearTimeout(t);
                };
        (i.prototype.destroy = function () {
            this.$container.off(".fb.touch");
        }),
            (i.prototype.ontouchstart = function (t) {
                var e = this,
                    i = m(t.target),
                    n = e.instance,
                    o = n.current,
                    s = o.$content,
                    r = "touchstart" == t.type;
                if (
                    (r && e.$container.off("mousedown.fb.touch"),
                    (!t.originalEvent || 2 != t.originalEvent.button) &&
                        i.length &&
                        !l(i) &&
                        !l(i.parent()) &&
                        (i.is("img") ||
                            !(
                                t.originalEvent.clientX >
                                i[0].clientWidth + i.offset().left
                            )))
                ) {
                    if (!o || n.isAnimating || n.isClosing)
                        return t.stopPropagation(), void t.preventDefault();
                    if (
                        ((e.realPoints = e.startPoints = h(t)),
                        e.startPoints.length)
                    ) {
                        if (
                            (t.stopPropagation(),
                            (e.startEvent = t),
                            (e.canTap = !0),
                            (e.$target = i),
                            (e.$content = s),
                            (e.opts = o.opts.touch),
                            (e.isPanning = !1),
                            (e.isSwiping = !1),
                            (e.isZooming = !1),
                            (e.isScrolling = !1),
                            (e.startTime = new Date().getTime()),
                            (e.distanceX = e.distanceY = e.distance = 0),
                            (e.canvasWidth = Math.round(
                                o.$slide[0].clientWidth,
                            )),
                            (e.canvasHeight = Math.round(
                                o.$slide[0].clientHeight,
                            )),
                            (e.contentLastPos = null),
                            (e.contentStartPos = m.fancybox.getTranslate(
                                e.$content,
                            ) || {
                                top: 0,
                                left: 0,
                            }),
                            (e.sliderStartPos =
                                e.sliderLastPos ||
                                m.fancybox.getTranslate(o.$slide)),
                            (e.stagePos = m.fancybox.getTranslate(
                                n.$refs.stage,
                            )),
                            (e.sliderStartPos.top -= e.stagePos.top),
                            (e.sliderStartPos.left -= e.stagePos.left),
                            (e.contentStartPos.top -= e.stagePos.top),
                            (e.contentStartPos.left -= e.stagePos.left),
                            m(a)
                                .off(".fb.touch")
                                .on(
                                    r
                                        ? "touchend.fb.touch touchcancel.fb.touch"
                                        : "mouseup.fb.touch mouseleave.fb.touch",
                                    m.proxy(e, "ontouchend"),
                                )
                                .on(
                                    r
                                        ? "touchmove.fb.touch"
                                        : "mousemove.fb.touch",
                                    m.proxy(e, "ontouchmove"),
                                ),
                            m.fancybox.isMobile &&
                                a.addEventListener("scroll", e.onscroll, !0),
                            (!e.opts && !n.canPan()) ||
                                (!i.is(e.$stage) && !e.$stage.find(i).length))
                        )
                            return void (
                                i.is(".fancybox-image") && t.preventDefault()
                            );
                        (m.fancybox.isMobile && (c(i) || c(i.parent()))) ||
                            t.preventDefault(),
                            (1 !== e.startPoints.length && !o.hasError) ||
                                (e.instance.canPan()
                                    ? (m.fancybox.stop(e.$content),
                                      e.$content.css("transition-duration", ""),
                                      (e.isPanning = !0))
                                    : (e.isSwiping = !0),
                                e.$container.addClass(
                                    "fancybox-controls--isGrabbing",
                                )),
                            2 === e.startPoints.length &&
                                "image" === o.type &&
                                (o.isLoaded || o.$ghost) &&
                                ((e.canTap = !1),
                                (e.isSwiping = !1),
                                (e.isPanning = !1),
                                (e.isZooming = !0),
                                m.fancybox.stop(e.$content),
                                e.$content.css("transition-duration", ""),
                                (e.centerPointStartX =
                                    0.5 *
                                        (e.startPoints[0].x +
                                            e.startPoints[1].x) -
                                    m(g).scrollLeft()),
                                (e.centerPointStartY =
                                    0.5 *
                                        (e.startPoints[0].y +
                                            e.startPoints[1].y) -
                                    m(g).scrollTop()),
                                (e.percentageOfImageAtPinchPointX =
                                    (e.centerPointStartX -
                                        e.contentStartPos.left) /
                                    e.contentStartPos.width),
                                (e.percentageOfImageAtPinchPointY =
                                    (e.centerPointStartY -
                                        e.contentStartPos.top) /
                                    e.contentStartPos.height),
                                (e.startDistanceBetweenFingers = v(
                                    e.startPoints[0],
                                    e.startPoints[1],
                                )));
                    }
                }
            }),
            (i.prototype.onscroll = function (t) {
                (this.isScrolling = !0),
                    a.removeEventListener("scroll", this.onscroll, !0);
            }),
            (i.prototype.ontouchmove = function (t) {
                var e = this,
                    i = m(t.target);
                return void 0 !== t.originalEvent.buttons &&
                    0 === t.originalEvent.buttons
                    ? void e.ontouchend(t)
                    : e.isScrolling ||
                        (!i.is(e.$stage) && !e.$stage.find(i).length)
                      ? void (e.canTap = !1)
                      : ((e.newPoints = h(t)),
                        void (
                            (e.opts || e.instance.canPan()) &&
                            e.newPoints.length &&
                            e.newPoints.length &&
                            ((e.isSwiping && !0 === e.isSwiping) ||
                                t.preventDefault(),
                            (e.distanceX = v(
                                e.newPoints[0],
                                e.startPoints[0],
                                "x",
                            )),
                            (e.distanceY = v(
                                e.newPoints[0],
                                e.startPoints[0],
                                "y",
                            )),
                            (e.distance = v(e.newPoints[0], e.startPoints[0])),
                            0 < e.distance &&
                                (e.isSwiping
                                    ? e.onSwipe(t)
                                    : e.isPanning
                                      ? e.onPan()
                                      : e.isZooming && e.onZoom()))
                        ));
            }),
            (i.prototype.onSwipe = function (t) {
                var e,
                    n = this,
                    i = n.isSwiping,
                    o = n.sliderStartPos.left || 0;
                if (!0 !== i)
                    "x" == i &&
                        (0 < n.distanceX &&
                        (n.instance.group.length < 2 ||
                            (0 === n.instance.current.index &&
                                !n.instance.current.opts.loop))
                            ? (o += Math.pow(n.distanceX, 0.8))
                            : n.distanceX < 0 &&
                                (n.instance.group.length < 2 ||
                                    (n.instance.current.index ===
                                        n.instance.group.length - 1 &&
                                        !n.instance.current.opts.loop))
                              ? (o -= Math.pow(-n.distanceX, 0.8))
                              : (o += n.distanceX)),
                        (n.sliderLastPos = {
                            top:
                                "x" == i
                                    ? 0
                                    : n.sliderStartPos.top + n.distanceY,
                            left: o,
                        }),
                        n.requestId && (_(n.requestId), (n.requestId = null)),
                        (n.requestId = y(function () {
                            n.sliderLastPos &&
                                (m.each(n.instance.slides, function (t, e) {
                                    var i = e.pos - n.instance.currPos;
                                    m.fancybox.setTranslate(e.$slide, {
                                        top: n.sliderLastPos.top,
                                        left:
                                            n.sliderLastPos.left +
                                            i * n.canvasWidth +
                                            i * e.opts.gutter,
                                    });
                                }),
                                n.$container.addClass("fancybox-is-sliding"));
                        }));
                else if (10 < Math.abs(n.distance)) {
                    if (
                        ((n.canTap = !1),
                        n.instance.group.length < 2 && n.opts.vertical
                            ? (n.isSwiping = "y")
                            : n.instance.isDragging ||
                                !1 === n.opts.vertical ||
                                ("auto" === n.opts.vertical &&
                                    800 < m(g).width())
                              ? (n.isSwiping = "x")
                              : ((e = Math.abs(
                                    (180 *
                                        Math.atan2(n.distanceY, n.distanceX)) /
                                        Math.PI,
                                )),
                                (n.isSwiping = 45 < e && e < 135 ? "y" : "x")),
                        (n.canTap = !1),
                        "y" === n.isSwiping &&
                            m.fancybox.isMobile &&
                            (c(n.$target) || c(n.$target.parent())))
                    )
                        return void (n.isScrolling = !0);
                    (n.instance.isDragging = n.isSwiping),
                        (n.startPoints = n.newPoints),
                        m.each(n.instance.slides, function (t, e) {
                            m.fancybox.stop(e.$slide),
                                e.$slide.css("transition-duration", ""),
                                (e.inTransition = !1),
                                e.pos === n.instance.current.pos &&
                                    (n.sliderStartPos.left =
                                        m.fancybox.getTranslate(e.$slide).left -
                                        m.fancybox.getTranslate(
                                            n.instance.$refs.stage,
                                        ).left);
                        }),
                        n.instance.SlideShow &&
                            n.instance.SlideShow.isActive &&
                            n.instance.SlideShow.stop();
                }
            }),
            (i.prototype.onPan = function () {
                var t = this;
                return v(t.newPoints[0], t.realPoints[0]) <
                    (m.fancybox.isMobile ? 10 : 5)
                    ? void (t.startPoints = t.newPoints)
                    : ((t.canTap = !1),
                      (t.contentLastPos = t.limitMovement()),
                      t.requestId && (_(t.requestId), (t.requestId = null)),
                      void (t.requestId = y(function () {
                          m.fancybox.setTranslate(t.$content, t.contentLastPos);
                      })));
            }),
            (i.prototype.limitMovement = function () {
                var t,
                    e,
                    i,
                    n,
                    o,
                    s,
                    r = this,
                    a = r.canvasWidth,
                    l = r.canvasHeight,
                    c = r.distanceX,
                    h = r.distanceY,
                    d = r.contentStartPos,
                    u = d.left,
                    p = d.top,
                    f = d.width,
                    g = d.height;
                return (
                    (o = a < f ? u + c : u),
                    (s = p + h),
                    (t = Math.max(0, 0.5 * a - 0.5 * f)),
                    (e = Math.max(0, 0.5 * l - 0.5 * g)),
                    (i = Math.min(a - f, 0.5 * a - 0.5 * f)),
                    (n = Math.min(l - g, 0.5 * l - 0.5 * g)),
                    0 < c &&
                        t < o &&
                        (o = t - 1 + Math.pow(-t + u + c, 0.8) || 0),
                    c < 0 &&
                        o < i &&
                        (o = i + 1 - Math.pow(i - u - c, 0.8) || 0),
                    0 < h &&
                        e < s &&
                        (s = e - 1 + Math.pow(-e + p + h, 0.8) || 0),
                    h < 0 &&
                        s < n &&
                        (s = n + 1 - Math.pow(n - p - h, 0.8) || 0),
                    { top: s, left: o }
                );
            }),
            (i.prototype.limitPosition = function (t, e, i, n) {
                var o = this.canvasWidth,
                    s = this.canvasHeight;
                return (
                    (t =
                        o < i
                            ? (t = 0 < t ? 0 : t) < o - i
                                ? o - i
                                : t
                            : Math.max(0, o / 2 - i / 2)),
                    {
                        top: (e =
                            s < n
                                ? (e = 0 < e ? 0 : e) < s - n
                                    ? s - n
                                    : e
                                : Math.max(0, s / 2 - n / 2)),
                        left: t,
                    }
                );
            }),
            (i.prototype.onZoom = function () {
                var t = this,
                    e = t.contentStartPos,
                    i = e.width,
                    n = e.height,
                    o = e.left,
                    s = e.top,
                    r =
                        v(t.newPoints[0], t.newPoints[1]) /
                        t.startDistanceBetweenFingers,
                    a = Math.floor(i * r),
                    l = Math.floor(n * r),
                    c = (i - a) * t.percentageOfImageAtPinchPointX,
                    h = (n - l) * t.percentageOfImageAtPinchPointY,
                    d =
                        (t.newPoints[0].x + t.newPoints[1].x) / 2 -
                        m(g).scrollLeft(),
                    u =
                        (t.newPoints[0].y + t.newPoints[1].y) / 2 -
                        m(g).scrollTop(),
                    p = d - t.centerPointStartX,
                    f = {
                        top: s + (h + (u - t.centerPointStartY)),
                        left: o + (c + p),
                        scaleX: r,
                        scaleY: r,
                    };
                (t.canTap = !1),
                    (t.newWidth = a),
                    (t.newHeight = l),
                    (t.contentLastPos = f),
                    t.requestId && (_(t.requestId), (t.requestId = null)),
                    (t.requestId = y(function () {
                        m.fancybox.setTranslate(t.$content, t.contentLastPos);
                    }));
            }),
            (i.prototype.ontouchend = function (t) {
                var e = this,
                    i = Math.max(new Date().getTime() - e.startTime, 1),
                    n = e.isSwiping,
                    o = e.isPanning,
                    s = e.isZooming,
                    r = e.isScrolling;
                return (
                    (e.endPoints = h(t)),
                    e.$container.removeClass("fancybox-controls--isGrabbing"),
                    m(a).off(".fb.touch"),
                    a.removeEventListener("scroll", e.onscroll, !0),
                    e.requestId && (_(e.requestId), (e.requestId = null)),
                    (e.isSwiping = !1),
                    (e.isPanning = !1),
                    (e.isZooming = !1),
                    (e.isScrolling = !1),
                    (e.instance.isDragging = !1),
                    e.canTap
                        ? e.onTap(t)
                        : ((e.speed = 366),
                          (e.velocityX = (e.distanceX / i) * 0.5),
                          (e.velocityY = (e.distanceY / i) * 0.5),
                          (e.speedX = Math.max(
                              0.5 * e.speed,
                              Math.min(
                                  1.5 * e.speed,
                                  (1 / Math.abs(e.velocityX)) * e.speed,
                              ),
                          )),
                          void (o
                              ? e.endPanning()
                              : s
                                ? e.endZooming()
                                : e.endSwiping(n, r)))
                );
            }),
            (i.prototype.endSwiping = function (t, e) {
                var i = this,
                    n = !1,
                    o = i.instance.group.length;
                (i.sliderLastPos = null),
                    "y" == t && !e && 50 < Math.abs(i.distanceY)
                        ? (m.fancybox.animate(
                              i.instance.current.$slide,
                              {
                                  top:
                                      i.sliderStartPos.top +
                                      i.distanceY +
                                      150 * i.velocityY,
                                  opacity: 0,
                              },
                              200,
                          ),
                          (n = i.instance.close(!0, 200)))
                        : "x" == t && 50 < i.distanceX && 1 < o
                          ? (n = i.instance.previous(i.speedX))
                          : "x" == t &&
                            i.distanceX < -50 &&
                            1 < o &&
                            (n = i.instance.next(i.speedX)),
                    !1 !== n ||
                        ("x" != t && "y" != t) ||
                        (e || o < 2
                            ? i.instance.centerSlide(i.instance.current, 150)
                            : i.instance.jumpTo(i.instance.current.index)),
                    i.$container.removeClass("fancybox-is-sliding");
            }),
            (i.prototype.endPanning = function () {
                var t,
                    e,
                    i,
                    n = this;
                n.contentLastPos &&
                    ((e =
                        !1 === n.opts.momentum
                            ? ((t = n.contentLastPos.left),
                              n.contentLastPos.top)
                            : ((t =
                                  n.contentLastPos.left +
                                  n.velocityX * n.speed),
                              n.contentLastPos.top + n.velocityY * n.speed)),
                    ((i = n.limitPosition(
                        t,
                        e,
                        n.contentStartPos.width,
                        n.contentStartPos.height,
                    )).width = n.contentStartPos.width),
                    (i.height = n.contentStartPos.height),
                    m.fancybox.animate(n.$content, i, 330));
            }),
            (i.prototype.endZooming = function () {
                var t,
                    e,
                    i,
                    n,
                    o = this,
                    s = o.instance.current,
                    r = o.newWidth,
                    a = o.newHeight;
                o.contentLastPos &&
                    ((t = o.contentLastPos.left),
                    (n = {
                        top: (e = o.contentLastPos.top),
                        left: t,
                        width: r,
                        height: a,
                        scaleX: 1,
                        scaleY: 1,
                    }),
                    m.fancybox.setTranslate(o.$content, n),
                    r < o.canvasWidth && a < o.canvasHeight
                        ? o.instance.scaleToFit(150)
                        : r > s.width || a > s.height
                          ? o.instance.scaleToActual(
                                o.centerPointStartX,
                                o.centerPointStartY,
                                150,
                            )
                          : ((i = o.limitPosition(t, e, r, a)),
                            m.fancybox.setTranslate(
                                o.$content,
                                m.fancybox.getTranslate(o.$content),
                            ),
                            m.fancybox.animate(o.$content, i, 150)));
            }),
            (i.prototype.onTap = function (i) {
                function t(t) {
                    var e = r.opts[t];
                    if ((m.isFunction(e) && (e = e.apply(s, [r, i])), e))
                        switch (e) {
                            case "close":
                                s.close(n.startEvent);
                                break;
                            case "toggleControls":
                                s.toggleControls(!0);
                                break;
                            case "next":
                                s.next();
                                break;
                            case "nextOrClose":
                                1 < s.group.length
                                    ? s.next()
                                    : s.close(n.startEvent);
                                break;
                            case "zoom":
                                "image" == r.type &&
                                    (r.isLoaded || r.$ghost) &&
                                    (s.canPan()
                                        ? s.scaleToFit()
                                        : s.isScaledDown()
                                          ? s.scaleToActual(l, c)
                                          : s.group.length < 2 &&
                                            s.close(n.startEvent));
                        }
                }
                var e,
                    n = this,
                    o = m(i.target),
                    s = n.instance,
                    r = s.current,
                    a = (i && h(i)) || n.startPoints,
                    l = a[0] ? a[0].x - m(g).scrollLeft() - n.stagePos.left : 0,
                    c = a[0] ? a[0].y - m(g).scrollTop() - n.stagePos.top : 0;
                if (
                    (!i.originalEvent || 2 != i.originalEvent.button) &&
                    (o.is("img") || !(l > o[0].clientWidth + o.offset().left))
                ) {
                    if (
                        o.is(
                            ".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container",
                        )
                    )
                        e = "Outside";
                    else if (o.is(".fancybox-slide")) e = "Slide";
                    else {
                        if (
                            !s.current.$content ||
                            !s.current.$content.find(o).addBack().filter(o)
                                .length
                        )
                            return;
                        e = "Content";
                    }
                    if (n.tapped) {
                        if (
                            (clearTimeout(n.tapped),
                            (n.tapped = null),
                            50 < Math.abs(l - n.tapX) ||
                                50 < Math.abs(c - n.tapY))
                        )
                            return this;
                        t("dblclick" + e);
                    } else
                        (n.tapX = l),
                            (n.tapY = c),
                            r.opts["dblclick" + e] &&
                            r.opts["dblclick" + e] !== r.opts["click" + e]
                                ? (n.tapped = setTimeout(function () {
                                      (n.tapped = null), t("click" + e);
                                  }, 500))
                                : t("click" + e);
                    return this;
                }
            }),
            m(a).on("onActivate.fb", function (t, e) {
                e && !e.Guestures && (e.Guestures = new i(e));
            });
    })(window, document, window.jQuery || jQuery),
    (function (r, a) {
        "use strict";
        a.extend(!0, a.fancybox.defaults, {
            btnTpl: {
                slideShow:
                    '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg viewBox="0 0 40 40"><path d="M13,12 L27,20 L13,27 Z" /><path d="M15,10 v19 M23,10 v19" /></svg></button>',
            },
            slideShow: { autoStart: !1, speed: 3e3 },
        });
        function i(t) {
            (this.instance = t), this.init();
        }
        a.extend(i.prototype, {
            timer: null,
            isActive: !1,
            $button: null,
            init: function () {
                var t = this;
                (t.$button = t.instance.$refs.toolbar
                    .find("[data-fancybox-play]")
                    .on("click", function () {
                        t.toggle();
                    })),
                    (t.instance.group.length < 2 ||
                        !t.instance.group[t.instance.currIndex].opts
                            .slideShow) &&
                        t.$button.hide();
            },
            set: function (t) {
                var e = this;
                e.instance &&
                e.instance.current &&
                (!0 === t ||
                    e.instance.current.opts.loop ||
                    e.instance.currIndex < e.instance.group.length - 1)
                    ? (e.timer = setTimeout(function () {
                          e.isActive &&
                              e.instance.jumpTo(
                                  (e.instance.currIndex + 1) %
                                      e.instance.group.length,
                              );
                      }, e.instance.current.opts.slideShow.speed))
                    : (e.stop(),
                      (e.instance.idleSecondsCounter = 0),
                      e.instance.showControls());
            },
            clear: function () {
                clearTimeout(this.timer), (this.timer = null);
            },
            start: function () {
                var t = this.instance.current;
                t &&
                    ((this.isActive = !0),
                    this.$button
                        .attr("title", t.opts.i18n[t.opts.lang].PLAY_STOP)
                        .removeClass("fancybox-button--play")
                        .addClass("fancybox-button--pause"),
                    this.set(!0));
            },
            stop: function () {
                var t = this.instance.current;
                this.clear(),
                    this.$button
                        .attr("title", t.opts.i18n[t.opts.lang].PLAY_START)
                        .removeClass("fancybox-button--pause")
                        .addClass("fancybox-button--play"),
                    (this.isActive = !1);
            },
            toggle: function () {
                this.isActive ? this.stop() : this.start();
            },
        }),
            a(r).on({
                "onInit.fb": function (t, e) {
                    e && !e.SlideShow && (e.SlideShow = new i(e));
                },
                "beforeShow.fb": function (t, e, i, n) {
                    var o = e && e.SlideShow;
                    n
                        ? o && i.opts.slideShow.autoStart && o.start()
                        : o && o.isActive && o.clear();
                },
                "afterShow.fb": function (t, e, i) {
                    var n = e && e.SlideShow;
                    n && n.isActive && n.set();
                },
                "afterKeydown.fb": function (t, e, i, n, o) {
                    var s = e && e.SlideShow;
                    !s ||
                        !i.opts.slideShow ||
                        (80 !== o && 32 !== o) ||
                        a(r.activeElement).is("button,a,input") ||
                        (n.preventDefault(), s.toggle());
                },
                "beforeClose.fb onDeactivate.fb": function (t, e) {
                    var i = e && e.SlideShow;
                    i && i.stop();
                },
            }),
            a(r).on("visibilitychange", function () {
                var t = a.fancybox.getInstance(),
                    e = t && t.SlideShow;
                e && e.isActive && (r.hidden ? e.clear() : e.set());
            });
    })(document, window.jQuery || jQuery),
    (function (s, i) {
        "use strict";
        var e = (function () {
            for (
                var t = [
                        [
                            "requestFullscreen",
                            "exitFullscreen",
                            "fullscreenElement",
                            "fullscreenEnabled",
                            "fullscreenchange",
                            "fullscreenerror",
                        ],
                        [
                            "webkitRequestFullscreen",
                            "webkitExitFullscreen",
                            "webkitFullscreenElement",
                            "webkitFullscreenEnabled",
                            "webkitfullscreenchange",
                            "webkitfullscreenerror",
                        ],
                        [
                            "webkitRequestFullScreen",
                            "webkitCancelFullScreen",
                            "webkitCurrentFullScreenElement",
                            "webkitCancelFullScreen",
                            "webkitfullscreenchange",
                            "webkitfullscreenerror",
                        ],
                        [
                            "mozRequestFullScreen",
                            "mozCancelFullScreen",
                            "mozFullScreenElement",
                            "mozFullScreenEnabled",
                            "mozfullscreenchange",
                            "mozfullscreenerror",
                        ],
                        [
                            "msRequestFullscreen",
                            "msExitFullscreen",
                            "msFullscreenElement",
                            "msFullscreenEnabled",
                            "MSFullscreenChange",
                            "MSFullscreenError",
                        ],
                    ],
                    e = {},
                    i = 0;
                i < t.length;
                i++
            ) {
                var n = t[i];
                if (n && n[1] in s) {
                    for (var o = 0; o < n.length; o++) e[t[0][o]] = n[o];
                    return e;
                }
            }
            return !1;
        })();
        if (e) {
            var n = {
                request: function (t) {
                    (t = t || s.documentElement)[e.requestFullscreen](
                        t.ALLOW_KEYBOARD_INPUT,
                    );
                },
                exit: function () {
                    s[e.exitFullscreen]();
                },
                toggle: function (t) {
                    (t = t || s.documentElement),
                        this.isFullscreen() ? this.exit() : this.request(t);
                },
                isFullscreen: function () {
                    return Boolean(s[e.fullscreenElement]);
                },
                enabled: function () {
                    return Boolean(s[e.fullscreenEnabled]);
                },
            };
            i.extend(!0, i.fancybox.defaults, {
                btnTpl: {
                    fullScreen:
                        '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fullscreen" title="{{FULL_SCREEN}}"><svg viewBox="0 0 40 40"><path d="M9,12 v16 h22 v-16 h-22 v8" /></svg></button>',
                },
                fullScreen: { autoStart: !1 },
            }),
                i(s).on({
                    "onInit.fb": function (t, e) {
                        e && e.group[e.currIndex].opts.fullScreen
                            ? (e.$refs.container.on(
                                  "click.fb-fullscreen",
                                  "[data-fancybox-fullscreen]",
                                  function (t) {
                                      t.stopPropagation(),
                                          t.preventDefault(),
                                          n.toggle();
                                  },
                              ),
                              e.opts.fullScreen &&
                                  !0 === e.opts.fullScreen.autoStart &&
                                  n.request(),
                              (e.FullScreen = n))
                            : e &&
                              e.$refs.toolbar
                                  .find("[data-fancybox-fullscreen]")
                                  .hide();
                    },
                    "afterKeydown.fb": function (t, e, i, n, o) {
                        e &&
                            e.FullScreen &&
                            70 === o &&
                            (n.preventDefault(), e.FullScreen.toggle());
                    },
                    "beforeClose.fb": function (t, e) {
                        e &&
                            e.FullScreen &&
                            e.$refs.container.hasClass(
                                "fancybox-is-fullscreen",
                            ) &&
                            n.exit();
                    },
                }),
                i(s).on(e.fullscreenchange, function () {
                    var t = n.isFullscreen(),
                        e = i.fancybox.getInstance();
                    e &&
                        (e.current &&
                            "image" === e.current.type &&
                            e.isAnimating &&
                            (e.current.$content.css("transition", "none"),
                            (e.isAnimating = !1),
                            e.update(!0, !0, 0)),
                        e.trigger("onFullscreenChange", t),
                        e.$refs.container.toggleClass(
                            "fancybox-is-fullscreen",
                            t,
                        ));
                });
        } else i && i.fancybox && (i.fancybox.defaults.btnTpl.fullScreen = !1);
    })(document, window.jQuery || jQuery),
    (function (t, s) {
        "use strict";
        var r = "fancybox-thumbs",
            a = r + "-active";
        s.fancybox.defaults = s.extend(
            !0,
            {
                btnTpl: {
                    thumbs: '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg viewBox="0 0 120 120"><path d="M30,30 h14 v14 h-14 Z M50,30 h14 v14 h-14 Z M70,30 h14 v14 h-14 Z M30,50 h14 v14 h-14 Z M50,50 h14 v14 h-14 Z M70,50 h14 v14 h-14 Z M30,70 h14 v14 h-14 Z M50,70 h14 v14 h-14 Z M70,70 h14 v14 h-14 Z" /></svg></button>',
                },
                thumbs: {
                    autoStart: !1,
                    hideOnClose: !0,
                    parentEl: ".fancybox-container",
                    axis: "y",
                },
            },
            s.fancybox.defaults,
        );
        function n(t) {
            this.init(t);
        }
        s.extend(n.prototype, {
            $button: null,
            $grid: null,
            $list: null,
            isVisible: !1,
            isActive: !1,
            init: function (t) {
                var e,
                    i,
                    n = this;
                (((n.instance = t).Thumbs = n).opts =
                    t.group[t.currIndex].opts.thumbs),
                    (e =
                        (e = t.group[0]).opts.thumb ||
                        (!(!e.opts.$thumb || !e.opts.$thumb.length) &&
                            e.opts.$thumb.attr("src"))),
                    1 < t.group.length &&
                        (i =
                            (i = t.group[1]).opts.thumb ||
                            (!(!i.opts.$thumb || !i.opts.$thumb.length) &&
                                i.opts.$thumb.attr("src"))),
                    (n.$button = t.$refs.toolbar.find(
                        "[data-fancybox-thumbs]",
                    )),
                    n.opts && e && i && e && i
                        ? (n.$button.show().on("click", function () {
                              n.toggle();
                          }),
                          (n.isActive = !0))
                        : n.$button.hide();
            },
            create: function () {
                var i,
                    t = this,
                    e = t.instance,
                    n = t.opts.parentEl,
                    o = [];
                t.$grid ||
                    ((t.$grid = s(
                        '<div class="' +
                            r +
                            " " +
                            r +
                            "-" +
                            t.opts.axis +
                            '"></div>',
                    ).appendTo(e.$refs.container.find(n).addBack().filter(n))),
                    t.$grid.on("click", "li", function () {
                        e.jumpTo(s(this).attr("data-index"));
                    })),
                    t.$list || (t.$list = s("<ul>").appendTo(t.$grid)),
                    s.each(e.group, function (t, e) {
                        (i =
                            e.opts.thumb ||
                            (e.opts.$thumb
                                ? e.opts.$thumb.attr("src")
                                : null)) ||
                            "image" !== e.type ||
                            (i = e.src),
                            o.push(
                                '<li data-index="' +
                                    t +
                                    '" tabindex="0" class="fancybox-thumbs-loading"' +
                                    (i && i.length
                                        ? ' style="background-image:url(' +
                                          i +
                                          ')" />'
                                        : "") +
                                    "></li>",
                            );
                    }),
                    (t.$list[0].innerHTML = o.join("")),
                    "x" === t.opts.axis &&
                        t.$list.width(
                            parseInt(t.$grid.css("padding-right"), 10) +
                                e.group.length *
                                    t.$list.children().eq(0).outerWidth(!0),
                        );
            },
            focus: function (t) {
                var e,
                    i,
                    n = this,
                    o = n.$list,
                    s = n.$grid;
                n.instance.current &&
                    ((i = (e = o
                        .children()
                        .removeClass(a)
                        .filter(
                            '[data-index="' + n.instance.current.index + '"]',
                        )
                        .addClass(a)).position()),
                    "y" === n.opts.axis &&
                    (i.top < 0 || i.top > o.height() - e.outerHeight())
                        ? o
                              .stop()
                              .animate({ scrollTop: o.scrollTop() + i.top }, t)
                        : "x" === n.opts.axis &&
                          (i.left < s.scrollLeft() ||
                              i.left >
                                  s.scrollLeft() +
                                      (s.width() - e.outerWidth())) &&
                          o.parent().stop().animate({ scrollLeft: i.left }, t));
            },
            update: function () {
                var t = this;
                t.instance.$refs.container.toggleClass(
                    "fancybox-show-thumbs",
                    this.isVisible,
                ),
                    t.isVisible
                        ? (t.$grid || t.create(),
                          t.instance.trigger("onThumbsShow"),
                          t.focus(0))
                        : t.$grid && t.instance.trigger("onThumbsHide"),
                    t.instance.update();
            },
            hide: function () {
                (this.isVisible = !1), this.update();
            },
            show: function () {
                (this.isVisible = !0), this.update();
            },
            toggle: function () {
                (this.isVisible = !this.isVisible), this.update();
            },
        }),
            s(t).on({
                "onInit.fb": function (t, e) {
                    var i;
                    !e ||
                        e.Thumbs ||
                        ((i = new n(e)).isActive &&
                            !0 === i.opts.autoStart &&
                            i.show());
                },
                "beforeShow.fb": function (t, e, i, n) {
                    var o = e && e.Thumbs;
                    o && o.isVisible && o.focus(n ? 0 : 250);
                },
                "afterKeydown.fb": function (t, e, i, n, o) {
                    var s = e && e.Thumbs;
                    s &&
                        s.isActive &&
                        71 === o &&
                        (n.preventDefault(), s.toggle());
                },
                "beforeClose.fb": function (t, e) {
                    var i = e && e.Thumbs;
                    i &&
                        i.isVisible &&
                        !1 !== i.opts.hideOnClose &&
                        i.$grid.hide();
                },
            });
    })(document, window.jQuery || jQuery),
    (function (t, s) {
        "use strict";
        s.extend(!0, s.fancybox.defaults, {
            btnTpl: {
                share: '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg viewBox="0 0 40 40"><path d="M6,30 C8,18 19,16 23,16 L23,16 L23,10 L33,20 L23,29 L23,24 C19,24 8,27 6,30 Z"></svg></button>',
            },
            share: {
                url: function (t, e) {
                    return (
                        (!t.currentHash &&
                            "inline" !== e.type &&
                            "html" !== e.type &&
                            (e.origSrc || e.src)) ||
                        window.location
                    );
                },
                tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" /></p></div>',
            },
        }),
            s(t).on("click", "[data-fancybox-share]", function () {
                var t,
                    e,
                    i,
                    n = s.fancybox.getInstance(),
                    o = n.current || null;
                o &&
                    ("function" === s.type(o.opts.share.url) &&
                        (t = o.opts.share.url.apply(o, [n, o])),
                    (e = o.opts.share.tpl
                        .replace(
                            /\{\{media\}\}/g,
                            "image" === o.type ? encodeURIComponent(o.src) : "",
                        )
                        .replace(/\{\{url\}\}/g, encodeURIComponent(t))
                        .replace(
                            /\{\{url_raw\}\}/g,
                            ((i = {
                                "&": "&amp;",
                                "<": "&lt;",
                                ">": "&gt;",
                                '"': "&quot;",
                                "'": "&#39;",
                                "/": "&#x2F;",
                                "`": "&#x60;",
                                "=": "&#x3D;",
                            }),
                            String(t).replace(/[&<>"'`=\/]/g, function (t) {
                                return i[t];
                            })),
                        )
                        .replace(
                            /\{\{descr\}\}/g,
                            n.$caption
                                ? encodeURIComponent(n.$caption.text())
                                : "",
                        )),
                    s.fancybox.open({
                        src: n.translate(n, e),
                        type: "html",
                        opts: {
                            animationEffect: !1,
                            afterLoad: function (t, e) {
                                n.$refs.container.one(
                                    "beforeClose.fb",
                                    function () {
                                        t.close(null, 0);
                                    },
                                ),
                                    e.$content
                                        .find(".fancybox-share__links a")
                                        .click(function () {
                                            return (
                                                window.open(
                                                    this.href,
                                                    "Share",
                                                    "width=550, height=450",
                                                ),
                                                !1
                                            );
                                        });
                            },
                        },
                    }));
            });
    })(document, window.jQuery || jQuery),
    (function (s, r, o) {
        "use strict";
        function a() {
            var t = r.location.hash.substr(1),
                e = t.split("-"),
                i =
                    (1 < e.length &&
                        /^\+?\d+$/.test(e[e.length - 1]) &&
                        parseInt(e.pop(-1), 10)) ||
                    1;
            return { hash: t, index: i < 1 ? 1 : i, gallery: e.join("-") };
        }
        function e(t) {
            "" !== t.gallery &&
                o("[data-fancybox='" + o.escapeSelector(t.gallery) + "']")
                    .eq(t.index - 1)
                    .trigger("click.fb-start");
        }
        function l(t) {
            var e, i;
            return (
                !!t &&
                "" !==
                    (i =
                        (e = t.current ? t.current.opts : t.opts).hash ||
                        (e.$orig ? e.$orig.data("fancybox") : "")) &&
                i
            );
        }
        o.escapeSelector ||
            (o.escapeSelector = function (t) {
                return (t + "").replace(
                    /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
                    function (t, e) {
                        return e
                            ? "\0" === t
                                ? "�"
                                : t.slice(0, -1) +
                                  "\\" +
                                  t.charCodeAt(t.length - 1).toString(16) +
                                  " "
                            : "\\" + t;
                    },
                );
            }),
            o(function () {
                !1 !== o.fancybox.defaults.hash &&
                    (o(s).on({
                        "onInit.fb": function (t, e) {
                            var i, n;
                            !1 !== e.group[e.currIndex].opts.hash &&
                                ((i = a()),
                                (n = l(e)) &&
                                    i.gallery &&
                                    n == i.gallery &&
                                    (e.currIndex = i.index - 1));
                        },
                        "beforeShow.fb": function (t, e, i, n) {
                            var o;
                            !i ||
                                !1 === i.opts.hash ||
                                ((o = l(e)) &&
                                    ((e.currentHash =
                                        o +
                                        (1 < e.group.length
                                            ? "-" + (i.index + 1)
                                            : "")),
                                    r.location.hash !== "#" + e.currentHash &&
                                        (e.origHash ||
                                            (e.origHash = r.location.hash),
                                        e.hashTimer &&
                                            clearTimeout(e.hashTimer),
                                        (e.hashTimer = setTimeout(function () {
                                            "replaceState" in r.history
                                                ? (r.history[
                                                      n
                                                          ? "pushState"
                                                          : "replaceState"
                                                  ](
                                                      {},
                                                      s.title,
                                                      r.location.pathname +
                                                          r.location.search +
                                                          "#" +
                                                          e.currentHash,
                                                  ),
                                                  n &&
                                                      (e.hasCreatedHistory =
                                                          !0))
                                                : (r.location.hash =
                                                      e.currentHash),
                                                (e.hashTimer = null);
                                        }, 300)))));
                        },
                        "beforeClose.fb": function (t, e, i) {
                            !1 !== i.opts.hash &&
                                (l(e),
                                e.currentHash && e.hasCreatedHistory
                                    ? r.history.back()
                                    : e.currentHash &&
                                      ("replaceState" in r.history
                                          ? r.history.replaceState(
                                                {},
                                                s.title,
                                                r.location.pathname +
                                                    r.location.search +
                                                    (e.origHash || ""),
                                            )
                                          : (r.location.hash = e.origHash)),
                                (e.currentHash = null),
                                clearTimeout(e.hashTimer));
                        },
                    }),
                    o(r).on("hashchange.fb", function () {
                        var n,
                            t = a();
                        o.each(
                            o(".fancybox-container").get().reverse(),
                            function (t, e) {
                                var i = o(e).data("FancyBox");
                                if (i.currentHash) return (n = i), !1;
                            },
                        ),
                            n
                                ? !n.currentHash ||
                                  n.currentHash === t.gallery + "-" + t.index ||
                                  (1 === t.index &&
                                      n.currentHash == t.gallery) ||
                                  ((n.currentHash = null), n.close())
                                : "" !== t.gallery && e(t);
                    }),
                    setTimeout(function () {
                        o.fancybox.getInstance() || e(a());
                    }, 50));
            });
    })(document, window, window.jQuery || jQuery),
    (function (t, e) {
        "use strict";
        var o = new Date().getTime();
        e(t).on({
            "onInit.fb": function (t, n, e) {
                n.$refs.stage.on(
                    "mousewheel DOMMouseScroll wheel MozMousePixelScroll",
                    function (t) {
                        var e = n.current,
                            i = new Date().getTime();
                        n.group.length < 2 ||
                            !1 === e.opts.wheel ||
                            ("auto" === e.opts.wheel && "image" !== e.type) ||
                            (t.preventDefault(),
                            t.stopPropagation(),
                            e.$slide.hasClass("fancybox-animated") ||
                                ((t = t.originalEvent || t),
                                i - o < 250 ||
                                    ((o = i),
                                    n[
                                        (-t.deltaY ||
                                            -t.deltaX ||
                                            t.wheelDelta ||
                                            -t.detail) < 0
                                            ? "next"
                                            : "previous"
                                    ]())));
                    },
                );
            },
        });
    })(document, window.jQuery || jQuery),
    (function (e, i) {
        "function" == typeof define && define.amd
            ? define("jquery-bridget/jquery-bridget", ["jquery"], function (t) {
                  return i(e, t);
              })
            : "object" == typeof module && module.exports
              ? (module.exports = i(e, require("jquery")))
              : (e.jQueryBridget = i(e, e.jQuery));
    })(window, function (t, e) {
        "use strict";
        function i(c, o, h) {
            (h = h || e || t.jQuery) &&
                (o.prototype.option ||
                    (o.prototype.option = function (t) {
                        h.isPlainObject(t) &&
                            (this.options = h.extend(!0, this.options, t));
                    }),
                (h.fn[c] = function (t) {
                    if ("string" != typeof t)
                        return (
                            (n = t),
                            this.each(function (t, e) {
                                var i = h.data(e, c);
                                i
                                    ? (i.option(n), i._init())
                                    : ((i = new o(e, n)), h.data(e, c, i));
                            }),
                            this
                        );
                    var e,
                        s,
                        r,
                        a,
                        l,
                        n,
                        i = d.call(arguments, 1);
                    return (
                        (r = i),
                        (l = "$()." + c + '("' + (s = t) + '")'),
                        (e = this).each(function (t, e) {
                            var i = h.data(e, c);
                            if (i) {
                                var n = i[s];
                                if (n && "_" != s.charAt(0)) {
                                    var o = n.apply(i, r);
                                    a = void 0 === a ? o : a;
                                } else u(l + " is not a valid method");
                            } else
                                u(
                                    c +
                                        " not initialized. Cannot call methods, i.e. " +
                                        l,
                                );
                        }),
                        void 0 !== a ? a : e
                    );
                }),
                n(h));
        }
        function n(t) {
            !t || (t && t.bridget) || (t.bridget = i);
        }
        var d = Array.prototype.slice,
            o = t.console,
            u =
                void 0 === o
                    ? function () {}
                    : function (t) {
                          o.error(t);
                      };
        return n(e || t.jQuery), i;
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("ev-emitter/ev-emitter", e)
            : "object" == typeof module && module.exports
              ? (module.exports = e())
              : (t.EvEmitter = e());
    })("undefined" != typeof window ? window : this, function () {
        function t() {}
        var e = t.prototype;
        return (
            (e.on = function (t, e) {
                if (t && e) {
                    var i = (this._events = this._events || {}),
                        n = (i[t] = i[t] || []);
                    return -1 == n.indexOf(e) && n.push(e), this;
                }
            }),
            (e.once = function (t, e) {
                if (t && e) {
                    this.on(t, e);
                    var i = (this._onceEvents = this._onceEvents || {});
                    return ((i[t] = i[t] || {})[e] = !0), this;
                }
            }),
            (e.off = function (t, e) {
                var i = this._events && this._events[t];
                if (i && i.length) {
                    var n = i.indexOf(e);
                    return -1 != n && i.splice(n, 1), this;
                }
            }),
            (e.emitEvent = function (t, e) {
                var i = this._events && this._events[t];
                if (i && i.length) {
                    (i = i.slice(0)), (e = e || []);
                    for (
                        var n = this._onceEvents && this._onceEvents[t], o = 0;
                        o < i.length;
                        o++
                    ) {
                        var s = i[o];
                        n && n[s] && (this.off(t, s), delete n[s]),
                            s.apply(this, e);
                    }
                    return this;
                }
            }),
            (e.allOff = function () {
                delete this._events, delete this._onceEvents;
            }),
            t
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("get-size/get-size", e)
            : "object" == typeof module && module.exports
              ? (module.exports = e())
              : (t.getSize = e());
    })(window, function () {
        "use strict";
        function v(t) {
            var e = parseFloat(t);
            return -1 == t.indexOf("%") && !isNaN(e) && e;
        }
        function y(t) {
            var e = getComputedStyle(t);
            return (
                e ||
                    i(
                        "Style returned " +
                            e +
                            ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1",
                    ),
                e
            );
        }
        function _(t) {
            if (
                ((function () {
                    if (!S) {
                        S = !0;
                        var t = document.createElement("div");
                        (t.style.width = "200px"),
                            (t.style.padding = "1px 2px 3px 4px"),
                            (t.style.borderStyle = "solid"),
                            (t.style.borderWidth = "1px 2px 3px 4px"),
                            (t.style.boxSizing = "border-box");
                        var e = document.body || document.documentElement;
                        e.appendChild(t);
                        var i = y(t);
                        (b = 200 == Math.round(v(i.width))),
                            (_.isBoxSizeOuter = b),
                            e.removeChild(t);
                    }
                })(),
                "string" == typeof t && (t = document.querySelector(t)),
                t && "object" == typeof t && t.nodeType)
            ) {
                var e = y(t);
                if ("none" == e.display)
                    return (function () {
                        for (
                            var t = {
                                    width: 0,
                                    height: 0,
                                    innerWidth: 0,
                                    innerHeight: 0,
                                    outerWidth: 0,
                                    outerHeight: 0,
                                },
                                e = 0;
                            e < x;
                            e++
                        ) {
                            t[w[e]] = 0;
                        }
                        return t;
                    })();
                var i = {};
                (i.width = t.offsetWidth), (i.height = t.offsetHeight);
                for (
                    var n = (i.isBorderBox = "border-box" == e.boxSizing),
                        o = 0;
                    o < x;
                    o++
                ) {
                    var s = w[o],
                        r = e[s],
                        a = parseFloat(r);
                    i[s] = isNaN(a) ? 0 : a;
                }
                var l = i.paddingLeft + i.paddingRight,
                    c = i.paddingTop + i.paddingBottom,
                    h = i.marginLeft + i.marginRight,
                    d = i.marginTop + i.marginBottom,
                    u = i.borderLeftWidth + i.borderRightWidth,
                    p = i.borderTopWidth + i.borderBottomWidth,
                    f = n && b,
                    g = v(e.width);
                !1 !== g && (i.width = g + (f ? 0 : l + u));
                var m = v(e.height);
                return (
                    !1 !== m && (i.height = m + (f ? 0 : c + p)),
                    (i.innerWidth = i.width - (l + u)),
                    (i.innerHeight = i.height - (c + p)),
                    (i.outerWidth = i.width + h),
                    (i.outerHeight = i.height + d),
                    i
                );
            }
        }
        var b,
            i =
                "undefined" == typeof console
                    ? function () {}
                    : function (t) {
                          console.error(t);
                      },
            w = [
                "paddingLeft",
                "paddingRight",
                "paddingTop",
                "paddingBottom",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom",
                "borderLeftWidth",
                "borderRightWidth",
                "borderTopWidth",
                "borderBottomWidth",
            ],
            x = w.length,
            S = !1;
        return _;
    }),
    (function (t, e) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("desandro-matches-selector/matches-selector", e)
            : "object" == typeof module && module.exports
              ? (module.exports = e())
              : (t.matchesSelector = e());
    })(window, function () {
        "use strict";
        var i = (function () {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (
                var e = ["webkit", "moz", "ms", "o"], i = 0;
                i < e.length;
                i++
            ) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n;
            }
        })();
        return function (t, e) {
            return t[i](e);
        };
    }),
    (function (e, i) {
        "function" == typeof define && define.amd
            ? define(
                  "fizzy-ui-utils/utils",
                  ["desandro-matches-selector/matches-selector"],
                  function (t) {
                      return i(e, t);
                  },
              )
            : "object" == typeof module && module.exports
              ? (module.exports = i(e, require("desandro-matches-selector")))
              : (e.fizzyUIUtils = i(e, e.matchesSelector));
    })(window, function (c, s) {
        var h = {
                extend: function (t, e) {
                    for (var i in e) t[i] = e[i];
                    return t;
                },
                modulo: function (t, e) {
                    return ((t % e) + e) % e;
                },
            },
            e = Array.prototype.slice;
        (h.makeArray = function (t) {
            return Array.isArray(t)
                ? t
                : null == t
                  ? []
                  : "object" == typeof t && "number" == typeof t.length
                    ? e.call(t)
                    : [t];
        }),
            (h.removeFrom = function (t, e) {
                var i = t.indexOf(e);
                -1 != i && t.splice(i, 1);
            }),
            (h.getParent = function (t, e) {
                for (; t.parentNode && t != document.body; )
                    if (((t = t.parentNode), s(t, e))) return t;
            }),
            (h.getQueryElement = function (t) {
                return "string" == typeof t ? document.querySelector(t) : t;
            }),
            (h.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
            }),
            (h.filterFindElements = function (t, n) {
                t = h.makeArray(t);
                var o = [];
                return (
                    t.forEach(function (t) {
                        if (t instanceof HTMLElement) {
                            if (!n) return void o.push(t);
                            s(t, n) && o.push(t);
                            for (
                                var e = t.querySelectorAll(n), i = 0;
                                i < e.length;
                                i++
                            )
                                o.push(e[i]);
                        }
                    }),
                    o
                );
            }),
            (h.debounceMethod = function (t, e, n) {
                n = n || 100;
                var o = t.prototype[e],
                    s = e + "Timeout";
                t.prototype[e] = function () {
                    var t = this[s];
                    clearTimeout(t);
                    var e = arguments,
                        i = this;
                    this[s] = setTimeout(function () {
                        o.apply(i, e), delete i[s];
                    }, n);
                };
            }),
            (h.docReady = function (t) {
                var e = document.readyState;
                "complete" == e || "interactive" == e
                    ? setTimeout(t)
                    : document.addEventListener("DOMContentLoaded", t);
            }),
            (h.toDashed = function (t) {
                return t
                    .replace(/(.)([A-Z])/g, function (t, e, i) {
                        return e + "-" + i;
                    })
                    .toLowerCase();
            });
        var d = c.console;
        return (
            (h.htmlInit = function (a, l) {
                h.docReady(function () {
                    var t = h.toDashed(l),
                        o = "data-" + t,
                        e = document.querySelectorAll("[" + o + "]"),
                        i = document.querySelectorAll(".js-" + t),
                        n = h.makeArray(e).concat(h.makeArray(i)),
                        s = o + "-options",
                        r = c.jQuery;
                    n.forEach(function (e) {
                        var t,
                            i = e.getAttribute(o) || e.getAttribute(s);
                        try {
                            t = i && JSON.parse(i);
                        } catch (t) {
                            return void (
                                d &&
                                d.error(
                                    "Error parsing " +
                                        o +
                                        " on " +
                                        e.className +
                                        ": " +
                                        t,
                                )
                            );
                        }
                        var n = new a(e, t);
                        r && r.data(e, l, n);
                    });
                });
            }),
            h
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define(
                  "outlayer/item",
                  ["ev-emitter/ev-emitter", "get-size/get-size"],
                  e,
              )
            : "object" == typeof module && module.exports
              ? (module.exports = e(require("ev-emitter"), require("get-size")))
              : ((t.Outlayer = {}),
                (t.Outlayer.Item = e(t.EvEmitter, t.getSize)));
    })(window, function (t, e) {
        "use strict";
        function i(t, e) {
            t &&
                ((this.element = t),
                (this.layout = e),
                (this.position = { x: 0, y: 0 }),
                this._create());
        }
        var n = document.documentElement.style,
            o =
                "string" == typeof n.transition
                    ? "transition"
                    : "WebkitTransition",
            s =
                "string" == typeof n.transform
                    ? "transform"
                    : "WebkitTransform",
            r = {
                WebkitTransition: "webkitTransitionEnd",
                transition: "transitionend",
            }[o],
            a = {
                transform: s,
                transition: o,
                transitionDuration: o + "Duration",
                transitionProperty: o + "Property",
                transitionDelay: o + "Delay",
            },
            l = (i.prototype = Object.create(t.prototype));
        (l.constructor = i),
            (l._create = function () {
                (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }),
                    this.css({ position: "absolute" });
            }),
            (l.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
            }),
            (l.getSize = function () {
                this.size = e(this.element);
            }),
            (l.css = function (t) {
                var e = this.element.style;
                for (var i in t) {
                    e[a[i] || i] = t[i];
                }
            }),
            (l.getPosition = function () {
                var t = getComputedStyle(this.element),
                    e = this.layout._getOption("originLeft"),
                    i = this.layout._getOption("originTop"),
                    n = t[e ? "left" : "right"],
                    o = t[i ? "top" : "bottom"],
                    s = parseFloat(n),
                    r = parseFloat(o),
                    a = this.layout.size;
                -1 != n.indexOf("%") && (s = (s / 100) * a.width),
                    -1 != o.indexOf("%") && (r = (r / 100) * a.height),
                    (s = isNaN(s) ? 0 : s),
                    (r = isNaN(r) ? 0 : r),
                    (s -= e ? a.paddingLeft : a.paddingRight),
                    (r -= i ? a.paddingTop : a.paddingBottom),
                    (this.position.x = s),
                    (this.position.y = r);
            }),
            (l.layoutPosition = function () {
                var t = this.layout.size,
                    e = {},
                    i = this.layout._getOption("originLeft"),
                    n = this.layout._getOption("originTop"),
                    o = i ? "paddingLeft" : "paddingRight",
                    s = i ? "left" : "right",
                    r = i ? "right" : "left",
                    a = this.position.x + t[o];
                (e[s] = this.getXValue(a)), (e[r] = "");
                var l = n ? "paddingTop" : "paddingBottom",
                    c = n ? "top" : "bottom",
                    h = n ? "bottom" : "top",
                    d = this.position.y + t[l];
                (e[c] = this.getYValue(d)),
                    (e[h] = ""),
                    this.css(e),
                    this.emitEvent("layout", [this]);
            }),
            (l.getXValue = function (t) {
                var e = this.layout._getOption("horizontal");
                return this.layout.options.percentPosition && !e
                    ? (t / this.layout.size.width) * 100 + "%"
                    : t + "px";
            }),
            (l.getYValue = function (t) {
                var e = this.layout._getOption("horizontal");
                return this.layout.options.percentPosition && e
                    ? (t / this.layout.size.height) * 100 + "%"
                    : t + "px";
            }),
            (l._transitionTo = function (t, e) {
                this.getPosition();
                var i = this.position.x,
                    n = this.position.y,
                    o = t == this.position.x && e == this.position.y;
                if ((this.setPosition(t, e), !o || this.isTransitioning)) {
                    var s = t - i,
                        r = e - n,
                        a = {};
                    (a.transform = this.getTranslate(s, r)),
                        this.transition({
                            to: a,
                            onTransitionEnd: { transform: this.layoutPosition },
                            isCleaning: !0,
                        });
                } else this.layoutPosition();
            }),
            (l.getTranslate = function (t, e) {
                return (
                    "translate3d(" +
                    (t = this.layout._getOption("originLeft") ? t : -t) +
                    "px, " +
                    (e = this.layout._getOption("originTop") ? e : -e) +
                    "px, 0)"
                );
            }),
            (l.goTo = function (t, e) {
                this.setPosition(t, e), this.layoutPosition();
            }),
            (l.moveTo = l._transitionTo),
            (l.setPosition = function (t, e) {
                (this.position.x = parseFloat(t)),
                    (this.position.y = parseFloat(e));
            }),
            (l._nonTransition = function (t) {
                for (var e in (this.css(t.to),
                t.isCleaning && this._removeStyles(t.to),
                t.onTransitionEnd))
                    t.onTransitionEnd[e].call(this);
            }),
            (l.transition = function (t) {
                if (parseFloat(this.layout.options.transitionDuration)) {
                    var e = this._transn;
                    for (var i in t.onTransitionEnd)
                        e.onEnd[i] = t.onTransitionEnd[i];
                    for (i in t.to)
                        (e.ingProperties[i] = !0),
                            t.isCleaning && (e.clean[i] = !0);
                    if (t.from) {
                        this.css(t.from);
                        this.element.offsetHeight;
                        0;
                    }
                    this.enableTransition(t.to),
                        this.css(t.to),
                        (this.isTransitioning = !0);
                } else this._nonTransition(t);
            });
        var c =
            "opacity," +
            s.replace(/([A-Z])/g, function (t) {
                return "-" + t.toLowerCase();
            });
        (l.enableTransition = function () {
            if (!this.isTransitioning) {
                var t = this.layout.options.transitionDuration;
                (t = "number" == typeof t ? t + "ms" : t),
                    this.css({
                        transitionProperty: c,
                        transitionDuration: t,
                        transitionDelay: this.staggerDelay || 0,
                    }),
                    this.element.addEventListener(r, this, !1);
            }
        }),
            (l.onwebkitTransitionEnd = function (t) {
                this.ontransitionend(t);
            }),
            (l.onotransitionend = function (t) {
                this.ontransitionend(t);
            });
        var h = { "-webkit-transform": "transform" };
        (l.ontransitionend = function (t) {
            if (t.target === this.element) {
                var e = this._transn,
                    i = h[t.propertyName] || t.propertyName;
                if (
                    (delete e.ingProperties[i],
                    (function (t) {
                        for (var e in t) return;
                        return 1;
                    })(e.ingProperties) && this.disableTransition(),
                    i in e.clean &&
                        ((this.element.style[t.propertyName] = ""),
                        delete e.clean[i]),
                    i in e.onEnd)
                )
                    e.onEnd[i].call(this), delete e.onEnd[i];
                this.emitEvent("transitionEnd", [this]);
            }
        }),
            (l.disableTransition = function () {
                this.removeTransitionStyles(),
                    this.element.removeEventListener(r, this, !1),
                    (this.isTransitioning = !1);
            }),
            (l._removeStyles = function (t) {
                var e = {};
                for (var i in t) e[i] = "";
                this.css(e);
            });
        var d = {
            transitionProperty: "",
            transitionDuration: "",
            transitionDelay: "",
        };
        return (
            (l.removeTransitionStyles = function () {
                this.css(d);
            }),
            (l.stagger = function (t) {
                (t = isNaN(t) ? 0 : t), (this.staggerDelay = t + "ms");
            }),
            (l.removeElem = function () {
                this.element.parentNode.removeChild(this.element),
                    this.css({ display: "" }),
                    this.emitEvent("remove", [this]);
            }),
            (l.remove = function () {
                return o && parseFloat(this.layout.options.transitionDuration)
                    ? (this.once("transitionEnd", function () {
                          this.removeElem();
                      }),
                      void this.hide())
                    : void this.removeElem();
            }),
            (l.reveal = function () {
                delete this.isHidden, this.css({ display: "" });
                var t = this.layout.options,
                    e = {};
                (e[this.getHideRevealTransitionEndProperty("visibleStyle")] =
                    this.onRevealTransitionEnd),
                    this.transition({
                        from: t.hiddenStyle,
                        to: t.visibleStyle,
                        isCleaning: !0,
                        onTransitionEnd: e,
                    });
            }),
            (l.onRevealTransitionEnd = function () {
                this.isHidden || this.emitEvent("reveal");
            }),
            (l.getHideRevealTransitionEndProperty = function (t) {
                var e = this.layout.options[t];
                if (e.opacity) return "opacity";
                for (var i in e) return i;
            }),
            (l.hide = function () {
                (this.isHidden = !0), this.css({ display: "" });
                var t = this.layout.options,
                    e = {};
                (e[this.getHideRevealTransitionEndProperty("hiddenStyle")] =
                    this.onHideTransitionEnd),
                    this.transition({
                        from: t.visibleStyle,
                        to: t.hiddenStyle,
                        isCleaning: !0,
                        onTransitionEnd: e,
                    });
            }),
            (l.onHideTransitionEnd = function () {
                this.isHidden &&
                    (this.css({ display: "none" }), this.emitEvent("hide"));
            }),
            (l.destroy = function () {
                this.css({
                    position: "",
                    left: "",
                    right: "",
                    top: "",
                    bottom: "",
                    transition: "",
                    transform: "",
                });
            }),
            i
        );
    }),
    (function (o, s) {
        "use strict";
        "function" == typeof define && define.amd
            ? define(
                  "outlayer/outlayer",
                  [
                      "ev-emitter/ev-emitter",
                      "get-size/get-size",
                      "fizzy-ui-utils/utils",
                      "./item",
                  ],
                  function (t, e, i, n) {
                      return s(o, t, e, i, n);
                  },
              )
            : "object" == typeof module && module.exports
              ? (module.exports = s(
                    o,
                    require("ev-emitter"),
                    require("get-size"),
                    require("fizzy-ui-utils"),
                    require("./item"),
                ))
              : (o.Outlayer = s(
                    o,
                    o.EvEmitter,
                    o.getSize,
                    o.fizzyUIUtils,
                    o.Outlayer.Item,
                ));
    })(window, function (t, e, o, s, n) {
        "use strict";
        function r(t, e) {
            var i = s.getQueryElement(t);
            if (i) {
                (this.element = i),
                    c && (this.$element = c(this.element)),
                    (this.options = s.extend({}, this.constructor.defaults)),
                    this.option(e);
                var n = ++h;
                (this.element.outlayerGUID = n),
                    (d[n] = this)._create(),
                    this._getOption("initLayout") && this.layout();
            } else
                l &&
                    l.error(
                        "Bad element for " +
                            this.constructor.namespace +
                            ": " +
                            (i || t),
                    );
        }
        function a(t) {
            function e() {
                t.apply(this, arguments);
            }
            return ((e.prototype = Object.create(t.prototype)).constructor = e);
        }
        function i() {}
        var l = t.console,
            c = t.jQuery,
            h = 0,
            d = {};
        (r.namespace = "outlayer"),
            (r.Item = n),
            (r.defaults = {
                containerStyle: { position: "relative" },
                initLayout: !0,
                originLeft: !0,
                originTop: !0,
                resize: !0,
                resizeContainer: !0,
                transitionDuration: "0.4s",
                hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
                visibleStyle: { opacity: 1, transform: "scale(1)" },
            });
        var u = r.prototype;
        s.extend(u, e.prototype),
            (u.option = function (t) {
                s.extend(this.options, t);
            }),
            (u._getOption = function (t) {
                var e = this.constructor.compatOptions[t];
                return e && void 0 !== this.options[e]
                    ? this.options[e]
                    : this.options[t];
            }),
            (r.compatOptions = {
                initLayout: "isInitLayout",
                horizontal: "isHorizontal",
                layoutInstant: "isLayoutInstant",
                originLeft: "isOriginLeft",
                originTop: "isOriginTop",
                resize: "isResizeBound",
                resizeContainer: "isResizingContainer",
            }),
            (u._create = function () {
                this.reloadItems(),
                    (this.stamps = []),
                    this.stamp(this.options.stamp),
                    s.extend(this.element.style, this.options.containerStyle),
                    this._getOption("resize") && this.bindResize();
            }),
            (u.reloadItems = function () {
                this.items = this._itemize(this.element.children);
            }),
            (u._itemize = function (t) {
                for (
                    var e = this._filterFindItemElements(t),
                        i = this.constructor.Item,
                        n = [],
                        o = 0;
                    o < e.length;
                    o++
                ) {
                    var s = new i(e[o], this);
                    n.push(s);
                }
                return n;
            }),
            (u._filterFindItemElements = function (t) {
                return s.filterFindElements(t, this.options.itemSelector);
            }),
            (u.getItemElements = function () {
                return this.items.map(function (t) {
                    return t.element;
                });
            }),
            (u.layout = function () {
                this._resetLayout(), this._manageStamps();
                var t = this._getOption("layoutInstant"),
                    e = void 0 !== t ? t : !this._isLayoutInited;
                this.layoutItems(this.items, e), (this._isLayoutInited = !0);
            }),
            (u._init = u.layout),
            (u._resetLayout = function () {
                this.getSize();
            }),
            (u.getSize = function () {
                this.size = o(this.element);
            }),
            (u._getMeasurement = function (t, e) {
                var i,
                    n = this.options[t];
                n
                    ? ("string" == typeof n
                          ? (i = this.element.querySelector(n))
                          : n instanceof HTMLElement && (i = n),
                      (this[t] = i ? o(i)[e] : n))
                    : (this[t] = 0);
            }),
            (u.layoutItems = function (t, e) {
                (t = this._getItemsForLayout(t)),
                    this._layoutItems(t, e),
                    this._postLayout();
            }),
            (u._getItemsForLayout = function (t) {
                return t.filter(function (t) {
                    return !t.isIgnored;
                });
            }),
            (u._layoutItems = function (t, i) {
                if ((this._emitCompleteOnItems("layout", t), t && t.length)) {
                    var n = [];
                    t.forEach(function (t) {
                        var e = this._getItemLayoutPosition(t);
                        (e.item = t),
                            (e.isInstant = i || t.isLayoutInstant),
                            n.push(e);
                    }, this),
                        this._processLayoutQueue(n);
                }
            }),
            (u._getItemLayoutPosition = function () {
                return { x: 0, y: 0 };
            }),
            (u._processLayoutQueue = function (t) {
                this.updateStagger(),
                    t.forEach(function (t, e) {
                        this._positionItem(t.item, t.x, t.y, t.isInstant, e);
                    }, this);
            }),
            (u.updateStagger = function () {
                var t = this.options.stagger;
                return null == t
                    ? void (this.stagger = 0)
                    : ((this.stagger = (function (t) {
                          if ("number" == typeof t) return t;
                          var e = t.match(/(^\d*\.?\d*)(\w*)/),
                              i = e && e[1],
                              n = e && e[2];
                          return i.length
                              ? (i = parseFloat(i)) * (p[n] || 1)
                              : 0;
                      })(t)),
                      this.stagger);
            }),
            (u._positionItem = function (t, e, i, n, o) {
                n
                    ? t.goTo(e, i)
                    : (t.stagger(o * this.stagger), t.moveTo(e, i));
            }),
            (u._postLayout = function () {
                this.resizeContainer();
            }),
            (u.resizeContainer = function () {
                if (this._getOption("resizeContainer")) {
                    var t = this._getContainerSize();
                    t &&
                        (this._setContainerMeasure(t.width, !0),
                        this._setContainerMeasure(t.height, !1));
                }
            }),
            (u._getContainerSize = i),
            (u._setContainerMeasure = function (t, e) {
                if (void 0 !== t) {
                    var i = this.size;
                    i.isBorderBox &&
                        (t += e
                            ? i.paddingLeft +
                              i.paddingRight +
                              i.borderLeftWidth +
                              i.borderRightWidth
                            : i.paddingBottom +
                              i.paddingTop +
                              i.borderTopWidth +
                              i.borderBottomWidth),
                        (t = Math.max(t, 0)),
                        (this.element.style[e ? "width" : "height"] = t + "px");
                }
            }),
            (u._emitCompleteOnItems = function (e, t) {
                function i() {
                    o.dispatchEvent(e + "Complete", null, [t]);
                }
                function n() {
                    ++r == s && i();
                }
                var o = this,
                    s = t.length;
                if (t && s) {
                    var r = 0;
                    t.forEach(function (t) {
                        t.once(e, n);
                    });
                } else i();
            }),
            (u.dispatchEvent = function (t, e, i) {
                var n = e ? [e].concat(i) : i;
                if ((this.emitEvent(t, n), c))
                    if (
                        ((this.$element = this.$element || c(this.element)), e)
                    ) {
                        var o = c.Event(e);
                        (o.type = t), this.$element.trigger(o, i);
                    } else this.$element.trigger(t, i);
            }),
            (u.ignore = function (t) {
                var e = this.getItem(t);
                e && (e.isIgnored = !0);
            }),
            (u.unignore = function (t) {
                var e = this.getItem(t);
                e && delete e.isIgnored;
            }),
            (u.stamp = function (t) {
                (t = this._find(t)) &&
                    ((this.stamps = this.stamps.concat(t)),
                    t.forEach(this.ignore, this));
            }),
            (u.unstamp = function (t) {
                (t = this._find(t)) &&
                    t.forEach(function (t) {
                        s.removeFrom(this.stamps, t), this.unignore(t);
                    }, this);
            }),
            (u._find = function (t) {
                if (t)
                    return (
                        "string" == typeof t &&
                            (t = this.element.querySelectorAll(t)),
                        s.makeArray(t)
                    );
            }),
            (u._manageStamps = function () {
                this.stamps &&
                    this.stamps.length &&
                    (this._getBoundingRect(),
                    this.stamps.forEach(this._manageStamp, this));
            }),
            (u._getBoundingRect = function () {
                var t = this.element.getBoundingClientRect(),
                    e = this.size;
                this._boundingRect = {
                    left: t.left + e.paddingLeft + e.borderLeftWidth,
                    top: t.top + e.paddingTop + e.borderTopWidth,
                    right: t.right - (e.paddingRight + e.borderRightWidth),
                    bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth),
                };
            }),
            (u._manageStamp = i),
            (u._getElementOffset = function (t) {
                var e = t.getBoundingClientRect(),
                    i = this._boundingRect,
                    n = o(t);
                return {
                    left: e.left - i.left - n.marginLeft,
                    top: e.top - i.top - n.marginTop,
                    right: i.right - e.right - n.marginRight,
                    bottom: i.bottom - e.bottom - n.marginBottom,
                };
            }),
            (u.handleEvent = s.handleEvent),
            (u.bindResize = function () {
                t.addEventListener("resize", this), (this.isResizeBound = !0);
            }),
            (u.unbindResize = function () {
                t.removeEventListener("resize", this),
                    (this.isResizeBound = !1);
            }),
            (u.onresize = function () {
                this.resize();
            }),
            s.debounceMethod(r, "onresize", 100),
            (u.resize = function () {
                this.isResizeBound && this.needsResizeLayout() && this.layout();
            }),
            (u.needsResizeLayout = function () {
                var t = o(this.element);
                return this.size && t && t.innerWidth !== this.size.innerWidth;
            }),
            (u.addItems = function (t) {
                var e = this._itemize(t);
                return e.length && (this.items = this.items.concat(e)), e;
            }),
            (u.appended = function (t) {
                var e = this.addItems(t);
                e.length && (this.layoutItems(e, !0), this.reveal(e));
            }),
            (u.prepended = function (t) {
                var e = this._itemize(t);
                if (e.length) {
                    var i = this.items.slice(0);
                    (this.items = e.concat(i)),
                        this._resetLayout(),
                        this._manageStamps(),
                        this.layoutItems(e, !0),
                        this.reveal(e),
                        this.layoutItems(i);
                }
            }),
            (u.reveal = function (t) {
                if ((this._emitCompleteOnItems("reveal", t), t && t.length)) {
                    var i = this.updateStagger();
                    t.forEach(function (t, e) {
                        t.stagger(e * i), t.reveal();
                    });
                }
            }),
            (u.hide = function (t) {
                if ((this._emitCompleteOnItems("hide", t), t && t.length)) {
                    var i = this.updateStagger();
                    t.forEach(function (t, e) {
                        t.stagger(e * i), t.hide();
                    });
                }
            }),
            (u.revealItemElements = function (t) {
                var e = this.getItems(t);
                this.reveal(e);
            }),
            (u.hideItemElements = function (t) {
                var e = this.getItems(t);
                this.hide(e);
            }),
            (u.getItem = function (t) {
                for (var e = 0; e < this.items.length; e++) {
                    var i = this.items[e];
                    if (i.element == t) return i;
                }
            }),
            (u.getItems = function (t) {
                t = s.makeArray(t);
                var i = [];
                return (
                    t.forEach(function (t) {
                        var e = this.getItem(t);
                        e && i.push(e);
                    }, this),
                    i
                );
            }),
            (u.remove = function (t) {
                var e = this.getItems(t);
                this._emitCompleteOnItems("remove", e),
                    e &&
                        e.length &&
                        e.forEach(function (t) {
                            t.remove(), s.removeFrom(this.items, t);
                        }, this);
            }),
            (u.destroy = function () {
                var t = this.element.style;
                (t.height = ""),
                    (t.position = ""),
                    (t.width = ""),
                    this.items.forEach(function (t) {
                        t.destroy();
                    }),
                    this.unbindResize();
                var e = this.element.outlayerGUID;
                delete d[e],
                    delete this.element.outlayerGUID,
                    c && c.removeData(this.element, this.constructor.namespace);
            }),
            (r.data = function (t) {
                var e = (t = s.getQueryElement(t)) && t.outlayerGUID;
                return e && d[e];
            }),
            (r.create = function (t, e) {
                var i = a(r);
                return (
                    (i.defaults = s.extend({}, r.defaults)),
                    s.extend(i.defaults, e),
                    (i.compatOptions = s.extend({}, r.compatOptions)),
                    (i.namespace = t),
                    (i.data = r.data),
                    (i.Item = a(n)),
                    s.htmlInit(i, t),
                    c && c.bridget && c.bridget(t, i),
                    i
                );
            });
        var p = { ms: 1, s: 1e3 };
        return (r.Item = n), r;
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("isotope-layout/js/item", ["outlayer/outlayer"], e)
            : "object" == typeof module && module.exports
              ? (module.exports = e(require("outlayer")))
              : ((t.Isotope = t.Isotope || {}),
                (t.Isotope.Item = e(t.Outlayer)));
    })(window, function (t) {
        "use strict";
        function e() {
            t.Item.apply(this, arguments);
        }
        var i = (e.prototype = Object.create(t.Item.prototype)),
            n = i._create;
        (i._create = function () {
            (this.id = this.layout.itemGUID++),
                n.call(this),
                (this.sortData = {});
        }),
            (i.updateSortData = function () {
                if (!this.isIgnored) {
                    (this.sortData.id = this.id),
                        (this.sortData["original-order"] = this.id),
                        (this.sortData.random = Math.random());
                    var t = this.layout.options.getSortData,
                        e = this.layout._sorters;
                    for (var i in t) {
                        var n = e[i];
                        this.sortData[i] = n(this.element, this);
                    }
                }
            });
        var o = i.destroy;
        return (
            (i.destroy = function () {
                o.apply(this, arguments), this.css({ display: "" });
            }),
            e
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define(
                  "isotope-layout/js/layout-mode",
                  ["get-size/get-size", "outlayer/outlayer"],
                  e,
              )
            : "object" == typeof module && module.exports
              ? (module.exports = e(require("get-size"), require("outlayer")))
              : ((t.Isotope = t.Isotope || {}),
                (t.Isotope.LayoutMode = e(t.getSize, t.Outlayer)));
    })(window, function (e, i) {
        "use strict";
        function n(t) {
            (this.isotope = t) &&
                ((this.options = t.options[this.namespace]),
                (this.element = t.element),
                (this.items = t.filteredItems),
                (this.size = t.size));
        }
        var o = n.prototype;
        return (
            [
                "_resetLayout",
                "_getItemLayoutPosition",
                "_manageStamp",
                "_getContainerSize",
                "_getElementOffset",
                "needsResizeLayout",
                "_getOption",
            ].forEach(function (t) {
                o[t] = function () {
                    return i.prototype[t].apply(this.isotope, arguments);
                };
            }),
            (o.needsVerticalResizeLayout = function () {
                var t = e(this.isotope.element);
                return (
                    this.isotope.size &&
                    t &&
                    t.innerHeight != this.isotope.size.innerHeight
                );
            }),
            (o._getMeasurement = function () {
                this.isotope._getMeasurement.apply(this, arguments);
            }),
            (o.getColumnWidth = function () {
                this.getSegmentSize("column", "Width");
            }),
            (o.getRowHeight = function () {
                this.getSegmentSize("row", "Height");
            }),
            (o.getSegmentSize = function (t, e) {
                var i = t + e,
                    n = "outer" + e;
                if ((this._getMeasurement(i, n), !this[i])) {
                    var o = this.getFirstItemSize();
                    this[i] = (o && o[n]) || this.isotope.size["inner" + e];
                }
            }),
            (o.getFirstItemSize = function () {
                var t = this.isotope.filteredItems[0];
                return t && t.element && e(t.element);
            }),
            (o.layout = function () {
                this.isotope.layout.apply(this.isotope, arguments);
            }),
            (o.getSize = function () {
                this.isotope.getSize(), (this.size = this.isotope.size);
            }),
            (n.modes = {}),
            (n.create = function (t, e) {
                function i() {
                    n.apply(this, arguments);
                }
                return (
                    ((i.prototype = Object.create(o)).constructor = i),
                    e && (i.options = e),
                    (n.modes[(i.prototype.namespace = t)] = i)
                );
            }),
            n
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define(
                  "masonry-layout/masonry",
                  ["outlayer/outlayer", "get-size/get-size"],
                  e,
              )
            : "object" == typeof module && module.exports
              ? (module.exports = e(require("outlayer"), require("get-size")))
              : (t.Masonry = e(t.Outlayer, t.getSize));
    })(window, function (t, c) {
        var e = t.create("masonry");
        e.compatOptions.fitWidth = "isFitWidth";
        var i = e.prototype;
        return (
            (i._resetLayout = function () {
                this.getSize(),
                    this._getMeasurement("columnWidth", "outerWidth"),
                    this._getMeasurement("gutter", "outerWidth"),
                    this.measureColumns(),
                    (this.colYs = []);
                for (var t = 0; t < this.cols; t++) this.colYs.push(0);
                (this.maxY = 0), (this.horizontalColIndex = 0);
            }),
            (i.measureColumns = function () {
                if ((this.getContainerWidth(), !this.columnWidth)) {
                    var t = this.items[0],
                        e = t && t.element;
                    this.columnWidth =
                        (e && c(e).outerWidth) || this.containerWidth;
                }
                var i = (this.columnWidth += this.gutter),
                    n = this.containerWidth + this.gutter,
                    o = n / i,
                    s = i - (n % i);
                (o = Math[s && s < 1 ? "round" : "floor"](o)),
                    (this.cols = Math.max(o, 1));
            }),
            (i.getContainerWidth = function () {
                var t = this._getOption("fitWidth")
                        ? this.element.parentNode
                        : this.element,
                    e = c(t);
                this.containerWidth = e && e.innerWidth;
            }),
            (i._getItemLayoutPosition = function (t) {
                t.getSize();
                var e = t.size.outerWidth % this.columnWidth,
                    i = Math[e && e < 1 ? "round" : "ceil"](
                        t.size.outerWidth / this.columnWidth,
                    );
                i = Math.min(i, this.cols);
                for (
                    var n = this[
                            this.options.horizontalOrder
                                ? "_getHorizontalColPosition"
                                : "_getTopColPosition"
                        ](i, t),
                        o = { x: this.columnWidth * n.col, y: n.y },
                        s = n.y + t.size.outerHeight,
                        r = i + n.col,
                        a = n.col;
                    a < r;
                    a++
                )
                    this.colYs[a] = s;
                return o;
            }),
            (i._getTopColPosition = function (t) {
                var e = this._getTopColGroup(t),
                    i = Math.min.apply(Math, e);
                return { col: e.indexOf(i), y: i };
            }),
            (i._getTopColGroup = function (t) {
                if (t < 2) return this.colYs;
                for (var e = [], i = this.cols + 1 - t, n = 0; n < i; n++)
                    e[n] = this._getColGroupY(n, t);
                return e;
            }),
            (i._getColGroupY = function (t, e) {
                if (e < 2) return this.colYs[t];
                var i = this.colYs.slice(t, t + e);
                return Math.max.apply(Math, i);
            }),
            (i._getHorizontalColPosition = function (t, e) {
                var i = this.horizontalColIndex % this.cols;
                i = 1 < t && i + t > this.cols ? 0 : i;
                var n = e.size.outerWidth && e.size.outerHeight;
                return (
                    (this.horizontalColIndex = n
                        ? i + t
                        : this.horizontalColIndex),
                    { col: i, y: this._getColGroupY(i, t) }
                );
            }),
            (i._manageStamp = function (t) {
                var e = c(t),
                    i = this._getElementOffset(t),
                    n = this._getOption("originLeft") ? i.left : i.right,
                    o = n + e.outerWidth,
                    s = Math.floor(n / this.columnWidth);
                s = Math.max(0, s);
                var r = Math.floor(o / this.columnWidth);
                (r -= o % this.columnWidth ? 0 : 1),
                    (r = Math.min(this.cols - 1, r));
                for (
                    var a =
                            (this._getOption("originTop") ? i.top : i.bottom) +
                            e.outerHeight,
                        l = s;
                    l <= r;
                    l++
                )
                    this.colYs[l] = Math.max(a, this.colYs[l]);
            }),
            (i._getContainerSize = function () {
                this.maxY = Math.max.apply(Math, this.colYs);
                var t = { height: this.maxY };
                return (
                    this._getOption("fitWidth") &&
                        (t.width = this._getContainerFitWidth()),
                    t
                );
            }),
            (i._getContainerFitWidth = function () {
                for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; )
                    t++;
                return (this.cols - t) * this.columnWidth - this.gutter;
            }),
            (i.needsResizeLayout = function () {
                var t = this.containerWidth;
                return this.getContainerWidth(), t != this.containerWidth;
            }),
            e
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define(
                  "isotope-layout/js/layout-modes/masonry",
                  ["../layout-mode", "masonry-layout/masonry"],
                  e,
              )
            : "object" == typeof module && module.exports
              ? (module.exports = e(
                    require("../layout-mode"),
                    require("masonry-layout"),
                ))
              : e(t.Isotope.LayoutMode, t.Masonry);
    })(window, function (t, e) {
        "use strict";
        var i = t.create("masonry"),
            n = i.prototype,
            o = { _getElementOffset: !0, layout: !0, _getMeasurement: !0 };
        for (var s in e.prototype) o[s] || (n[s] = e.prototype[s]);
        var r = n.measureColumns;
        n.measureColumns = function () {
            (this.items = this.isotope.filteredItems), r.call(this);
        };
        var a = n._getOption;
        return (
            (n._getOption = function (t) {
                return "fitWidth" == t
                    ? void 0 !== this.options.isFitWidth
                        ? this.options.isFitWidth
                        : this.options.fitWidth
                    : a.apply(this.isotope, arguments);
            }),
            i
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define(
                  "isotope-layout/js/layout-modes/fit-rows",
                  ["../layout-mode"],
                  e,
              )
            : "object" == typeof exports
              ? (module.exports = e(require("../layout-mode")))
              : e(t.Isotope.LayoutMode);
    })(window, function (t) {
        "use strict";
        var e = t.create("fitRows"),
            i = e.prototype;
        return (
            (i._resetLayout = function () {
                (this.x = 0),
                    (this.y = 0),
                    (this.maxY = 0),
                    this._getMeasurement("gutter", "outerWidth");
            }),
            (i._getItemLayoutPosition = function (t) {
                t.getSize();
                var e = t.size.outerWidth + this.gutter,
                    i = this.isotope.size.innerWidth + this.gutter;
                0 !== this.x &&
                    e + this.x > i &&
                    ((this.x = 0), (this.y = this.maxY));
                var n = { x: this.x, y: this.y };
                return (
                    (this.maxY = Math.max(
                        this.maxY,
                        this.y + t.size.outerHeight,
                    )),
                    (this.x += e),
                    n
                );
            }),
            (i._getContainerSize = function () {
                return { height: this.maxY };
            }),
            e
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define(
                  "isotope-layout/js/layout-modes/vertical",
                  ["../layout-mode"],
                  e,
              )
            : "object" == typeof module && module.exports
              ? (module.exports = e(require("../layout-mode")))
              : e(t.Isotope.LayoutMode);
    })(window, function (t) {
        "use strict";
        var e = t.create("vertical", { horizontalAlignment: 0 }),
            i = e.prototype;
        return (
            (i._resetLayout = function () {
                this.y = 0;
            }),
            (i._getItemLayoutPosition = function (t) {
                t.getSize();
                var e =
                        (this.isotope.size.innerWidth - t.size.outerWidth) *
                        this.options.horizontalAlignment,
                    i = this.y;
                return (this.y += t.size.outerHeight), { x: e, y: i };
            }),
            (i._getContainerSize = function () {
                return { height: this.y };
            }),
            e
        );
    }),
    (function (r, a) {
        "function" == typeof define && define.amd
            ? define(
                  [
                      "outlayer/outlayer",
                      "get-size/get-size",
                      "desandro-matches-selector/matches-selector",
                      "fizzy-ui-utils/utils",
                      "isotope-layout/js/item",
                      "isotope-layout/js/layout-mode",
                      "isotope-layout/js/layout-modes/masonry",
                      "isotope-layout/js/layout-modes/fit-rows",
                      "isotope-layout/js/layout-modes/vertical",
                  ],
                  function (t, e, i, n, o, s) {
                      return a(r, t, 0, i, n, o, s);
                  },
              )
            : "object" == typeof module && module.exports
              ? (module.exports = a(
                    r,
                    require("outlayer"),
                    require("get-size"),
                    require("desandro-matches-selector"),
                    require("fizzy-ui-utils"),
                    require("isotope-layout/js/item"),
                    require("isotope-layout/js/layout-mode"),
                    require("isotope-layout/js/layout-modes/masonry"),
                    require("isotope-layout/js/layout-modes/fit-rows"),
                    require("isotope-layout/js/layout-modes/vertical"),
                ))
              : (r.Isotope = a(
                    r,
                    r.Outlayer,
                    r.getSize,
                    r.matchesSelector,
                    r.fizzyUIUtils,
                    r.Isotope.Item,
                    r.Isotope.LayoutMode,
                ));
    })(window, function (t, i, e, n, s, o, r) {
        var a = t.jQuery,
            c = String.prototype.trim
                ? function (t) {
                      return t.trim();
                  }
                : function (t) {
                      return t.replace(/^\s+|\s+$/g, "");
                  },
            h = i.create("isotope", {
                layoutMode: "masonry",
                isJQueryFiltering: !0,
                sortAscending: !0,
            });
        (h.Item = o), (h.LayoutMode = r);
        var l = h.prototype;
        (l._create = function () {
            for (var t in ((this.itemGUID = 0),
            (this._sorters = {}),
            this._getSorters(),
            i.prototype._create.call(this),
            (this.modes = {}),
            (this.filteredItems = this.items),
            (this.sortHistory = ["original-order"]),
            r.modes))
                this._initLayoutMode(t);
        }),
            (l.reloadItems = function () {
                (this.itemGUID = 0), i.prototype.reloadItems.call(this);
            }),
            (l._itemize = function () {
                for (
                    var t = i.prototype._itemize.apply(this, arguments), e = 0;
                    e < t.length;
                    e++
                ) {
                    t[e].id = this.itemGUID++;
                }
                return this._updateItemsSortData(t), t;
            }),
            (l._initLayoutMode = function (t) {
                var e = r.modes[t],
                    i = this.options[t] || {};
                (this.options[t] = e.options ? s.extend(e.options, i) : i),
                    (this.modes[t] = new e(this));
            }),
            (l.layout = function () {
                return !this._isLayoutInited && this._getOption("initLayout")
                    ? void this.arrange()
                    : void this._layout();
            }),
            (l._layout = function () {
                var t = this._getIsInstant();
                this._resetLayout(),
                    this._manageStamps(),
                    this.layoutItems(this.filteredItems, t),
                    (this._isLayoutInited = !0);
            }),
            (l.arrange = function (t) {
                this.option(t), this._getIsInstant();
                var e = this._filter(this.items);
                (this.filteredItems = e.matches),
                    this._bindArrangeComplete(),
                    this._isInstant
                        ? this._noTransition(this._hideReveal, [e])
                        : this._hideReveal(e),
                    this._sort(),
                    this._layout();
            }),
            (l._init = l.arrange),
            (l._hideReveal = function (t) {
                this.reveal(t.needReveal), this.hide(t.needHide);
            }),
            (l._getIsInstant = function () {
                var t = this._getOption("layoutInstant"),
                    e = void 0 !== t ? t : !this._isLayoutInited;
                return (this._isInstant = e);
            }),
            (l._bindArrangeComplete = function () {
                function t() {
                    e &&
                        i &&
                        n &&
                        o.dispatchEvent("arrangeComplete", null, [
                            o.filteredItems,
                        ]);
                }
                var e,
                    i,
                    n,
                    o = this;
                this.once("layoutComplete", function () {
                    (e = !0), t();
                }),
                    this.once("hideComplete", function () {
                        (i = !0), t();
                    }),
                    this.once("revealComplete", function () {
                        (n = !0), t();
                    });
            }),
            (l._filter = function (t) {
                var e = this.options.filter;
                e = e || "*";
                for (
                    var i = [],
                        n = [],
                        o = [],
                        s = this._getFilterTest(e),
                        r = 0;
                    r < t.length;
                    r++
                ) {
                    var a = t[r];
                    if (!a.isIgnored) {
                        var l = s(a);
                        l && i.push(a),
                            l && a.isHidden
                                ? n.push(a)
                                : l || a.isHidden || o.push(a);
                    }
                }
                return { matches: i, needReveal: n, needHide: o };
            }),
            (l._getFilterTest = function (e) {
                return a && this.options.isJQueryFiltering
                    ? function (t) {
                          return a(t.element).is(e);
                      }
                    : "function" == typeof e
                      ? function (t) {
                            return e(t.element);
                        }
                      : function (t) {
                            return n(t.element, e);
                        };
            }),
            (l.updateSortData = function (t) {
                var e;
                (e = t ? ((t = s.makeArray(t)), this.getItems(t)) : this.items),
                    this._getSorters(),
                    this._updateItemsSortData(e);
            }),
            (l._getSorters = function () {
                var t = this.options.getSortData;
                for (var e in t) {
                    var i = t[e];
                    this._sorters[e] = d(i);
                }
            }),
            (l._updateItemsSortData = function (t) {
                for (var e = t && t.length, i = 0; e && i < e; i++) {
                    t[i].updateSortData();
                }
            });
        var d = function (t) {
            if ("string" != typeof t) return t;
            var e,
                i,
                n = c(t).split(" "),
                o = n[0],
                s = o.match(/^\[(.+)\]$/),
                r = s && s[1],
                a =
                    ((i = o),
                    (e = r)
                        ? function (t) {
                              return t.getAttribute(e);
                          }
                        : function (t) {
                              var e = t.querySelector(i);
                              return e && e.textContent;
                          }),
                l = h.sortDataParsers[n[1]];
            return l
                ? function (t) {
                      return t && l(a(t));
                  }
                : function (t) {
                      return t && a(t);
                  };
        };
        (h.sortDataParsers = {
            parseInt: function (t) {
                return parseInt(t, 10);
            },
            parseFloat: function (t) {
                return parseFloat(t);
            },
        }),
            (l._sort = function () {
                if (this.options.sortBy) {
                    var t = s.makeArray(this.options.sortBy);
                    this._getIsSameSortBy(t) ||
                        (this.sortHistory = t.concat(this.sortHistory));
                    var e =
                        ((r = this.sortHistory),
                        (a = this.options.sortAscending),
                        function (t, e) {
                            for (var i = 0; i < r.length; i++) {
                                var n = r[i],
                                    o = t.sortData[n],
                                    s = e.sortData[n];
                                if (s < o || o < s)
                                    return (
                                        (s < o ? 1 : -1) *
                                        ((void 0 !== a[n] ? a[n] : a) ? 1 : -1)
                                    );
                            }
                            return 0;
                        });
                    this.filteredItems.sort(e);
                }
                var r, a;
            }),
            (l._getIsSameSortBy = function (t) {
                for (var e = 0; e < t.length; e++)
                    if (t[e] != this.sortHistory[e]) return !1;
                return !0;
            }),
            (l._mode = function () {
                var t = this.options.layoutMode,
                    e = this.modes[t];
                if (!e) throw new Error("No layout mode: " + t);
                return (e.options = this.options[t]), e;
            }),
            (l._resetLayout = function () {
                i.prototype._resetLayout.call(this),
                    this._mode()._resetLayout();
            }),
            (l._getItemLayoutPosition = function (t) {
                return this._mode()._getItemLayoutPosition(t);
            }),
            (l._manageStamp = function (t) {
                this._mode()._manageStamp(t);
            }),
            (l._getContainerSize = function () {
                return this._mode()._getContainerSize();
            }),
            (l.needsResizeLayout = function () {
                return this._mode().needsResizeLayout();
            }),
            (l.appended = function (t) {
                var e = this.addItems(t);
                if (e.length) {
                    var i = this._filterRevealAdded(e);
                    this.filteredItems = this.filteredItems.concat(i);
                }
            }),
            (l.prepended = function (t) {
                var e = this._itemize(t);
                if (e.length) {
                    this._resetLayout(), this._manageStamps();
                    var i = this._filterRevealAdded(e);
                    this.layoutItems(this.filteredItems),
                        (this.filteredItems = i.concat(this.filteredItems)),
                        (this.items = e.concat(this.items));
                }
            }),
            (l._filterRevealAdded = function (t) {
                var e = this._filter(t);
                return (
                    this.hide(e.needHide),
                    this.reveal(e.matches),
                    this.layoutItems(e.matches, !0),
                    e.matches
                );
            }),
            (l.insert = function (t) {
                var e = this.addItems(t);
                if (e.length) {
                    var i,
                        n,
                        o = e.length;
                    for (i = 0; i < o; i++)
                        (n = e[i]), this.element.appendChild(n.element);
                    var s = this._filter(e).matches;
                    for (i = 0; i < o; i++) e[i].isLayoutInstant = !0;
                    for (this.arrange(), i = 0; i < o; i++)
                        delete e[i].isLayoutInstant;
                    this.reveal(s);
                }
            });
        var u = l.remove;
        return (
            (l.remove = function (t) {
                t = s.makeArray(t);
                var e = this.getItems(t);
                u.call(this, t);
                for (var i = e && e.length, n = 0; i && n < i; n++) {
                    var o = e[n];
                    s.removeFrom(this.filteredItems, o);
                }
            }),
            (l.shuffle = function () {
                for (var t = 0; t < this.items.length; t++) {
                    this.items[t].sortData.random = Math.random();
                }
                (this.options.sortBy = "random"), this._sort(), this._layout();
            }),
            (l._noTransition = function (t, e) {
                var i = this.options.transitionDuration;
                this.options.transitionDuration = 0;
                var n = t.apply(this, e);
                return (this.options.transitionDuration = i), n;
            }),
            (l.getFilteredItemElements = function () {
                return this.filteredItems.map(function (t) {
                    return t.element;
                });
            }),
            h
        );
    }),
    (function (i) {
        var n = {};
        function o(t) {
            if (n[t]) return n[t].exports;
            var e = (n[t] = { i: t, l: !1, exports: {} });
            return i[t].call(e.exports, e, e.exports, o), (e.l = !0), e.exports;
        }
        (o.m = i),
            (o.c = n),
            (o.d = function (t, e, i) {
                o.o(t, e) ||
                    Object.defineProperty(t, e, { enumerable: !0, get: i });
            }),
            (o.r = function (t) {
                "undefined" != typeof Symbol &&
                    Symbol.toStringTag &&
                    Object.defineProperty(t, Symbol.toStringTag, {
                        value: "Module",
                    }),
                    Object.defineProperty(t, "__esModule", { value: !0 });
            }),
            (o.t = function (e, t) {
                if ((1 & t && (e = o(e)), 8 & t)) return e;
                if (4 & t && "object" == typeof e && e && e.__esModule)
                    return e;
                var i = Object.create(null);
                if (
                    (o.r(i),
                    Object.defineProperty(i, "default", {
                        enumerable: !0,
                        value: e,
                    }),
                    2 & t && "string" != typeof e)
                )
                    for (var n in e)
                        o.d(
                            i,
                            n,
                            function (t) {
                                return e[t];
                            }.bind(null, n),
                        );
                return i;
            }),
            (o.n = function (t) {
                var e =
                    t && t.__esModule
                        ? function () {
                              return t.default;
                          }
                        : function () {
                              return t;
                          };
                return o.d(e, "a", e), e;
            }),
            (o.o = function (t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
            }),
            (o.p = ""),
            o((o.s = 11));
    })([
        ,
        ,
        function (t, e, i) {
            "use strict";
            t.exports = function (t) {
                "complete" === document.readyState ||
                "interactive" === document.readyState
                    ? t.call()
                    : document.attachEvent
                      ? document.attachEvent("onreadystatechange", function () {
                            "interactive" === document.readyState && t.call();
                        })
                      : document.addEventListener &&
                        document.addEventListener("DOMContentLoaded", t);
            };
        },
        ,
        function (i, t, e) {
            "use strict";
            (function (t) {
                var e;
                (e =
                    "undefined" != typeof window
                        ? window
                        : void 0 !== t
                          ? t
                          : "undefined" != typeof self
                            ? self
                            : {}),
                    (i.exports = e);
            }).call(this, e(5));
        },
        function (t, e, i) {
            "use strict";
            var n,
                o =
                    "function" == typeof Symbol &&
                    "symbol" == typeof Symbol.iterator
                        ? function (t) {
                              return typeof t;
                          }
                        : function (t) {
                              return t &&
                                  "function" == typeof Symbol &&
                                  t.constructor === Symbol &&
                                  t !== Symbol.prototype
                                  ? "symbol"
                                  : typeof t;
                          };
            n = (function () {
                return this;
            })();
            try {
                n = n || new Function("return this")();
            } catch (t) {
                "object" ===
                    ("undefined" == typeof window ? "undefined" : o(window)) &&
                    (n = window);
            }
            t.exports = n;
        },
        ,
        ,
        ,
        ,
        ,
        function (t, e, i) {
            t.exports = i(12);
        },
        function (t, e, i) {
            "use strict";
            var n =
                    "function" == typeof Symbol &&
                    "symbol" == typeof Symbol.iterator
                        ? function (t) {
                              return typeof t;
                          }
                        : function (t) {
                              return t &&
                                  "function" == typeof Symbol &&
                                  t.constructor === Symbol &&
                                  t !== Symbol.prototype
                                  ? "symbol"
                                  : typeof t;
                          },
                o = a(i(2)),
                s = i(4),
                r = a(i(13));
            function a(t) {
                return t && t.__esModule ? t : { default: t };
            }
            var l = s.window.jarallax;
            if (
                ((s.window.jarallax = r.default),
                (s.window.jarallax.noConflict = function () {
                    return (s.window.jarallax = l), this;
                }),
                void 0 !== s.jQuery)
            ) {
                var c = function () {
                    var t = arguments || [];
                    Array.prototype.unshift.call(t, this);
                    var e = r.default.apply(s.window, t);
                    return "object" !== (void 0 === e ? "undefined" : n(e))
                        ? e
                        : this;
                };
                c.constructor = r.default.constructor;
                var h = s.jQuery.fn.jarallax;
                (s.jQuery.fn.jarallax = c),
                    (s.jQuery.fn.jarallax.noConflict = function () {
                        return (s.jQuery.fn.jarallax = h), this;
                    });
            }
            (0, o.default)(function () {
                (0, r.default)(document.querySelectorAll("[data-jarallax]"));
            });
        },
        function (t, I, A) {
            "use strict";
            (function (t) {
                Object.defineProperty(I, "__esModule", { value: !0 });
                var l = function (t, e) {
                    if (Array.isArray(t)) return t;
                    if (Symbol.iterator in Object(t))
                        return (function (t, e) {
                            var i = [],
                                n = !0,
                                o = !1,
                                s = void 0;
                            try {
                                for (
                                    var r, a = t[Symbol.iterator]();
                                    !(n = (r = a.next()).done) &&
                                    (i.push(r.value), !e || i.length !== e);
                                    n = !0
                                );
                            } catch (t) {
                                (o = !0), (s = t);
                            } finally {
                                try {
                                    !n && a.return && a.return();
                                } finally {
                                    if (o) throw s;
                                }
                            }
                            return i;
                        })(t, e);
                    throw new TypeError(
                        "Invalid attempt to destructure non-iterable instance",
                    );
                };
                function e(t, e) {
                    for (var i = 0; i < e.length; i++) {
                        var n = e[i];
                        (n.enumerable = n.enumerable || !1),
                            (n.configurable = !0),
                            "value" in n && (n.writable = !0),
                            Object.defineProperty(t, n.key, n);
                    }
                }
                var c =
                        "function" == typeof Symbol &&
                        "symbol" == typeof Symbol.iterator
                            ? function (t) {
                                  return typeof t;
                              }
                            : function (t) {
                                  return t &&
                                      "function" == typeof Symbol &&
                                      t.constructor === Symbol &&
                                      t !== Symbol.prototype
                                      ? "symbol"
                                      : typeof t;
                              },
                    i = s(A(2)),
                    n = s(A(14)),
                    o = A(4);
                function s(t) {
                    return t && t.__esModule ? t : { default: t };
                }
                var h =
                        -1 < navigator.userAgent.indexOf("MSIE ") ||
                        -1 < navigator.userAgent.indexOf("Trident/") ||
                        -1 < navigator.userAgent.indexOf("Edge/"),
                    r =
                        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                            navigator.userAgent,
                        ),
                    a = (function () {
                        for (
                            var t =
                                    "transform WebkitTransform MozTransform".split(
                                        " ",
                                    ),
                                e = document.createElement("div"),
                                i = 0;
                            i < t.length;
                            i++
                        )
                            if (e && void 0 !== e.style[t[i]]) return t[i];
                        return !1;
                    })(),
                    d = void 0,
                    v = void 0,
                    y = void 0,
                    u = void 0,
                    p = !1,
                    f = !1;
                function g(t) {
                    (v =
                        o.window.innerWidth ||
                        document.documentElement.clientWidth),
                        (y = r
                            ? (!d &&
                                  document.body &&
                                  (((d =
                                      document.createElement(
                                          "div",
                                      )).style.cssText =
                                      "position: fixed; top: -9999px; left: 0; height: 100vh; width: 0;"),
                                  document.body.appendChild(d)),
                              (d ? d.clientHeight : 0) ||
                                  o.window.innerHeight ||
                                  document.documentElement.clientHeight)
                            : o.window.innerHeight ||
                              document.documentElement.clientHeight),
                        "object" !== (void 0 === t ? "undefined" : c(t)) ||
                            ("load" !== t.type && "dom-loaded" !== t.type) ||
                            (p = !0);
                }
                g(),
                    o.window.addEventListener("resize", g),
                    o.window.addEventListener("orientationchange", g),
                    o.window.addEventListener("load", g),
                    (0, i.default)(function () {
                        g({ type: "dom-loaded" });
                    });
                var m = [],
                    _ = !1;
                function b() {
                    if (m.length) {
                        u =
                            void 0 !== o.window.pageYOffset
                                ? o.window.pageYOffset
                                : (
                                      document.documentElement ||
                                      document.body.parentNode ||
                                      document.body
                                  ).scrollTop;
                        var e = p || !_ || _.width !== v || _.height !== y,
                            i = f || e || !_ || _.y !== u;
                        (f = p = !1),
                            (e || i) &&
                                (m.forEach(function (t) {
                                    e && t.onResize(), i && t.onScroll();
                                }),
                                (_ = { width: v, height: y, y: u })),
                            (0, n.default)(b);
                    }
                }
                var w,
                    x,
                    S,
                    T =
                        !!t.ResizeObserver &&
                        new t.ResizeObserver(function (t) {
                            t &&
                                t.length &&
                                (0, n.default)(function () {
                                    t.forEach(function (t) {
                                        t.target &&
                                            t.target.jarallax &&
                                            (p || t.target.jarallax.onResize(),
                                            (f = !0));
                                    });
                                });
                        }),
                    C = 0,
                    k =
                        ((w = E),
                        (x = [
                            {
                                key: "css",
                                value: function (e, i) {
                                    return "string" == typeof i
                                        ? o.window
                                              .getComputedStyle(e)
                                              .getPropertyValue(i)
                                        : (i.transform &&
                                              a &&
                                              (i[a] = i.transform),
                                          Object.keys(i).forEach(function (t) {
                                              e.style[t] = i[t];
                                          }),
                                          e);
                                },
                            },
                            {
                                key: "extend",
                                value: function (i) {
                                    var n = arguments;
                                    return (
                                        (i = i || {}),
                                        Object.keys(arguments).forEach(
                                            function (e) {
                                                n[e] &&
                                                    Object.keys(n[e]).forEach(
                                                        function (t) {
                                                            i[t] = n[e][t];
                                                        },
                                                    );
                                            },
                                        ),
                                        i
                                    );
                                },
                            },
                            {
                                key: "getWindowData",
                                value: function () {
                                    return { width: v, height: y, y: u };
                                },
                            },
                            {
                                key: "initImg",
                                value: function () {
                                    var t = this,
                                        e = t.options.imgElement;
                                    return (
                                        e &&
                                            "string" == typeof e &&
                                            (e = t.$item.querySelector(e)),
                                        e instanceof Element || (e = null),
                                        e &&
                                            (t.options.keepImg
                                                ? (t.image.$item =
                                                      e.cloneNode(!0))
                                                : ((t.image.$item = e),
                                                  (t.image.$itemParent =
                                                      e.parentNode)),
                                            (t.image.useImgTag = !0)),
                                        !(
                                            !t.image.$item &&
                                            (null === t.image.src &&
                                                ((t.image.src =
                                                    "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"),
                                                (t.image.bgImage = t.css(
                                                    t.$item,
                                                    "background-image",
                                                ))),
                                            !t.image.bgImage ||
                                                "none" === t.image.bgImage)
                                        )
                                    );
                                },
                            },
                            {
                                key: "canInitParallax",
                                value: function () {
                                    return a && !this.options.disableParallax();
                                },
                            },
                            {
                                key: "init",
                                value: function () {
                                    var t = this,
                                        e = {
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            overflow: "hidden",
                                            pointerEvents: "none",
                                        },
                                        i = {};
                                    if (!t.options.keepImg) {
                                        var n = t.$item.getAttribute("style");
                                        if (
                                            (n &&
                                                t.$item.setAttribute(
                                                    "data-jarallax-original-styles",
                                                    n,
                                                ),
                                            t.image.useImgTag)
                                        ) {
                                            var o =
                                                t.image.$item.getAttribute(
                                                    "style",
                                                );
                                            o &&
                                                t.image.$item.setAttribute(
                                                    "data-jarallax-original-styles",
                                                    o,
                                                );
                                        }
                                    }
                                    if (
                                        ("static" ===
                                            t.css(t.$item, "position") &&
                                            t.css(t.$item, {
                                                position: "relative",
                                            }),
                                        "auto" === t.css(t.$item, "z-index") &&
                                            t.css(t.$item, { zIndex: 0 }),
                                        (t.image.$container =
                                            document.createElement("div")),
                                        t.css(t.image.$container, e),
                                        t.css(t.image.$container, {
                                            "z-index": t.options.zIndex,
                                        }),
                                        h &&
                                            t.css(t.image.$container, {
                                                opacity: 0.9999,
                                            }),
                                        t.image.$container.setAttribute(
                                            "id",
                                            "jarallax-container-" +
                                                t.instanceID,
                                        ),
                                        t.$item.appendChild(t.image.$container),
                                        t.image.useImgTag
                                            ? (i = t.extend(
                                                  {
                                                      "object-fit":
                                                          t.options.imgSize,
                                                      "object-position":
                                                          t.options.imgPosition,
                                                      "font-family":
                                                          "object-fit: " +
                                                          t.options.imgSize +
                                                          "; object-position: " +
                                                          t.options
                                                              .imgPosition +
                                                          ";",
                                                      "max-width": "none",
                                                  },
                                                  e,
                                                  i,
                                              ))
                                            : ((t.image.$item =
                                                  document.createElement(
                                                      "div",
                                                  )),
                                              t.image.src &&
                                                  (i = t.extend(
                                                      {
                                                          "background-position":
                                                              t.options
                                                                  .imgPosition,
                                                          "background-size":
                                                              t.options.imgSize,
                                                          "background-repeat":
                                                              t.options
                                                                  .imgRepeat,
                                                          "background-image":
                                                              t.image.bgImage ||
                                                              'url("' +
                                                                  t.image.src +
                                                                  '")',
                                                      },
                                                      e,
                                                      i,
                                                  ))),
                                        ("opacity" !== t.options.type &&
                                            "scale" !== t.options.type &&
                                            "scale-opacity" !==
                                                t.options.type &&
                                            1 !== t.options.speed) ||
                                            (t.image.position = "absolute"),
                                        "fixed" === t.image.position)
                                    )
                                        for (
                                            var s = 0, r = t.$item;
                                            null !== r &&
                                            r !== document &&
                                            0 === s;

                                        ) {
                                            var a =
                                                t.css(r, "-webkit-transform") ||
                                                t.css(r, "-moz-transform") ||
                                                t.css(r, "transform");
                                            a &&
                                                "none" !== a &&
                                                ((s = 1),
                                                (t.image.position =
                                                    "absolute")),
                                                (r = r.parentNode);
                                        }
                                    (i.position = t.image.position),
                                        t.css(t.image.$item, i),
                                        t.image.$container.appendChild(
                                            t.image.$item,
                                        ),
                                        t.onResize(),
                                        t.onScroll(!0),
                                        t.options.automaticResize &&
                                            T &&
                                            T.observe(t.$item),
                                        t.options.onInit &&
                                            t.options.onInit.call(t),
                                        "none" !==
                                            t.css(
                                                t.$item,
                                                "background-image",
                                            ) &&
                                            t.css(t.$item, {
                                                "background-image": "none",
                                            }),
                                        t.addToParallaxList();
                                },
                            },
                            {
                                key: "addToParallaxList",
                                value: function () {
                                    m.push(this), 1 === m.length && b();
                                },
                            },
                            {
                                key: "removeFromParallaxList",
                                value: function () {
                                    var i = this;
                                    m.forEach(function (t, e) {
                                        t.instanceID === i.instanceID &&
                                            m.splice(e, 1);
                                    });
                                },
                            },
                            {
                                key: "destroy",
                                value: function () {
                                    var t = this;
                                    t.removeFromParallaxList();
                                    var e = t.$item.getAttribute(
                                        "data-jarallax-original-styles",
                                    );
                                    if (
                                        (t.$item.removeAttribute(
                                            "data-jarallax-original-styles",
                                        ),
                                        e
                                            ? t.$item.setAttribute("style", e)
                                            : t.$item.removeAttribute("style"),
                                        t.image.useImgTag)
                                    ) {
                                        var i = t.image.$item.getAttribute(
                                            "data-jarallax-original-styles",
                                        );
                                        t.image.$item.removeAttribute(
                                            "data-jarallax-original-styles",
                                        ),
                                            i
                                                ? t.image.$item.setAttribute(
                                                      "style",
                                                      e,
                                                  )
                                                : t.image.$item.removeAttribute(
                                                      "style",
                                                  ),
                                            t.image.$itemParent &&
                                                t.image.$itemParent.appendChild(
                                                    t.image.$item,
                                                );
                                    }
                                    t.$clipStyles &&
                                        t.$clipStyles.parentNode.removeChild(
                                            t.$clipStyles,
                                        ),
                                        t.image.$container &&
                                            t.image.$container.parentNode.removeChild(
                                                t.image.$container,
                                            ),
                                        t.options.onDestroy &&
                                            t.options.onDestroy.call(t),
                                        delete t.$item.jarallax;
                                },
                            },
                            {
                                key: "clipContainer",
                                value: function () {
                                    if ("fixed" === this.image.position) {
                                        var t = this,
                                            e =
                                                t.image.$container.getBoundingClientRect(),
                                            i = e.width,
                                            n = e.height;
                                        t.$clipStyles ||
                                            ((t.$clipStyles =
                                                document.createElement(
                                                    "style",
                                                )),
                                            t.$clipStyles.setAttribute(
                                                "type",
                                                "text/css",
                                            ),
                                            t.$clipStyles.setAttribute(
                                                "id",
                                                "jarallax-clip-" + t.instanceID,
                                            ),
                                            (
                                                document.head ||
                                                document.getElementsByTagName(
                                                    "head",
                                                )[0]
                                            ).appendChild(t.$clipStyles));
                                        var o =
                                            "#jarallax-container-" +
                                            t.instanceID +
                                            " {\n           clip: rect(0 " +
                                            i +
                                            "px " +
                                            n +
                                            "px 0);\n           clip: rect(0, " +
                                            i +
                                            "px, " +
                                            n +
                                            "px, 0);\n        }";
                                        t.$clipStyles.styleSheet
                                            ? (t.$clipStyles.styleSheet.cssText =
                                                  o)
                                            : (t.$clipStyles.innerHTML = o);
                                    }
                                },
                            },
                            {
                                key: "coverImage",
                                value: function () {
                                    var t,
                                        e = this,
                                        i =
                                            e.image.$container.getBoundingClientRect(),
                                        n = i.height,
                                        o = e.options.speed,
                                        s =
                                            "scroll" === e.options.type ||
                                            "scroll-opacity" === e.options.type,
                                        r = 0,
                                        a = n;
                                    return (
                                        s &&
                                            (o < 0
                                                ? ((r = o * Math.max(n, y)),
                                                  y < n && (r -= o * (n - y)))
                                                : (r = o * (n + y)),
                                            1 < o
                                                ? (a = Math.abs(r - y))
                                                : o < 0
                                                  ? (a = r / o + Math.abs(r))
                                                  : (a += (y - n) * (1 - o)),
                                            (r /= 2)),
                                        (e.parallaxScrollDistance = r),
                                        (t = s ? (y - a) / 2 : (n - a) / 2),
                                        e.css(e.image.$item, {
                                            height: a + "px",
                                            marginTop: t + "px",
                                            left:
                                                "fixed" === e.image.position
                                                    ? i.left + "px"
                                                    : "0",
                                            width: i.width + "px",
                                        }),
                                        e.options.onCoverImage &&
                                            e.options.onCoverImage.call(e),
                                        {
                                            image: { height: a, marginTop: t },
                                            container: i,
                                        }
                                    );
                                },
                            },
                            {
                                key: "isVisible",
                                value: function () {
                                    return this.isElementInViewport || !1;
                                },
                            },
                            {
                                key: "onScroll",
                                value: function (t) {
                                    var e = this,
                                        i = e.$item.getBoundingClientRect(),
                                        n = i.top,
                                        o = i.height,
                                        s = {},
                                        r = i;
                                    if (
                                        (e.options.elementInViewport &&
                                            (r =
                                                e.options.elementInViewport.getBoundingClientRect()),
                                        (e.isElementInViewport =
                                            0 <= r.bottom &&
                                            0 <= r.right &&
                                            r.top <= y &&
                                            r.left <= v),
                                        t || e.isElementInViewport)
                                    ) {
                                        var a = Math.max(0, n),
                                            l = Math.max(0, o + n),
                                            c = Math.max(0, -n),
                                            h = Math.max(0, n + o - y),
                                            d = Math.max(0, o - (n + o - y)),
                                            u = Math.max(0, -n + y - o),
                                            p = 1 - (2 * (y - n)) / (y + o),
                                            f = 1;
                                        if (
                                            (o < y
                                                ? (f = 1 - (c || h) / o)
                                                : l <= y
                                                  ? (f = l / y)
                                                  : d <= y && (f = d / y),
                                            ("opacity" !== e.options.type &&
                                                "scale-opacity" !==
                                                    e.options.type &&
                                                "scroll-opacity" !==
                                                    e.options.type) ||
                                                ((s.transform =
                                                    "translate3d(0,0,0)"),
                                                (s.opacity = f)),
                                            "scale" === e.options.type ||
                                                "scale-opacity" ===
                                                    e.options.type)
                                        ) {
                                            var g = 1;
                                            e.options.speed < 0
                                                ? (g -= e.options.speed * f)
                                                : (g +=
                                                      e.options.speed *
                                                      (1 - f)),
                                                (s.transform =
                                                    "scale(" +
                                                    g +
                                                    ") translate3d(0,0,0)");
                                        }
                                        if (
                                            "scroll" === e.options.type ||
                                            "scroll-opacity" === e.options.type
                                        ) {
                                            var m =
                                                e.parallaxScrollDistance * p;
                                            "absolute" === e.image.position &&
                                                (m -= n),
                                                (s.transform =
                                                    "translate3d(0," +
                                                    m +
                                                    "px,0)");
                                        }
                                        e.css(e.image.$item, s),
                                            e.options.onScroll &&
                                                e.options.onScroll.call(e, {
                                                    section: i,
                                                    beforeTop: a,
                                                    beforeTopEnd: l,
                                                    afterTop: c,
                                                    beforeBottom: h,
                                                    beforeBottomEnd: d,
                                                    afterBottom: u,
                                                    visiblePercent: f,
                                                    fromViewportCenter: p,
                                                });
                                    }
                                },
                            },
                            {
                                key: "onResize",
                                value: function () {
                                    this.coverImage(), this.clipContainer();
                                },
                            },
                        ]) && e(w.prototype, x),
                        S && e(w, S),
                        E);
                function E(t, e) {
                    !(function (t) {
                        if (!(t instanceof E))
                            throw new TypeError(
                                "Cannot call a class as a function",
                            );
                    })(this);
                    var i = this;
                    (i.instanceID = C++),
                        (i.$item = t),
                        (i.defaults = {
                            type: "scroll",
                            speed: 0.5,
                            imgSrc: null,
                            imgElement: ".jarallax-img",
                            imgSize: "cover",
                            imgPosition: "50% 50%",
                            imgRepeat: "no-repeat",
                            keepImg: !1,
                            elementInViewport: null,
                            zIndex: -100,
                            disableParallax: !1,
                            disableVideo: !1,
                            automaticResize: !0,
                            videoSrc: null,
                            videoStartTime: 0,
                            videoEndTime: 0,
                            videoVolume: 0,
                            videoLoop: !0,
                            videoPlayOnlyVisible: !0,
                            videoLazyLoading: !0,
                            onScroll: null,
                            onInit: null,
                            onDestroy: null,
                            onCoverImage: null,
                        });
                    var n = i.$item.dataset || {},
                        o = {};
                    if (
                        (Object.keys(n).forEach(function (t) {
                            var e = t.substr(0, 1).toLowerCase() + t.substr(1);
                            e && void 0 !== i.defaults[e] && (o[e] = n[t]);
                        }),
                        (i.options = i.extend({}, i.defaults, o, e)),
                        (i.pureOptions = i.extend({}, i.options)),
                        Object.keys(i.options).forEach(function (t) {
                            "true" === i.options[t]
                                ? (i.options[t] = !0)
                                : "false" === i.options[t] &&
                                  (i.options[t] = !1);
                        }),
                        (i.options.speed = Math.min(
                            2,
                            Math.max(-1, parseFloat(i.options.speed)),
                        )),
                        "string" == typeof i.options.disableParallax &&
                            (i.options.disableParallax = new RegExp(
                                i.options.disableParallax,
                            )),
                        i.options.disableParallax instanceof RegExp)
                    ) {
                        var s = i.options.disableParallax;
                        i.options.disableParallax = function () {
                            return s.test(navigator.userAgent);
                        };
                    }
                    if (
                        ("function" != typeof i.options.disableParallax &&
                            (i.options.disableParallax = function () {
                                return !1;
                            }),
                        "string" == typeof i.options.disableVideo &&
                            (i.options.disableVideo = new RegExp(
                                i.options.disableVideo,
                            )),
                        i.options.disableVideo instanceof RegExp)
                    ) {
                        var r = i.options.disableVideo;
                        i.options.disableVideo = function () {
                            return r.test(navigator.userAgent);
                        };
                    }
                    "function" != typeof i.options.disableVideo &&
                        (i.options.disableVideo = function () {
                            return !1;
                        });
                    var a = i.options.elementInViewport;
                    a &&
                        "object" === (void 0 === a ? "undefined" : c(a)) &&
                        void 0 !== a.length &&
                        (a = l(a, 1)[0]),
                        a instanceof Element || (a = null),
                        (i.options.elementInViewport = a),
                        (i.image = {
                            src: i.options.imgSrc || null,
                            $container: null,
                            useImgTag: !1,
                            position: /iPad|iPhone|iPod|Android/.test(
                                navigator.userAgent,
                            )
                                ? "absolute"
                                : "fixed",
                        }),
                        i.initImg() && i.canInitParallax() && i.init();
                }
                function $(t, e) {
                    ("object" ===
                    ("undefined" == typeof HTMLElement
                        ? "undefined"
                        : c(HTMLElement))
                        ? t instanceof HTMLElement
                        : t &&
                          "object" === (void 0 === t ? "undefined" : c(t)) &&
                          null !== t &&
                          1 === t.nodeType &&
                          "string" == typeof t.nodeName) && (t = [t]);
                    for (
                        var i = e,
                            n = Array.prototype.slice.call(arguments, 2),
                            o = t.length,
                            s = 0,
                            r = void 0;
                        s < o;
                        s++
                    )
                        if (
                            ("object" === (void 0 === i ? "undefined" : c(i)) ||
                            void 0 === i
                                ? t[s].jarallax ||
                                  (t[s].jarallax = new k(t[s], i))
                                : t[s].jarallax &&
                                  (r = t[s].jarallax[i].apply(
                                      t[s].jarallax,
                                      n,
                                  )),
                            void 0 !== r)
                        )
                            return r;
                    return t;
                }
                ($.constructor = k), (I.default = $);
            }).call(this, A(5));
        },
        function (t, e, i) {
            "use strict";
            var n = i(15),
                o =
                    n.requestAnimationFrame ||
                    n.webkitRequestAnimationFrame ||
                    n.mozRequestAnimationFrame ||
                    function (t) {
                        var e = +new Date(),
                            i = Math.max(0, 16 - (e - s)),
                            n = setTimeout(t, i);
                        return (s = e), n;
                    },
                s = +new Date(),
                r =
                    n.cancelAnimationFrame ||
                    n.webkitCancelAnimationFrame ||
                    n.mozCancelAnimationFrame ||
                    clearTimeout;
            Function.prototype.bind && ((o = o.bind(n)), (r = r.bind(n))),
                ((t.exports = o).cancel = r);
        },
        function (i, t, e) {
            "use strict";
            (function (t) {
                var e;
                (e =
                    "undefined" != typeof window
                        ? window
                        : void 0 !== t
                          ? t
                          : "undefined" != typeof self
                            ? self
                            : {}),
                    (i.exports = e);
            }).call(this, e(5));
        },
    ]),
    (function (s) {
        s.fn.niceSelect = function (t) {
            function n(t) {
                t.after(
                    s("<div></div>")
                        .addClass("nice-select")
                        .addClass(t.attr("class") || "")
                        .addClass(t.attr("disabled") ? "disabled" : "")
                        .attr("tabindex", t.attr("disabled") ? null : "0")
                        .html(
                            '<span class="current"></span><ul class="list"></ul>',
                        ),
                );
                var n = t.next(),
                    e = t.find("option"),
                    i = t.find("option:selected");
                n.find(".current").html(i.data("display") || i.text()),
                    e.each(function (t) {
                        var e = s(this),
                            i = e.data("display");
                        n.find("ul").append(
                            s("<li></li>")
                                .attr("data-value", e.val())
                                .attr("data-display", i || null)
                                .addClass(
                                    "option" +
                                        (e.is(":selected") ? " selected" : "") +
                                        (e.is(":disabled") ? " disabled" : ""),
                                )
                                .html(e.text()),
                        );
                    });
            }
            if ("string" == typeof t)
                return (
                    "update" == t
                        ? this.each(function () {
                              var t = s(this),
                                  e = s(this).next(".nice-select"),
                                  i = e.hasClass("open");
                              e.length &&
                                  (e.remove(),
                                  n(t),
                                  i && t.next().trigger("click"));
                          })
                        : "destroy" == t
                          ? (this.each(function () {
                                var t = s(this),
                                    e = s(this).next(".nice-select");
                                e.length && (e.remove(), t.css("display", ""));
                            }),
                            0 == s(".nice-select").length &&
                                s(document).off(".nice_select"))
                          : console.log('Method "' + t + '" does not exist.'),
                    this
                );
            this.hide(),
                this.each(function () {
                    var t = s(this);
                    t.next().hasClass("nice-select") || n(t);
                }),
                s(document).off(".nice_select"),
                s(document).on(
                    "click.nice_select",
                    ".nice-select",
                    function (t) {
                        var e = s(this);
                        s(".nice-select").not(e).removeClass("open"),
                            e.toggleClass("open"),
                            e.hasClass("open")
                                ? (e.find(".option"),
                                  e.find(".focus").removeClass("focus"),
                                  e.find(".selected").addClass("focus"))
                                : e.focus();
                    },
                ),
                s(document).on("click.nice_select", function (t) {
                    0 === s(t.target).closest(".nice-select").length &&
                        s(".nice-select").removeClass("open").find(".option");
                }),
                s(document).on(
                    "click.nice_select",
                    ".nice-select .option:not(.disabled)",
                    function (t) {
                        var e = s(this),
                            i = e.closest(".nice-select");
                        i.find(".selected").removeClass("selected"),
                            e.addClass("selected");
                        var n = e.data("display") || e.text();
                        i.find(".current").text(n),
                            i
                                .prev("select")
                                .val(e.data("value"))
                                .trigger("change");
                    },
                ),
                s(document).on(
                    "keydown.nice_select",
                    ".nice-select",
                    function (t) {
                        var e = s(this),
                            i = s(
                                e.find(".focus") ||
                                    e.find(".list .option.selected"),
                            );
                        if (32 == t.keyCode || 13 == t.keyCode)
                            return (
                                e.hasClass("open")
                                    ? i.trigger("click")
                                    : e.trigger("click"),
                                !1
                            );
                        if (40 == t.keyCode) {
                            if (e.hasClass("open")) {
                                var n = i
                                    .nextAll(".option:not(.disabled)")
                                    .first();
                                0 < n.length &&
                                    (e.find(".focus").removeClass("focus"),
                                    n.addClass("focus"));
                            } else e.trigger("click");
                            return !1;
                        }
                        if (38 == t.keyCode) {
                            if (e.hasClass("open")) {
                                var o = i
                                    .prevAll(".option:not(.disabled)")
                                    .first();
                                0 < o.length &&
                                    (e.find(".focus").removeClass("focus"),
                                    o.addClass("focus"));
                            } else e.trigger("click");
                            return !1;
                        }
                        if (27 == t.keyCode)
                            e.hasClass("open") && e.trigger("click");
                        else if (9 == t.keyCode && e.hasClass("open"))
                            return !1;
                    },
                );
            var e = document.createElement("a").style;
            return (
                (e.cssText = "pointer-events:auto"),
                "auto" !== e.pointerEvents &&
                    s("html").addClass("no-csspointerevents"),
                this
            );
        };
    })(jQuery);
var objectFitImages = (function () {
    "use strict";
    function s(t, e, i) {
        var n =
            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" +
            (e || 1) +
            "' height='" +
            (i || 0) +
            "'%3E%3C/svg%3E";
        f.call(t, "src") !== n && g.call(t, "src", n);
    }
    function r(t, e) {
        t.naturalWidth ? e(t) : setTimeout(r, 100, t, e);
    }
    function a(e) {
        var i,
            n,
            t = (function (t) {
                for (
                    var e, i = getComputedStyle(t).fontFamily, n = {};
                    null !== (e = c.exec(i));

                )
                    n[e[1]] = e[2];
                return n;
            })(e),
            o = e[l];
        if (((t["object-fit"] = t["object-fit"] || "fill"), !o.img)) {
            if ("fill" === t["object-fit"]) return;
            if (!o.skipTest && h && !t["object-position"]) return;
        }
        if (!o.img) {
            (o.img = new Image(e.width, e.height)),
                (o.img.srcset = f.call(e, "data-ofi-srcset") || e.srcset),
                (o.img.src = f.call(e, "data-ofi-src") || e.src),
                g.call(e, "data-ofi-src", e.src),
                e.srcset && g.call(e, "data-ofi-srcset", e.srcset),
                s(e, e.naturalWidth || e.width, e.naturalHeight || e.height),
                e.srcset && (e.srcset = "");
            try {
                (i = e),
                    (n = {
                        get: function (t) {
                            return i[l].img[t || "src"];
                        },
                        set: function (t, e) {
                            return (
                                (i[l].img[e || "src"] = t),
                                g.call(i, "data-ofi-" + e, t),
                                a(i),
                                t
                            );
                        },
                    }),
                    Object.defineProperty(i, "src", n),
                    Object.defineProperty(i, "currentSrc", {
                        get: function () {
                            return n.get("currentSrc");
                        },
                    }),
                    Object.defineProperty(i, "srcset", {
                        get: function () {
                            return n.get("srcset");
                        },
                        set: function (t) {
                            return n.set(t, "srcset");
                        },
                    });
            } catch (e) {
                window.console &&
                    console.warn("https://bit.ly/ofi-old-browser");
            }
        }
        (function (t) {
            if (t.srcset && !p && window.picturefill) {
                var e = window.picturefill._;
                (t[e.ns] && t[e.ns].evaled) || e.fillImg(t, { reselect: !0 }),
                    t[e.ns].curSrc ||
                        ((t[e.ns].supported = !1),
                        e.fillImg(t, { reselect: !0 })),
                    (t.currentSrc = t[e.ns].curSrc || t.src);
            }
        })(o.img),
            (e.style.backgroundImage =
                'url("' +
                (o.img.currentSrc || o.img.src).replace(/"/g, '\\"') +
                '")'),
            (e.style.backgroundPosition = t["object-position"] || "center"),
            (e.style.backgroundRepeat = "no-repeat"),
            (e.style.backgroundOrigin = "content-box"),
            /scale-down/.test(t["object-fit"])
                ? r(o.img, function () {
                      o.img.naturalWidth > e.width ||
                      o.img.naturalHeight > e.height
                          ? (e.style.backgroundSize = "contain")
                          : (e.style.backgroundSize = "auto");
                  })
                : (e.style.backgroundSize = t["object-fit"]
                      .replace("none", "auto")
                      .replace("fill", "100% 100%")),
            r(o.img, function (t) {
                s(e, t.naturalWidth, t.naturalHeight);
            });
    }
    function o(t, e) {
        var i = !m && !t;
        if (((e = e || {}), (t = t || "img"), (d && !e.skipTest) || !u))
            return !1;
        "img" === t
            ? (t = document.getElementsByTagName("img"))
            : "string" == typeof t
              ? (t = document.querySelectorAll(t))
              : "length" in t || (t = [t]);
        for (var n = 0; n < t.length; n++)
            (t[n][l] = t[n][l] || { skipTest: e.skipTest }), a(t[n]);
        i &&
            (document.body.addEventListener(
                "load",
                function (t) {
                    "IMG" === t.target.tagName &&
                        o(t.target, { skipTest: e.skipTest });
                },
                !0,
            ),
            (m = !0),
            (t = "img")),
            e.watchMQ &&
                window.addEventListener(
                    "resize",
                    o.bind(null, t, { skipTest: e.skipTest }),
                );
    }
    var l = "fregante:object-fit-images",
        c = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g,
        t =
            "undefined" == typeof Image
                ? { style: { "object-position": 1 } }
                : new Image(),
        h = "object-fit" in t.style,
        d = "object-position" in t.style,
        u = "background-size" in t.style,
        p = "string" == typeof t.currentSrc,
        f = t.getAttribute,
        g = t.setAttribute,
        m = !1;
    return (
        (o.supportsObjectFit = h),
        (o.supportsObjectPosition = d) ||
            ((HTMLImageElement.prototype.getAttribute = function (t) {
                return f.call(i(this, t), t);
            }),
            (HTMLImageElement.prototype.setAttribute = function (t, e) {
                return g.call(i(this, t), t, String(e));
            })),
        o
    );
    function i(t, e) {
        return t[l] && t[l].img && ("src" === e || "srcset" === e)
            ? t[l].img
            : t;
    }
})();
!(function (e) {
    !jQuery && "function" == typeof define && define.amd
        ? define(["jquery"], function (t) {
              return e(t, document, window, navigator);
          })
        : jQuery || "object" != typeof exports
          ? e(jQuery, document, window, navigator)
          : e(require("jquery"), document, window, navigator);
})(function (l, c, h, t, d) {
    "use strict";
    var e,
        i,
        n = 0,
        o =
            ((i = /msie\s\d+/i),
            0 < (e = t.userAgent).search(i) &&
                i.exec(e).toString().split(" ")[1] < 9 &&
                (l("html").addClass("lt-ie9"), !0));
    Function.prototype.bind ||
        (Function.prototype.bind = function (n) {
            var o = this,
                s = [].slice;
            if ("function" != typeof o) throw new TypeError();
            var r = s.call(arguments, 1),
                a = function () {
                    if (this instanceof a) {
                        var t = function () {};
                        t.prototype = o.prototype;
                        var e = new t(),
                            i = o.apply(e, r.concat(s.call(arguments)));
                        return Object(i) === i ? i : e;
                    }
                    return o.apply(n, r.concat(s.call(arguments)));
                };
            return a;
        }),
        Array.prototype.indexOf ||
            (Array.prototype.indexOf = function (t, e) {
                var i;
                if (null == this)
                    throw new TypeError('"this" is null or not defined');
                var n = Object(this),
                    o = n.length >>> 0;
                if (0 == o) return -1;
                var s = +e || 0;
                if ((Math.abs(s) === 1 / 0 && (s = 0), o <= s)) return -1;
                for (i = Math.max(0 <= s ? s : o - Math.abs(s), 0); i < o; ) {
                    if (i in n && n[i] === t) return i;
                    i++;
                }
                return -1;
            });
    function s(t, e, i) {
        (this.VERSION = "2.3.0"),
            (this.input = t),
            (this.plugin_count = i),
            (this.current_plugin = 0),
            (this.calc_count = 0),
            (this.update_tm = 0),
            (this.old_from = 0),
            (this.old_to = 0),
            (this.old_min_interval = null),
            (this.raf_id = null),
            (this.dragging = !1),
            (this.force_redraw = !1),
            (this.no_diapason = !1),
            (this.has_tab_index = !0),
            (this.is_key = !1),
            (this.is_update = !1),
            (this.is_start = !0),
            (this.is_finish = !1),
            (this.is_active = !1),
            (this.is_resize = !1),
            (this.is_click = !1),
            (e = e || {}),
            (this.$cache = {
                win: l(h),
                body: l(c.body),
                input: l(t),
                cont: null,
                rs: null,
                min: null,
                max: null,
                from: null,
                to: null,
                single: null,
                bar: null,
                line: null,
                s_single: null,
                s_from: null,
                s_to: null,
                shad_single: null,
                shad_from: null,
                shad_to: null,
                edge: null,
                grid: null,
                grid_labels: [],
            }),
            (this.coords = {
                x_gap: 0,
                x_pointer: 0,
                w_rs: 0,
                w_rs_old: 0,
                w_handle: 0,
                p_gap: 0,
                p_gap_left: 0,
                p_gap_right: 0,
                p_step: 0,
                p_pointer: 0,
                p_handle: 0,
                p_single_fake: 0,
                p_single_real: 0,
                p_from_fake: 0,
                p_from_real: 0,
                p_to_fake: 0,
                p_to_real: 0,
                p_bar_x: 0,
                p_bar_w: 0,
                grid_gap: 0,
                big_num: 0,
                big: [],
                big_w: [],
                big_p: [],
                big_x: [],
            }),
            (this.labels = {
                w_min: 0,
                w_max: 0,
                w_from: 0,
                w_to: 0,
                w_single: 0,
                p_min: 0,
                p_max: 0,
                p_from_fake: 0,
                p_from_left: 0,
                p_to_fake: 0,
                p_to_left: 0,
                p_single_fake: 0,
                p_single_left: 0,
            });
        var n,
            o,
            s,
            r = this.$cache.input,
            a = r.prop("value");
        for (s in ((n = {
            skin: "flat",
            type: "single",
            min: 10,
            max: 100,
            from: null,
            to: null,
            step: 1,
            min_interval: 0,
            max_interval: 0,
            drag_interval: !1,
            values: [],
            p_values: [],
            from_fixed: !1,
            from_min: null,
            from_max: null,
            from_shadow: !1,
            to_fixed: !1,
            to_min: null,
            to_max: null,
            to_shadow: !1,
            prettify_enabled: !0,
            prettify_separator: " ",
            prettify: null,
            force_edges: !1,
            keyboard: !0,
            grid: !1,
            grid_margin: !0,
            grid_num: 4,
            grid_snap: !1,
            hide_min_max: !1,
            hide_from_to: !1,
            prefix: "",
            postfix: "",
            max_postfix: "",
            decorate_both: !0,
            values_separator: " — ",
            input_values_separator: ";",
            disable: !1,
            block: !1,
            extra_classes: "",
            scope: null,
            onStart: null,
            onChange: null,
            onFinish: null,
            onUpdate: null,
        }),
        "INPUT" !== r[0].nodeName &&
            console &&
            console.warn &&
            console.warn("Base element should be <input>!", r[0]),
        ((o = {
            skin: r.data("skin"),
            type: r.data("type"),
            min: r.data("min"),
            max: r.data("max"),
            from: r.data("from"),
            to: r.data("to"),
            step: r.data("step"),
            min_interval: r.data("minInterval"),
            max_interval: r.data("maxInterval"),
            drag_interval: r.data("dragInterval"),
            values: r.data("values"),
            from_fixed: r.data("fromFixed"),
            from_min: r.data("fromMin"),
            from_max: r.data("fromMax"),
            from_shadow: r.data("fromShadow"),
            to_fixed: r.data("toFixed"),
            to_min: r.data("toMin"),
            to_max: r.data("toMax"),
            to_shadow: r.data("toShadow"),
            prettify_enabled: r.data("prettifyEnabled"),
            prettify_separator: r.data("prettifySeparator"),
            force_edges: r.data("forceEdges"),
            keyboard: r.data("keyboard"),
            grid: r.data("grid"),
            grid_margin: r.data("gridMargin"),
            grid_num: r.data("gridNum"),
            grid_snap: r.data("gridSnap"),
            hide_min_max: r.data("hideMinMax"),
            hide_from_to: r.data("hideFromTo"),
            prefix: r.data("prefix"),
            postfix: r.data("postfix"),
            max_postfix: r.data("maxPostfix"),
            decorate_both: r.data("decorateBoth"),
            values_separator: r.data("valuesSeparator"),
            input_values_separator: r.data("inputValuesSeparator"),
            disable: r.data("disable"),
            block: r.data("block"),
            extra_classes: r.data("extraClasses"),
        }).values = o.values && o.values.split(",")),
        o))
            o.hasOwnProperty(s) && ((o[s] !== d && "" !== o[s]) || delete o[s]);
        a !== d &&
            "" !== a &&
            ((a = a.split(
                o.input_values_separator || e.input_values_separator || ";",
            ))[0] &&
                a[0] == +a[0] &&
                (a[0] = +a[0]),
            a[1] && a[1] == +a[1] && (a[1] = +a[1]),
            e && e.values && e.values.length
                ? ((n.from = a[0] && e.values.indexOf(a[0])),
                  (n.to = a[1] && e.values.indexOf(a[1])))
                : ((n.from = a[0] && +a[0]), (n.to = a[1] && +a[1]))),
            l.extend(n, e),
            l.extend(n, o),
            (this.options = n),
            (this.update_check = {}),
            this.validate(),
            (this.result = {
                input: this.$cache.input,
                slider: null,
                min: this.options.min,
                max: this.options.max,
                from: this.options.from,
                from_percent: 0,
                from_value: null,
                to: this.options.to,
                to_percent: 0,
                to_value: null,
            }),
            this.init();
    }
    (s.prototype = {
        init: function (t) {
            (this.no_diapason = !1),
                (this.coords.p_step = this.convertToPercent(
                    this.options.step,
                    !0,
                )),
                (this.target = "base"),
                this.toggleInput(),
                this.append(),
                this.setMinMax(),
                t
                    ? ((this.force_redraw = !0),
                      this.calc(!0),
                      this.callOnUpdate())
                    : ((this.force_redraw = !0),
                      this.calc(!0),
                      this.callOnStart()),
                this.updateScene();
        },
        append: function () {
            var t =
                '<span class="irs irs--' +
                this.options.skin +
                " js-irs-" +
                this.plugin_count +
                " " +
                this.options.extra_classes +
                '"></span>';
            this.$cache.input.before(t),
                this.$cache.input.prop("readonly", !0),
                (this.$cache.cont = this.$cache.input.prev()),
                (this.result.slider = this.$cache.cont),
                this.$cache.cont.html(
                    '<span class="irs"><span class="irs-line" tabindex="0"></span><span class="irs-min">0</span><span class="irs-max">1</span><span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span></span><span class="irs-grid"></span>',
                ),
                (this.$cache.rs = this.$cache.cont.find(".irs")),
                (this.$cache.min = this.$cache.cont.find(".irs-min")),
                (this.$cache.max = this.$cache.cont.find(".irs-max")),
                (this.$cache.from = this.$cache.cont.find(".irs-from")),
                (this.$cache.to = this.$cache.cont.find(".irs-to")),
                (this.$cache.single = this.$cache.cont.find(".irs-single")),
                (this.$cache.line = this.$cache.cont.find(".irs-line")),
                (this.$cache.grid = this.$cache.cont.find(".irs-grid")),
                "single" === this.options.type
                    ? (this.$cache.cont.append(
                          '<span class="irs-bar irs-bar--single"></span><span class="irs-shadow shadow-single"></span><span class="irs-handle single"><i></i><i></i><i></i></span>',
                      ),
                      (this.$cache.bar = this.$cache.cont.find(".irs-bar")),
                      (this.$cache.edge =
                          this.$cache.cont.find(".irs-bar-edge")),
                      (this.$cache.s_single = this.$cache.cont.find(".single")),
                      (this.$cache.from[0].style.visibility = "hidden"),
                      (this.$cache.to[0].style.visibility = "hidden"),
                      (this.$cache.shad_single =
                          this.$cache.cont.find(".shadow-single")))
                    : (this.$cache.cont.append(
                          '<span class="irs-bar"></span><span class="irs-shadow shadow-from"></span><span class="irs-shadow shadow-to"></span><span class="irs-handle from"><i></i><i></i><i></i></span><span class="irs-handle to"><i></i><i></i><i></i></span>',
                      ),
                      (this.$cache.bar = this.$cache.cont.find(".irs-bar")),
                      (this.$cache.s_from = this.$cache.cont.find(".from")),
                      (this.$cache.s_to = this.$cache.cont.find(".to")),
                      (this.$cache.shad_from =
                          this.$cache.cont.find(".shadow-from")),
                      (this.$cache.shad_to =
                          this.$cache.cont.find(".shadow-to")),
                      this.setTopHandler()),
                this.options.hide_from_to &&
                    ((this.$cache.from[0].style.display = "none"),
                    (this.$cache.to[0].style.display = "none"),
                    (this.$cache.single[0].style.display = "none")),
                this.appendGrid(),
                this.options.disable
                    ? (this.appendDisableMask(),
                      (this.$cache.input[0].disabled = !0))
                    : ((this.$cache.input[0].disabled = !1),
                      this.removeDisableMask(),
                      this.bindEvents()),
                this.options.disable ||
                    (this.options.block
                        ? this.appendDisableMask()
                        : this.removeDisableMask()),
                this.options.drag_interval &&
                    (this.$cache.bar[0].style.cursor = "ew-resize");
        },
        setTopHandler: function () {
            var t = this.options.min,
                e = this.options.max,
                i = this.options.from,
                n = this.options.to;
            t < i && n === e
                ? this.$cache.s_from.addClass("type_last")
                : n < e && this.$cache.s_to.addClass("type_last");
        },
        changeLevel: function (t) {
            switch (t) {
                case "single":
                    (this.coords.p_gap = this.toFixed(
                        this.coords.p_pointer - this.coords.p_single_fake,
                    )),
                        this.$cache.s_single.addClass("state_hover");
                    break;
                case "from":
                    (this.coords.p_gap = this.toFixed(
                        this.coords.p_pointer - this.coords.p_from_fake,
                    )),
                        this.$cache.s_from.addClass("state_hover"),
                        this.$cache.s_from.addClass("type_last"),
                        this.$cache.s_to.removeClass("type_last");
                    break;
                case "to":
                    (this.coords.p_gap = this.toFixed(
                        this.coords.p_pointer - this.coords.p_to_fake,
                    )),
                        this.$cache.s_to.addClass("state_hover"),
                        this.$cache.s_to.addClass("type_last"),
                        this.$cache.s_from.removeClass("type_last");
                    break;
                case "both":
                    (this.coords.p_gap_left = this.toFixed(
                        this.coords.p_pointer - this.coords.p_from_fake,
                    )),
                        (this.coords.p_gap_right = this.toFixed(
                            this.coords.p_to_fake - this.coords.p_pointer,
                        )),
                        this.$cache.s_to.removeClass("type_last"),
                        this.$cache.s_from.removeClass("type_last");
            }
        },
        appendDisableMask: function () {
            this.$cache.cont.append('<span class="irs-disable-mask"></span>'),
                this.$cache.cont.addClass("irs-disabled");
        },
        removeDisableMask: function () {
            this.$cache.cont.remove(".irs-disable-mask"),
                this.$cache.cont.removeClass("irs-disabled");
        },
        remove: function () {
            this.$cache.cont.remove(),
                (this.$cache.cont = null),
                this.$cache.line.off("keydown.irs_" + this.plugin_count),
                this.$cache.body.off("touchmove.irs_" + this.plugin_count),
                this.$cache.body.off("mousemove.irs_" + this.plugin_count),
                this.$cache.win.off("touchend.irs_" + this.plugin_count),
                this.$cache.win.off("mouseup.irs_" + this.plugin_count),
                o &&
                    (this.$cache.body.off("mouseup.irs_" + this.plugin_count),
                    this.$cache.body.off(
                        "mouseleave.irs_" + this.plugin_count,
                    )),
                (this.$cache.grid_labels = []),
                (this.coords.big = []),
                (this.coords.big_w = []),
                (this.coords.big_p = []),
                (this.coords.big_x = []),
                cancelAnimationFrame(this.raf_id);
        },
        bindEvents: function () {
            this.no_diapason ||
                (this.$cache.body.on(
                    "touchmove.irs_" + this.plugin_count,
                    this.pointerMove.bind(this),
                ),
                this.$cache.body.on(
                    "mousemove.irs_" + this.plugin_count,
                    this.pointerMove.bind(this),
                ),
                this.$cache.win.on(
                    "touchend.irs_" + this.plugin_count,
                    this.pointerUp.bind(this),
                ),
                this.$cache.win.on(
                    "mouseup.irs_" + this.plugin_count,
                    this.pointerUp.bind(this),
                ),
                this.$cache.line.on(
                    "touchstart.irs_" + this.plugin_count,
                    this.pointerClick.bind(this, "click"),
                ),
                this.$cache.line.on(
                    "mousedown.irs_" + this.plugin_count,
                    this.pointerClick.bind(this, "click"),
                ),
                this.$cache.line.on(
                    "focus.irs_" + this.plugin_count,
                    this.pointerFocus.bind(this),
                ),
                this.options.drag_interval && "double" === this.options.type
                    ? (this.$cache.bar.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "both"),
                      ),
                      this.$cache.bar.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "both"),
                      ))
                    : (this.$cache.bar.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerClick.bind(this, "click"),
                      ),
                      this.$cache.bar.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerClick.bind(this, "click"),
                      )),
                "single" === this.options.type
                    ? (this.$cache.single.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "single"),
                      ),
                      this.$cache.s_single.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "single"),
                      ),
                      this.$cache.shad_single.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerClick.bind(this, "click"),
                      ),
                      this.$cache.single.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "single"),
                      ),
                      this.$cache.s_single.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "single"),
                      ),
                      this.$cache.edge.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerClick.bind(this, "click"),
                      ),
                      this.$cache.shad_single.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerClick.bind(this, "click"),
                      ))
                    : (this.$cache.single.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, null),
                      ),
                      this.$cache.single.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, null),
                      ),
                      this.$cache.from.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "from"),
                      ),
                      this.$cache.s_from.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "from"),
                      ),
                      this.$cache.to.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "to"),
                      ),
                      this.$cache.s_to.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "to"),
                      ),
                      this.$cache.shad_from.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerClick.bind(this, "click"),
                      ),
                      this.$cache.shad_to.on(
                          "touchstart.irs_" + this.plugin_count,
                          this.pointerClick.bind(this, "click"),
                      ),
                      this.$cache.from.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "from"),
                      ),
                      this.$cache.s_from.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "from"),
                      ),
                      this.$cache.to.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "to"),
                      ),
                      this.$cache.s_to.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerDown.bind(this, "to"),
                      ),
                      this.$cache.shad_from.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerClick.bind(this, "click"),
                      ),
                      this.$cache.shad_to.on(
                          "mousedown.irs_" + this.plugin_count,
                          this.pointerClick.bind(this, "click"),
                      )),
                this.options.keyboard &&
                    this.$cache.line.on(
                        "keydown.irs_" + this.plugin_count,
                        this.key.bind(this, "keyboard"),
                    ),
                o &&
                    (this.$cache.body.on(
                        "mouseup.irs_" + this.plugin_count,
                        this.pointerUp.bind(this),
                    ),
                    this.$cache.body.on(
                        "mouseleave.irs_" + this.plugin_count,
                        this.pointerUp.bind(this),
                    )));
        },
        pointerFocus: function (t) {
            var e, i;
            this.target ||
                ((e = (i =
                    "single" === this.options.type
                        ? this.$cache.single
                        : this.$cache.from).offset().left),
                (e += i.width() / 2 - 1),
                this.pointerClick("single", {
                    preventDefault: function () {},
                    pageX: e,
                }));
        },
        pointerMove: function (t) {
            if (this.dragging) {
                var e =
                    t.pageX ||
                    (t.originalEvent.touches &&
                        t.originalEvent.touches[0].pageX);
                (this.coords.x_pointer = e - this.coords.x_gap), this.calc();
            }
        },
        pointerUp: function (t) {
            this.current_plugin === this.plugin_count &&
                this.is_active &&
                ((this.is_active = !1),
                this.$cache.cont
                    .find(".state_hover")
                    .removeClass("state_hover"),
                (this.force_redraw = !0),
                o && l("*").prop("unselectable", !1),
                this.updateScene(),
                this.restoreOriginalMinInterval(),
                (l.contains(this.$cache.cont[0], t.target) || this.dragging) &&
                    this.callOnFinish(),
                (this.dragging = !1));
        },
        pointerDown: function (t, e) {
            e.preventDefault();
            var i =
                e.pageX ||
                (e.originalEvent.touches && e.originalEvent.touches[0].pageX);
            2 !== e.button &&
                ("both" === t && this.setTempMinInterval(),
                (t = t || this.target || "from"),
                (this.current_plugin = this.plugin_count),
                (this.target = t),
                (this.is_active = !0),
                (this.dragging = !0),
                (this.coords.x_gap = this.$cache.rs.offset().left),
                (this.coords.x_pointer = i - this.coords.x_gap),
                this.calcPointerPercent(),
                this.changeLevel(t),
                o && l("*").prop("unselectable", !0),
                this.$cache.line.trigger("focus"),
                this.updateScene());
        },
        pointerClick: function (t, e) {
            e.preventDefault();
            var i =
                e.pageX ||
                (e.originalEvent.touches && e.originalEvent.touches[0].pageX);
            2 !== e.button &&
                ((this.current_plugin = this.plugin_count),
                (this.target = t),
                (this.is_click = !0),
                (this.coords.x_gap = this.$cache.rs.offset().left),
                (this.coords.x_pointer = +(i - this.coords.x_gap).toFixed()),
                (this.force_redraw = !0),
                this.calc(),
                this.$cache.line.trigger("focus"));
        },
        key: function (t, e) {
            if (
                !(
                    this.current_plugin !== this.plugin_count ||
                    e.altKey ||
                    e.ctrlKey ||
                    e.shiftKey ||
                    e.metaKey
                )
            ) {
                switch (e.which) {
                    case 83:
                    case 65:
                    case 40:
                    case 37:
                        e.preventDefault(), this.moveByKey(!1);
                        break;
                    case 87:
                    case 68:
                    case 38:
                    case 39:
                        e.preventDefault(), this.moveByKey(!0);
                }
                return !0;
            }
        },
        moveByKey: function (t) {
            var e = this.coords.p_pointer,
                i = (this.options.max - this.options.min) / 100;
            (i = this.options.step / i),
                t ? (e += i) : (e -= i),
                (this.coords.x_pointer = this.toFixed(
                    (this.coords.w_rs / 100) * e,
                )),
                (this.is_key = !0),
                this.calc();
        },
        setMinMax: function () {
            if (this.options) {
                if (this.options.hide_min_max)
                    return (
                        (this.$cache.min[0].style.display = "none"),
                        void (this.$cache.max[0].style.display = "none")
                    );
                if (this.options.values.length)
                    this.$cache.min.html(
                        this.decorate(this.options.p_values[this.options.min]),
                    ),
                        this.$cache.max.html(
                            this.decorate(
                                this.options.p_values[this.options.max],
                            ),
                        );
                else {
                    var t = this._prettify(this.options.min),
                        e = this._prettify(this.options.max);
                    (this.result.min_pretty = t),
                        (this.result.max_pretty = e),
                        this.$cache.min.html(
                            this.decorate(t, this.options.min),
                        ),
                        this.$cache.max.html(
                            this.decorate(e, this.options.max),
                        );
                }
                (this.labels.w_min = this.$cache.min.outerWidth(!1)),
                    (this.labels.w_max = this.$cache.max.outerWidth(!1));
            }
        },
        setTempMinInterval: function () {
            var t = this.result.to - this.result.from;
            null === this.old_min_interval &&
                (this.old_min_interval = this.options.min_interval),
                (this.options.min_interval = t);
        },
        restoreOriginalMinInterval: function () {
            null !== this.old_min_interval &&
                ((this.options.min_interval = this.old_min_interval),
                (this.old_min_interval = null));
        },
        calc: function (t) {
            if (
                this.options &&
                (this.calc_count++,
                (10 !== this.calc_count && !t) ||
                    ((this.calc_count = 0),
                    (this.coords.w_rs = this.$cache.rs.outerWidth(!1)),
                    this.calcHandlePercent()),
                this.coords.w_rs)
            ) {
                this.calcPointerPercent();
                var e = this.getHandleX();
                switch (
                    ("both" === this.target &&
                        ((this.coords.p_gap = 0), (e = this.getHandleX())),
                    "click" === this.target &&
                        ((this.coords.p_gap = this.coords.p_handle / 2),
                        (e = this.getHandleX()),
                        this.options.drag_interval
                            ? (this.target = "both_one")
                            : (this.target = this.chooseHandle(e))),
                    this.target)
                ) {
                    case "base":
                        var i = (this.options.max - this.options.min) / 100,
                            n = (this.result.from - this.options.min) / i,
                            o = (this.result.to - this.options.min) / i;
                        (this.coords.p_single_real = this.toFixed(n)),
                            (this.coords.p_from_real = this.toFixed(n)),
                            (this.coords.p_to_real = this.toFixed(o)),
                            (this.coords.p_single_real = this.checkDiapason(
                                this.coords.p_single_real,
                                this.options.from_min,
                                this.options.from_max,
                            )),
                            (this.coords.p_from_real = this.checkDiapason(
                                this.coords.p_from_real,
                                this.options.from_min,
                                this.options.from_max,
                            )),
                            (this.coords.p_to_real = this.checkDiapason(
                                this.coords.p_to_real,
                                this.options.to_min,
                                this.options.to_max,
                            )),
                            (this.coords.p_single_fake =
                                this.convertToFakePercent(
                                    this.coords.p_single_real,
                                )),
                            (this.coords.p_from_fake =
                                this.convertToFakePercent(
                                    this.coords.p_from_real,
                                )),
                            (this.coords.p_to_fake = this.convertToFakePercent(
                                this.coords.p_to_real,
                            )),
                            (this.target = null);
                        break;
                    case "single":
                        if (this.options.from_fixed) break;
                        (this.coords.p_single_real =
                            this.convertToRealPercent(e)),
                            (this.coords.p_single_real = this.calcWithStep(
                                this.coords.p_single_real,
                            )),
                            (this.coords.p_single_real = this.checkDiapason(
                                this.coords.p_single_real,
                                this.options.from_min,
                                this.options.from_max,
                            )),
                            (this.coords.p_single_fake =
                                this.convertToFakePercent(
                                    this.coords.p_single_real,
                                ));
                        break;
                    case "from":
                        if (this.options.from_fixed) break;
                        (this.coords.p_from_real =
                            this.convertToRealPercent(e)),
                            (this.coords.p_from_real = this.calcWithStep(
                                this.coords.p_from_real,
                            )),
                            this.coords.p_from_real > this.coords.p_to_real &&
                                (this.coords.p_from_real =
                                    this.coords.p_to_real),
                            (this.coords.p_from_real = this.checkDiapason(
                                this.coords.p_from_real,
                                this.options.from_min,
                                this.options.from_max,
                            )),
                            (this.coords.p_from_real = this.checkMinInterval(
                                this.coords.p_from_real,
                                this.coords.p_to_real,
                                "from",
                            )),
                            (this.coords.p_from_real = this.checkMaxInterval(
                                this.coords.p_from_real,
                                this.coords.p_to_real,
                                "from",
                            )),
                            (this.coords.p_from_fake =
                                this.convertToFakePercent(
                                    this.coords.p_from_real,
                                ));
                        break;
                    case "to":
                        if (this.options.to_fixed) break;
                        (this.coords.p_to_real = this.convertToRealPercent(e)),
                            (this.coords.p_to_real = this.calcWithStep(
                                this.coords.p_to_real,
                            )),
                            this.coords.p_to_real < this.coords.p_from_real &&
                                (this.coords.p_to_real =
                                    this.coords.p_from_real),
                            (this.coords.p_to_real = this.checkDiapason(
                                this.coords.p_to_real,
                                this.options.to_min,
                                this.options.to_max,
                            )),
                            (this.coords.p_to_real = this.checkMinInterval(
                                this.coords.p_to_real,
                                this.coords.p_from_real,
                                "to",
                            )),
                            (this.coords.p_to_real = this.checkMaxInterval(
                                this.coords.p_to_real,
                                this.coords.p_from_real,
                                "to",
                            )),
                            (this.coords.p_to_fake = this.convertToFakePercent(
                                this.coords.p_to_real,
                            ));
                        break;
                    case "both":
                        if (this.options.from_fixed || this.options.to_fixed)
                            break;
                        (e = this.toFixed(e + 0.001 * this.coords.p_handle)),
                            (this.coords.p_from_real =
                                this.convertToRealPercent(e) -
                                this.coords.p_gap_left),
                            (this.coords.p_from_real = this.calcWithStep(
                                this.coords.p_from_real,
                            )),
                            (this.coords.p_from_real = this.checkDiapason(
                                this.coords.p_from_real,
                                this.options.from_min,
                                this.options.from_max,
                            )),
                            (this.coords.p_from_real = this.checkMinInterval(
                                this.coords.p_from_real,
                                this.coords.p_to_real,
                                "from",
                            )),
                            (this.coords.p_from_fake =
                                this.convertToFakePercent(
                                    this.coords.p_from_real,
                                )),
                            (this.coords.p_to_real =
                                this.convertToRealPercent(e) +
                                this.coords.p_gap_right),
                            (this.coords.p_to_real = this.calcWithStep(
                                this.coords.p_to_real,
                            )),
                            (this.coords.p_to_real = this.checkDiapason(
                                this.coords.p_to_real,
                                this.options.to_min,
                                this.options.to_max,
                            )),
                            (this.coords.p_to_real = this.checkMinInterval(
                                this.coords.p_to_real,
                                this.coords.p_from_real,
                                "to",
                            )),
                            (this.coords.p_to_fake = this.convertToFakePercent(
                                this.coords.p_to_real,
                            ));
                        break;
                    case "both_one":
                        if (this.options.from_fixed || this.options.to_fixed)
                            break;
                        var s = this.convertToRealPercent(e),
                            r = this.result.from_percent,
                            a = this.result.to_percent - r,
                            l = a / 2,
                            c = s - l,
                            h = s + l;
                        c < 0 && (h = (c = 0) + a),
                            100 < h && (c = (h = 100) - a),
                            (this.coords.p_from_real = this.calcWithStep(c)),
                            (this.coords.p_from_real = this.checkDiapason(
                                this.coords.p_from_real,
                                this.options.from_min,
                                this.options.from_max,
                            )),
                            (this.coords.p_from_fake =
                                this.convertToFakePercent(
                                    this.coords.p_from_real,
                                )),
                            (this.coords.p_to_real = this.calcWithStep(h)),
                            (this.coords.p_to_real = this.checkDiapason(
                                this.coords.p_to_real,
                                this.options.to_min,
                                this.options.to_max,
                            )),
                            (this.coords.p_to_fake = this.convertToFakePercent(
                                this.coords.p_to_real,
                            ));
                }
                "single" === this.options.type
                    ? ((this.coords.p_bar_x = this.coords.p_handle / 2),
                      (this.coords.p_bar_w = this.coords.p_single_fake),
                      (this.result.from_percent = this.coords.p_single_real),
                      (this.result.from = this.convertToValue(
                          this.coords.p_single_real,
                      )),
                      (this.result.from_pretty = this._prettify(
                          this.result.from,
                      )),
                      this.options.values.length &&
                          (this.result.from_value =
                              this.options.values[this.result.from]))
                    : ((this.coords.p_bar_x = this.toFixed(
                          this.coords.p_from_fake + this.coords.p_handle / 2,
                      )),
                      (this.coords.p_bar_w = this.toFixed(
                          this.coords.p_to_fake - this.coords.p_from_fake,
                      )),
                      (this.result.from_percent = this.coords.p_from_real),
                      (this.result.from = this.convertToValue(
                          this.coords.p_from_real,
                      )),
                      (this.result.from_pretty = this._prettify(
                          this.result.from,
                      )),
                      (this.result.to_percent = this.coords.p_to_real),
                      (this.result.to = this.convertToValue(
                          this.coords.p_to_real,
                      )),
                      (this.result.to_pretty = this._prettify(this.result.to)),
                      this.options.values.length &&
                          ((this.result.from_value =
                              this.options.values[this.result.from]),
                          (this.result.to_value =
                              this.options.values[this.result.to]))),
                    this.calcMinMax(),
                    this.calcLabels();
            }
        },
        calcPointerPercent: function () {
            this.coords.w_rs
                ? (this.coords.x_pointer < 0 || isNaN(this.coords.x_pointer)
                      ? (this.coords.x_pointer = 0)
                      : this.coords.x_pointer > this.coords.w_rs &&
                        (this.coords.x_pointer = this.coords.w_rs),
                  (this.coords.p_pointer = this.toFixed(
                      (this.coords.x_pointer / this.coords.w_rs) * 100,
                  )))
                : (this.coords.p_pointer = 0);
        },
        convertToRealPercent: function (t) {
            return (t / (100 - this.coords.p_handle)) * 100;
        },
        convertToFakePercent: function (t) {
            return (t / 100) * (100 - this.coords.p_handle);
        },
        getHandleX: function () {
            var t = 100 - this.coords.p_handle,
                e = this.toFixed(this.coords.p_pointer - this.coords.p_gap);
            return e < 0 ? (e = 0) : t < e && (e = t), e;
        },
        calcHandlePercent: function () {
            "single" === this.options.type
                ? (this.coords.w_handle = this.$cache.s_single.outerWidth(!1))
                : (this.coords.w_handle = this.$cache.s_from.outerWidth(!1)),
                (this.coords.p_handle = this.toFixed(
                    (this.coords.w_handle / this.coords.w_rs) * 100,
                ));
        },
        chooseHandle: function (t) {
            return "single" === this.options.type
                ? "single"
                : this.coords.p_from_real +
                        (this.coords.p_to_real - this.coords.p_from_real) / 2 <=
                    t
                  ? this.options.to_fixed
                      ? "from"
                      : "to"
                  : this.options.from_fixed
                    ? "to"
                    : "from";
        },
        calcMinMax: function () {
            this.coords.w_rs &&
                ((this.labels.p_min =
                    (this.labels.w_min / this.coords.w_rs) * 100),
                (this.labels.p_max =
                    (this.labels.w_max / this.coords.w_rs) * 100));
        },
        calcLabels: function () {
            this.coords.w_rs &&
                !this.options.hide_from_to &&
                ("single" === this.options.type
                    ? ((this.labels.w_single =
                          this.$cache.single.outerWidth(!1)),
                      (this.labels.p_single_fake =
                          (this.labels.w_single / this.coords.w_rs) * 100),
                      (this.labels.p_single_left =
                          this.coords.p_single_fake +
                          this.coords.p_handle / 2 -
                          this.labels.p_single_fake / 2))
                    : ((this.labels.w_from = this.$cache.from.outerWidth(!1)),
                      (this.labels.p_from_fake =
                          (this.labels.w_from / this.coords.w_rs) * 100),
                      (this.labels.p_from_left =
                          this.coords.p_from_fake +
                          this.coords.p_handle / 2 -
                          this.labels.p_from_fake / 2),
                      (this.labels.p_from_left = this.toFixed(
                          this.labels.p_from_left,
                      )),
                      (this.labels.p_from_left = this.checkEdges(
                          this.labels.p_from_left,
                          this.labels.p_from_fake,
                      )),
                      (this.labels.w_to = this.$cache.to.outerWidth(!1)),
                      (this.labels.p_to_fake =
                          (this.labels.w_to / this.coords.w_rs) * 100),
                      (this.labels.p_to_left =
                          this.coords.p_to_fake +
                          this.coords.p_handle / 2 -
                          this.labels.p_to_fake / 2),
                      (this.labels.p_to_left = this.toFixed(
                          this.labels.p_to_left,
                      )),
                      (this.labels.p_to_left = this.checkEdges(
                          this.labels.p_to_left,
                          this.labels.p_to_fake,
                      )),
                      (this.labels.w_single =
                          this.$cache.single.outerWidth(!1)),
                      (this.labels.p_single_fake =
                          (this.labels.w_single / this.coords.w_rs) * 100),
                      (this.labels.p_single_left =
                          (this.labels.p_from_left +
                              this.labels.p_to_left +
                              this.labels.p_to_fake) /
                              2 -
                          this.labels.p_single_fake / 2),
                      (this.labels.p_single_left = this.toFixed(
                          this.labels.p_single_left,
                      ))),
                (this.labels.p_single_left = this.checkEdges(
                    this.labels.p_single_left,
                    this.labels.p_single_fake,
                )));
        },
        updateScene: function () {
            this.raf_id &&
                (cancelAnimationFrame(this.raf_id), (this.raf_id = null)),
                clearTimeout(this.update_tm),
                (this.update_tm = null),
                this.options &&
                    (this.drawHandles(),
                    this.is_active
                        ? (this.raf_id = requestAnimationFrame(
                              this.updateScene.bind(this),
                          ))
                        : (this.update_tm = setTimeout(
                              this.updateScene.bind(this),
                              300,
                          )));
        },
        drawHandles: function () {
            (this.coords.w_rs = this.$cache.rs.outerWidth(!1)),
                this.coords.w_rs &&
                    (this.coords.w_rs !== this.coords.w_rs_old &&
                        ((this.target = "base"), (this.is_resize = !0)),
                    (this.coords.w_rs === this.coords.w_rs_old &&
                        !this.force_redraw) ||
                        (this.setMinMax(),
                        this.calc(!0),
                        this.drawLabels(),
                        this.options.grid &&
                            (this.calcGridMargin(), this.calcGridLabels()),
                        (this.force_redraw = !0),
                        (this.coords.w_rs_old = this.coords.w_rs),
                        this.drawShadow()),
                    this.coords.w_rs &&
                        (this.dragging || this.force_redraw || this.is_key) &&
                        ((this.old_from !== this.result.from ||
                            this.old_to !== this.result.to ||
                            this.force_redraw ||
                            this.is_key) &&
                            (this.drawLabels(),
                            (this.$cache.bar[0].style.left =
                                this.coords.p_bar_x + "%"),
                            (this.$cache.bar[0].style.width =
                                this.coords.p_bar_w + "%"),
                            "single" === this.options.type
                                ? ((this.$cache.bar[0].style.left = 0),
                                  (this.$cache.bar[0].style.width =
                                      this.coords.p_bar_w +
                                      this.coords.p_bar_x +
                                      "%"),
                                  (this.$cache.s_single[0].style.left =
                                      this.coords.p_single_fake + "%"))
                                : ((this.$cache.s_from[0].style.left =
                                      this.coords.p_from_fake + "%"),
                                  (this.$cache.s_to[0].style.left =
                                      this.coords.p_to_fake + "%"),
                                  (this.old_from === this.result.from &&
                                      !this.force_redraw) ||
                                      (this.$cache.from[0].style.left =
                                          this.labels.p_from_left + "%"),
                                  (this.old_to === this.result.to &&
                                      !this.force_redraw) ||
                                      (this.$cache.to[0].style.left =
                                          this.labels.p_to_left + "%")),
                            (this.$cache.single[0].style.left =
                                this.labels.p_single_left + "%"),
                            this.writeToInput(),
                            (this.old_from === this.result.from &&
                                this.old_to === this.result.to) ||
                                this.is_start ||
                                (this.$cache.input.trigger("change"),
                                this.$cache.input.trigger("input")),
                            (this.old_from = this.result.from),
                            (this.old_to = this.result.to),
                            this.is_resize ||
                                this.is_update ||
                                this.is_start ||
                                this.is_finish ||
                                this.callOnChange(),
                            (this.is_key || this.is_click) &&
                                ((this.is_key = !1),
                                (this.is_click = !1),
                                this.callOnFinish()),
                            (this.is_update = !1),
                            (this.is_resize = !1),
                            (this.is_finish = !1)),
                        (this.is_start = !1),
                        (this.is_key = !1),
                        (this.is_click = !1),
                        (this.force_redraw = !1)));
        },
        drawLabels: function () {
            if (this.options) {
                var t,
                    e,
                    i,
                    n,
                    o,
                    s = this.options.values.length,
                    r = this.options.p_values;
                if (!this.options.hide_from_to)
                    if ("single" === this.options.type)
                        (t = s
                            ? this.decorate(r[this.result.from])
                            : ((n = this._prettify(this.result.from)),
                              this.decorate(n, this.result.from))),
                            this.$cache.single.html(t),
                            this.calcLabels(),
                            this.labels.p_single_left < this.labels.p_min + 1
                                ? (this.$cache.min[0].style.visibility =
                                      "hidden")
                                : (this.$cache.min[0].style.visibility =
                                      "visible"),
                            this.labels.p_single_left +
                                this.labels.p_single_fake >
                            100 - this.labels.p_max - 1
                                ? (this.$cache.max[0].style.visibility =
                                      "hidden")
                                : (this.$cache.max[0].style.visibility =
                                      "visible");
                    else {
                        (i = s
                            ? (this.options.decorate_both
                                  ? ((t = this.decorate(r[this.result.from])),
                                    (t += this.options.values_separator),
                                    (t += this.decorate(r[this.result.to])))
                                  : (t = this.decorate(
                                        r[this.result.from] +
                                            this.options.values_separator +
                                            r[this.result.to],
                                    )),
                              (e = this.decorate(r[this.result.from])),
                              this.decorate(r[this.result.to]))
                            : ((n = this._prettify(this.result.from)),
                              (o = this._prettify(this.result.to)),
                              this.options.decorate_both
                                  ? ((t = this.decorate(n, this.result.from)),
                                    (t += this.options.values_separator),
                                    (t += this.decorate(o, this.result.to)))
                                  : (t = this.decorate(
                                        n + this.options.values_separator + o,
                                        this.result.to,
                                    )),
                              (e = this.decorate(n, this.result.from)),
                              this.decorate(o, this.result.to))),
                            this.$cache.single.html(t),
                            this.$cache.from.html(e),
                            this.$cache.to.html(i),
                            this.calcLabels();
                        var a = Math.min(
                                this.labels.p_single_left,
                                this.labels.p_from_left,
                            ),
                            l =
                                this.labels.p_single_left +
                                this.labels.p_single_fake,
                            c = this.labels.p_to_left + this.labels.p_to_fake,
                            h = Math.max(l, c);
                        this.labels.p_from_left + this.labels.p_from_fake >=
                        this.labels.p_to_left
                            ? ((this.$cache.from[0].style.visibility =
                                  "hidden"),
                              (this.$cache.to[0].style.visibility = "hidden"),
                              (this.$cache.single[0].style.visibility =
                                  "visible"),
                              (h =
                                  this.result.from === this.result.to
                                      ? ("from" === this.target
                                            ? (this.$cache.from[0].style.visibility =
                                                  "visible")
                                            : "to" === this.target
                                              ? (this.$cache.to[0].style.visibility =
                                                    "visible")
                                              : this.target ||
                                                (this.$cache.from[0].style.visibility =
                                                    "visible"),
                                        (this.$cache.single[0].style.visibility =
                                            "hidden"),
                                        c)
                                      : ((this.$cache.from[0].style.visibility =
                                            "hidden"),
                                        (this.$cache.to[0].style.visibility =
                                            "hidden"),
                                        (this.$cache.single[0].style.visibility =
                                            "visible"),
                                        Math.max(l, c))))
                            : ((this.$cache.from[0].style.visibility =
                                  "visible"),
                              (this.$cache.to[0].style.visibility = "visible"),
                              (this.$cache.single[0].style.visibility =
                                  "hidden")),
                            a < this.labels.p_min + 1
                                ? (this.$cache.min[0].style.visibility =
                                      "hidden")
                                : (this.$cache.min[0].style.visibility =
                                      "visible"),
                            h > 100 - this.labels.p_max - 1
                                ? (this.$cache.max[0].style.visibility =
                                      "hidden")
                                : (this.$cache.max[0].style.visibility =
                                      "visible");
                    }
            }
        },
        drawShadow: function () {
            var t,
                e,
                i,
                n,
                o = this.options,
                s = this.$cache,
                r = "number" == typeof o.from_min && !isNaN(o.from_min),
                a = "number" == typeof o.from_max && !isNaN(o.from_max),
                l = "number" == typeof o.to_min && !isNaN(o.to_min),
                c = "number" == typeof o.to_max && !isNaN(o.to_max);
            "single" === o.type
                ? o.from_shadow && (r || a)
                    ? ((t = this.convertToPercent(r ? o.from_min : o.min)),
                      (e = this.convertToPercent(a ? o.from_max : o.max) - t),
                      (t = this.toFixed(t - (this.coords.p_handle / 100) * t)),
                      (e = this.toFixed(e - (this.coords.p_handle / 100) * e)),
                      (t += this.coords.p_handle / 2),
                      (s.shad_single[0].style.display = "block"),
                      (s.shad_single[0].style.left = t + "%"),
                      (s.shad_single[0].style.width = e + "%"))
                    : (s.shad_single[0].style.display = "none")
                : (o.from_shadow && (r || a)
                      ? ((t = this.convertToPercent(r ? o.from_min : o.min)),
                        (e = this.convertToPercent(a ? o.from_max : o.max) - t),
                        (t = this.toFixed(
                            t - (this.coords.p_handle / 100) * t,
                        )),
                        (e = this.toFixed(
                            e - (this.coords.p_handle / 100) * e,
                        )),
                        (t += this.coords.p_handle / 2),
                        (s.shad_from[0].style.display = "block"),
                        (s.shad_from[0].style.left = t + "%"),
                        (s.shad_from[0].style.width = e + "%"))
                      : (s.shad_from[0].style.display = "none"),
                  o.to_shadow && (l || c)
                      ? ((i = this.convertToPercent(l ? o.to_min : o.min)),
                        (n = this.convertToPercent(c ? o.to_max : o.max) - i),
                        (i = this.toFixed(
                            i - (this.coords.p_handle / 100) * i,
                        )),
                        (n = this.toFixed(
                            n - (this.coords.p_handle / 100) * n,
                        )),
                        (i += this.coords.p_handle / 2),
                        (s.shad_to[0].style.display = "block"),
                        (s.shad_to[0].style.left = i + "%"),
                        (s.shad_to[0].style.width = n + "%"))
                      : (s.shad_to[0].style.display = "none"));
        },
        writeToInput: function () {
            "single" === this.options.type
                ? (this.options.values.length
                      ? this.$cache.input.prop("value", this.result.from_value)
                      : this.$cache.input.prop("value", this.result.from),
                  this.$cache.input.data("from", this.result.from))
                : (this.options.values.length
                      ? this.$cache.input.prop(
                            "value",
                            this.result.from_value +
                                this.options.input_values_separator +
                                this.result.to_value,
                        )
                      : this.$cache.input.prop(
                            "value",
                            this.result.from +
                                this.options.input_values_separator +
                                this.result.to,
                        ),
                  this.$cache.input.data("from", this.result.from),
                  this.$cache.input.data("to", this.result.to));
        },
        callOnStart: function () {
            this.writeToInput(),
                this.options.onStart &&
                    "function" == typeof this.options.onStart &&
                    (this.options.scope
                        ? this.options.onStart.call(
                              this.options.scope,
                              this.result,
                          )
                        : this.options.onStart(this.result));
        },
        callOnChange: function () {
            this.writeToInput(),
                this.options.onChange &&
                    "function" == typeof this.options.onChange &&
                    (this.options.scope
                        ? this.options.onChange.call(
                              this.options.scope,
                              this.result,
                          )
                        : this.options.onChange(this.result));
        },
        callOnFinish: function () {
            this.writeToInput(),
                this.options.onFinish &&
                    "function" == typeof this.options.onFinish &&
                    (this.options.scope
                        ? this.options.onFinish.call(
                              this.options.scope,
                              this.result,
                          )
                        : this.options.onFinish(this.result));
        },
        callOnUpdate: function () {
            this.writeToInput(),
                this.options.onUpdate &&
                    "function" == typeof this.options.onUpdate &&
                    (this.options.scope
                        ? this.options.onUpdate.call(
                              this.options.scope,
                              this.result,
                          )
                        : this.options.onUpdate(this.result));
        },
        toggleInput: function () {
            this.$cache.input.toggleClass("irs-hidden-input"),
                this.has_tab_index
                    ? this.$cache.input.prop("tabindex", -1)
                    : this.$cache.input.removeProp("tabindex"),
                (this.has_tab_index = !this.has_tab_index);
        },
        convertToPercent: function (t, e) {
            var i,
                n = this.options.max - this.options.min,
                o = n / 100;
            return n
                ? ((i = (e ? t : t - this.options.min) / o), this.toFixed(i))
                : ((this.no_diapason = !0), 0);
        },
        convertToValue: function (t) {
            var e,
                i,
                n = this.options.min,
                o = this.options.max,
                s = n.toString().split(".")[1],
                r = o.toString().split(".")[1],
                a = 0,
                l = 0;
            if (0 === t) return this.options.min;
            if (100 === t) return this.options.max;
            s && (a = e = s.length),
                r && (a = i = r.length),
                e && i && (a = i <= e ? e : i),
                n < 0 &&
                    ((n = +(n + (l = Math.abs(n))).toFixed(a)),
                    (o = +(o + l).toFixed(a)));
            var c,
                h = ((o - n) / 100) * t + n,
                d = this.options.step.toString().split(".")[1];
            return (
                (h = d
                    ? +h.toFixed(d.length)
                    : ((h /= this.options.step),
                      +(h *= this.options.step).toFixed(0))),
                l && (h -= l),
                (c = d ? +h.toFixed(d.length) : this.toFixed(h)) <
                this.options.min
                    ? (c = this.options.min)
                    : c > this.options.max && (c = this.options.max),
                c
            );
        },
        calcWithStep: function (t) {
            var e = Math.round(t / this.coords.p_step) * this.coords.p_step;
            return (
                100 < e && (e = 100), 100 === t && (e = 100), this.toFixed(e)
            );
        },
        checkMinInterval: function (t, e, i) {
            var n,
                o,
                s = this.options;
            return s.min_interval
                ? ((n = this.convertToValue(t)),
                  (o = this.convertToValue(e)),
                  "from" === i
                      ? o - n < s.min_interval && (n = o - s.min_interval)
                      : n - o < s.min_interval && (n = o + s.min_interval),
                  this.convertToPercent(n))
                : t;
        },
        checkMaxInterval: function (t, e, i) {
            var n,
                o,
                s = this.options;
            return s.max_interval
                ? ((n = this.convertToValue(t)),
                  (o = this.convertToValue(e)),
                  "from" === i
                      ? o - n > s.max_interval && (n = o - s.max_interval)
                      : n - o > s.max_interval && (n = o + s.max_interval),
                  this.convertToPercent(n))
                : t;
        },
        checkDiapason: function (t, e, i) {
            var n = this.convertToValue(t),
                o = this.options;
            return (
                "number" != typeof e && (e = o.min),
                "number" != typeof i && (i = o.max),
                n < e && (n = e),
                i < n && (n = i),
                this.convertToPercent(n)
            );
        },
        toFixed: function (t) {
            return +t.toFixed(20);
        },
        _prettify: function (t) {
            return this.options.prettify_enabled
                ? this.options.prettify &&
                  "function" == typeof this.options.prettify
                    ? this.options.prettify(t)
                    : this.prettify(t)
                : t;
        },
        prettify: function (t) {
            return t
                .toString()
                .replace(
                    /(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g,
                    "$1" + this.options.prettify_separator,
                );
        },
        checkEdges: function (t, e) {
            return (
                this.options.force_edges &&
                    (t < 0 ? (t = 0) : 100 - e < t && (t = 100 - e)),
                this.toFixed(t)
            );
        },
        validate: function () {
            var t,
                e,
                i = this.options,
                n = this.result,
                o = i.values,
                s = o.length;
            if (
                ("string" == typeof i.min && (i.min = +i.min),
                "string" == typeof i.max && (i.max = +i.max),
                "string" == typeof i.from && (i.from = +i.from),
                "string" == typeof i.to && (i.to = +i.to),
                "string" == typeof i.step && (i.step = +i.step),
                "string" == typeof i.from_min && (i.from_min = +i.from_min),
                "string" == typeof i.from_max && (i.from_max = +i.from_max),
                "string" == typeof i.to_min && (i.to_min = +i.to_min),
                "string" == typeof i.to_max && (i.to_max = +i.to_max),
                "string" == typeof i.grid_num && (i.grid_num = +i.grid_num),
                i.max < i.min && (i.max = i.min),
                s)
            )
                for (
                    i.p_values = [],
                        i.min = 0,
                        i.max = s - 1,
                        i.step = 1,
                        i.grid_num = i.max,
                        i.grid_snap = !0,
                        e = 0;
                    e < s;
                    e++
                )
                    (t = +o[e]),
                        (t = isNaN(t) ? o[e] : ((o[e] = t), this._prettify(t))),
                        i.p_values.push(t);
            ("number" == typeof i.from && !isNaN(i.from)) || (i.from = i.min),
                ("number" == typeof i.to && !isNaN(i.to)) || (i.to = i.max),
                "single" === i.type
                    ? (i.from < i.min && (i.from = i.min),
                      i.from > i.max && (i.from = i.max))
                    : (i.from < i.min && (i.from = i.min),
                      i.from > i.max && (i.from = i.max),
                      i.to < i.min && (i.to = i.min),
                      i.to > i.max && (i.to = i.max),
                      this.update_check.from &&
                          (this.update_check.from !== i.from &&
                              i.from > i.to &&
                              (i.from = i.to),
                          this.update_check.to !== i.to &&
                              i.to < i.from &&
                              (i.to = i.from)),
                      i.from > i.to && (i.from = i.to),
                      i.to < i.from && (i.to = i.from)),
                ("number" != typeof i.step ||
                    isNaN(i.step) ||
                    !i.step ||
                    i.step < 0) &&
                    (i.step = 1),
                "number" == typeof i.from_min &&
                    i.from < i.from_min &&
                    (i.from = i.from_min),
                "number" == typeof i.from_max &&
                    i.from > i.from_max &&
                    (i.from = i.from_max),
                "number" == typeof i.to_min &&
                    i.to < i.to_min &&
                    (i.to = i.to_min),
                "number" == typeof i.to_max &&
                    i.from > i.to_max &&
                    (i.to = i.to_max),
                n &&
                    (n.min !== i.min && (n.min = i.min),
                    n.max !== i.max && (n.max = i.max),
                    (n.from < n.min || n.from > n.max) && (n.from = i.from),
                    (n.to < n.min || n.to > n.max) && (n.to = i.to)),
                ("number" != typeof i.min_interval ||
                    isNaN(i.min_interval) ||
                    !i.min_interval ||
                    i.min_interval < 0) &&
                    (i.min_interval = 0),
                ("number" != typeof i.max_interval ||
                    isNaN(i.max_interval) ||
                    !i.max_interval ||
                    i.max_interval < 0) &&
                    (i.max_interval = 0),
                i.min_interval &&
                    i.min_interval > i.max - i.min &&
                    (i.min_interval = i.max - i.min),
                i.max_interval &&
                    i.max_interval > i.max - i.min &&
                    (i.max_interval = i.max - i.min);
        },
        decorate: function (t, e) {
            var i = "",
                n = this.options;
            return (
                n.prefix && (i += n.prefix),
                (i += t),
                n.max_postfix &&
                    ((n.values.length && t === n.p_values[n.max]) ||
                        e === n.max) &&
                    ((i += n.max_postfix), n.postfix && (i += " ")),
                n.postfix && (i += n.postfix),
                i
            );
        },
        updateFrom: function () {
            (this.result.from = this.options.from),
                (this.result.from_percent = this.convertToPercent(
                    this.result.from,
                )),
                (this.result.from_pretty = this._prettify(this.result.from)),
                this.options.values &&
                    (this.result.from_value =
                        this.options.values[this.result.from]);
        },
        updateTo: function () {
            (this.result.to = this.options.to),
                (this.result.to_percent = this.convertToPercent(
                    this.result.to,
                )),
                (this.result.to_pretty = this._prettify(this.result.to)),
                this.options.values &&
                    (this.result.to_value =
                        this.options.values[this.result.to]);
        },
        updateResult: function () {
            (this.result.min = this.options.min),
                (this.result.max = this.options.max),
                this.updateFrom(),
                this.updateTo();
        },
        appendGrid: function () {
            if (this.options.grid) {
                var t,
                    e,
                    i,
                    n,
                    o,
                    s,
                    r = this.options,
                    a = r.max - r.min,
                    l = r.grid_num,
                    c = 0,
                    h = 4,
                    d = "";
                for (
                    this.calcGridMargin(),
                        r.grid_snap && (l = a / r.step),
                        50 < l && (l = 50),
                        i = this.toFixed(100 / l),
                        4 < l && (h = 3),
                        7 < l && (h = 2),
                        14 < l && (h = 1),
                        28 < l && (h = 0),
                        t = 0;
                    t < l + 1;
                    t++
                ) {
                    for (
                        n = h,
                            100 < (c = this.toFixed(i * t)) && (c = 100),
                            o =
                                ((this.coords.big[t] = c) - i * (t - 1)) /
                                (n + 1),
                            e = 1;
                        e <= n && 0 !== c;
                        e++
                    )
                        d +=
                            '<span class="irs-grid-pol small" style="left: ' +
                            this.toFixed(c - o * e) +
                            '%"></span>';
                    (d +=
                        '<span class="irs-grid-pol" style="left: ' +
                        c +
                        '%"></span>'),
                        (s = this.convertToValue(c)),
                        (d +=
                            '<span class="irs-grid-text js-grid-text-' +
                            t +
                            '" style="left: ' +
                            c +
                            '%">' +
                            (s = r.values.length
                                ? r.p_values[s]
                                : this._prettify(s)) +
                            "</span>");
                }
                (this.coords.big_num = Math.ceil(l + 1)),
                    this.$cache.cont.addClass("irs-with-grid"),
                    this.$cache.grid.html(d),
                    this.cacheGridLabels();
            }
        },
        cacheGridLabels: function () {
            var t,
                e,
                i = this.coords.big_num;
            for (e = 0; e < i; e++)
                (t = this.$cache.grid.find(".js-grid-text-" + e)),
                    this.$cache.grid_labels.push(t);
            this.calcGridLabels();
        },
        calcGridLabels: function () {
            var t,
                e,
                i = [],
                n = [],
                o = this.coords.big_num;
            for (t = 0; t < o; t++)
                (this.coords.big_w[t] =
                    this.$cache.grid_labels[t].outerWidth(!1)),
                    (this.coords.big_p[t] = this.toFixed(
                        (this.coords.big_w[t] / this.coords.w_rs) * 100,
                    )),
                    (this.coords.big_x[t] = this.toFixed(
                        this.coords.big_p[t] / 2,
                    )),
                    (i[t] = this.toFixed(
                        this.coords.big[t] - this.coords.big_x[t],
                    )),
                    (n[t] = this.toFixed(i[t] + this.coords.big_p[t]));
            for (
                this.options.force_edges &&
                    (i[0] < -this.coords.grid_gap &&
                        ((i[0] = -this.coords.grid_gap),
                        (n[0] = this.toFixed(i[0] + this.coords.big_p[0])),
                        (this.coords.big_x[0] = this.coords.grid_gap)),
                    n[o - 1] > 100 + this.coords.grid_gap &&
                        ((n[o - 1] = 100 + this.coords.grid_gap),
                        (i[o - 1] = this.toFixed(
                            n[o - 1] - this.coords.big_p[o - 1],
                        )),
                        (this.coords.big_x[o - 1] = this.toFixed(
                            this.coords.big_p[o - 1] - this.coords.grid_gap,
                        )))),
                    this.calcGridCollision(2, i, n),
                    this.calcGridCollision(4, i, n),
                    t = 0;
                t < o;
                t++
            )
                (e = this.$cache.grid_labels[t][0]),
                    this.coords.big_x[t] !== Number.POSITIVE_INFINITY &&
                        (e.style.marginLeft = -this.coords.big_x[t] + "%");
        },
        calcGridCollision: function (t, e, i) {
            var n,
                o,
                s,
                r = this.coords.big_num;
            for (n = 0; n < r && !(r <= (o = n + t / 2)); n += t)
                (s = this.$cache.grid_labels[o][0]),
                    i[n] <= e[o]
                        ? (s.style.visibility = "visible")
                        : (s.style.visibility = "hidden");
        },
        calcGridMargin: function () {
            this.options.grid_margin &&
                ((this.coords.w_rs = this.$cache.rs.outerWidth(!1)),
                this.coords.w_rs &&
                    ("single" === this.options.type
                        ? (this.coords.w_handle =
                              this.$cache.s_single.outerWidth(!1))
                        : (this.coords.w_handle =
                              this.$cache.s_from.outerWidth(!1)),
                    (this.coords.p_handle = this.toFixed(
                        (this.coords.w_handle / this.coords.w_rs) * 100,
                    )),
                    (this.coords.grid_gap = this.toFixed(
                        this.coords.p_handle / 2 - 0.1,
                    )),
                    (this.$cache.grid[0].style.width =
                        this.toFixed(100 - this.coords.p_handle) + "%"),
                    (this.$cache.grid[0].style.left =
                        this.coords.grid_gap + "%")));
        },
        update: function (t) {
            this.input &&
                ((this.is_update = !0),
                (this.options.from = this.result.from),
                (this.options.to = this.result.to),
                (this.update_check.from = this.result.from),
                (this.update_check.to = this.result.to),
                (this.options = l.extend(this.options, t)),
                this.validate(),
                this.updateResult(t),
                this.toggleInput(),
                this.remove(),
                this.init(!0));
        },
        reset: function () {
            this.input && (this.updateResult(), this.update());
        },
        destroy: function () {
            this.input &&
                (this.toggleInput(),
                this.$cache.input.prop("readonly", !1),
                l.data(this.input, "ionRangeSlider", null),
                this.remove(),
                (this.input = null),
                (this.options = null));
        },
    }),
        (l.fn.ionRangeSlider = function (t) {
            return this.each(function () {
                l.data(this, "ionRangeSlider") ||
                    l.data(this, "ionRangeSlider", new s(this, t, n++));
            });
        }),
        (function () {
            for (
                var s = 0, t = ["ms", "moz", "webkit", "o"], e = 0;
                e < t.length && !h.requestAnimationFrame;
                ++e
            )
                (h.requestAnimationFrame = h[t[e] + "RequestAnimationFrame"]),
                    (h.cancelAnimationFrame =
                        h[t[e] + "CancelAnimationFrame"] ||
                        h[t[e] + "CancelRequestAnimationFrame"]);
            h.requestAnimationFrame ||
                (h.requestAnimationFrame = function (t, e) {
                    var i = new Date().getTime(),
                        n = Math.max(0, 16 - (i - s)),
                        o = h.setTimeout(function () {
                            t(i + n);
                        }, n);
                    return (s = i + n), o;
                }),
                h.cancelAnimationFrame ||
                    (h.cancelAnimationFrame = function (t) {
                        clearTimeout(t);
                    });
        })();
}),
    (function (S, T, c) {
        var i,
            C,
            n,
            o,
            r,
            s,
            a,
            l,
            h,
            d,
            t,
            u,
            e = "mPageScroll2id",
            k = "mPS2id",
            p = {
                scrollSpeed: 1e3,
                autoScrollSpeed: !0,
                scrollEasing: "easeInOutQuint",
                scrollingEasing: "easeOutQuint",
                pageEndSmoothScroll: !0,
                layout: "vertical",
                offset: 0,
                highlightSelector: !1,
                clickedClass: k + "-clicked",
                targetClass: k + "-target",
                highlightClass: k + "-highlight",
                forceSingleHighlight: !1,
                keepHighlightUntilNext: !1,
                highlightByNextTarget: !1,
                disablePluginBelow: !1,
                clickEvents: !0,
                appendHash: !1,
                onStart: function () {},
                onComplete: function () {},
                defaultSelector: !1,
                live: !0,
                liveSelector: !1,
                excludeSelectors: !1,
            },
            f = 0,
            g = {
                init: function (t) {
                    t = S.extend(!0, {}, p, t);
                    if ((S(c).data(k, t), (C = S(c).data(k)), !this.selector)) {
                        var e = "__" + k;
                        this.each(function () {
                            var t = S(this);
                            t.hasClass(e) || t.addClass(e);
                        }),
                            (this.selector = "." + e);
                    }
                    C.liveSelector && (this.selector += "," + C.liveSelector),
                        (i = i ? i + "," + this.selector : this.selector),
                        C.defaultSelector &&
                            (("object" == typeof S(i) && 0 !== S(i).length) ||
                                (i =
                                    ".m_PageScroll2id,a[rel~='m_PageScroll2id'],.page-scroll-to-id,a[rel~='page-scroll-to-id'],._ps2id")),
                        C.clickEvents &&
                            S(c)
                                .undelegate("." + k)
                                .delegate(i, "click." + k, function (t) {
                                    if (m._isDisabled.call(null))
                                        m._removeClasses.call(null);
                                    else {
                                        var e = S(this),
                                            i = e.attr("href"),
                                            n =
                                                e.prop("href").baseVal ||
                                                e.prop("href");
                                        (C.excludeSelectors &&
                                            e.is(C.excludeSelectors)) ||
                                            (i && -1 !== i.indexOf("#/")) ||
                                            (m._reset.call(null),
                                            (d = e.data("ps2id-offset") || 0),
                                            m._isValid.call(null, i, n) &&
                                                m._findTarget.call(null, i) &&
                                                (t.preventDefault(),
                                                (o = "selector"),
                                                (r = e),
                                                m._setClasses.call(null, !0),
                                                m._scrollTo.call(null)));
                                    }
                                }),
                        S(T)
                            .unbind("." + k)
                            .bind("scroll.mPS2id resize." + k, function () {
                                if (m._isDisabled.call(null))
                                    m._removeClasses.call(null);
                                else {
                                    var o = S("._mPS2id-t");
                                    o.each(function (t) {
                                        var e = S(this),
                                            i = e.attr("id"),
                                            n = m._findHighlight.call(null, i);
                                        m._setClasses.call(null, !1, e, n),
                                            t == o.length - 1 &&
                                                m._extendClasses.call(null);
                                    });
                                }
                            }),
                        (n = !0),
                        m._setup.call(null),
                        m._live.call(null);
                },
                scrollTo: function (t, e) {
                    if (m._isDisabled.call(null)) m._removeClasses.call(null);
                    else if (t && void 0 !== t) {
                        m._isInit.call(null);
                        var i = {
                            layout: C.layout,
                            offset: C.offset,
                            clicked: !1,
                        };
                        e = S.extend(!0, {}, i, e);
                        m._reset.call(null),
                            (l = e.layout),
                            (h = e.offset),
                            (t = -1 !== t.indexOf("#") ? t : "#" + t),
                            m._isValid.call(null, t) &&
                                m._findTarget.call(null, t) &&
                                ((o = "scrollTo"),
                                (r = e.clicked) && m._setClasses.call(null, !0),
                                m._scrollTo.call(null));
                    }
                },
                destroy: function () {
                    S(T).unbind("." + k),
                        S(c)
                            .undelegate("." + k)
                            .removeData(k),
                        S("._mPS2id-t").removeData(k),
                        m._removeClasses.call(null, !0);
                },
            },
            m = {
                _isDisabled: function () {
                    var t = T,
                        e = "inner",
                        i =
                            C.disablePluginBelow instanceof Array
                                ? [
                                      C.disablePluginBelow[0] || 0,
                                      C.disablePluginBelow[1] || 0,
                                  ]
                                : [C.disablePluginBelow || 0, 0];
                    return (
                        "innerWidth" in T ||
                            ((e = "client"), (t = c.documentElement || c.body)),
                        t[e + "Width"] <= i[0] || t[e + "Height"] <= i[1]
                    );
                },
                _isValid: function (t, e) {
                    if (t) {
                        var i =
                                -1 !== (e = e || t).indexOf("#/")
                                    ? e.split("#/")[0]
                                    : e.split("#")[0],
                            n = T.location.toString().split("#")[0];
                        return (
                            "#" !== t &&
                            -1 !== t.indexOf("#") &&
                            ("" === i ||
                                decodeURIComponent(i) === decodeURIComponent(n))
                        );
                    }
                },
                _setup: function () {
                    var r = m._highlightSelector(),
                        a = 1,
                        l = 0;
                    return S(r).each(function () {
                        var t = S(this),
                            e = t.attr("href"),
                            i = t.prop("href").baseVal || t.prop("href");
                        if (m._isValid.call(null, e, i)) {
                            if (C.excludeSelectors && t.is(C.excludeSelectors))
                                return;
                            var n =
                                    -1 !== e.indexOf("#/")
                                        ? e.split("#/")[1]
                                        : e.split("#")[1],
                                o = S(
                                    -1 !== n.indexOf("%")
                                        ? c.getElementById(n)
                                        : "#" + n,
                                );
                            if (0 < o.length) {
                                C.highlightByNextTarget &&
                                    o !== l &&
                                    (l
                                        ? l.data(k, { tn: o })
                                        : o.data(k, { tn: "0" }),
                                    (l = o)),
                                    o.hasClass("_mPS2id-t") ||
                                        o.addClass("_mPS2id-t"),
                                    o.data(k, { i: a }),
                                    t.hasClass("_mPS2id-h") ||
                                        t.addClass("_mPS2id-h");
                                var s = m._findHighlight.call(null, n);
                                m._setClasses.call(null, !1, o, s),
                                    (f = a),
                                    ++a == S(r).length &&
                                        m._extendClasses.call(null);
                            }
                        }
                    });
                },
                _highlightSelector: function () {
                    return C.highlightSelector && "" !== C.highlightSelector
                        ? C.highlightSelector
                        : i;
                },
                _findTarget: function (t) {
                    var e =
                            -1 !== t.indexOf("#/")
                                ? t.split("#/")[1]
                                : t.split("#")[1],
                        i = S(
                            -1 !== e.indexOf("%")
                                ? c.getElementById(e)
                                : "#" + e,
                        );
                    if (i.length < 1 || "fixed" === i.css("position")) {
                        if ("top" !== e) return;
                        i = S("body");
                    }
                    return (
                        (s = i),
                        (l = l || C.layout),
                        (h = m._setOffset.call(null)),
                        ((a = [
                            (i.offset().top - h[0]).toString(),
                            (i.offset().left - h[1]).toString(),
                        ])[0] = a[0] < 0 ? 0 : a[0]),
                        (a[1] = a[1] < 0 ? 0 : a[1]),
                        a
                    );
                },
                _setOffset: function () {
                    var t, e, i, n;
                    switch (
                        ((h = h || (C.offset ? C.offset : 0)),
                        d && (h = d),
                        typeof h)
                    ) {
                        case "object":
                        case "string":
                            0 <
                            (e = [
                                (t = [
                                    h.y ? h.y : h,
                                    h.x ? h.x : h,
                                ])[0] instanceof jQuery
                                    ? t[0]
                                    : S(t[0]),
                                t[1] instanceof jQuery ? t[1] : S(t[1]),
                            ])[0].length
                                ? ((i = e[0].height()),
                                  "fixed" === e[0].css("position") &&
                                      (i += e[0][0].offsetTop))
                                : (i =
                                      !isNaN(parseFloat(t[0])) && isFinite(t[0])
                                          ? parseInt(t[0])
                                          : 0),
                                0 < e[1].length
                                    ? ((n = e[1].width()),
                                      "fixed" === e[1].css("position") &&
                                          (n += e[1][0].offsetLeft))
                                    : (n =
                                          !isNaN(parseFloat(t[1])) &&
                                          isFinite(t[1])
                                              ? parseInt(t[1])
                                              : 0);
                            break;
                        case "function":
                            (t = h.call(null)) instanceof Array
                                ? ((i = t[0]), (n = t[1]))
                                : (i = n = t);
                            break;
                        default:
                            i = n = parseInt(h);
                    }
                    return [i, n];
                },
                _findHighlight: function (t) {
                    var e = T.location,
                        i = e.toString().split("#")[0],
                        n = e.pathname;
                    return (
                        -1 !== i.indexOf("'") && (i = i.replace("'", "\\'")),
                        -1 !== n.indexOf("'") && (n = n.replace("'", "\\'")),
                        (i = decodeURIComponent(i)),
                        (n = decodeURIComponent(n)),
                        S(
                            "._mPS2id-h[href='#" +
                                t +
                                "'],._" +
                                k +
                                "-h[href='" +
                                i +
                                "#" +
                                t +
                                "'],._" +
                                k +
                                "-h[href='" +
                                n +
                                "#" +
                                t +
                                "'],._" +
                                k +
                                "-h[href='#/" +
                                t +
                                "'],._" +
                                k +
                                "-h[href='" +
                                i +
                                "#/" +
                                t +
                                "'],._" +
                                k +
                                "-h[href='" +
                                n +
                                "#/" +
                                t +
                                "']",
                        )
                    );
                },
                _setClasses: function (t, e, i) {
                    var n = C.clickedClass,
                        o = C.targetClass,
                        s = C.highlightClass;
                    t && n && "" !== n
                        ? (S("." + n).removeClass(n), r.addClass(n))
                        : e &&
                          o &&
                          "" !== o &&
                          i &&
                          s &&
                          "" !== s &&
                          (m._currentTarget.call(null, e)
                              ? (e.addClass(o), i.addClass(s))
                              : (!C.keepHighlightUntilNext ||
                                    1 < S("." + s).length) &&
                                (e.removeClass(o), i.removeClass(s)));
                },
                _extendClasses: function () {
                    var t = C.targetClass,
                        e = C.highlightClass,
                        i = S("." + t),
                        n = S("." + e),
                        o = t + "-first",
                        s = t + "-last",
                        r = e + "-first",
                        a = e + "-last";
                    S("._mPS2id-t").removeClass(o + " " + s),
                        S("._mPS2id-h").removeClass(r + " " + a),
                        C.forceSingleHighlight
                            ? C.keepHighlightUntilNext && 1 < i.length
                                ? (i.slice(0, 1).removeClass(t),
                                  n.slice(0, 1).removeClass(e))
                                : (i.slice(1).removeClass(t),
                                  n.slice(1).removeClass(e))
                            : (i
                                  .slice(0, 1)
                                  .addClass(o)
                                  .end()
                                  .slice(-1)
                                  .addClass(s),
                              n
                                  .slice(0, 1)
                                  .addClass(r)
                                  .end()
                                  .slice(-1)
                                  .addClass(a));
                },
                _removeClasses: function (t) {
                    S("." + C.clickedClass).removeClass(C.clickedClass),
                        S("." + C.targetClass).removeClass(
                            C.targetClass +
                                " " +
                                C.targetClass +
                                "-first " +
                                C.targetClass +
                                "-last",
                        ),
                        S("." + C.highlightClass).removeClass(
                            C.highlightClass +
                                " " +
                                C.highlightClass +
                                "-first " +
                                C.highlightClass +
                                "-last",
                        ),
                        t &&
                            (S("._mPS2id-t").removeClass("_mPS2id-t"),
                            S("._mPS2id-h").removeClass("_mPS2id-h"));
                },
                _currentTarget: function (t) {
                    var e = C["target_" + t.data(k).i],
                        i = t.data("ps2id-target"),
                        n =
                            i && S(i)[0]
                                ? S(i)[0].getBoundingClientRect()
                                : t[0].getBoundingClientRect();
                    if (void 0 !== e) {
                        var o = t.offset().top,
                            s = t.offset().left,
                            r = e.from ? e.from + o : o,
                            a = e.to ? e.to + o : o,
                            l = e.fromX ? e.fromX + s : s,
                            c = e.toX ? e.toX + s : s;
                        return (
                            n.top >= a &&
                            n.top <= r &&
                            n.left >= c &&
                            n.left <= l
                        );
                    }
                    var h = S(T).height(),
                        d = S(T).width(),
                        u = i ? S(i).height() : t.height(),
                        p = i ? S(i).width() : t.width(),
                        f = 1 + u / h,
                        g = f,
                        m = u < h ? (h / u) * f : f,
                        v = 1 + p / d,
                        y = v,
                        _ = p < d ? (d / p) * v : v,
                        b = [
                            n.top <= h / g,
                            n.bottom >= h / m,
                            n.left <= d / y,
                            n.right >= d / _,
                        ];
                    if (C.highlightByNextTarget) {
                        var w = t.data(k).tn;
                        if (w) {
                            var x = w[0].getBoundingClientRect();
                            "vertical" === C.layout
                                ? (b = [n.top <= h / 2, x.top > h / 2, 1, 1])
                                : "horizontal" === C.layout &&
                                  (b = [1, 1, n.left <= d / 2, x.left > d / 2]);
                        }
                    }
                    return b[0] && b[1] && b[2] && b[3];
                },
                _scrollTo: function () {
                    (u = m._scrollSpeed.call(null)),
                        (a = C.pageEndSmoothScroll
                            ? m._pageEndSmoothScroll.call(null)
                            : a);
                    var t = S("html,body"),
                        e = C.autoScrollSpeed
                            ? m._autoScrollSpeed.call(null)
                            : u,
                        i = t.is(":animated")
                            ? C.scrollingEasing
                            : C.scrollEasing,
                        n = S(T).scrollTop(),
                        o = S(T).scrollLeft();
                    switch (l) {
                        case "horizontal":
                            o != a[1] &&
                                (m._callbacks.call(null, "onStart"),
                                t
                                    .stop()
                                    .animate({ scrollLeft: a[1] }, e, i)
                                    .promise()
                                    .then(function () {
                                        m._callbacks.call(null, "onComplete");
                                    }));
                            break;
                        case "auto":
                            if (n != a[0] || o != a[1])
                                if (
                                    (m._callbacks.call(null, "onStart"),
                                    navigator.userAgent.match(
                                        /(iPod|iPhone|iPad|Android)/,
                                    ))
                                ) {
                                    var s;
                                    t.stop()
                                        .animate(
                                            {
                                                pageYOffset: a[0],
                                                pageXOffset: a[1],
                                            },
                                            {
                                                duration: e,
                                                easing: i,
                                                step: function (t, e) {
                                                    "pageXOffset" == e.prop
                                                        ? (s = t)
                                                        : "pageYOffset" ==
                                                              e.prop &&
                                                          T.scrollTo(s, t);
                                                },
                                            },
                                        )
                                        .promise()
                                        .then(function () {
                                            m._callbacks.call(
                                                null,
                                                "onComplete",
                                            );
                                        });
                                } else
                                    t.stop()
                                        .animate(
                                            {
                                                scrollTop: a[0],
                                                scrollLeft: a[1],
                                            },
                                            e,
                                            i,
                                        )
                                        .promise()
                                        .then(function () {
                                            m._callbacks.call(
                                                null,
                                                "onComplete",
                                            );
                                        });
                            break;
                        default:
                            n != a[0] &&
                                (m._callbacks.call(null, "onStart"),
                                t
                                    .stop()
                                    .animate({ scrollTop: a[0] }, e, i)
                                    .promise()
                                    .then(function () {
                                        m._callbacks.call(null, "onComplete");
                                    }));
                    }
                },
                _pageEndSmoothScroll: function () {
                    var t = S(c).height(),
                        e = S(c).width(),
                        i = S(T).height(),
                        n = S(T).width();
                    return [
                        t - a[0] < i ? t - i : a[0],
                        e - a[1] < n ? e - n : a[1],
                    ];
                },
                _scrollSpeed: function () {
                    var n = C.scrollSpeed;
                    return (
                        r &&
                            r.length &&
                            r.add(r.parent()).each(function () {
                                var t = S(this);
                                if (t.attr("class")) {
                                    var e = t.attr("class").split(" ");
                                    for (var i in e)
                                        if (
                                            String(e[i]).match(
                                                /^ps2id-speed-\d+$/,
                                            )
                                        ) {
                                            n = e[i].split("ps2id-speed-")[1];
                                            break;
                                        }
                                }
                            }),
                        parseInt(n)
                    );
                },
                _autoScrollSpeed: function () {
                    var t = S(T).scrollTop(),
                        e = S(T).scrollLeft(),
                        i = S(c).height(),
                        n = S(c).width(),
                        o = [
                            u +
                                (u *
                                    Math.floor(
                                        (Math.abs(a[0] - t) / i) * 100,
                                    )) /
                                    100,
                            u +
                                (u *
                                    Math.floor(
                                        (Math.abs(a[1] - e) / n) * 100,
                                    )) /
                                    100,
                        ];
                    return Math.max.apply(Math, o);
                },
                _callbacks: function (t) {
                    if (C)
                        switch (
                            ((this[k] = {
                                trigger: o,
                                clicked: r,
                                target: s,
                                scrollTo: { y: a[0], x: a[1] },
                            }),
                            t)
                        ) {
                            case "onStart":
                                if (
                                    C.appendHash &&
                                    T.history &&
                                    T.history.pushState &&
                                    r &&
                                    r.length
                                ) {
                                    var e = "#" + r.attr("href").split("#")[1];
                                    e !== T.location.hash &&
                                        history.pushState("", "", e);
                                }
                                C.onStart.call(null, this[k]);
                                break;
                            case "onComplete":
                                C.onComplete.call(null, this[k]);
                        }
                },
                _reset: function () {
                    l = h = d = !1;
                },
                _isInit: function () {
                    n || g.init.apply(this);
                },
                _live: function () {
                    t = setTimeout(function () {
                        C.live
                            ? S(m._highlightSelector()).length !== f &&
                              m._setup.call(null)
                            : t && clearTimeout(t),
                            m._live.call(null);
                    }, 1e3);
                },
                _easing: function () {
                    function e(t) {
                        var e = 7.5625,
                            i = 2.75;
                        return t < 1 / i
                            ? e * t * t
                            : t < 2 / i
                              ? e * (t -= 1.5 / i) * t + 0.75
                              : t < 2.5 / i
                                ? e * (t -= 2.25 / i) * t + 0.9375
                                : e * (t -= 2.625 / i) * t + 0.984375;
                    }
                    (S.easing.easeInQuad =
                        S.easing.easeInQuad ||
                        function (t) {
                            return t * t;
                        }),
                        (S.easing.easeOutQuad =
                            S.easing.easeOutQuad ||
                            function (t) {
                                return 1 - (1 - t) * (1 - t);
                            }),
                        (S.easing.easeInOutQuad =
                            S.easing.easeInOutQuad ||
                            function (t) {
                                return t < 0.5
                                    ? 2 * t * t
                                    : 1 - Math.pow(-2 * t + 2, 2) / 2;
                            }),
                        (S.easing.easeInCubic =
                            S.easing.easeInCubic ||
                            function (t) {
                                return t * t * t;
                            }),
                        (S.easing.easeOutCubic =
                            S.easing.easeOutCubic ||
                            function (t) {
                                return 1 - Math.pow(1 - t, 3);
                            }),
                        (S.easing.easeInOutCubic =
                            S.easing.easeInOutCubic ||
                            function (t) {
                                return t < 0.5
                                    ? 4 * t * t * t
                                    : 1 - Math.pow(-2 * t + 2, 3) / 2;
                            }),
                        (S.easing.easeInQuart =
                            S.easing.easeInQuart ||
                            function (t) {
                                return t * t * t * t;
                            }),
                        (S.easing.easeOutQuart =
                            S.easing.easeOutQuart ||
                            function (t) {
                                return 1 - Math.pow(1 - t, 4);
                            }),
                        (S.easing.easeInOutQuart =
                            S.easing.easeInOutQuart ||
                            function (t) {
                                return t < 0.5
                                    ? 8 * t * t * t * t
                                    : 1 - Math.pow(-2 * t + 2, 4) / 2;
                            }),
                        (S.easing.easeInQuint =
                            S.easing.easeInQuint ||
                            function (t) {
                                return t * t * t * t * t;
                            }),
                        (S.easing.easeOutQuint =
                            S.easing.easeOutQuint ||
                            function (t) {
                                return 1 - Math.pow(1 - t, 5);
                            }),
                        (S.easing.easeInOutQuint =
                            S.easing.easeInOutQuint ||
                            function (t) {
                                return t < 0.5
                                    ? 16 * t * t * t * t * t
                                    : 1 - Math.pow(-2 * t + 2, 5) / 2;
                            }),
                        (S.easing.easeInExpo =
                            S.easing.easeInExpo ||
                            function (t) {
                                return 0 === t ? 0 : Math.pow(2, 10 * t - 10);
                            }),
                        (S.easing.easeOutExpo =
                            S.easing.easeOutExpo ||
                            function (t) {
                                return 1 === t ? 1 : 1 - Math.pow(2, -10 * t);
                            }),
                        (S.easing.easeInOutExpo =
                            S.easing.easeInOutExpo ||
                            function (t) {
                                return 0 === t
                                    ? 0
                                    : 1 === t
                                      ? 1
                                      : t < 0.5
                                        ? Math.pow(2, 20 * t - 10) / 2
                                        : (2 - Math.pow(2, -20 * t + 10)) / 2;
                            }),
                        (S.easing.easeInSine =
                            S.easing.easeInSine ||
                            function (t) {
                                return 1 - Math.cos((t * Math.PI) / 2);
                            }),
                        (S.easing.easeOutSine =
                            S.easing.easeOutSine ||
                            function (t) {
                                return Math.sin((t * Math.PI) / 2);
                            }),
                        (S.easing.easeInOutSine =
                            S.easing.easeInOutSine ||
                            function (t) {
                                return -(Math.cos(Math.PI * t) - 1) / 2;
                            }),
                        (S.easing.easeInCirc =
                            S.easing.easeInCirc ||
                            function (t) {
                                return 1 - Math.sqrt(1 - Math.pow(t, 2));
                            }),
                        (S.easing.easeOutCirc =
                            S.easing.easeOutCirc ||
                            function (t) {
                                return Math.sqrt(1 - Math.pow(t - 1, 2));
                            }),
                        (S.easing.easeInOutCirc =
                            S.easing.easeInOutCirc ||
                            function (t) {
                                return t < 0.5
                                    ? (1 - Math.sqrt(1 - Math.pow(2 * t, 2))) /
                                          2
                                    : (Math.sqrt(1 - Math.pow(-2 * t + 2, 2)) +
                                          1) /
                                          2;
                            }),
                        (S.easing.easeInElastic =
                            S.easing.easeInElastic ||
                            function (t) {
                                return 0 === t
                                    ? 0
                                    : 1 === t
                                      ? 1
                                      : -Math.pow(2, 10 * t - 10) *
                                        Math.sin(
                                            (10 * t - 10.75) *
                                                ((2 * Math.PI) / 3),
                                        );
                            }),
                        (S.easing.easeOutElastic =
                            S.easing.easeOutElastic ||
                            function (t) {
                                return 0 === t
                                    ? 0
                                    : 1 === t
                                      ? 1
                                      : Math.pow(2, -10 * t) *
                                            Math.sin(
                                                (10 * t - 0.75) *
                                                    ((2 * Math.PI) / 3),
                                            ) +
                                        1;
                            }),
                        (S.easing.easeInOutElastic =
                            S.easing.easeInOutElastic ||
                            function (t) {
                                return 0 === t
                                    ? 0
                                    : 1 === t
                                      ? 1
                                      : t < 0.5
                                        ? -(
                                              Math.pow(2, 20 * t - 10) *
                                              Math.sin(
                                                  (20 * t - 11.125) *
                                                      ((2 * Math.PI) / 4.5),
                                              )
                                          ) / 2
                                        : (Math.pow(2, -20 * t + 10) *
                                              Math.sin(
                                                  (20 * t - 11.125) *
                                                      ((2 * Math.PI) / 4.5),
                                              )) /
                                              2 +
                                          1;
                            }),
                        (S.easing.easeInBack =
                            S.easing.easeInBack ||
                            function (t) {
                                return 2.70158 * t * t * t - 1.70158 * t * t;
                            }),
                        (S.easing.easeOutBack =
                            S.easing.easeOutBack ||
                            function (t) {
                                return (
                                    1 +
                                    2.70158 * Math.pow(t - 1, 3) +
                                    1.70158 * Math.pow(t - 1, 2)
                                );
                            }),
                        (S.easing.easeInOutBack =
                            S.easing.easeInOutBack ||
                            function (t) {
                                return t < 0.5
                                    ? (Math.pow(2 * t, 2) *
                                          (7.189819 * t - 2.5949095)) /
                                          2
                                    : (Math.pow(2 * t - 2, 2) *
                                          (3.5949095 * (2 * t - 2) +
                                              2.5949095) +
                                          2) /
                                          2;
                            }),
                        (S.easing.easeInBounce =
                            S.easing.easeInBounce ||
                            function (t) {
                                return 1 - e(1 - t);
                            }),
                        (S.easing.easeOutBounce = S.easing.easeOutBounce || e),
                        (S.easing.easeInOutBounce =
                            S.easing.easeInOutBounce ||
                            function (t) {
                                return t < 0.5
                                    ? (1 - e(1 - 2 * t)) / 2
                                    : (1 + e(2 * t - 1)) / 2;
                            });
                },
            };
        m._easing.call(),
            (S.fn[e] = function (t) {
                return g[t]
                    ? g[t].apply(this, Array.prototype.slice.call(arguments, 1))
                    : "object" != typeof t && t
                      ? void S.error("Method " + t + " does not exist")
                      : g.init.apply(this, arguments);
            }),
            (S[e] = function (t) {
                return g[t]
                    ? g[t].apply(this, Array.prototype.slice.call(arguments, 1))
                    : "object" != typeof t && t
                      ? void S.error("Method " + t + " does not exist")
                      : g.init.apply(this, arguments);
            }),
            (S[e].defaults = p);
    })(jQuery, window, document),
    (function (t) {
        "use strict";
        "function" == typeof define && define.amd
            ? define(["jquery"], t)
            : "undefined" != typeof exports
              ? (module.exports = t(require("jquery")))
              : t(jQuery);
    })(function (c) {
        "use strict";
        var o,
            s = window.Slick || {};
        (o = 0),
            ((s = function (t, e) {
                var i,
                    n = this;
                (n.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: c(t),
                    appendDots: c(t),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow:
                        '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                    nextArrow:
                        '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: "50px",
                    cssEase: "ease",
                    customPaging: function (t, e) {
                        return c('<button type="button" />').text(e + 1);
                    },
                    dots: !1,
                    dotsClass: "slick-dots",
                    draggable: !0,
                    easing: "linear",
                    edgeFriction: 0.35,
                    fade: !1,
                    focusOnSelect: !1,
                    focusOnChange: !1,
                    infinite: !0,
                    initialSlide: 0,
                    lazyLoad: "ondemand",
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: "window",
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: "",
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3,
                }),
                    (n.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        scrolling: !1,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        swiping: !1,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1,
                    }),
                    c.extend(n, n.initials),
                    (n.activeBreakpoint = null),
                    (n.animType = null),
                    (n.animProp = null),
                    (n.breakpoints = []),
                    (n.breakpointSettings = []),
                    (n.cssTransitions = !1),
                    (n.focussed = !1),
                    (n.interrupted = !1),
                    (n.hidden = "hidden"),
                    (n.paused = !0),
                    (n.positionProp = null),
                    (n.respondTo = null),
                    (n.rowCount = 1),
                    (n.shouldClick = !0),
                    (n.$slider = c(t)),
                    (n.$slidesCache = null),
                    (n.transformType = null),
                    (n.transitionType = null),
                    (n.visibilityChange = "visibilitychange"),
                    (n.windowWidth = 0),
                    (n.windowTimer = null),
                    (i = c(t).data("slick") || {}),
                    (n.options = c.extend({}, n.defaults, e, i)),
                    (n.currentSlide = n.options.initialSlide),
                    (n.originalSettings = n.options),
                    void 0 !== document.mozHidden
                        ? ((n.hidden = "mozHidden"),
                          (n.visibilityChange = "mozvisibilitychange"))
                        : void 0 !== document.webkitHidden &&
                          ((n.hidden = "webkitHidden"),
                          (n.visibilityChange = "webkitvisibilitychange")),
                    (n.autoPlay = c.proxy(n.autoPlay, n)),
                    (n.autoPlayClear = c.proxy(n.autoPlayClear, n)),
                    (n.autoPlayIterator = c.proxy(n.autoPlayIterator, n)),
                    (n.changeSlide = c.proxy(n.changeSlide, n)),
                    (n.clickHandler = c.proxy(n.clickHandler, n)),
                    (n.selectHandler = c.proxy(n.selectHandler, n)),
                    (n.setPosition = c.proxy(n.setPosition, n)),
                    (n.swipeHandler = c.proxy(n.swipeHandler, n)),
                    (n.dragHandler = c.proxy(n.dragHandler, n)),
                    (n.keyHandler = c.proxy(n.keyHandler, n)),
                    (n.instanceUid = o++),
                    (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                    n.registerBreakpoints(),
                    n.init(!0);
            }).prototype.activateADA = function () {
                this.$slideTrack
                    .find(".slick-active")
                    .attr({ "aria-hidden": "false" })
                    .find("a, input, button, select")
                    .attr({ tabindex: "0" });
            }),
            (s.prototype.addSlide = s.prototype.slickAdd =
                function (t, e, i) {
                    var n = this;
                    if ("boolean" == typeof e) (i = e), (e = null);
                    else if (e < 0 || e >= n.slideCount) return !1;
                    n.unload(),
                        "number" == typeof e
                            ? 0 === e && 0 === n.$slides.length
                                ? c(t).appendTo(n.$slideTrack)
                                : i
                                  ? c(t).insertBefore(n.$slides.eq(e))
                                  : c(t).insertAfter(n.$slides.eq(e))
                            : !0 === i
                              ? c(t).prependTo(n.$slideTrack)
                              : c(t).appendTo(n.$slideTrack),
                        (n.$slides = n.$slideTrack.children(
                            this.options.slide,
                        )),
                        n.$slideTrack.children(this.options.slide).detach(),
                        n.$slideTrack.append(n.$slides),
                        n.$slides.each(function (t, e) {
                            c(e).attr("data-slick-index", t);
                        }),
                        (n.$slidesCache = n.$slides),
                        n.reinit();
                }),
            (s.prototype.animateHeight = function () {
                var t = this;
                if (
                    1 === t.options.slidesToShow &&
                    !0 === t.options.adaptiveHeight &&
                    !1 === t.options.vertical
                ) {
                    var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
                    t.$list.animate({ height: e }, t.options.speed);
                }
            }),
            (s.prototype.animateSlide = function (t, e) {
                var i = {},
                    n = this;
                n.animateHeight(),
                    !0 === n.options.rtl &&
                        !1 === n.options.vertical &&
                        (t = -t),
                    !1 === n.transformsEnabled
                        ? !1 === n.options.vertical
                            ? n.$slideTrack.animate(
                                  { left: t },
                                  n.options.speed,
                                  n.options.easing,
                                  e,
                              )
                            : n.$slideTrack.animate(
                                  { top: t },
                                  n.options.speed,
                                  n.options.easing,
                                  e,
                              )
                        : !1 === n.cssTransitions
                          ? (!0 === n.options.rtl &&
                                (n.currentLeft = -n.currentLeft),
                            c({ animStart: n.currentLeft }).animate(
                                { animStart: t },
                                {
                                    duration: n.options.speed,
                                    easing: n.options.easing,
                                    step: function (t) {
                                        (t = Math.ceil(t)),
                                            !1 === n.options.vertical
                                                ? (i[n.animType] =
                                                      "translate(" +
                                                      t +
                                                      "px, 0px)")
                                                : (i[n.animType] =
                                                      "translate(0px," +
                                                      t +
                                                      "px)"),
                                            n.$slideTrack.css(i);
                                    },
                                    complete: function () {
                                        e && e.call();
                                    },
                                },
                            ))
                          : (n.applyTransition(),
                            (t = Math.ceil(t)),
                            !1 === n.options.vertical
                                ? (i[n.animType] =
                                      "translate3d(" + t + "px, 0px, 0px)")
                                : (i[n.animType] =
                                      "translate3d(0px," + t + "px, 0px)"),
                            n.$slideTrack.css(i),
                            e &&
                                setTimeout(function () {
                                    n.disableTransition(), e.call();
                                }, n.options.speed));
            }),
            (s.prototype.getNavTarget = function () {
                var t = this.options.asNavFor;
                return t && null !== t && (t = c(t).not(this.$slider)), t;
            }),
            (s.prototype.asNavFor = function (e) {
                var t = this.getNavTarget();
                null !== t &&
                    "object" == typeof t &&
                    t.each(function () {
                        var t = c(this).slick("getSlick");
                        t.unslicked || t.slideHandler(e, !0);
                    });
            }),
            (s.prototype.applyTransition = function (t) {
                var e = this,
                    i = {};
                !1 === e.options.fade
                    ? (i[e.transitionType] =
                          e.transformType +
                          " " +
                          e.options.speed +
                          "ms " +
                          e.options.cssEase)
                    : (i[e.transitionType] =
                          "opacity " +
                          e.options.speed +
                          "ms " +
                          e.options.cssEase),
                    !1 === e.options.fade
                        ? e.$slideTrack.css(i)
                        : e.$slides.eq(t).css(i);
            }),
            (s.prototype.autoPlay = function () {
                var t = this;
                t.autoPlayClear(),
                    t.slideCount > t.options.slidesToShow &&
                        (t.autoPlayTimer = setInterval(
                            t.autoPlayIterator,
                            t.options.autoplaySpeed,
                        ));
            }),
            (s.prototype.autoPlayClear = function () {
                this.autoPlayTimer && clearInterval(this.autoPlayTimer);
            }),
            (s.prototype.autoPlayIterator = function () {
                var t = this,
                    e = t.currentSlide + t.options.slidesToScroll;
                t.paused ||
                    t.interrupted ||
                    t.focussed ||
                    (!1 === t.options.infinite &&
                        (1 === t.direction &&
                        t.currentSlide + 1 === t.slideCount - 1
                            ? (t.direction = 0)
                            : 0 === t.direction &&
                              ((e = t.currentSlide - t.options.slidesToScroll),
                              t.currentSlide - 1 == 0 && (t.direction = 1))),
                    t.slideHandler(e));
            }),
            (s.prototype.buildArrows = function () {
                var t = this;
                !0 === t.options.arrows &&
                    ((t.$prevArrow = c(t.options.prevArrow).addClass(
                        "slick-arrow",
                    )),
                    (t.$nextArrow = c(t.options.nextArrow).addClass(
                        "slick-arrow",
                    )),
                    t.slideCount > t.options.slidesToShow
                        ? (t.$prevArrow
                              .removeClass("slick-hidden")
                              .removeAttr("aria-hidden tabindex"),
                          t.$nextArrow
                              .removeClass("slick-hidden")
                              .removeAttr("aria-hidden tabindex"),
                          t.htmlExpr.test(t.options.prevArrow) &&
                              t.$prevArrow.prependTo(t.options.appendArrows),
                          t.htmlExpr.test(t.options.nextArrow) &&
                              t.$nextArrow.appendTo(t.options.appendArrows),
                          !0 !== t.options.infinite &&
                              t.$prevArrow
                                  .addClass("slick-disabled")
                                  .attr("aria-disabled", "true"))
                        : t.$prevArrow
                              .add(t.$nextArrow)
                              .addClass("slick-hidden")
                              .attr({
                                  "aria-disabled": "true",
                                  tabindex: "-1",
                              }));
            }),
            (s.prototype.buildDots = function () {
                var t,
                    e,
                    i = this;
                if (
                    !0 === i.options.dots &&
                    i.slideCount > i.options.slidesToShow
                ) {
                    for (
                        i.$slider.addClass("slick-dotted"),
                            e = c("<ul />").addClass(i.options.dotsClass),
                            t = 0;
                        t <= i.getDotCount();
                        t += 1
                    )
                        e.append(
                            c("<li />").append(
                                i.options.customPaging.call(this, i, t),
                            ),
                        );
                    (i.$dots = e.appendTo(i.options.appendDots)),
                        i.$dots.find("li").first().addClass("slick-active");
                }
            }),
            (s.prototype.buildOut = function () {
                var t = this;
                (t.$slides = t.$slider
                    .children(t.options.slide + ":not(.slick-cloned)")
                    .addClass("slick-slide")),
                    (t.slideCount = t.$slides.length),
                    t.$slides.each(function (t, e) {
                        c(e)
                            .attr("data-slick-index", t)
                            .data("originalStyling", c(e).attr("style") || "");
                    }),
                    t.$slider.addClass("slick-slider"),
                    (t.$slideTrack =
                        0 === t.slideCount
                            ? c('<div class="slick-track"/>').appendTo(
                                  t.$slider,
                              )
                            : t.$slides
                                  .wrapAll('<div class="slick-track"/>')
                                  .parent()),
                    (t.$list = t.$slideTrack
                        .wrap('<div class="slick-list"/>')
                        .parent()),
                    t.$slideTrack.css("opacity", 0),
                    (!0 !== t.options.centerMode &&
                        !0 !== t.options.swipeToSlide) ||
                        (t.options.slidesToScroll = 1),
                    c("img[data-lazy]", t.$slider)
                        .not("[src]")
                        .addClass("slick-loading"),
                    t.setupInfinite(),
                    t.buildArrows(),
                    t.buildDots(),
                    t.updateDots(),
                    t.setSlideClasses(
                        "number" == typeof t.currentSlide ? t.currentSlide : 0,
                    ),
                    !0 === t.options.draggable && t.$list.addClass("draggable");
            }),
            (s.prototype.buildRows = function () {
                var t,
                    e,
                    i,
                    n,
                    o,
                    s,
                    r,
                    a = this;
                if (
                    ((n = document.createDocumentFragment()),
                    (s = a.$slider.children()),
                    0 < a.options.rows)
                ) {
                    for (
                        r = a.options.slidesPerRow * a.options.rows,
                            o = Math.ceil(s.length / r),
                            t = 0;
                        t < o;
                        t++
                    ) {
                        var l = document.createElement("div");
                        for (e = 0; e < a.options.rows; e++) {
                            var c = document.createElement("div");
                            for (i = 0; i < a.options.slidesPerRow; i++) {
                                var h =
                                    t * r + (e * a.options.slidesPerRow + i);
                                s.get(h) && c.appendChild(s.get(h));
                            }
                            l.appendChild(c);
                        }
                        n.appendChild(l);
                    }
                    a.$slider.empty().append(n),
                        a.$slider
                            .children()
                            .children()
                            .children()
                            .css({
                                width: 100 / a.options.slidesPerRow + "%",
                                display: "inline-block",
                            });
                }
            }),
            (s.prototype.checkResponsive = function (t, e) {
                var i,
                    n,
                    o,
                    s = this,
                    r = !1,
                    a = s.$slider.width(),
                    l = window.innerWidth || c(window).width();
                if (
                    ("window" === s.respondTo
                        ? (o = l)
                        : "slider" === s.respondTo
                          ? (o = a)
                          : "min" === s.respondTo && (o = Math.min(l, a)),
                    s.options.responsive &&
                        s.options.responsive.length &&
                        null !== s.options.responsive)
                ) {
                    for (i in ((n = null), s.breakpoints))
                        s.breakpoints.hasOwnProperty(i) &&
                            (!1 === s.originalSettings.mobileFirst
                                ? o < s.breakpoints[i] && (n = s.breakpoints[i])
                                : o > s.breakpoints[i] &&
                                  (n = s.breakpoints[i]));
                    null !== n
                        ? (null !== s.activeBreakpoint &&
                              n === s.activeBreakpoint &&
                              !e) ||
                          ((s.activeBreakpoint = n),
                          "unslick" === s.breakpointSettings[n]
                              ? s.unslick(n)
                              : ((s.options = c.extend(
                                    {},
                                    s.originalSettings,
                                    s.breakpointSettings[n],
                                )),
                                !0 === t &&
                                    (s.currentSlide = s.options.initialSlide),
                                s.refresh(t)),
                          (r = n))
                        : null !== s.activeBreakpoint &&
                          ((s.activeBreakpoint = null),
                          (s.options = s.originalSettings),
                          !0 === t && (s.currentSlide = s.options.initialSlide),
                          s.refresh(t),
                          (r = n)),
                        t ||
                            !1 === r ||
                            s.$slider.trigger("breakpoint", [s, r]);
                }
            }),
            (s.prototype.changeSlide = function (t, e) {
                var i,
                    n,
                    o = this,
                    s = c(t.currentTarget);
                switch (
                    (s.is("a") && t.preventDefault(),
                    s.is("li") || (s = s.closest("li")),
                    (i =
                        o.slideCount % o.options.slidesToScroll != 0
                            ? 0
                            : (o.slideCount - o.currentSlide) %
                              o.options.slidesToScroll),
                    t.data.message)
                ) {
                    case "previous":
                        (n =
                            0 == i
                                ? o.options.slidesToScroll
                                : o.options.slidesToShow - i),
                            o.slideCount > o.options.slidesToShow &&
                                o.slideHandler(o.currentSlide - n, !1, e);
                        break;
                    case "next":
                        (n = 0 == i ? o.options.slidesToScroll : i),
                            o.slideCount > o.options.slidesToShow &&
                                o.slideHandler(o.currentSlide + n, !1, e);
                        break;
                    case "index":
                        var r =
                            0 === t.data.index
                                ? 0
                                : t.data.index ||
                                  s.index() * o.options.slidesToScroll;
                        o.slideHandler(o.checkNavigable(r), !1, e),
                            s.children().trigger("focus");
                        break;
                    default:
                        return;
                }
            }),
            (s.prototype.checkNavigable = function (t) {
                var e, i;
                if (
                    ((i = 0),
                    t > (e = this.getNavigableIndexes())[e.length - 1])
                )
                    t = e[e.length - 1];
                else
                    for (var n in e) {
                        if (t < e[n]) {
                            t = i;
                            break;
                        }
                        i = e[n];
                    }
                return t;
            }),
            (s.prototype.cleanUpEvents = function () {
                var t = this;
                t.options.dots &&
                    null !== t.$dots &&
                    (c("li", t.$dots)
                        .off("click.slick", t.changeSlide)
                        .off("mouseenter.slick", c.proxy(t.interrupt, t, !0))
                        .off("mouseleave.slick", c.proxy(t.interrupt, t, !1)),
                    !0 === t.options.accessibility &&
                        t.$dots.off("keydown.slick", t.keyHandler)),
                    t.$slider.off("focus.slick blur.slick"),
                    !0 === t.options.arrows &&
                        t.slideCount > t.options.slidesToShow &&
                        (t.$prevArrow &&
                            t.$prevArrow.off("click.slick", t.changeSlide),
                        t.$nextArrow &&
                            t.$nextArrow.off("click.slick", t.changeSlide),
                        !0 === t.options.accessibility &&
                            (t.$prevArrow &&
                                t.$prevArrow.off("keydown.slick", t.keyHandler),
                            t.$nextArrow &&
                                t.$nextArrow.off(
                                    "keydown.slick",
                                    t.keyHandler,
                                ))),
                    t.$list.off(
                        "touchstart.slick mousedown.slick",
                        t.swipeHandler,
                    ),
                    t.$list.off(
                        "touchmove.slick mousemove.slick",
                        t.swipeHandler,
                    ),
                    t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
                    t.$list.off(
                        "touchcancel.slick mouseleave.slick",
                        t.swipeHandler,
                    ),
                    t.$list.off("click.slick", t.clickHandler),
                    c(document).off(t.visibilityChange, t.visibility),
                    t.cleanUpSlideEvents(),
                    !0 === t.options.accessibility &&
                        t.$list.off("keydown.slick", t.keyHandler),
                    !0 === t.options.focusOnSelect &&
                        c(t.$slideTrack)
                            .children()
                            .off("click.slick", t.selectHandler),
                    c(window).off(
                        "orientationchange.slick.slick-" + t.instanceUid,
                        t.orientationChange,
                    ),
                    c(window).off(
                        "resize.slick.slick-" + t.instanceUid,
                        t.resize,
                    ),
                    c("[draggable!=true]", t.$slideTrack).off(
                        "dragstart",
                        t.preventDefault,
                    ),
                    c(window).off(
                        "load.slick.slick-" + t.instanceUid,
                        t.setPosition,
                    );
            }),
            (s.prototype.cleanUpSlideEvents = function () {
                var t = this;
                t.$list.off("mouseenter.slick", c.proxy(t.interrupt, t, !0)),
                    t.$list.off(
                        "mouseleave.slick",
                        c.proxy(t.interrupt, t, !1),
                    );
            }),
            (s.prototype.cleanUpRows = function () {
                var t;
                0 < this.options.rows &&
                    ((t = this.$slides.children().children()).removeAttr(
                        "style",
                    ),
                    this.$slider.empty().append(t));
            }),
            (s.prototype.clickHandler = function (t) {
                !1 === this.shouldClick &&
                    (t.stopImmediatePropagation(),
                    t.stopPropagation(),
                    t.preventDefault());
            }),
            (s.prototype.destroy = function (t) {
                var e = this;
                e.autoPlayClear(),
                    (e.touchObject = {}),
                    e.cleanUpEvents(),
                    c(".slick-cloned", e.$slider).detach(),
                    e.$dots && e.$dots.remove(),
                    e.$prevArrow &&
                        e.$prevArrow.length &&
                        (e.$prevArrow
                            .removeClass(
                                "slick-disabled slick-arrow slick-hidden",
                            )
                            .removeAttr("aria-hidden aria-disabled tabindex")
                            .css("display", ""),
                        e.htmlExpr.test(e.options.prevArrow) &&
                            e.$prevArrow.remove()),
                    e.$nextArrow &&
                        e.$nextArrow.length &&
                        (e.$nextArrow
                            .removeClass(
                                "slick-disabled slick-arrow slick-hidden",
                            )
                            .removeAttr("aria-hidden aria-disabled tabindex")
                            .css("display", ""),
                        e.htmlExpr.test(e.options.nextArrow) &&
                            e.$nextArrow.remove()),
                    e.$slides &&
                        (e.$slides
                            .removeClass(
                                "slick-slide slick-active slick-center slick-visible slick-current",
                            )
                            .removeAttr("aria-hidden")
                            .removeAttr("data-slick-index")
                            .each(function () {
                                c(this).attr(
                                    "style",
                                    c(this).data("originalStyling"),
                                );
                            }),
                        e.$slideTrack.children(this.options.slide).detach(),
                        e.$slideTrack.detach(),
                        e.$list.detach(),
                        e.$slider.append(e.$slides)),
                    e.cleanUpRows(),
                    e.$slider.removeClass("slick-slider"),
                    e.$slider.removeClass("slick-initialized"),
                    e.$slider.removeClass("slick-dotted"),
                    (e.unslicked = !0),
                    t || e.$slider.trigger("destroy", [e]);
            }),
            (s.prototype.disableTransition = function (t) {
                var e = {};
                (e[this.transitionType] = ""),
                    !1 === this.options.fade
                        ? this.$slideTrack.css(e)
                        : this.$slides.eq(t).css(e);
            }),
            (s.prototype.fadeSlide = function (t, e) {
                var i = this;
                !1 === i.cssTransitions
                    ? (i.$slides.eq(t).css({ zIndex: i.options.zIndex }),
                      i.$slides
                          .eq(t)
                          .animate(
                              { opacity: 1 },
                              i.options.speed,
                              i.options.easing,
                              e,
                          ))
                    : (i.applyTransition(t),
                      i.$slides
                          .eq(t)
                          .css({ opacity: 1, zIndex: i.options.zIndex }),
                      e &&
                          setTimeout(function () {
                              i.disableTransition(t), e.call();
                          }, i.options.speed));
            }),
            (s.prototype.fadeSlideOut = function (t) {
                var e = this;
                !1 === e.cssTransitions
                    ? e.$slides
                          .eq(t)
                          .animate(
                              { opacity: 0, zIndex: e.options.zIndex - 2 },
                              e.options.speed,
                              e.options.easing,
                          )
                    : (e.applyTransition(t),
                      e.$slides
                          .eq(t)
                          .css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
            }),
            (s.prototype.filterSlides = s.prototype.slickFilter =
                function (t) {
                    var e = this;
                    null !== t &&
                        ((e.$slidesCache = e.$slides),
                        e.unload(),
                        e.$slideTrack.children(this.options.slide).detach(),
                        e.$slidesCache.filter(t).appendTo(e.$slideTrack),
                        e.reinit());
                }),
            (s.prototype.focusHandler = function () {
                var i = this;
                i.$slider
                    .off("focus.slick blur.slick")
                    .on("focus.slick blur.slick", "*", function (t) {
                        t.stopImmediatePropagation();
                        var e = c(this);
                        setTimeout(function () {
                            i.options.pauseOnFocus &&
                                ((i.focussed = e.is(":focus")), i.autoPlay());
                        }, 0);
                    });
            }),
            (s.prototype.getCurrent = s.prototype.slickCurrentSlide =
                function () {
                    return this.currentSlide;
                }),
            (s.prototype.getDotCount = function () {
                var t = this,
                    e = 0,
                    i = 0,
                    n = 0;
                if (!0 === t.options.infinite)
                    if (t.slideCount <= t.options.slidesToShow) ++n;
                    else
                        for (; e < t.slideCount; )
                            ++n,
                                (e = i + t.options.slidesToScroll),
                                (i +=
                                    t.options.slidesToScroll <=
                                    t.options.slidesToShow
                                        ? t.options.slidesToScroll
                                        : t.options.slidesToShow);
                else if (!0 === t.options.centerMode) n = t.slideCount;
                else if (t.options.asNavFor)
                    for (; e < t.slideCount; )
                        ++n,
                            (e = i + t.options.slidesToScroll),
                            (i +=
                                t.options.slidesToScroll <=
                                t.options.slidesToShow
                                    ? t.options.slidesToScroll
                                    : t.options.slidesToShow);
                else
                    n =
                        1 +
                        Math.ceil(
                            (t.slideCount - t.options.slidesToShow) /
                                t.options.slidesToScroll,
                        );
                return n - 1;
            }),
            (s.prototype.getLeft = function (t) {
                var e,
                    i,
                    n,
                    o,
                    s = this,
                    r = 0;
                return (
                    (s.slideOffset = 0),
                    (i = s.$slides.first().outerHeight(!0)),
                    !0 === s.options.infinite
                        ? (s.slideCount > s.options.slidesToShow &&
                              ((s.slideOffset =
                                  s.slideWidth * s.options.slidesToShow * -1),
                              (o = -1),
                              !0 === s.options.vertical &&
                                  !0 === s.options.centerMode &&
                                  (2 === s.options.slidesToShow
                                      ? (o = -1.5)
                                      : 1 === s.options.slidesToShow &&
                                        (o = -2)),
                              (r = i * s.options.slidesToShow * o)),
                          s.slideCount % s.options.slidesToScroll != 0 &&
                              t + s.options.slidesToScroll > s.slideCount &&
                              s.slideCount > s.options.slidesToShow &&
                              (r =
                                  t > s.slideCount
                                      ? ((s.slideOffset =
                                            (s.options.slidesToShow -
                                                (t - s.slideCount)) *
                                            s.slideWidth *
                                            -1),
                                        (s.options.slidesToShow -
                                            (t - s.slideCount)) *
                                            i *
                                            -1)
                                      : ((s.slideOffset =
                                            (s.slideCount %
                                                s.options.slidesToScroll) *
                                            s.slideWidth *
                                            -1),
                                        (s.slideCount %
                                            s.options.slidesToScroll) *
                                            i *
                                            -1)))
                        : t + s.options.slidesToShow > s.slideCount &&
                          ((s.slideOffset =
                              (t + s.options.slidesToShow - s.slideCount) *
                              s.slideWidth),
                          (r =
                              (t + s.options.slidesToShow - s.slideCount) * i)),
                    s.slideCount <= s.options.slidesToShow &&
                        (r = s.slideOffset = 0),
                    !0 === s.options.centerMode &&
                    s.slideCount <= s.options.slidesToShow
                        ? (s.slideOffset =
                              (s.slideWidth *
                                  Math.floor(s.options.slidesToShow)) /
                                  2 -
                              (s.slideWidth * s.slideCount) / 2)
                        : !0 === s.options.centerMode &&
                            !0 === s.options.infinite
                          ? (s.slideOffset +=
                                s.slideWidth *
                                    Math.floor(s.options.slidesToShow / 2) -
                                s.slideWidth)
                          : !0 === s.options.centerMode &&
                            ((s.slideOffset = 0),
                            (s.slideOffset +=
                                s.slideWidth *
                                Math.floor(s.options.slidesToShow / 2))),
                    (e =
                        !1 === s.options.vertical
                            ? t * s.slideWidth * -1 + s.slideOffset
                            : t * i * -1 + r),
                    !0 === s.options.variableWidth &&
                        ((n =
                            s.slideCount <= s.options.slidesToShow ||
                            !1 === s.options.infinite
                                ? s.$slideTrack.children(".slick-slide").eq(t)
                                : s.$slideTrack
                                      .children(".slick-slide")
                                      .eq(t + s.options.slidesToShow)),
                        (e =
                            !0 === s.options.rtl
                                ? n[0]
                                    ? -1 *
                                      (s.$slideTrack.width() -
                                          n[0].offsetLeft -
                                          n.width())
                                    : 0
                                : n[0]
                                  ? -1 * n[0].offsetLeft
                                  : 0),
                        !0 === s.options.centerMode &&
                            ((n =
                                s.slideCount <= s.options.slidesToShow ||
                                !1 === s.options.infinite
                                    ? s.$slideTrack
                                          .children(".slick-slide")
                                          .eq(t)
                                    : s.$slideTrack
                                          .children(".slick-slide")
                                          .eq(t + s.options.slidesToShow + 1)),
                            (e =
                                !0 === s.options.rtl
                                    ? n[0]
                                        ? -1 *
                                          (s.$slideTrack.width() -
                                              n[0].offsetLeft -
                                              n.width())
                                        : 0
                                    : n[0]
                                      ? -1 * n[0].offsetLeft
                                      : 0),
                            (e += (s.$list.width() - n.outerWidth()) / 2))),
                    e
                );
            }),
            (s.prototype.getOption = s.prototype.slickGetOption =
                function (t) {
                    return this.options[t];
                }),
            (s.prototype.getNavigableIndexes = function () {
                var t,
                    e = this,
                    i = 0,
                    n = 0,
                    o = [];
                for (
                    t =
                        !1 === e.options.infinite
                            ? e.slideCount
                            : ((i = -1 * e.options.slidesToScroll),
                              (n = -1 * e.options.slidesToScroll),
                              2 * e.slideCount);
                    i < t;

                )
                    o.push(i),
                        (i = n + e.options.slidesToScroll),
                        (n +=
                            e.options.slidesToScroll <= e.options.slidesToShow
                                ? e.options.slidesToScroll
                                : e.options.slidesToShow);
                return o;
            }),
            (s.prototype.getSlick = function () {
                return this;
            }),
            (s.prototype.getSlideCount = function () {
                var i,
                    n,
                    o = this;
                return (
                    (n =
                        !0 === o.options.centerMode
                            ? o.slideWidth *
                              Math.floor(o.options.slidesToShow / 2)
                            : 0),
                    !0 === o.options.swipeToSlide
                        ? (o.$slideTrack
                              .find(".slick-slide")
                              .each(function (t, e) {
                                  if (
                                      e.offsetLeft - n + c(e).outerWidth() / 2 >
                                      -1 * o.swipeLeft
                                  )
                                      return (i = e), !1;
                              }),
                          Math.abs(
                              c(i).attr("data-slick-index") - o.currentSlide,
                          ) || 1)
                        : o.options.slidesToScroll
                );
            }),
            (s.prototype.goTo = s.prototype.slickGoTo =
                function (t, e) {
                    this.changeSlide(
                        { data: { message: "index", index: parseInt(t) } },
                        e,
                    );
                }),
            (s.prototype.init = function (t) {
                var e = this;
                c(e.$slider).hasClass("slick-initialized") ||
                    (c(e.$slider).addClass("slick-initialized"),
                    e.buildRows(),
                    e.buildOut(),
                    e.setProps(),
                    e.startLoad(),
                    e.loadSlider(),
                    e.initializeEvents(),
                    e.updateArrows(),
                    e.updateDots(),
                    e.checkResponsive(!0),
                    e.focusHandler()),
                    t && e.$slider.trigger("init", [e]),
                    !0 === e.options.accessibility && e.initADA(),
                    e.options.autoplay && ((e.paused = !1), e.autoPlay());
            }),
            (s.prototype.initADA = function () {
                var n = this,
                    i = Math.ceil(n.slideCount / n.options.slidesToShow),
                    o = n.getNavigableIndexes().filter(function (t) {
                        return 0 <= t && t < n.slideCount;
                    });
                n.$slides
                    .add(n.$slideTrack.find(".slick-cloned"))
                    .attr({ "aria-hidden": "true", tabindex: "-1" })
                    .find("a, input, button, select")
                    .attr({ tabindex: "-1" }),
                    null !== n.$dots &&
                        (n.$slides
                            .not(n.$slideTrack.find(".slick-cloned"))
                            .each(function (t) {
                                var e = o.indexOf(t);
                                if (
                                    (c(this).attr({
                                        role: "tabpanel",
                                        id: "slick-slide" + n.instanceUid + t,
                                        tabindex: -1,
                                    }),
                                    -1 !== e)
                                ) {
                                    var i =
                                        "slick-slide-control" +
                                        n.instanceUid +
                                        e;
                                    c("#" + i).length &&
                                        c(this).attr({ "aria-describedby": i });
                                }
                            }),
                        n.$dots
                            .attr("role", "tablist")
                            .find("li")
                            .each(function (t) {
                                var e = o[t];
                                c(this).attr({ role: "presentation" }),
                                    c(this)
                                        .find("button")
                                        .first()
                                        .attr({
                                            role: "tab",
                                            id:
                                                "slick-slide-control" +
                                                n.instanceUid +
                                                t,
                                            "aria-controls":
                                                "slick-slide" +
                                                n.instanceUid +
                                                e,
                                            "aria-label": t + 1 + " of " + i,
                                            "aria-selected": null,
                                            tabindex: "-1",
                                        });
                            })
                            .eq(n.currentSlide)
                            .find("button")
                            .attr({ "aria-selected": "true", tabindex: "0" })
                            .end());
                for (
                    var t = n.currentSlide, e = t + n.options.slidesToShow;
                    t < e;
                    t++
                )
                    n.options.focusOnChange
                        ? n.$slides.eq(t).attr({ tabindex: "0" })
                        : n.$slides.eq(t).removeAttr("tabindex");
                n.activateADA();
            }),
            (s.prototype.initArrowEvents = function () {
                var t = this;
                !0 === t.options.arrows &&
                    t.slideCount > t.options.slidesToShow &&
                    (t.$prevArrow
                        .off("click.slick")
                        .on(
                            "click.slick",
                            { message: "previous" },
                            t.changeSlide,
                        ),
                    t.$nextArrow
                        .off("click.slick")
                        .on("click.slick", { message: "next" }, t.changeSlide),
                    !0 === t.options.accessibility &&
                        (t.$prevArrow.on("keydown.slick", t.keyHandler),
                        t.$nextArrow.on("keydown.slick", t.keyHandler)));
            }),
            (s.prototype.initDotEvents = function () {
                var t = this;
                !0 === t.options.dots &&
                    t.slideCount > t.options.slidesToShow &&
                    (c("li", t.$dots).on(
                        "click.slick",
                        { message: "index" },
                        t.changeSlide,
                    ),
                    !0 === t.options.accessibility &&
                        t.$dots.on("keydown.slick", t.keyHandler)),
                    !0 === t.options.dots &&
                        !0 === t.options.pauseOnDotsHover &&
                        t.slideCount > t.options.slidesToShow &&
                        c("li", t.$dots)
                            .on("mouseenter.slick", c.proxy(t.interrupt, t, !0))
                            .on(
                                "mouseleave.slick",
                                c.proxy(t.interrupt, t, !1),
                            );
            }),
            (s.prototype.initSlideEvents = function () {
                this.options.pauseOnHover &&
                    (this.$list.on(
                        "mouseenter.slick",
                        c.proxy(this.interrupt, this, !0),
                    ),
                    this.$list.on(
                        "mouseleave.slick",
                        c.proxy(this.interrupt, this, !1),
                    ));
            }),
            (s.prototype.initializeEvents = function () {
                var t = this;
                t.initArrowEvents(),
                    t.initDotEvents(),
                    t.initSlideEvents(),
                    t.$list.on(
                        "touchstart.slick mousedown.slick",
                        { action: "start" },
                        t.swipeHandler,
                    ),
                    t.$list.on(
                        "touchmove.slick mousemove.slick",
                        { action: "move" },
                        t.swipeHandler,
                    ),
                    t.$list.on(
                        "touchend.slick mouseup.slick",
                        { action: "end" },
                        t.swipeHandler,
                    ),
                    t.$list.on(
                        "touchcancel.slick mouseleave.slick",
                        { action: "end" },
                        t.swipeHandler,
                    ),
                    t.$list.on("click.slick", t.clickHandler),
                    c(document).on(
                        t.visibilityChange,
                        c.proxy(t.visibility, t),
                    ),
                    !0 === t.options.accessibility &&
                        t.$list.on("keydown.slick", t.keyHandler),
                    !0 === t.options.focusOnSelect &&
                        c(t.$slideTrack)
                            .children()
                            .on("click.slick", t.selectHandler),
                    c(window).on(
                        "orientationchange.slick.slick-" + t.instanceUid,
                        c.proxy(t.orientationChange, t),
                    ),
                    c(window).on(
                        "resize.slick.slick-" + t.instanceUid,
                        c.proxy(t.resize, t),
                    ),
                    c("[draggable!=true]", t.$slideTrack).on(
                        "dragstart",
                        t.preventDefault,
                    ),
                    c(window).on(
                        "load.slick.slick-" + t.instanceUid,
                        t.setPosition,
                    ),
                    c(t.setPosition);
            }),
            (s.prototype.initUI = function () {
                !0 === this.options.arrows &&
                    this.slideCount > this.options.slidesToShow &&
                    (this.$prevArrow.show(), this.$nextArrow.show()),
                    !0 === this.options.dots &&
                        this.slideCount > this.options.slidesToShow &&
                        this.$dots.show();
            }),
            (s.prototype.keyHandler = function (t) {
                t.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                    (37 === t.keyCode && !0 === this.options.accessibility
                        ? this.changeSlide({
                              data: {
                                  message:
                                      !0 === this.options.rtl
                                          ? "next"
                                          : "previous",
                              },
                          })
                        : 39 === t.keyCode &&
                          !0 === this.options.accessibility &&
                          this.changeSlide({
                              data: {
                                  message:
                                      !0 === this.options.rtl
                                          ? "previous"
                                          : "next",
                              },
                          }));
            }),
            (s.prototype.lazyLoad = function () {
                var t,
                    e,
                    i,
                    s = this;
                function n(t) {
                    c("img[data-lazy]", t).each(function () {
                        var t = c(this),
                            e = c(this).attr("data-lazy"),
                            i = c(this).attr("data-srcset"),
                            n =
                                c(this).attr("data-sizes") ||
                                s.$slider.attr("data-sizes"),
                            o = document.createElement("img");
                        (o.onload = function () {
                            t.animate({ opacity: 0 }, 100, function () {
                                i &&
                                    (t.attr("srcset", i),
                                    n && t.attr("sizes", n)),
                                    t
                                        .attr("src", e)
                                        .animate(
                                            { opacity: 1 },
                                            200,
                                            function () {
                                                t.removeAttr(
                                                    "data-lazy data-srcset data-sizes",
                                                ).removeClass("slick-loading");
                                            },
                                        ),
                                    s.$slider.trigger("lazyLoaded", [s, t, e]);
                            });
                        }),
                            (o.onerror = function () {
                                t
                                    .removeAttr("data-lazy")
                                    .removeClass("slick-loading")
                                    .addClass("slick-lazyload-error"),
                                    s.$slider.trigger("lazyLoadError", [
                                        s,
                                        t,
                                        e,
                                    ]);
                            }),
                            (o.src = e);
                    });
                }
                if (
                    (!0 === s.options.centerMode
                        ? (i =
                              !0 === s.options.infinite
                                  ? (e =
                                        s.currentSlide +
                                        (s.options.slidesToShow / 2 + 1)) +
                                    s.options.slidesToShow +
                                    2
                                  : ((e = Math.max(
                                        0,
                                        s.currentSlide -
                                            (s.options.slidesToShow / 2 + 1),
                                    )),
                                    s.options.slidesToShow / 2 +
                                        1 +
                                        2 +
                                        s.currentSlide))
                        : ((e = s.options.infinite
                              ? s.options.slidesToShow + s.currentSlide
                              : s.currentSlide),
                          (i = Math.ceil(e + s.options.slidesToShow)),
                          !0 === s.options.fade &&
                              (0 < e && e--, i <= s.slideCount && i++)),
                    (t = s.$slider.find(".slick-slide").slice(e, i)),
                    "anticipated" === s.options.lazyLoad)
                )
                    for (
                        var o = e - 1,
                            r = i,
                            a = s.$slider.find(".slick-slide"),
                            l = 0;
                        l < s.options.slidesToScroll;
                        l++
                    )
                        o < 0 && (o = s.slideCount - 1),
                            (t = (t = t.add(a.eq(o))).add(a.eq(r))),
                            o--,
                            r++;
                n(t),
                    s.slideCount <= s.options.slidesToShow
                        ? n(s.$slider.find(".slick-slide"))
                        : s.currentSlide >=
                            s.slideCount - s.options.slidesToShow
                          ? n(
                                s.$slider
                                    .find(".slick-cloned")
                                    .slice(0, s.options.slidesToShow),
                            )
                          : 0 === s.currentSlide &&
                            n(
                                s.$slider
                                    .find(".slick-cloned")
                                    .slice(-1 * s.options.slidesToShow),
                            );
            }),
            (s.prototype.loadSlider = function () {
                this.setPosition(),
                    this.$slideTrack.css({ opacity: 1 }),
                    this.$slider.removeClass("slick-loading"),
                    this.initUI(),
                    "progressive" === this.options.lazyLoad &&
                        this.progressiveLazyLoad();
            }),
            (s.prototype.next = s.prototype.slickNext =
                function () {
                    this.changeSlide({ data: { message: "next" } });
                }),
            (s.prototype.orientationChange = function () {
                this.checkResponsive(), this.setPosition();
            }),
            (s.prototype.pause = s.prototype.slickPause =
                function () {
                    this.autoPlayClear(), (this.paused = !0);
                }),
            (s.prototype.play = s.prototype.slickPlay =
                function () {
                    this.autoPlay(),
                        (this.options.autoplay = !0),
                        (this.paused = !1),
                        (this.focussed = !1),
                        (this.interrupted = !1);
                }),
            (s.prototype.postSlide = function (t) {
                var e = this;
                e.unslicked ||
                    (e.$slider.trigger("afterChange", [e, t]),
                    (e.animating = !1),
                    e.slideCount > e.options.slidesToShow && e.setPosition(),
                    (e.swipeLeft = null),
                    e.options.autoplay && e.autoPlay(),
                    !0 === e.options.accessibility &&
                        (e.initADA(),
                        e.options.focusOnChange &&
                            c(e.$slides.get(e.currentSlide))
                                .attr("tabindex", 0)
                                .focus()));
            }),
            (s.prototype.prev = s.prototype.slickPrev =
                function () {
                    this.changeSlide({ data: { message: "previous" } });
                }),
            (s.prototype.preventDefault = function (t) {
                t.preventDefault();
            }),
            (s.prototype.progressiveLazyLoad = function (t) {
                t = t || 1;
                var e,
                    i,
                    n,
                    o,
                    s,
                    r = this,
                    a = c("img[data-lazy]", r.$slider);
                a.length
                    ? ((e = a.first()),
                      (i = e.attr("data-lazy")),
                      (n = e.attr("data-srcset")),
                      (o =
                          e.attr("data-sizes") || r.$slider.attr("data-sizes")),
                      ((s = document.createElement("img")).onload =
                          function () {
                              n &&
                                  (e.attr("srcset", n),
                                  o && e.attr("sizes", o)),
                                  e
                                      .attr("src", i)
                                      .removeAttr(
                                          "data-lazy data-srcset data-sizes",
                                      )
                                      .removeClass("slick-loading"),
                                  !0 === r.options.adaptiveHeight &&
                                      r.setPosition(),
                                  r.$slider.trigger("lazyLoaded", [r, e, i]),
                                  r.progressiveLazyLoad();
                          }),
                      (s.onerror = function () {
                          t < 3
                              ? setTimeout(function () {
                                    r.progressiveLazyLoad(t + 1);
                                }, 500)
                              : (e
                                    .removeAttr("data-lazy")
                                    .removeClass("slick-loading")
                                    .addClass("slick-lazyload-error"),
                                r.$slider.trigger("lazyLoadError", [r, e, i]),
                                r.progressiveLazyLoad());
                      }),
                      (s.src = i))
                    : r.$slider.trigger("allImagesLoaded", [r]);
            }),
            (s.prototype.refresh = function (t) {
                var e,
                    i,
                    n = this;
                (i = n.slideCount - n.options.slidesToShow),
                    !n.options.infinite &&
                        n.currentSlide > i &&
                        (n.currentSlide = i),
                    n.slideCount <= n.options.slidesToShow &&
                        (n.currentSlide = 0),
                    (e = n.currentSlide),
                    n.destroy(!0),
                    c.extend(n, n.initials, { currentSlide: e }),
                    n.init(),
                    t ||
                        n.changeSlide(
                            { data: { message: "index", index: e } },
                            !1,
                        );
            }),
            (s.prototype.registerBreakpoints = function () {
                var t,
                    e,
                    i,
                    n = this,
                    o = n.options.responsive || null;
                if ("array" === c.type(o) && o.length) {
                    for (t in ((n.respondTo = n.options.respondTo || "window"),
                    o))
                        if (
                            ((i = n.breakpoints.length - 1),
                            o.hasOwnProperty(t))
                        ) {
                            for (e = o[t].breakpoint; 0 <= i; )
                                n.breakpoints[i] &&
                                    n.breakpoints[i] === e &&
                                    n.breakpoints.splice(i, 1),
                                    i--;
                            n.breakpoints.push(e),
                                (n.breakpointSettings[e] = o[t].settings);
                        }
                    n.breakpoints.sort(function (t, e) {
                        return n.options.mobileFirst ? t - e : e - t;
                    });
                }
            }),
            (s.prototype.reinit = function () {
                var t = this;
                (t.$slides = t.$slideTrack
                    .children(t.options.slide)
                    .addClass("slick-slide")),
                    (t.slideCount = t.$slides.length),
                    t.currentSlide >= t.slideCount &&
                        0 !== t.currentSlide &&
                        (t.currentSlide =
                            t.currentSlide - t.options.slidesToScroll),
                    t.slideCount <= t.options.slidesToShow &&
                        (t.currentSlide = 0),
                    t.registerBreakpoints(),
                    t.setProps(),
                    t.setupInfinite(),
                    t.buildArrows(),
                    t.updateArrows(),
                    t.initArrowEvents(),
                    t.buildDots(),
                    t.updateDots(),
                    t.initDotEvents(),
                    t.cleanUpSlideEvents(),
                    t.initSlideEvents(),
                    t.checkResponsive(!1, !0),
                    !0 === t.options.focusOnSelect &&
                        c(t.$slideTrack)
                            .children()
                            .on("click.slick", t.selectHandler),
                    t.setSlideClasses(
                        "number" == typeof t.currentSlide ? t.currentSlide : 0,
                    ),
                    t.setPosition(),
                    t.focusHandler(),
                    (t.paused = !t.options.autoplay),
                    t.autoPlay(),
                    t.$slider.trigger("reInit", [t]);
            }),
            (s.prototype.resize = function () {
                var t = this;
                c(window).width() !== t.windowWidth &&
                    (clearTimeout(t.windowDelay),
                    (t.windowDelay = window.setTimeout(function () {
                        (t.windowWidth = c(window).width()),
                            t.checkResponsive(),
                            t.unslicked || t.setPosition();
                    }, 50)));
            }),
            (s.prototype.removeSlide = s.prototype.slickRemove =
                function (t, e, i) {
                    var n = this;
                    if (
                        ((t =
                            "boolean" == typeof t
                                ? !0 === (e = t)
                                    ? 0
                                    : n.slideCount - 1
                                : !0 === e
                                  ? --t
                                  : t),
                        n.slideCount < 1 || t < 0 || t > n.slideCount - 1)
                    )
                        return !1;
                    n.unload(),
                        !0 === i
                            ? n.$slideTrack.children().remove()
                            : n.$slideTrack
                                  .children(this.options.slide)
                                  .eq(t)
                                  .remove(),
                        (n.$slides = n.$slideTrack.children(
                            this.options.slide,
                        )),
                        n.$slideTrack.children(this.options.slide).detach(),
                        n.$slideTrack.append(n.$slides),
                        (n.$slidesCache = n.$slides),
                        n.reinit();
                }),
            (s.prototype.setCSS = function (t) {
                var e,
                    i,
                    n = this,
                    o = {};
                !0 === n.options.rtl && (t = -t),
                    (e =
                        "left" == n.positionProp ? Math.ceil(t) + "px" : "0px"),
                    (i = "top" == n.positionProp ? Math.ceil(t) + "px" : "0px"),
                    (o[n.positionProp] = t),
                    !1 === n.transformsEnabled ||
                        (!(o = {}) === n.cssTransitions
                            ? (o[n.animType] =
                                  "translate(" + e + ", " + i + ")")
                            : (o[n.animType] =
                                  "translate3d(" + e + ", " + i + ", 0px)")),
                    n.$slideTrack.css(o);
            }),
            (s.prototype.setDimensions = function () {
                var t = this;
                !1 === t.options.vertical
                    ? !0 === t.options.centerMode &&
                      t.$list.css({ padding: "0px " + t.options.centerPadding })
                    : (t.$list.height(
                          t.$slides.first().outerHeight(!0) *
                              t.options.slidesToShow,
                      ),
                      !0 === t.options.centerMode &&
                          t.$list.css({
                              padding: t.options.centerPadding + " 0px",
                          })),
                    (t.listWidth = t.$list.width()),
                    (t.listHeight = t.$list.height()),
                    !1 === t.options.vertical && !1 === t.options.variableWidth
                        ? ((t.slideWidth = Math.ceil(
                              t.listWidth / t.options.slidesToShow,
                          )),
                          t.$slideTrack.width(
                              Math.ceil(
                                  t.slideWidth *
                                      t.$slideTrack.children(".slick-slide")
                                          .length,
                              ),
                          ))
                        : !0 === t.options.variableWidth
                          ? t.$slideTrack.width(5e3 * t.slideCount)
                          : ((t.slideWidth = Math.ceil(t.listWidth)),
                            t.$slideTrack.height(
                                Math.ceil(
                                    t.$slides.first().outerHeight(!0) *
                                        t.$slideTrack.children(".slick-slide")
                                            .length,
                                ),
                            ));
                var e =
                    t.$slides.first().outerWidth(!0) -
                    t.$slides.first().width();
                !1 === t.options.variableWidth &&
                    t.$slideTrack
                        .children(".slick-slide")
                        .width(t.slideWidth - e);
            }),
            (s.prototype.setFade = function () {
                var i,
                    n = this;
                n.$slides.each(function (t, e) {
                    (i = n.slideWidth * t * -1),
                        !0 === n.options.rtl
                            ? c(e).css({
                                  position: "relative",
                                  right: i,
                                  top: 0,
                                  zIndex: n.options.zIndex - 2,
                                  opacity: 0,
                              })
                            : c(e).css({
                                  position: "relative",
                                  left: i,
                                  top: 0,
                                  zIndex: n.options.zIndex - 2,
                                  opacity: 0,
                              });
                }),
                    n.$slides
                        .eq(n.currentSlide)
                        .css({ zIndex: n.options.zIndex - 1, opacity: 1 });
            }),
            (s.prototype.setHeight = function () {
                if (
                    1 === this.options.slidesToShow &&
                    !0 === this.options.adaptiveHeight &&
                    !1 === this.options.vertical
                ) {
                    var t = this.$slides.eq(this.currentSlide).outerHeight(!0);
                    this.$list.css("height", t);
                }
            }),
            (s.prototype.setOption = s.prototype.slickSetOption =
                function () {
                    var t,
                        e,
                        i,
                        n,
                        o,
                        s = this,
                        r = !1;
                    if (
                        ("object" === c.type(arguments[0])
                            ? ((i = arguments[0]),
                              (r = arguments[1]),
                              (o = "multiple"))
                            : "string" === c.type(arguments[0]) &&
                              ((n = arguments[1]),
                              (r = arguments[2]),
                              "responsive" === (i = arguments[0]) &&
                              "array" === c.type(arguments[1])
                                  ? (o = "responsive")
                                  : void 0 !== arguments[1] && (o = "single")),
                        "single" === o)
                    )
                        s.options[i] = n;
                    else if ("multiple" === o)
                        c.each(i, function (t, e) {
                            s.options[t] = e;
                        });
                    else if ("responsive" === o)
                        for (e in n)
                            if ("array" !== c.type(s.options.responsive))
                                s.options.responsive = [n[e]];
                            else {
                                for (
                                    t = s.options.responsive.length - 1;
                                    0 <= t;

                                )
                                    s.options.responsive[t].breakpoint ===
                                        n[e].breakpoint &&
                                        s.options.responsive.splice(t, 1),
                                        t--;
                                s.options.responsive.push(n[e]);
                            }
                    r && (s.unload(), s.reinit());
                }),
            (s.prototype.setPosition = function () {
                this.setDimensions(),
                    this.setHeight(),
                    !1 === this.options.fade
                        ? this.setCSS(this.getLeft(this.currentSlide))
                        : this.setFade(),
                    this.$slider.trigger("setPosition", [this]);
            }),
            (s.prototype.setProps = function () {
                var t = this,
                    e = document.body.style;
                (t.positionProp = !0 === t.options.vertical ? "top" : "left"),
                    "top" === t.positionProp
                        ? t.$slider.addClass("slick-vertical")
                        : t.$slider.removeClass("slick-vertical"),
                    (void 0 === e.WebkitTransition &&
                        void 0 === e.MozTransition &&
                        void 0 === e.msTransition) ||
                        (!0 === t.options.useCSS && (t.cssTransitions = !0)),
                    t.options.fade &&
                        ("number" == typeof t.options.zIndex
                            ? t.options.zIndex < 3 && (t.options.zIndex = 3)
                            : (t.options.zIndex = t.defaults.zIndex)),
                    void 0 !== e.OTransform &&
                        ((t.animType = "OTransform"),
                        (t.transformType = "-o-transform"),
                        (t.transitionType = "OTransition"),
                        void 0 === e.perspectiveProperty &&
                            void 0 === e.webkitPerspective &&
                            (t.animType = !1)),
                    void 0 !== e.MozTransform &&
                        ((t.animType = "MozTransform"),
                        (t.transformType = "-moz-transform"),
                        (t.transitionType = "MozTransition"),
                        void 0 === e.perspectiveProperty &&
                            void 0 === e.MozPerspective &&
                            (t.animType = !1)),
                    void 0 !== e.webkitTransform &&
                        ((t.animType = "webkitTransform"),
                        (t.transformType = "-webkit-transform"),
                        (t.transitionType = "webkitTransition"),
                        void 0 === e.perspectiveProperty &&
                            void 0 === e.webkitPerspective &&
                            (t.animType = !1)),
                    void 0 !== e.msTransform &&
                        ((t.animType = "msTransform"),
                        (t.transformType = "-ms-transform"),
                        (t.transitionType = "msTransition"),
                        void 0 === e.msTransform && (t.animType = !1)),
                    void 0 !== e.transform &&
                        !1 !== t.animType &&
                        ((t.animType = "transform"),
                        (t.transformType = "transform"),
                        (t.transitionType = "transition")),
                    (t.transformsEnabled =
                        t.options.useTransform &&
                        null !== t.animType &&
                        !1 !== t.animType);
            }),
            (s.prototype.setSlideClasses = function (t) {
                var e,
                    i,
                    n,
                    o,
                    s = this;
                if (
                    ((i = s.$slider
                        .find(".slick-slide")
                        .removeClass("slick-active slick-center slick-current")
                        .attr("aria-hidden", "true")),
                    s.$slides.eq(t).addClass("slick-current"),
                    !0 === s.options.centerMode)
                ) {
                    var r = s.options.slidesToShow % 2 == 0 ? 1 : 0;
                    (e = Math.floor(s.options.slidesToShow / 2)),
                        !0 === s.options.infinite &&
                            (e <= t && t <= s.slideCount - 1 - e
                                ? s.$slides
                                      .slice(t - e + r, t + e + 1)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")
                                : ((n = s.options.slidesToShow + t),
                                  i
                                      .slice(n - e + 1 + r, n + e + 2)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")),
                            0 === t
                                ? i
                                      .eq(i.length - 1 - s.options.slidesToShow)
                                      .addClass("slick-center")
                                : t === s.slideCount - 1 &&
                                  i
                                      .eq(s.options.slidesToShow)
                                      .addClass("slick-center")),
                        s.$slides.eq(t).addClass("slick-center");
                } else
                    0 <= t && t <= s.slideCount - s.options.slidesToShow
                        ? s.$slides
                              .slice(t, t + s.options.slidesToShow)
                              .addClass("slick-active")
                              .attr("aria-hidden", "false")
                        : i.length <= s.options.slidesToShow
                          ? i
                                .addClass("slick-active")
                                .attr("aria-hidden", "false")
                          : ((o = s.slideCount % s.options.slidesToShow),
                            (n =
                                !0 === s.options.infinite
                                    ? s.options.slidesToShow + t
                                    : t),
                            s.options.slidesToShow ==
                                s.options.slidesToScroll &&
                            s.slideCount - t < s.options.slidesToShow
                                ? i
                                      .slice(
                                          n - (s.options.slidesToShow - o),
                                          n + o,
                                      )
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")
                                : i
                                      .slice(n, n + s.options.slidesToShow)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false"));
                ("ondemand" !== s.options.lazyLoad &&
                    "anticipated" !== s.options.lazyLoad) ||
                    s.lazyLoad();
            }),
            (s.prototype.setupInfinite = function () {
                var t,
                    e,
                    i,
                    n = this;
                if (
                    (!0 === n.options.fade && (n.options.centerMode = !1),
                    !0 === n.options.infinite &&
                        !1 === n.options.fade &&
                        ((e = null), n.slideCount > n.options.slidesToShow))
                ) {
                    for (
                        i =
                            !0 === n.options.centerMode
                                ? n.options.slidesToShow + 1
                                : n.options.slidesToShow,
                            t = n.slideCount;
                        t > n.slideCount - i;
                        --t
                    )
                        (e = t - 1),
                            c(n.$slides[e])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", e - n.slideCount)
                                .prependTo(n.$slideTrack)
                                .addClass("slick-cloned");
                    for (t = 0; t < i + n.slideCount; t += 1)
                        (e = t),
                            c(n.$slides[e])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", e + n.slideCount)
                                .appendTo(n.$slideTrack)
                                .addClass("slick-cloned");
                    n.$slideTrack
                        .find(".slick-cloned")
                        .find("[id]")
                        .each(function () {
                            c(this).attr("id", "");
                        });
                }
            }),
            (s.prototype.interrupt = function (t) {
                t || this.autoPlay(), (this.interrupted = t);
            }),
            (s.prototype.selectHandler = function (t) {
                var e = c(t.target).is(".slick-slide")
                        ? c(t.target)
                        : c(t.target).parents(".slick-slide"),
                    i = parseInt(e.attr("data-slick-index"));
                (i = i || 0),
                    this.slideCount <= this.options.slidesToShow
                        ? this.slideHandler(i, !1, !0)
                        : this.slideHandler(i);
            }),
            (s.prototype.slideHandler = function (t, e, i) {
                var n,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c = this;
                if (
                    ((e = e || !1),
                    !(
                        (!0 === c.animating &&
                            !0 === c.options.waitForAnimate) ||
                        (!0 === c.options.fade && c.currentSlide === t)
                    ))
                )
                    if (
                        (!1 === e && c.asNavFor(t),
                        (n = t),
                        (a = c.getLeft(n)),
                        (r = c.getLeft(c.currentSlide)),
                        (c.currentLeft =
                            null === c.swipeLeft ? r : c.swipeLeft),
                        !1 === c.options.infinite &&
                            !1 === c.options.centerMode &&
                            (t < 0 ||
                                t > c.getDotCount() * c.options.slidesToScroll))
                    )
                        !1 === c.options.fade &&
                            ((n = c.currentSlide),
                            !0 !== i && c.slideCount > c.options.slidesToShow
                                ? c.animateSlide(r, function () {
                                      c.postSlide(n);
                                  })
                                : c.postSlide(n));
                    else if (
                        !1 === c.options.infinite &&
                        !0 === c.options.centerMode &&
                        (t < 0 || t > c.slideCount - c.options.slidesToScroll)
                    )
                        !1 === c.options.fade &&
                            ((n = c.currentSlide),
                            !0 !== i && c.slideCount > c.options.slidesToShow
                                ? c.animateSlide(r, function () {
                                      c.postSlide(n);
                                  })
                                : c.postSlide(n));
                    else {
                        if (
                            (c.options.autoplay &&
                                clearInterval(c.autoPlayTimer),
                            (o =
                                n < 0
                                    ? c.slideCount % c.options.slidesToScroll !=
                                      0
                                        ? c.slideCount -
                                          (c.slideCount %
                                              c.options.slidesToScroll)
                                        : c.slideCount + n
                                    : n >= c.slideCount
                                      ? c.slideCount %
                                            c.options.slidesToScroll !=
                                        0
                                          ? 0
                                          : n - c.slideCount
                                      : n),
                            (c.animating = !0),
                            c.$slider.trigger("beforeChange", [
                                c,
                                c.currentSlide,
                                o,
                            ]),
                            (s = c.currentSlide),
                            (c.currentSlide = o),
                            c.setSlideClasses(c.currentSlide),
                            c.options.asNavFor &&
                                (l = (l = c.getNavTarget()).slick("getSlick"))
                                    .slideCount <= l.options.slidesToShow &&
                                l.setSlideClasses(c.currentSlide),
                            c.updateDots(),
                            c.updateArrows(),
                            !0 === c.options.fade)
                        )
                            return (
                                !0 !== i
                                    ? (c.fadeSlideOut(s),
                                      c.fadeSlide(o, function () {
                                          c.postSlide(o);
                                      }))
                                    : c.postSlide(o),
                                void c.animateHeight()
                            );
                        !0 !== i && c.slideCount > c.options.slidesToShow
                            ? c.animateSlide(a, function () {
                                  c.postSlide(o);
                              })
                            : c.postSlide(o);
                    }
            }),
            (s.prototype.startLoad = function () {
                var t = this;
                !0 === t.options.arrows &&
                    t.slideCount > t.options.slidesToShow &&
                    (t.$prevArrow.hide(), t.$nextArrow.hide()),
                    !0 === t.options.dots &&
                        t.slideCount > t.options.slidesToShow &&
                        t.$dots.hide(),
                    t.$slider.addClass("slick-loading");
            }),
            (s.prototype.swipeDirection = function () {
                var t, e, i, n;
                return (
                    (t = this.touchObject.startX - this.touchObject.curX),
                    (e = this.touchObject.startY - this.touchObject.curY),
                    (i = Math.atan2(e, t)),
                    (n = Math.round((180 * i) / Math.PI)) < 0 &&
                        (n = 360 - Math.abs(n)),
                    (n <= 45 && 0 <= n) || (n <= 360 && 315 <= n)
                        ? !1 === this.options.rtl
                            ? "left"
                            : "right"
                        : 135 <= n && n <= 225
                          ? !1 === this.options.rtl
                              ? "right"
                              : "left"
                          : !0 === this.options.verticalSwiping
                            ? 35 <= n && n <= 135
                                ? "down"
                                : "up"
                            : "vertical"
                );
            }),
            (s.prototype.swipeEnd = function (t) {
                var e,
                    i,
                    n = this;
                if (((n.dragging = !1), (n.swiping = !1), n.scrolling))
                    return (n.scrolling = !1);
                if (
                    ((n.interrupted = !1),
                    (n.shouldClick = !(10 < n.touchObject.swipeLength)),
                    void 0 === n.touchObject.curX)
                )
                    return !1;
                if (
                    (!0 === n.touchObject.edgeHit &&
                        n.$slider.trigger("edge", [n, n.swipeDirection()]),
                    n.touchObject.swipeLength >= n.touchObject.minSwipe)
                ) {
                    switch ((i = n.swipeDirection())) {
                        case "left":
                        case "down":
                            (e = n.options.swipeToSlide
                                ? n.checkNavigable(
                                      n.currentSlide + n.getSlideCount(),
                                  )
                                : n.currentSlide + n.getSlideCount()),
                                (n.currentDirection = 0);
                            break;
                        case "right":
                        case "up":
                            (e = n.options.swipeToSlide
                                ? n.checkNavigable(
                                      n.currentSlide - n.getSlideCount(),
                                  )
                                : n.currentSlide - n.getSlideCount()),
                                (n.currentDirection = 1);
                    }
                    "vertical" != i &&
                        (n.slideHandler(e),
                        (n.touchObject = {}),
                        n.$slider.trigger("swipe", [n, i]));
                } else
                    n.touchObject.startX !== n.touchObject.curX &&
                        (n.slideHandler(n.currentSlide), (n.touchObject = {}));
            }),
            (s.prototype.swipeHandler = function (t) {
                var e = this;
                if (
                    !(
                        !1 === e.options.swipe ||
                        ("ontouchend" in document && !1 === e.options.swipe) ||
                        (!1 === e.options.draggable &&
                            -1 !== t.type.indexOf("mouse"))
                    )
                )
                    switch (
                        ((e.touchObject.fingerCount =
                            t.originalEvent &&
                            void 0 !== t.originalEvent.touches
                                ? t.originalEvent.touches.length
                                : 1),
                        (e.touchObject.minSwipe =
                            e.listWidth / e.options.touchThreshold),
                        !0 === e.options.verticalSwiping &&
                            (e.touchObject.minSwipe =
                                e.listHeight / e.options.touchThreshold),
                        t.data.action)
                    ) {
                        case "start":
                            e.swipeStart(t);
                            break;
                        case "move":
                            e.swipeMove(t);
                            break;
                        case "end":
                            e.swipeEnd(t);
                    }
            }),
            (s.prototype.swipeMove = function (t) {
                var e,
                    i,
                    n,
                    o,
                    s,
                    r,
                    a = this;
                return (
                    (s =
                        void 0 !== t.originalEvent
                            ? t.originalEvent.touches
                            : null),
                    !(!a.dragging || a.scrolling || (s && 1 !== s.length)) &&
                        ((e = a.getLeft(a.currentSlide)),
                        (a.touchObject.curX =
                            void 0 !== s ? s[0].pageX : t.clientX),
                        (a.touchObject.curY =
                            void 0 !== s ? s[0].pageY : t.clientY),
                        (a.touchObject.swipeLength = Math.round(
                            Math.sqrt(
                                Math.pow(
                                    a.touchObject.curX - a.touchObject.startX,
                                    2,
                                ),
                            ),
                        )),
                        (r = Math.round(
                            Math.sqrt(
                                Math.pow(
                                    a.touchObject.curY - a.touchObject.startY,
                                    2,
                                ),
                            ),
                        )),
                        !a.options.verticalSwiping && !a.swiping && 4 < r
                            ? !(a.scrolling = !0)
                            : (!0 === a.options.verticalSwiping &&
                                  (a.touchObject.swipeLength = r),
                              (i = a.swipeDirection()),
                              void 0 !== t.originalEvent &&
                                  4 < a.touchObject.swipeLength &&
                                  ((a.swiping = !0), t.preventDefault()),
                              (o =
                                  (!1 === a.options.rtl ? 1 : -1) *
                                  (a.touchObject.curX > a.touchObject.startX
                                      ? 1
                                      : -1)),
                              !0 === a.options.verticalSwiping &&
                                  (o =
                                      a.touchObject.curY > a.touchObject.startY
                                          ? 1
                                          : -1),
                              (n = a.touchObject.swipeLength),
                              (a.touchObject.edgeHit = !1) ===
                                  a.options.infinite &&
                                  ((0 === a.currentSlide && "right" === i) ||
                                      (a.currentSlide >= a.getDotCount() &&
                                          "left" === i)) &&
                                  ((n =
                                      a.touchObject.swipeLength *
                                      a.options.edgeFriction),
                                  (a.touchObject.edgeHit = !0)),
                              !1 === a.options.vertical
                                  ? (a.swipeLeft = e + n * o)
                                  : (a.swipeLeft =
                                        e +
                                        n *
                                            (a.$list.height() / a.listWidth) *
                                            o),
                              !0 === a.options.verticalSwiping &&
                                  (a.swipeLeft = e + n * o),
                              !0 !== a.options.fade &&
                                  !1 !== a.options.touchMove &&
                                  (!0 === a.animating
                                      ? ((a.swipeLeft = null), !1)
                                      : void a.setCSS(a.swipeLeft))))
                );
            }),
            (s.prototype.swipeStart = function (t) {
                var e,
                    i = this;
                if (
                    ((i.interrupted = !0),
                    1 !== i.touchObject.fingerCount ||
                        i.slideCount <= i.options.slidesToShow)
                )
                    return !(i.touchObject = {});
                void 0 !== t.originalEvent &&
                    void 0 !== t.originalEvent.touches &&
                    (e = t.originalEvent.touches[0]),
                    (i.touchObject.startX = i.touchObject.curX =
                        void 0 !== e ? e.pageX : t.clientX),
                    (i.touchObject.startY = i.touchObject.curY =
                        void 0 !== e ? e.pageY : t.clientY),
                    (i.dragging = !0);
            }),
            (s.prototype.unfilterSlides = s.prototype.slickUnfilter =
                function () {
                    null !== this.$slidesCache &&
                        (this.unload(),
                        this.$slideTrack.children(this.options.slide).detach(),
                        this.$slidesCache.appendTo(this.$slideTrack),
                        this.reinit());
                }),
            (s.prototype.unload = function () {
                var t = this;
                c(".slick-cloned", t.$slider).remove(),
                    t.$dots && t.$dots.remove(),
                    t.$prevArrow &&
                        t.htmlExpr.test(t.options.prevArrow) &&
                        t.$prevArrow.remove(),
                    t.$nextArrow &&
                        t.htmlExpr.test(t.options.nextArrow) &&
                        t.$nextArrow.remove(),
                    t.$slides
                        .removeClass(
                            "slick-slide slick-active slick-visible slick-current",
                        )
                        .attr("aria-hidden", "true")
                        .css("width", "");
            }),
            (s.prototype.unslick = function (t) {
                this.$slider.trigger("unslick", [this, t]), this.destroy();
            }),
            (s.prototype.updateArrows = function () {
                var t = this;
                Math.floor(t.options.slidesToShow / 2),
                    !0 === t.options.arrows &&
                        t.slideCount > t.options.slidesToShow &&
                        !t.options.infinite &&
                        (t.$prevArrow
                            .removeClass("slick-disabled")
                            .attr("aria-disabled", "false"),
                        t.$nextArrow
                            .removeClass("slick-disabled")
                            .attr("aria-disabled", "false"),
                        0 === t.currentSlide
                            ? (t.$prevArrow
                                  .addClass("slick-disabled")
                                  .attr("aria-disabled", "true"),
                              t.$nextArrow
                                  .removeClass("slick-disabled")
                                  .attr("aria-disabled", "false"))
                            : ((t.currentSlide >=
                                  t.slideCount - t.options.slidesToShow &&
                                  !1 === t.options.centerMode) ||
                                  (t.currentSlide >= t.slideCount - 1 &&
                                      !0 === t.options.centerMode)) &&
                              (t.$nextArrow
                                  .addClass("slick-disabled")
                                  .attr("aria-disabled", "true"),
                              t.$prevArrow
                                  .removeClass("slick-disabled")
                                  .attr("aria-disabled", "false")));
            }),
            (s.prototype.updateDots = function () {
                null !== this.$dots &&
                    (this.$dots.find("li").removeClass("slick-active").end(),
                    this.$dots
                        .find("li")
                        .eq(
                            Math.floor(
                                this.currentSlide / this.options.slidesToScroll,
                            ),
                        )
                        .addClass("slick-active"));
            }),
            (s.prototype.visibility = function () {
                this.options.autoplay &&
                    (document[this.hidden]
                        ? (this.interrupted = !0)
                        : (this.interrupted = !1));
            }),
            (c.fn.slick = function () {
                var t,
                    e,
                    i = arguments[0],
                    n = Array.prototype.slice.call(arguments, 1),
                    o = this.length;
                for (t = 0; t < o; t++)
                    if (
                        ("object" == typeof i || void 0 === i
                            ? (this[t].slick = new s(this[t], i))
                            : (e = this[t].slick[i].apply(this[t].slick, n)),
                        void 0 !== e)
                    )
                        return e;
                return this;
            });
    }),
    (function (t) {
        "function" == typeof define && define.amd && define.amd.jQuery
            ? define(["jquery"], t)
            : t(
                  "undefined" != typeof module && module.exports
                      ? require("jquery")
                      : jQuery,
              );
    })(function (at) {
        "use strict";
        function n(t, g) {
            function e(t) {
                if (
                    !(
                        !0 === K.data(Pt + "_intouch") ||
                        0 < at(t.target).closest(g.excludedElements, K).length
                    )
                ) {
                    var e = t.originalEvent ? t.originalEvent : t;
                    if (
                        !e.pointerType ||
                        "mouse" != e.pointerType ||
                        0 != g.fallbackToMouseEvents
                    ) {
                        var i,
                            n = e.touches,
                            o = n ? n[0] : e;
                        return (
                            (G = Ct),
                            n
                                ? (Z = n.length)
                                : !1 !== g.preventDefaultEvents &&
                                  t.preventDefault(),
                            (X = W = R = null),
                            (Q = 1),
                            (Y = U = B = q = N = 0),
                            ((s = {})[lt] = I(lt)),
                            (s[ct] = I(ct)),
                            (s[ht] = I(ht)),
                            (s[dt] = I(dt)),
                            (V = s),
                            S(),
                            k(0, o),
                            !n || Z === g.fingers || g.fingers === St || y()
                                ? ((tt = D()),
                                  2 == Z &&
                                      (k(1, n[1]),
                                      (B = U = O(J[0].start, J[1].start))),
                                  (g.swipeStatus || g.pinchStatus) &&
                                      (i = v(e, G)))
                                : (i = !1),
                            !1 === i
                                ? (v(e, (G = $t)), i)
                                : (g.hold &&
                                      (rt = setTimeout(
                                          at.proxy(function () {
                                              K.trigger("hold", [e.target]),
                                                  g.hold &&
                                                      (i = g.hold.call(
                                                          K,
                                                          e,
                                                          e.target,
                                                      ));
                                          }, this),
                                          g.longTapThreshold,
                                      )),
                                  C(!0),
                                  null)
                        );
                    }
                }
                var s;
            }
            function i(t) {
                var e,
                    i,
                    n,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c = t.originalEvent ? t.originalEvent : t;
                if (G !== Et && G !== $t && !T()) {
                    var h,
                        d = c.touches,
                        u = E(d ? d[0] : c);
                    if (
                        ((et = D()),
                        d && (Z = d.length),
                        g.hold && clearTimeout(rt),
                        (G = kt),
                        2 == Z &&
                            (0 == B
                                ? (k(1, d[1]),
                                  (B = U = O(J[0].start, J[1].start)))
                                : (E(d[1]),
                                  (U = O(J[0].end, J[1].end)),
                                  J[0].end,
                                  J[1].end,
                                  (X = Q < 1 ? pt : ut)),
                            (Q = ((U / B) * 1).toFixed(2)),
                            (Y = Math.abs(B - U))),
                        Z === g.fingers || g.fingers === St || !d || y())
                    ) {
                        if (
                            ((R = P(u.start, u.end)),
                            (function (t, e) {
                                if (!1 !== g.preventDefaultEvents)
                                    if (g.allowPageScroll === ft)
                                        t.preventDefault();
                                    else {
                                        var i = g.allowPageScroll === gt;
                                        switch (e) {
                                            case lt:
                                                ((g.swipeLeft && i) ||
                                                    (!i &&
                                                        g.allowPageScroll !=
                                                            wt)) &&
                                                    t.preventDefault();
                                                break;
                                            case ct:
                                                ((g.swipeRight && i) ||
                                                    (!i &&
                                                        g.allowPageScroll !=
                                                            wt)) &&
                                                    t.preventDefault();
                                                break;
                                            case ht:
                                                ((g.swipeUp && i) ||
                                                    (!i &&
                                                        g.allowPageScroll !=
                                                            xt)) &&
                                                    t.preventDefault();
                                                break;
                                            case dt:
                                                ((g.swipeDown && i) ||
                                                    (!i &&
                                                        g.allowPageScroll !=
                                                            xt)) &&
                                                    t.preventDefault();
                                        }
                                    }
                            })(t, (W = P(u.last, u.end))),
                            (a = u.start),
                            (l = u.end),
                            (N = Math.round(
                                Math.sqrt(
                                    Math.pow(l.x - a.x, 2) +
                                        Math.pow(l.y - a.y, 2),
                                ),
                            )),
                            (q = A()),
                            (r = N),
                            (s = R) != ft &&
                                ((r = Math.max(r, $(s))), (V[s].distance = r)),
                            (h = v(c, G)),
                            !g.triggerOnTouchEnd || g.triggerOnTouchLeave)
                        ) {
                            var p = !0;
                            if (g.triggerOnTouchLeave) {
                                var f = {
                                    left: (o = (n = at((n = this))).offset())
                                        .left,
                                    right: o.left + n.outerWidth(),
                                    top: o.top,
                                    bottom: o.top + n.outerHeight(),
                                };
                                (e = u.end),
                                    (i = f),
                                    (p =
                                        e.x > i.left &&
                                        e.x < i.right &&
                                        e.y > i.top &&
                                        e.y < i.bottom);
                            }
                            !g.triggerOnTouchEnd && p
                                ? (G = m(kt))
                                : g.triggerOnTouchLeave && !p && (G = m(Et)),
                                (G != $t && G != Et) || v(c, G);
                        }
                    } else v(c, (G = $t));
                    !1 === h && v(c, (G = $t));
                }
            }
            function n(t) {
                var e,
                    i = t.originalEvent ? t.originalEvent : t,
                    n = i.touches;
                if (n) {
                    if (n.length && !T())
                        return (
                            (e = i), (it = D()), (nt = e.touches.length + 1), !0
                        );
                    if (n.length && T()) return !0;
                }
                return (
                    T() && (Z = nt),
                    (et = D()),
                    (q = A()),
                    c() || !l()
                        ? v(i, (G = $t))
                        : g.triggerOnTouchEnd ||
                            (!1 === g.triggerOnTouchEnd && G === kt)
                          ? (!1 !== g.preventDefaultEvents &&
                                !1 !== t.cancelable &&
                                t.preventDefault(),
                            v(i, (G = Et)))
                          : !g.triggerOnTouchEnd && b()
                            ? a(i, (G = Et), yt)
                            : G === kt && v(i, (G = $t)),
                    C(!1),
                    null
                );
            }
            function o() {
                (U = B = tt = et = Z = 0), S(), C(!(Q = 1));
            }
            function s(t) {
                var e = t.originalEvent ? t.originalEvent : t;
                g.triggerOnTouchLeave && v(e, (G = m(Et)));
            }
            function r() {
                K.unbind(L, e),
                    K.unbind(H, o),
                    K.unbind(j, i),
                    K.unbind(z, n),
                    F && K.unbind(F, s),
                    C(!1);
            }
            function m(t) {
                var e = t,
                    i = h(),
                    n = l(),
                    o = c();
                return (
                    !i || o
                        ? (e = $t)
                        : !n ||
                            t != kt ||
                            (g.triggerOnTouchEnd && !g.triggerOnTouchLeave)
                          ? !n && t == Et && g.triggerOnTouchLeave && (e = $t)
                          : (e = Et),
                    e
                );
            }
            function v(t, e) {
                var i,
                    n = t.touches;
                return (
                    ((u() && p()) || p()) && (i = a(t, e, mt)),
                    ((d() && y()) || y()) && !1 !== i && (i = a(t, e, vt)),
                    x() && w() && !1 !== i
                        ? (i = a(t, e, _t))
                        : q > g.longTapThreshold &&
                            N < Tt &&
                            g.longTap &&
                            !1 !== i
                          ? (i = a(t, e, bt))
                          : (1 !== Z && It) ||
                            !(isNaN(N) || N < g.threshold) ||
                            !b() ||
                            !1 === i ||
                            (i = a(t, e, yt)),
                    e === $t && o(),
                    e === Et && ((n && n.length) || o()),
                    i
                );
            }
            function a(t, e, i) {
                var n;
                if (i == mt) {
                    if (
                        (K.trigger("swipeStatus", [
                            e,
                            R || null,
                            N || 0,
                            q || 0,
                            Z,
                            J,
                            W,
                        ]),
                        g.swipeStatus &&
                            !1 ===
                                (n = g.swipeStatus.call(
                                    K,
                                    t,
                                    e,
                                    R || null,
                                    N || 0,
                                    q || 0,
                                    Z,
                                    J,
                                    W,
                                )))
                    )
                        return !1;
                    if (e == Et && u()) {
                        if (
                            (clearTimeout(st),
                            clearTimeout(rt),
                            K.trigger("swipe", [R, N, q, Z, J, W]),
                            g.swipe &&
                                !1 ===
                                    (n = g.swipe.call(K, t, R, N, q, Z, J, W)))
                        )
                            return !1;
                        switch (R) {
                            case lt:
                                K.trigger("swipeLeft", [R, N, q, Z, J, W]),
                                    g.swipeLeft &&
                                        (n = g.swipeLeft.call(
                                            K,
                                            t,
                                            R,
                                            N,
                                            q,
                                            Z,
                                            J,
                                            W,
                                        ));
                                break;
                            case ct:
                                K.trigger("swipeRight", [R, N, q, Z, J, W]),
                                    g.swipeRight &&
                                        (n = g.swipeRight.call(
                                            K,
                                            t,
                                            R,
                                            N,
                                            q,
                                            Z,
                                            J,
                                            W,
                                        ));
                                break;
                            case ht:
                                K.trigger("swipeUp", [R, N, q, Z, J, W]),
                                    g.swipeUp &&
                                        (n = g.swipeUp.call(
                                            K,
                                            t,
                                            R,
                                            N,
                                            q,
                                            Z,
                                            J,
                                            W,
                                        ));
                                break;
                            case dt:
                                K.trigger("swipeDown", [R, N, q, Z, J, W]),
                                    g.swipeDown &&
                                        (n = g.swipeDown.call(
                                            K,
                                            t,
                                            R,
                                            N,
                                            q,
                                            Z,
                                            J,
                                            W,
                                        ));
                        }
                    }
                }
                if (i == vt) {
                    if (
                        (K.trigger("pinchStatus", [
                            e,
                            X || null,
                            Y || 0,
                            q || 0,
                            Z,
                            Q,
                            J,
                        ]),
                        g.pinchStatus &&
                            !1 ===
                                (n = g.pinchStatus.call(
                                    K,
                                    t,
                                    e,
                                    X || null,
                                    Y || 0,
                                    q || 0,
                                    Z,
                                    Q,
                                    J,
                                )))
                    )
                        return !1;
                    if (e == Et && d())
                        switch (X) {
                            case ut:
                                K.trigger("pinchIn", [
                                    X || null,
                                    Y || 0,
                                    q || 0,
                                    Z,
                                    Q,
                                    J,
                                ]),
                                    g.pinchIn &&
                                        (n = g.pinchIn.call(
                                            K,
                                            t,
                                            X || null,
                                            Y || 0,
                                            q || 0,
                                            Z,
                                            Q,
                                            J,
                                        ));
                                break;
                            case pt:
                                K.trigger("pinchOut", [
                                    X || null,
                                    Y || 0,
                                    q || 0,
                                    Z,
                                    Q,
                                    J,
                                ]),
                                    g.pinchOut &&
                                        (n = g.pinchOut.call(
                                            K,
                                            t,
                                            X || null,
                                            Y || 0,
                                            q || 0,
                                            Z,
                                            Q,
                                            J,
                                        ));
                        }
                }
                return (
                    i == yt
                        ? (e !== $t && e !== Et) ||
                          (clearTimeout(st),
                          clearTimeout(rt),
                          w() && !x()
                              ? ((ot = D()),
                                (st = setTimeout(
                                    at.proxy(function () {
                                        (ot = null),
                                            K.trigger("tap", [t.target]),
                                            g.tap &&
                                                (n = g.tap.call(
                                                    K,
                                                    t,
                                                    t.target,
                                                ));
                                    }, this),
                                    g.doubleTapThreshold,
                                )))
                              : ((ot = null),
                                K.trigger("tap", [t.target]),
                                g.tap && (n = g.tap.call(K, t, t.target))))
                        : i == _t
                          ? (e !== $t && e !== Et) ||
                            (clearTimeout(st),
                            clearTimeout(rt),
                            (ot = null),
                            K.trigger("doubletap", [t.target]),
                            g.doubleTap &&
                                (n = g.doubleTap.call(K, t, t.target)))
                          : i == bt &&
                            ((e !== $t && e !== Et) ||
                                (clearTimeout(st),
                                (ot = null),
                                K.trigger("longtap", [t.target]),
                                g.longTap &&
                                    (n = g.longTap.call(K, t, t.target)))),
                    n
                );
            }
            function l() {
                var t = !0;
                return null !== g.threshold && (t = N >= g.threshold), t;
            }
            function c() {
                var t = !1;
                return (
                    null !== g.cancelThreshold &&
                        null !== R &&
                        (t = $(R) - N >= g.cancelThreshold),
                    t
                );
            }
            function h() {
                return !(g.maxTimeThreshold && q >= g.maxTimeThreshold);
            }
            function d() {
                var t = f(),
                    e = _(),
                    i = null === g.pinchThreshold || Y >= g.pinchThreshold;
                return t && e && i;
            }
            function y() {
                return g.pinchStatus || g.pinchIn || g.pinchOut;
            }
            function u() {
                var t = h(),
                    e = l(),
                    i = f(),
                    n = _();
                return !c() && n && i && e && t;
            }
            function p() {
                return (
                    g.swipe ||
                    g.swipeStatus ||
                    g.swipeLeft ||
                    g.swipeRight ||
                    g.swipeUp ||
                    g.swipeDown
                );
            }
            function f() {
                return Z === g.fingers || g.fingers === St || !It;
            }
            function _() {
                return 0 !== J[0].end.x;
            }
            function b() {
                return g.tap;
            }
            function w() {
                return !!g.doubleTap;
            }
            function x() {
                if (null == ot) return !1;
                var t = D();
                return w() && t - ot <= g.doubleTapThreshold;
            }
            function S() {
                nt = it = 0;
            }
            function T() {
                var t = !1;
                it && D() - it <= g.fingerReleaseThreshold && (t = !0);
                return t;
            }
            function C(t) {
                K &&
                    (!0 === t
                        ? (K.bind(j, i), K.bind(z, n), F && K.bind(F, s))
                        : (K.unbind(j, i, !1),
                          K.unbind(z, n, !1),
                          F && K.unbind(F, s, !1)),
                    K.data(Pt + "_intouch", !0 === t));
            }
            function k(t, e) {
                var i = {
                    start: { x: 0, y: 0 },
                    last: { x: 0, y: 0 },
                    end: { x: 0, y: 0 },
                };
                return (
                    (i.start.x = i.last.x = i.end.x = e.pageX || e.clientX),
                    (i.start.y = i.last.y = i.end.y = e.pageY || e.clientY),
                    (J[t] = i)
                );
            }
            function E(t) {
                var e = void 0 !== t.identifier ? t.identifier : 0,
                    i = J[e] || null;
                return (
                    null === i && (i = k(e, t)),
                    (i.last.x = i.end.x),
                    (i.last.y = i.end.y),
                    (i.end.x = t.pageX || t.clientX),
                    (i.end.y = t.pageY || t.clientY),
                    i
                );
            }
            function $(t) {
                if (V[t]) return V[t].distance;
            }
            function I(t) {
                return { direction: t, distance: 0 };
            }
            function A() {
                return et - tt;
            }
            function O(t, e) {
                var i = Math.abs(t.x - e.x),
                    n = Math.abs(t.y - e.y);
                return Math.round(Math.sqrt(i * i + n * n));
            }
            function P(t, e) {
                if (((n = e), (i = t).x == n.x && i.y == n.y)) return ft;
                var i,
                    n,
                    o,
                    s,
                    r,
                    a,
                    l,
                    c,
                    h =
                        ((s = e),
                        (r = (o = t).x - s.x),
                        (a = s.y - o.y),
                        (l = Math.atan2(a, r)),
                        (c = Math.round((180 * l) / Math.PI)) < 0 &&
                            (c = 360 - Math.abs(c)),
                        c);
                return (h <= 45 && 0 <= h) || (h <= 360 && 315 <= h)
                    ? lt
                    : 135 <= h && h <= 225
                      ? ct
                      : 45 < h && h < 135
                        ? dt
                        : ht;
            }
            function D() {
                return new Date().getTime();
            }
            g = at.extend({}, g);
            var M = It || Ot || !g.fallbackToMouseEvents,
                L = M
                    ? Ot
                        ? At
                            ? "MSPointerDown"
                            : "pointerdown"
                        : "touchstart"
                    : "mousedown",
                j = M
                    ? Ot
                        ? At
                            ? "MSPointerMove"
                            : "pointermove"
                        : "touchmove"
                    : "mousemove",
                z = M
                    ? Ot
                        ? At
                            ? "MSPointerUp"
                            : "pointerup"
                        : "touchend"
                    : "mouseup",
                F = !M || Ot ? "mouseleave" : null,
                H = Ot
                    ? At
                        ? "MSPointerCancel"
                        : "pointercancel"
                    : "touchcancel",
                N = 0,
                R = null,
                W = null,
                q = 0,
                B = 0,
                U = 0,
                Q = 1,
                Y = 0,
                X = 0,
                V = null,
                K = at(t),
                G = "start",
                Z = 0,
                J = {},
                tt = 0,
                et = 0,
                it = 0,
                nt = 0,
                ot = 0,
                st = null,
                rt = null;
            try {
                K.bind(L, e), K.bind(H, o);
            } catch (t) {
                at.error(
                    "events not supported " + L + "," + H + " on jQuery.swipe",
                );
            }
            (this.enable = function () {
                return this.disable(), K.bind(L, e), K.bind(H, o), K;
            }),
                (this.disable = function () {
                    return r(), K;
                }),
                (this.destroy = function () {
                    r(), K.data(Pt, null), (K = null);
                }),
                (this.option = function (t, e) {
                    if ("object" == typeof t) g = at.extend(g, t);
                    else if (void 0 !== g[t]) {
                        if (void 0 === e) return g[t];
                        g[t] = e;
                    } else {
                        if (!t) return g;
                        at.error(
                            "Option " +
                                t +
                                " does not exist on jQuery.swipe.options",
                        );
                    }
                    return null;
                });
        }
        var lt = "left",
            ct = "right",
            ht = "up",
            dt = "down",
            ut = "in",
            pt = "out",
            ft = "none",
            gt = "auto",
            mt = "swipe",
            vt = "pinch",
            yt = "tap",
            _t = "doubletap",
            bt = "longtap",
            wt = "horizontal",
            xt = "vertical",
            St = "all",
            Tt = 10,
            Ct = "start",
            kt = "move",
            Et = "end",
            $t = "cancel",
            It = "ontouchstart" in window,
            At =
                window.navigator.msPointerEnabled &&
                !window.navigator.pointerEnabled &&
                !It,
            Ot =
                (window.navigator.pointerEnabled ||
                    window.navigator.msPointerEnabled) &&
                !It,
            Pt = "TouchSwipe";
        (at.fn.swipe = function (t) {
            var e = at(this),
                i = e.data(Pt);
            if (i && "string" == typeof t) {
                if (i[t])
                    return i[t].apply(
                        i,
                        Array.prototype.slice.call(arguments, 1),
                    );
                at.error("Method " + t + " does not exist on jQuery.swipe");
            } else if (i && "object" == typeof t) i.option.apply(i, arguments);
            else if (!(i || ("object" != typeof t && t)))
                return function (i) {
                    return (
                        !i ||
                            void 0 !== i.allowPageScroll ||
                            (void 0 === i.swipe && void 0 === i.swipeStatus) ||
                            (i.allowPageScroll = ft),
                        void 0 !== i.click &&
                            void 0 === i.tap &&
                            (i.tap = i.click),
                        (i = i || {}),
                        (i = at.extend({}, at.fn.swipe.defaults, i)),
                        this.each(function () {
                            var t = at(this),
                                e = t.data(Pt);
                            e || ((e = new n(this, i)), t.data(Pt, e));
                        })
                    );
                }.apply(this, arguments);
            return e;
        }),
            (at.fn.swipe.version = "1.6.18"),
            (at.fn.swipe.defaults = {
                fingers: 1,
                threshold: 75,
                cancelThreshold: null,
                pinchThreshold: 20,
                maxTimeThreshold: null,
                fingerReleaseThreshold: 250,
                longTapThreshold: 500,
                doubleTapThreshold: 200,
                swipe: null,
                swipeLeft: null,
                swipeRight: null,
                swipeUp: null,
                swipeDown: null,
                swipeStatus: null,
                pinchIn: null,
                pinchOut: null,
                pinchStatus: null,
                click: null,
                tap: null,
                doubleTap: null,
                longTap: null,
                hold: null,
                triggerOnTouchEnd: !0,
                triggerOnTouchLeave: !1,
                allowPageScroll: "auto",
                fallbackToMouseEvents: !0,
                excludedElements: ".noSwipe",
                preventDefaultEvents: !0,
            }),
            (at.fn.swipe.phases = {
                PHASE_START: Ct,
                PHASE_MOVE: kt,
                PHASE_END: Et,
                PHASE_CANCEL: $t,
            }),
            (at.fn.swipe.directions = {
                LEFT: lt,
                RIGHT: ct,
                UP: ht,
                DOWN: dt,
                IN: ut,
                OUT: pt,
            }),
            (at.fn.swipe.pageScroll = {
                NONE: ft,
                HORIZONTAL: wt,
                VERTICAL: xt,
                AUTO: gt,
            }),
            (at.fn.swipe.fingers = {
                ONE: 1,
                TWO: 2,
                THREE: 3,
                FOUR: 4,
                FIVE: 5,
                ALL: St,
            });
    }),
    (function (h, o) {
        var i = {
            active: null,
            event: "click",
            disabled: [],
            collapsible: "accordion",
            startCollapsed: !1,
            rotate: !1,
            setHash: !1,
            animation: "default",
            animationQueue: !1,
            duration: 500,
            fluidHeight: !0,
            scrollToAccordion: !1,
            scrollToAccordionOnLoad: !0,
            scrollToAccordionOffset: 0,
            accordionTabElement: "<div></div>",
            navigationContainer: "",
            click: function () {},
            activate: function () {},
            deactivate: function () {},
            load: function () {},
            activateState: function () {},
            classes: {
                stateDefault: "r-tabs-state-default",
                stateActive: "r-tabs-state-active",
                stateDisabled: "r-tabs-state-disabled",
                stateExcluded: "r-tabs-state-excluded",
                container: "r-tabs",
                ul: "r-tabs-nav",
                tab: "r-tabs-tab",
                anchor: "r-tabs-anchor",
                panel: "r-tabs-panel",
                accordionTitle: "r-tabs-accordion-title",
            },
        };
        function n(t, e) {
            (this.element = t),
                (this.$element = h(t)),
                (this.tabs = []),
                (this.state = ""),
                (this.rotateInterval = 0),
                (this.$queue = h({})),
                (this.options = h.extend({}, i, e)),
                this.init();
        }
        (n.prototype.init = function () {
            var n = this;
            (this.tabs = this._loadElements()),
                this._loadClasses(),
                this._loadEvents(),
                h(o).on("resize", function (t) {
                    n._setState(t),
                        !0 !== n.options.fluidHeight && n._equaliseHeights();
                }),
                h(o).on("hashchange", function (t) {
                    var e = n._getTabRefBySelector(o.location.hash),
                        i = n._getTab(e);
                    0 <= e &&
                        !i._ignoreHashChange &&
                        !i.disabled &&
                        n._openTab(t, n._getTab(e), !0);
                }),
                !1 !== this.options.rotate && this.startRotation(),
                !0 !== this.options.fluidHeight && n._equaliseHeights(),
                this.$element.bind("tabs-click", function (t, e) {
                    n.options.click.call(this, t, e);
                }),
                this.$element.bind("tabs-activate", function (t, e) {
                    n.options.activate.call(this, t, e);
                }),
                this.$element.bind("tabs-deactivate", function (t, e) {
                    n.options.deactivate.call(this, t, e);
                }),
                this.$element.bind("tabs-activate-state", function (t, e) {
                    n.options.activateState.call(this, t, e);
                }),
                this.$element.bind("tabs-load", function (t) {
                    var e;
                    n._setState(t),
                        !0 === n.options.startCollapsed ||
                            ("accordion" === n.options.startCollapsed &&
                                "accordion" === n.state) ||
                            ((e = n._getStartTab()),
                            n._openTab(t, e),
                            n.options.load.call(this, t, e));
                }),
                this.$element.trigger("tabs-load");
        }),
            (n.prototype._loadElements = function () {
                var a = this,
                    t =
                        "" === a.options.navigationContainer
                            ? this.$element.children("ul:first")
                            : this.$element
                                  .find(a.options.navigationContainer)
                                  .children("ul:first"),
                    l = [],
                    c = 0;
                return (
                    this.$element.addClass(a.options.classes.container),
                    t.addClass(a.options.classes.ul),
                    h("li", t).each(function () {
                        var t,
                            e,
                            i,
                            n,
                            o,
                            s = h(this);
                        if (!s.hasClass(a.options.classes.stateExcluded)) {
                            (o = (t = h("a", s)).attr("href")),
                                (e = h(o)),
                                (i = h(
                                    a.options.accordionTabElement,
                                ).insertBefore(e)),
                                (n = h("<a></a>")
                                    .attr("href", o)
                                    .html(t.html())
                                    .appendTo(i));
                            var r = {
                                _ignoreHashChange: !1,
                                id: c,
                                disabled:
                                    -1 !== h.inArray(c, a.options.disabled),
                                tab: h(this),
                                anchor: h("a", s),
                                panel: e,
                                selector: o,
                                accordionTab: i,
                                accordionAnchor: n,
                                active: !1,
                            };
                            c++, l.push(r);
                        }
                    }),
                    l
                );
            }),
            (n.prototype._loadClasses = function () {
                for (var t = 0; t < this.tabs.length; t++)
                    this.tabs[t].tab
                        .addClass(this.options.classes.stateDefault)
                        .addClass(this.options.classes.tab),
                        this.tabs[t].anchor.addClass(
                            this.options.classes.anchor,
                        ),
                        this.tabs[t].panel
                            .addClass(this.options.classes.stateDefault)
                            .addClass(this.options.classes.panel),
                        this.tabs[t].accordionTab.addClass(
                            this.options.classes.accordionTitle,
                        ),
                        this.tabs[t].accordionAnchor.addClass(
                            this.options.classes.anchor,
                        ),
                        this.tabs[t].disabled &&
                            (this.tabs[t].tab
                                .removeClass(this.options.classes.stateDefault)
                                .addClass(this.options.classes.stateDisabled),
                            this.tabs[t].accordionTab
                                .removeClass(this.options.classes.stateDefault)
                                .addClass(this.options.classes.stateDisabled));
            }),
            (n.prototype._loadEvents = function () {
                function t(t) {
                    var e = n._getCurrentTab(),
                        i = t.data.tab;
                    t.preventDefault(),
                        i.tab.trigger("tabs-click", i),
                        i.disabled ||
                            (n.options.setHash &&
                                (history.pushState
                                    ? (o.location.origin ||
                                          (o.location.origin =
                                              o.location.protocol +
                                              "//" +
                                              o.location.hostname +
                                              (o.location.port
                                                  ? ":" + o.location.port
                                                  : "")),
                                      history.pushState(
                                          null,
                                          null,
                                          o.location.origin +
                                              o.location.pathname +
                                              o.location.search +
                                              i.selector,
                                      ))
                                    : (o.location.hash = i.selector)),
                            (t.data.tab._ignoreHashChange = !0),
                            (e === i && !n._isCollapisble()) ||
                                (n._closeTab(t, e),
                                (e === i && n._isCollapisble()) ||
                                    n._openTab(t, i, !1, !0)));
                }
                for (var n = this, e = 0; e < this.tabs.length; e++)
                    this.tabs[e].anchor.on(
                        n.options.event,
                        { tab: n.tabs[e] },
                        t,
                    ),
                        this.tabs[e].accordionAnchor.on(
                            n.options.event,
                            { tab: n.tabs[e] },
                            t,
                        );
            }),
            (n.prototype._getStartTab = function () {
                var t = this._getTabRefBySelector(o.location.hash);
                return 0 <= t && !this._getTab(t).disabled
                    ? this._getTab(t)
                    : 0 < this.options.active &&
                        !this._getTab(this.options.active).disabled
                      ? this._getTab(this.options.active)
                      : this._getTab(0);
            }),
            (n.prototype._setState = function (t) {
                var e,
                    i = h("ul:first", this.$element),
                    n = this.state,
                    o = "string" == typeof this.options.startCollapsed;
                i.is(":visible")
                    ? (this.state = "tabs")
                    : (this.state = "accordion"),
                    this.state !== n &&
                        (this.$element.trigger("tabs-activate-state", {
                            oldState: n,
                            newState: this.state,
                        }),
                        n &&
                            o &&
                            this.options.startCollapsed !== this.state &&
                            void 0 === this._getCurrentTab() &&
                            ((e = this._getStartTab(t)), this._openTab(t, e)));
            }),
            (n.prototype._openTab = function (e, i, t, n) {
                var o,
                    s = this;
                t && this._closeTab(e, this._getCurrentTab()),
                    n && 0 < this.rotateInterval && this.stopRotation(),
                    (i.active = !0),
                    i.tab
                        .removeClass(s.options.classes.stateDefault)
                        .addClass(s.options.classes.stateActive),
                    i.accordionTab
                        .removeClass(s.options.classes.stateDefault)
                        .addClass(s.options.classes.stateActive),
                    s._doTransition(
                        i.panel,
                        s.options.animation,
                        "open",
                        function () {
                            var t =
                                "tabs-load" !== e.type ||
                                s.options.scrollToAccordionOnLoad;
                            i.panel
                                .removeClass(s.options.classes.stateDefault)
                                .addClass(s.options.classes.stateActive),
                                "accordion" !== s.getState() ||
                                    !s.options.scrollToAccordion ||
                                    (s._isInView(i.accordionTab) &&
                                        "default" === s.options.animation) ||
                                    !t ||
                                    ((o =
                                        i.accordionTab.offset().top -
                                        s.options.scrollToAccordionOffset),
                                    "default" !== s.options.animation &&
                                    0 < s.options.duration
                                        ? h("html, body").animate(
                                              { scrollTop: o },
                                              s.options.duration,
                                          )
                                        : h("html, body").scrollTop(o));
                        },
                    ),
                    this.$element.trigger("tabs-activate", i);
            }),
            (n.prototype._closeTab = function (t, e) {
                var i,
                    n = this,
                    o = "string" == typeof n.options.animationQueue;
                void 0 !== e &&
                    ((i =
                        (o && n.getState() === n.options.animationQueue) ||
                        (!o && n.options.animationQueue)),
                    (e.active = !1),
                    e.tab
                        .removeClass(n.options.classes.stateActive)
                        .addClass(n.options.classes.stateDefault),
                    n._doTransition(
                        e.panel,
                        n.options.animation,
                        "close",
                        function () {
                            e.accordionTab
                                .removeClass(n.options.classes.stateActive)
                                .addClass(n.options.classes.stateDefault),
                                e.panel
                                    .removeClass(n.options.classes.stateActive)
                                    .addClass(n.options.classes.stateDefault);
                        },
                        !i,
                    ),
                    this.$element.trigger("tabs-deactivate", e));
            }),
            (n.prototype._doTransition = function (e, i, n, o, t) {
                var s,
                    r = this;
                switch (i) {
                    case "slide":
                        s = "open" === n ? "slideDown" : "slideUp";
                        break;
                    case "fade":
                        s = "open" === n ? "fadeIn" : "fadeOut";
                        break;
                    default:
                        (s = "open" === n ? "show" : "hide"),
                            (r.options.duration = 0);
                }
                this.$queue.queue("responsive-tabs", function (t) {
                    e[s]({
                        duration: r.options.duration,
                        complete: function () {
                            o.call(e, i, n), t();
                        },
                    });
                }),
                    ("open" !== n && !t) ||
                        this.$queue.dequeue("responsive-tabs");
            }),
            (n.prototype._isCollapisble = function () {
                return (
                    ("boolean" == typeof this.options.collapsible &&
                        this.options.collapsible) ||
                    ("string" == typeof this.options.collapsible &&
                        this.options.collapsible === this.getState())
                );
            }),
            (n.prototype._getTab = function (t) {
                return this.tabs[t];
            }),
            (n.prototype._getTabRefBySelector = function (t) {
                for (var e = 0; e < this.tabs.length; e++)
                    if (this.tabs[e].selector === t) return e;
                return -1;
            }),
            (n.prototype._getCurrentTab = function () {
                return this._getTab(this._getCurrentTabRef());
            }),
            (n.prototype._getNextTabRef = function (t) {
                var e = t || this._getCurrentTabRef(),
                    i = e === this.tabs.length - 1 ? 0 : e + 1;
                return this._getTab(i).disabled ? this._getNextTabRef(i) : i;
            }),
            (n.prototype._getPreviousTabRef = function () {
                return 0 === this._getCurrentTabRef()
                    ? this.tabs.length - 1
                    : this._getCurrentTabRef() - 1;
            }),
            (n.prototype._getCurrentTabRef = function () {
                for (var t = 0; t < this.tabs.length; t++)
                    if (this.tabs[t].active) return t;
                return -1;
            }),
            (n.prototype._equaliseHeights = function () {
                var e = 0;
                h.each(
                    h.map(this.tabs, function (t) {
                        return (
                            (e = Math.max(
                                e,
                                t.panel.css("minHeight", "").height(),
                            )),
                            t.panel
                        );
                    }),
                    function () {
                        this.css("minHeight", e);
                    },
                );
            }),
            (n.prototype._isInView = function (t) {
                var e = h(o).scrollTop(),
                    i = e + h(o).height(),
                    n = t.offset().top;
                return n + t.height() <= i && e <= n;
            }),
            (n.prototype.activate = function (t, e) {
                var i = jQuery.Event("tabs-activate"),
                    n = this._getTab(t);
                n.disabled || this._openTab(i, n, !0, e || !0);
            }),
            (n.prototype.deactivate = function (t) {
                var e = jQuery.Event("tabs-dectivate"),
                    i = this._getTab(t);
                i.disabled || this._closeTab(e, i);
            }),
            (n.prototype.enable = function (t) {
                var e = this._getTab(t);
                e &&
                    ((e.disabled = !1),
                    e.tab
                        .addClass(this.options.classes.stateDefault)
                        .removeClass(this.options.classes.stateDisabled),
                    e.accordionTab
                        .addClass(this.options.classes.stateDefault)
                        .removeClass(this.options.classes.stateDisabled));
            }),
            (n.prototype.disable = function (t) {
                var e = this._getTab(t);
                e &&
                    ((e.disabled = !0),
                    e.tab
                        .removeClass(this.options.classes.stateDefault)
                        .addClass(this.options.classes.stateDisabled),
                    e.accordionTab
                        .removeClass(this.options.classes.stateDefault)
                        .addClass(this.options.classes.stateDisabled));
            }),
            (n.prototype.getState = function () {
                return this.state;
            }),
            (n.prototype.startRotation = function (t) {
                var e = this;
                if (!(this.tabs.length > this.options.disabled.length))
                    throw new Error(
                        "Rotation is not possible if all tabs are disabled",
                    );
                this.rotateInterval = setInterval(
                    function () {
                        var t = jQuery.Event("rotate");
                        e._openTab(t, e._getTab(e._getNextTabRef()), !0);
                    },
                    t ||
                        (h.isNumeric(e.options.rotate)
                            ? e.options.rotate
                            : 4e3),
                );
            }),
            (n.prototype.stopRotation = function () {
                o.clearInterval(this.rotateInterval), (this.rotateInterval = 0);
            }),
            (n.prototype.option = function (t, e) {
                return e && (this.options[t] = e), this.options[t];
            }),
            (h.fn.responsiveTabs = function (t) {
                var e,
                    i = arguments;
                return void 0 === t || "object" == typeof t
                    ? this.each(function () {
                          h.data(this, "responsivetabs") ||
                              h.data(this, "responsivetabs", new n(this, t));
                      })
                    : "string" == typeof t && "_" !== t[0] && "init" !== t
                      ? ((e = h.data(this[0], "responsivetabs")),
                        "destroy" === t && h.data(this, "responsivetabs", null),
                        e instanceof n && "function" == typeof e[t]
                            ? e[t].apply(e, Array.prototype.slice.call(i, 1))
                            : this)
                      : void 0;
            });
    })(jQuery, window),
    function () {
        var e,
            i,
            b =
                [].indexOf ||
                function (t) {
                    for (var e = 0, i = this.length; e < i; e++)
                        if (e in this && this[e] === t) return e;
                    return -1;
                },
            w = [].slice;
        (e = this),
            (i = function (l, s) {
                var e, r, a, c, i, h, d, o, u, n, p, f, g, m, v, y;
                function t(t) {
                    var e = this;
                    (this.$element = t),
                        (this.element = t[0]),
                        (this.didResize = !1),
                        (this.didScroll = !1),
                        (this.id = "context" + i++),
                        (this.oldScroll = {
                            x: t.scrollLeft(),
                            y: t.scrollTop(),
                        }),
                        (this.waypoints = { horizontal: {}, vertical: {} }),
                        t.data(h, this.id),
                        (d[this.id] = this),
                        t.bind(f, function () {
                            var t;
                            if (!e.didScroll && !o)
                                return (
                                    (e.didScroll = !0),
                                    (t = function () {
                                        return e.doScroll(), (e.didScroll = !1);
                                    }),
                                    s.setTimeout(
                                        t,
                                        l[y].settings.scrollThrottle,
                                    )
                                );
                        }),
                        t.bind(p, function () {
                            var t;
                            if (!e.didResize)
                                return (
                                    (e.didResize = !0),
                                    (t = function () {
                                        return (
                                            l[y]("refresh"), (e.didResize = !1)
                                        );
                                    }),
                                    s.setTimeout(
                                        t,
                                        l[y].settings.resizeThrottle,
                                    )
                                );
                        });
                }
                function _(t, e, i) {
                    var n, o;
                    "bottom-in-view" ===
                        (i = l.extend({}, l.fn[v].defaults, i)).offset &&
                        (i.offset = function () {
                            var t;
                            return (
                                (t = l[y]("viewportHeight")),
                                l.isWindow(e.element) ||
                                    (t = e.$element.height()),
                                t - l(this).outerHeight()
                            );
                        }),
                        (this.$element = t),
                        (this.element = t[0]),
                        (this.axis = i.horizontal ? "horizontal" : "vertical"),
                        (this.callback = i.handler),
                        (this.context = e),
                        (this.enabled = i.enabled),
                        (this.id = "waypoints" + g++),
                        (this.offset = null),
                        (this.options = i),
                        (e.waypoints[this.axis][this.id] = this),
                        (c[this.axis][this.id] = this),
                        (n = null != (o = t.data(m)) ? o : []).push(this.id),
                        t.data(m, n);
                }
                return (
                    (e = l(s)),
                    (o = 0 <= b.call(s, "ontouchstart")),
                    (c = { horizontal: {}, vertical: {} }),
                    (d = {}),
                    (h = "waypoints-context-id"),
                    (p = "resize.waypoints"),
                    (f = "scroll.waypoints"),
                    (g = i = 1),
                    (m = "waypoints-waypoint-ids"),
                    (v = "waypoint"),
                    (y = "waypoints"),
                    (t.prototype.doScroll = function () {
                        var t,
                            n = this;
                        return (
                            (t = {
                                horizontal: {
                                    newScroll: this.$element.scrollLeft(),
                                    oldScroll: this.oldScroll.x,
                                    forward: "right",
                                    backward: "left",
                                },
                                vertical: {
                                    newScroll: this.$element.scrollTop(),
                                    oldScroll: this.oldScroll.y,
                                    forward: "down",
                                    backward: "up",
                                },
                            }),
                            !o ||
                                (t.vertical.oldScroll &&
                                    t.vertical.newScroll) ||
                                l[y]("refresh"),
                            l.each(t, function (t, o) {
                                var i, e, s;
                                return (
                                    (s = []),
                                    (e = o.newScroll > o.oldScroll),
                                    (i = e ? o.forward : o.backward),
                                    l.each(n.waypoints[t], function (t, e) {
                                        var i, n;
                                        return (o.oldScroll < (i = e.offset) &&
                                            i <= o.newScroll) ||
                                            (o.newScroll < (n = e.offset) &&
                                                n <= o.oldScroll)
                                            ? s.push(e)
                                            : void 0;
                                    }),
                                    s.sort(function (t, e) {
                                        return t.offset - e.offset;
                                    }),
                                    e || s.reverse(),
                                    l.each(s, function (t, e) {
                                        if (
                                            e.options.continuous ||
                                            t === s.length - 1
                                        )
                                            return e.trigger([i]);
                                    })
                                );
                            }),
                            (this.oldScroll = {
                                x: t.horizontal.newScroll,
                                y: t.vertical.newScroll,
                            })
                        );
                    }),
                    (t.prototype.refresh = function () {
                        var t,
                            e,
                            i,
                            n = this;
                        return (
                            (i = l.isWindow(this.element)),
                            (e = this.$element.offset()),
                            this.doScroll(),
                            (t = {
                                horizontal: {
                                    contextOffset: i ? 0 : e.left,
                                    contextScroll: i ? 0 : this.oldScroll.x,
                                    contextDimension: this.$element.width(),
                                    oldScroll: this.oldScroll.x,
                                    forward: "right",
                                    backward: "left",
                                    offsetProp: "left",
                                },
                                vertical: {
                                    contextOffset: i ? 0 : e.top,
                                    contextScroll: i ? 0 : this.oldScroll.y,
                                    contextDimension: i
                                        ? l[y]("viewportHeight")
                                        : this.$element.height(),
                                    oldScroll: this.oldScroll.y,
                                    forward: "down",
                                    backward: "up",
                                    offsetProp: "top",
                                },
                            }),
                            l.each(t, function (t, a) {
                                return l.each(n.waypoints[t], function (t, e) {
                                    var i, n, o, s, r;
                                    if (
                                        ((i = e.options.offset),
                                        (o = e.offset),
                                        (n = l.isWindow(e.element)
                                            ? 0
                                            : e.$element.offset()[
                                                  a.offsetProp
                                              ]),
                                        l.isFunction(i)
                                            ? (i = i.apply(e.element))
                                            : "string" == typeof i &&
                                              ((i = parseFloat(i)),
                                              -1 <
                                                  e.options.offset.indexOf(
                                                      "%",
                                                  ) &&
                                                  (i = Math.ceil(
                                                      (a.contextDimension * i) /
                                                          100,
                                                  ))),
                                        (e.offset =
                                            n -
                                            a.contextOffset +
                                            a.contextScroll -
                                            i),
                                        (!e.options.onlyOnScroll ||
                                            null == o) &&
                                            e.enabled)
                                    )
                                        return null !== o &&
                                            o < (s = a.oldScroll) &&
                                            s <= e.offset
                                            ? e.trigger([a.backward])
                                            : (null !== o &&
                                                    o > (r = a.oldScroll) &&
                                                    r >= e.offset) ||
                                                (null === o &&
                                                    a.oldScroll >= e.offset)
                                              ? e.trigger([a.forward])
                                              : void 0;
                                });
                            })
                        );
                    }),
                    (t.prototype.checkEmpty = function () {
                        if (
                            l.isEmptyObject(this.waypoints.horizontal) &&
                            l.isEmptyObject(this.waypoints.vertical)
                        )
                            return (
                                this.$element.unbind([p, f].join(" ")),
                                delete d[this.id]
                            );
                    }),
                    (r = t),
                    (_.prototype.trigger = function (t) {
                        if (this.enabled)
                            return (
                                null != this.callback &&
                                    this.callback.apply(this.element, t),
                                this.options.triggerOnce
                                    ? this.destroy()
                                    : void 0
                            );
                    }),
                    (_.prototype.disable = function () {
                        return (this.enabled = !1);
                    }),
                    (_.prototype.enable = function () {
                        return this.context.refresh(), (this.enabled = !0);
                    }),
                    (_.prototype.destroy = function () {
                        return (
                            delete c[this.axis][this.id],
                            delete this.context.waypoints[this.axis][this.id],
                            this.context.checkEmpty()
                        );
                    }),
                    (_.getWaypointsByElement = function (t) {
                        var e, i;
                        return (i = l(t).data(m))
                            ? ((e = l.extend({}, c.horizontal, c.vertical)),
                              l.map(i, function (t) {
                                  return e[t];
                              }))
                            : [];
                    }),
                    (a = _),
                    (n = {
                        init: function (t, o) {
                            return (
                                null == o && (o = {}),
                                null == o.handler && (o.handler = t),
                                this.each(function () {
                                    var t, e, i, n;
                                    return (
                                        (t = l(this)),
                                        (i =
                                            null != (n = o.context)
                                                ? n
                                                : l.fn[v].defaults.context),
                                        l.isWindow(i) || (i = t.closest(i)),
                                        (i = l(i)),
                                        (e = (e = d[i.data(h)]) || new r(i)),
                                        new a(t, e, o)
                                    );
                                }),
                                l[y]("refresh"),
                                this
                            );
                        },
                        disable: function () {
                            return n._invoke(this, "disable");
                        },
                        enable: function () {
                            return n._invoke(this, "enable");
                        },
                        destroy: function () {
                            return n._invoke(this, "destroy");
                        },
                        prev: function (t, e) {
                            return n._traverse.call(
                                this,
                                t,
                                e,
                                function (t, e, i) {
                                    if (0 < e) return t.push(i[e - 1]);
                                },
                            );
                        },
                        next: function (t, e) {
                            return n._traverse.call(
                                this,
                                t,
                                e,
                                function (t, e, i) {
                                    if (e < i.length - 1)
                                        return t.push(i[e + 1]);
                                },
                            );
                        },
                        _traverse: function (e, t, i) {
                            var n, o;
                            return (
                                null == e && (e = "vertical"),
                                null == t && (t = s),
                                (o = u.aggregate(t)),
                                (n = []),
                                this.each(function () {
                                    var t;
                                    return (
                                        (t = l.inArray(this, o[e])),
                                        i(n, t, o[e])
                                    );
                                }),
                                this.pushStack(n)
                            );
                        },
                        _invoke: function (t, i) {
                            return (
                                t.each(function () {
                                    var t;
                                    return (
                                        (t = a.getWaypointsByElement(this)),
                                        l.each(t, function (t, e) {
                                            return e[i](), !0;
                                        })
                                    );
                                }),
                                this
                            );
                        },
                    }),
                    (l.fn[v] = function () {
                        var t, e;
                        return (
                            (e = arguments[0]),
                            (t =
                                2 <= arguments.length
                                    ? w.call(arguments, 1)
                                    : []),
                            n[e]
                                ? n[e].apply(this, t)
                                : l.isFunction(e)
                                  ? n.init.apply(this, arguments)
                                  : l.isPlainObject(e)
                                    ? n.init.apply(this, [null, e])
                                    : e
                                      ? l.error(
                                            "The " +
                                                e +
                                                " method does not exist in jQuery Waypoints.",
                                        )
                                      : l.error(
                                            "jQuery Waypoints needs a callback function or handler option.",
                                        )
                        );
                    }),
                    (l.fn[v].defaults = {
                        context: s,
                        continuous: !0,
                        enabled: !0,
                        horizontal: !1,
                        offset: 0,
                        triggerOnce: !1,
                    }),
                    (u = {
                        refresh: function () {
                            return l.each(d, function (t, e) {
                                return e.refresh();
                            });
                        },
                        viewportHeight: function () {
                            var t;
                            return null != (t = s.innerHeight) ? t : e.height();
                        },
                        aggregate: function (t) {
                            var e, n, i;
                            return (
                                (e = c),
                                t &&
                                    (e =
                                        null != (i = d[l(t).data(h)])
                                            ? i.waypoints
                                            : void 0),
                                e
                                    ? ((n = { horizontal: [], vertical: [] }),
                                      l.each(n, function (t, i) {
                                          return (
                                              l.each(e[t], function (t, e) {
                                                  return i.push(e);
                                              }),
                                              i.sort(function (t, e) {
                                                  return t.offset - e.offset;
                                              }),
                                              (n[t] = l.map(i, function (t) {
                                                  return t.element;
                                              })),
                                              (n[t] = l.unique(n[t]))
                                          );
                                      }),
                                      n)
                                    : []
                            );
                        },
                        above: function (t) {
                            return (
                                null == t && (t = s),
                                u._filter(t, "vertical", function (t, e) {
                                    return e.offset <= t.oldScroll.y;
                                })
                            );
                        },
                        below: function (t) {
                            return (
                                null == t && (t = s),
                                u._filter(t, "vertical", function (t, e) {
                                    return e.offset > t.oldScroll.y;
                                })
                            );
                        },
                        left: function (t) {
                            return (
                                null == t && (t = s),
                                u._filter(t, "horizontal", function (t, e) {
                                    return e.offset <= t.oldScroll.x;
                                })
                            );
                        },
                        right: function (t) {
                            return (
                                null == t && (t = s),
                                u._filter(t, "horizontal", function (t, e) {
                                    return e.offset > t.oldScroll.x;
                                })
                            );
                        },
                        enable: function () {
                            return u._invoke("enable");
                        },
                        disable: function () {
                            return u._invoke("disable");
                        },
                        destroy: function () {
                            return u._invoke("destroy");
                        },
                        extendFn: function (t, e) {
                            return (n[t] = e);
                        },
                        _invoke: function (i) {
                            var t;
                            return (
                                (t = l.extend({}, c.vertical, c.horizontal)),
                                l.each(t, function (t, e) {
                                    return e[i](), !0;
                                })
                            );
                        },
                        _filter: function (t, e, i) {
                            var n, o;
                            return (n = d[l(t).data(h)])
                                ? ((o = []),
                                  l.each(n.waypoints[e], function (t, e) {
                                      if (i(n, e)) return o.push(e);
                                  }),
                                  o.sort(function (t, e) {
                                      return t.offset - e.offset;
                                  }),
                                  l.map(o, function (t) {
                                      return t.element;
                                  }))
                                : [];
                        },
                    }),
                    (l[y] = function () {
                        var t, e;
                        return (
                            (e = arguments[0]),
                            (t =
                                2 <= arguments.length
                                    ? w.call(arguments, 1)
                                    : []),
                            u[e]
                                ? u[e].apply(null, t)
                                : u.aggregate.call(null, e)
                        );
                    }),
                    (l[y].settings = {
                        resizeThrottle: 100,
                        scrollThrottle: 30,
                    }),
                    e.load(function () {
                        return l[y]("refresh");
                    })
                );
            }),
            "function" == typeof define && define.amd
                ? define("waypoints", ["jquery"], function (t) {
                      return i(t, e);
                  })
                : i(e.jQuery, e);
    }.call(this);

(function ($) {
    "use strict";

    jQuery(document).ready(function () {
        // object fit

        objectFitImages();

        // header

        // aside dropdown

        asideDropdown();

        // video trigger

        function videoTrigger() {
            var trigger = $(".video-trigger");

            if (!trigger.length) return;

            trigger.fancybox();
        }

        videoTrigger();

        // alert close

        $(".alert__close").on("click", function () {
            $(this).parent(".alert").fadeOut(300);
        });

        // accordion

        function accordion() {
            var accordion = $(".accordion");

            if (!accordion.length) return;

            var close = $(".accordion .accordion__close");

            close.on("click", function () {
                $(this)
                    .toggleClass("accordion__close--active")
                    .parents()
                    .children(".accordion__text-block")
                    .stop()
                    .slideToggle(300);
            });
        }

        accordion();

        // parallax

        function parallax() {
            var parallax = $(".jarallax");

            if (!jarallax.length) return;

            parallax.jarallax({
                speed: 0.3,
            });
        }

        parallax();

        // tabs

        function tabs() {
            var tabs = $(".tabs");

            if (!tabs.length) return;

            tabs.responsiveTabs({
                startCollapsed: "false",
            });
        }

        tabs();

        // counter

        function counter() {
            var counter = $(".js-counter");

            if (!counter.length) return;

            counter.counterUp({
                delay: 10,
                time: 1500,
            });
        }

        counter();

        // masonry projects

        function masonryProjects() {
            var masonryProjects = $(".projects-masonry");

            if (!masonryProjects.length) return;

            masonryProjects.isotope({
                itemSelector: ".projects-masonry__item",
                percentPosition: true,
            });
        }

        masonryProjects();

        // masonry gallery

        function masonryGallery() {
            var masonryGallery = $(".gallery-masonry");

            if (!masonryGallery.length) return;

            masonryGallery.isotope({
                itemSelector: ".gallery-masonry__item",
                percentPosition: true,
            });

            var filter = $(".filter-panel__item");

            filter.on("click", function () {
                var filterValue = $(this).attr("data-filter");

                masonryGallery.isotope({
                    filter: filterValue,
                });
            });

            filter.on("click", function () {
                filter.removeClass("filter-panel__item--active");
                $(this).addClass("filter-panel__item--active");
            });
        }

        masonryGallery();

        // range slider

        function rangeSlider() {
            var rangeSlider = $(".range-slider .range-slider__bar");

            if (!rangeSlider.length) return;

            var min = $(".range-slider__min");
            var max = $(".range-slider__max");

            rangeSlider.ionRangeSlider({
                type: "double",
                min: 0,
                max: 1200,
                from: 50,
                to: 900,
                skin: "round",
                step: 10,
                onChange: function (data) {
                    min.val(data.from);
                    max.val(data.to);
                },
            });
        }

        rangeSlider();

        // quantity

        function quantity() {
            var count = $(".cart-item__count");

            if (!count.length) return;

            var minus = $(".cart-item__minus");
            var plus = $(".cart-item__plus");

            minus.on("click", function () {
                var $input = $(this).parent().find("input");
                var count = parseInt($input.val()) - 1;
                count = count < 1 ? 1 : count;
                $input.val(count);
                $input.change();
                return false;
            });

            plus.on("click", function () {
                var $input = $(this).parent().find("input");
                $input.val(parseInt($input.val()) + 1);
                $input.change();
                return false;
            });
        }

        quantity();

        // form quantity

        function formQuantity() {
            var count = $(".form__count");

            if (!count.length) return;

            var minus = $(".form__minus");
            var plus = $(".form__plus");

            minus.on("click", function () {
                var $input = $(this).parent().find("input");
                var count = parseInt($input.val()) - 1;
                count = count < 1 ? 1 : count;
                $input.val(count);
                $input.change();
                return false;
            });

            plus.on("click", function () {
                var $input = $(this).parent().find("input");
                $input.val(parseInt($input.val()) + 1);
                $input.change();
                return false;
            });
        }

        formQuantity();

        // nice select

        function select() {
            var select = $(".form__select");

            if (!select.length) return;

            select.niceSelect({});
        }

        select();

        function asideTrigger() {
            var trigger = $(".shop__aside-trigger");

            if (!trigger.length) return;

            trigger.on("click", function () {
                $("body")
                    .find(".aside-holder")
                    .toggleClass("aside-holder--visible");
                $("body")
                    .find(".shop__backdrop")
                    .toggleClass("shop__backdrop--visible");
            });

            var close = $(".shop__aside-close");

            close.on("click", function () {
                $("body")
                    .find(".aside-holder")
                    .removeClass("aside-holder--visible");
                $("body")
                    .find(".shop__backdrop")
                    .removeClass("shop__backdrop--visible");
            });

            var backdrop = $(".shop__backdrop");

            backdrop.on("click", function () {
                $(this).removeClass("shop__backdrop--visible");
                $("body")
                    .find(".aside-holder")
                    .removeClass("aside-holder--visible");
            });
        }

        asideTrigger();

        // mobile menu

        $(".aside-menu__item--has-child a").on("click", function () {
            $(this)
                .parent()
                .children(".aside-menu__sub-list")
                .stop()
                .slideToggle(300);
        });

        // scroll to id

        function scrollTo() {
            var scrollTo = $('a.anchor[href^="#"]');

            if (!scrollTo.length) return;

            scrollTo.on("click", function (e) {
                var anchor = $(this);

                $("html, body")
                    .stop()
                    .animate(
                        {
                            scrollTop: $(anchor.attr("href")).offset().top,
                        },
                        600,
                    );

                e.preventDefault();
            });
        }

        scrollTo();

        // scroll to id

        function scrollToId() {
            var scroll = $("a.main-menu__link--scroll");

            if (!scroll.length) return;

            scroll.mPageScroll2id({
                highlightClass: "main-menu__link--highlighted",
            });
        }

        scrollToId();

        // |----------~-----------------~----------| //
        // |------___________________________------| //
        // |-----! S L I D E R S   S T A R T !-----| //
        // |------‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾------| //
        // |----------~-----------------~----------| //

        // promo slider

        function promoSlider() {
            var promoSlider = $(".promo-slider");

            if (!promoSlider.length) return;

            var status = $(".promo-slider__count");
            var prev = $(".slider__nav--promo .slider__prev");
            var next = $(".slider__nav--promo .slider__next");

            promoSlider.on(
                "init afterChange",
                function (event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + 1;
                    status.text(i + "/" + slick.slideCount);
                },
            );

            promoSlider.slick({
                fade: true,

                adaptiveHeight: true,
                infinite: true,
                speed: 1200,
                prevArrow: prev,
                nextArrow: next,
            });
        }

        promoSlider();

        // dual slider

        function dualSlider() {
            var slider = $(".main-slider");

            if (!slider.length) return;

            slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                asNavFor: ".nav-slider",
                fade: true,
            });

            var navSlider = $(".nav-slider");

            navSlider.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: ".main-slider",
                focusOnSelect: true,
                arrows: false,
            });
        }

        dualSlider();

        // project slider

        function projectsSlider() {
            var projectsSlider = $(".projects-slider");

            if (!projectsSlider.length) return;

            var prev = $(".projects-slider__nav .slider__prev");
            var next = $(".projects-slider__nav .slider__next");

            projectsSlider.slick({
                slidesToShow: 3,
                prevArrow: prev,
                nextArrow: next,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }

        projectsSlider();

        // related slider

        function relatedSlider() {
            var relatedSlider = $(".related-slider");

            if (!relatedSlider.length) return;

            var prev = $(".related-slider__nav .slider__prev");
            var next = $(".related-slider__nav .slider__next");

            relatedSlider.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: prev,
                nextArrow: next,

                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }

        relatedSlider();

        // instagram slider

        function instagramSlider() {
            var instagramSlider = $(".instagram-slider");

            if (!instagramSlider.length) return;

            var prev = $(".instagram-slider__nav .slider__prev");
            var next = $(".instagram-slider__nav .slider__next");

            instagramSlider.slick({
                prevArrow: prev,
                nextArrow: next,
                slidesToShow: 6,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 5,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                ],
            });
        }

        instagramSlider();

        // donors slider

        function donorsSlider() {
            var donorsSlider = $(".donors-slider");
            var styleOne = $(".donors-slider--style-1");
            var styleTwo = $(".donors-slider--style-2");

            if (!donorsSlider.length) return;

            styleOne.slick({
                arrows: false,
                dots: true,
                slidesToShow: 4,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });

            styleTwo.slick({
                rows: 2,
                slidesPerRow: 4,
                arrows: false,
                dots: true,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            rows: 2,
                            slidesPerRow: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            rows: 2,
                            slidesPerRow: 2,
                        },
                    },
                    {
                        breakpoint: 765,
                        settings: {
                            rows: 2,
                            slidesPerRow: 1,
                        },
                    },
                ],
            });
        }

        donorsSlider();

        // causes slider

        // testimonials-1

        function testimonialsFirst() {
            var testimonials = $(".testimonials-slider--style-1");

            if (!testimonials.length) return;

            var prev = $(".testimonials-style-1__nav .slider__prev");
            var next = $(".testimonials-style-1__nav .slider__next");

            testimonials.slick({
                prevArrow: prev,
                nextArrow: next,
                adaptiveHeight: true,
            });
        }

        testimonialsFirst();

        // testimonials-2

        function testimonialsSecond() {
            var testimonials = $(".testimonials-slider--style-2");

            if (!testimonials.length) return;

            var prev = $(".testimonials-style-2__nav .slider__prev");
            var next = $(".testimonials-style-2__nav .slider__next");

            testimonials.slick({
                prevArrow: prev,
                nextArrow: next,
                adaptiveHeight: true,
            });
        }

        testimonialsSecond();

        // testimonials-3

        function testimonialsThird() {
            var testimonials = $(".testimonials-slider--style-3");

            if (!testimonials.length) return;

            var prev = $(".testimonials-style-3__nav .slider__prev");
            var next = $(".testimonials-style-3__nav .slider__next");

            testimonials.slick({
                prevArrow: prev,
                nextArrow: next,
                adaptiveHeight: true,
                slidesToShow: 3,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }

        testimonialsThird();

        // items slider

        function itemsSlider() {
            var itemsSlider = $(".items-slider");

            if (!itemsSlider.length) return;

            var prev = $(".items-slider__nav .slider__prev");
            var next = $(".items-slider__nav .slider__next");

            itemsSlider.slick({
                prevArrow: prev,
                nextArrow: next,
                fade: true,
            });
        }

        itemsSlider();

        function pagesSlider() {
            var slider = $(".pages-slider");

            if (!slider.length) return;

            var prev = $(".pages-slider__nav .slider__prev");
            var next = $(".pages-slider__nav .slider__next");

            slider.slick({
                slidesToShow: 3,
                prevArrow: prev,
                nextArrow: next,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        }

        pagesSlider();

        // |----------~-------------~----------| //
        // |------_______________________------| //
        // |-----! S L I D E R S   E N D !-----| //
        // |------‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾------| //
        // |----------~-------------~----------| //
    });
})(jQuery);
